/* tslint:disable */
/* eslint-disable */
// Generated using typescript-generator version 4.1.0 on 2026-11-03 16:08:44.

import {RequestRespons, RequestValg} from "./AngularHttpKlient";

export interface HttpClient {

    request<R>(requestConfig: { method: string; url: string; queryParams?: any; data?: any; copyFn?: (data: R) => R; options?: RequestValg; }): RestResponse<R>;
}

export class AksjeeierRessursClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * HTTP GET /aksjeeier/{id}
     * Java method: no.systemfabrikken.lederplan.resources.aksjeeierbok.AksjeeierRessurs.hent
     */
    hent(id: AksjeeierId, options?: RequestValg): RestResponse<AksjeeierModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`aksjeeier/${id}`, options: options });
    }

    /**
     * HTTP POST /aksjeeier/{id}
     * Java method: no.systemfabrikken.lederplan.resources.aksjeeierbok.AksjeeierRessurs.oppdater
     */
    oppdater(id: AksjeeierId, arg1: OppdaterAksjeeierSpesifikasjon, options?: RequestValg): RestResponse<AksjeeierModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`aksjeeier/${id}`, data: arg1, options: options });
    }

    /**
     * HTTP PUT /aksjeeier/{id}
     * Java method: no.systemfabrikken.lederplan.resources.aksjeeierbok.AksjeeierRessurs.opprett
     */
    opprett(id: AksjeeierbokId, arg1: OpprettAksjeeierSpesifikasjon, options?: RequestValg): RestResponse<AksjeeierModell> {
        return this.httpClient.request({ method: 'PUT', url: uriEncoding`aksjeeier/${id}`, data: arg1, options: options });
    }

    /**
     * HTTP POST /aksjeeier/{id}/oppdaterKommentarPaaBeholdning
     * Java method: no.systemfabrikken.lederplan.resources.aksjeeierbok.AksjeeierRessurs.oppdaterKommentarPåNåværendeBeholdning
     */
    oppdaterKommentarPåNåværendeBeholdning(id: AksjeeierId, arg1: OppdaterBeholdningKommentarSpesifikasjon, options?: RequestValg): RestResponse<AksjeeierModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`aksjeeier/${id}/oppdaterKommentarPaaBeholdning`, data: arg1, options: options });
    }
}

export class AksjeeierbokRessursClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * HTTP GET /aksjeeierbok/{id}
     * Java method: no.systemfabrikken.lederplan.resources.aksjeeierbok.AksjeeierbokRessurs.hent
     */
    hent(id: AksjeeierbokId, options?: RequestValg): RestResponse<AksjeeierbokModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`aksjeeierbok/${id}`, options: options });
    }

    /**
     * HTTP GET /aksjeeierbok/{id}/aksjeeierbok.xlsx
     * Java method: no.systemfabrikken.lederplan.resources.aksjeeierbok.AksjeeierbokRessurs.aksjeeierbokeksport
     */
    aksjeeierbokeksport(id: AksjeeierbokId, queryParams?: { fullHistorikk?: boolean; }, options?: RequestValg): RestResponse<any> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`aksjeeierbok/${id}/aksjeeierbok.xlsx`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /aksjeeierbok/{id}/hentSlettSisteBeholdningsendringInfo
     * Java method: no.systemfabrikken.lederplan.resources.aksjeeierbok.AksjeeierbokRessurs.hentSlettSisteBeholdningsendringInfo
     */
    hentSlettSisteBeholdningsendringInfo(id: AksjeeierbokId, options?: RequestValg): RestResponse<SlettSisteBeholdningsendringModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`aksjeeierbok/${id}/hentSlettSisteBeholdningsendringInfo`, options: options });
    }

    /**
     * HTTP POST /aksjeeierbok/{id}/oppdaterBeholdninger
     * Java method: no.systemfabrikken.lederplan.resources.aksjeeierbok.AksjeeierbokRessurs.oppdaterBeholdninger
     */
    oppdaterBeholdninger(id: AksjeeierbokId, arg1: OppdaterBeholdningerSpesifikasjon, options?: RequestValg): RestResponse<AksjeeierbokModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`aksjeeierbok/${id}/oppdaterBeholdninger`, data: arg1, options: options });
    }

    /**
     * HTTP PUT /aksjeeierbok/{id}/opprettAksjeeiereOgBeholding
     * Java method: no.systemfabrikken.lederplan.resources.aksjeeierbok.AksjeeierbokRessurs.opprettAksjeeiereOgBeholding
     */
    opprettAksjeeiereOgBeholding(id: AksjeeierbokId, arg1: OpprettAksjeeiereOgBeholdningerSpesifikasjon, options?: RequestValg): RestResponse<AksjeeierbokModell> {
        return this.httpClient.request({ method: 'PUT', url: uriEncoding`aksjeeierbok/${id}/opprettAksjeeiereOgBeholding`, data: arg1, options: options });
    }

    /**
     * Kaller {@link Aksjeeierbok#slettSisteBeholdningsendring} . For info om hva sluttilstanden blir kan {@link #hentSlettSisteBeholdningsendringInfo} kalles. Merk at kaller bør håndtere httpStatus=417 som indikerer at {@link Aksjeeierbok#sisteInnføringsdato} ikke er lik angitt innfoeringsdatoSomSlettes
     * HTTP POST /aksjeeierbok/{id}/slettSisteBeholdningsendring
     * Java method: no.systemfabrikken.lederplan.resources.aksjeeierbok.AksjeeierbokRessurs.slettSisteBeholdningsendring
     */
    slettSisteBeholdningsendring(id: AksjeeierbokId, arg1: SlettSisteBeholdningsendringSpesifikasjon, options?: RequestValg): RestResponse<AksjeeierbokModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`aksjeeierbok/${id}/slettSisteBeholdningsendring`, data: arg1, options: options });
    }
}

export class AksjeklasseRessursClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * HTTP GET /aksjeklasse/alle/{aksjeeierbokId}
     * Java method: no.systemfabrikken.lederplan.resources.aksjeeierbok.AksjeklasseRessurs.hentAlle
     */
    hentAlle(aksjeeierbokId: AksjeeierbokId, options?: RequestValg): RestResponse<AksjeklasseMedDetaljerModell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`aksjeklasse/alle/${aksjeeierbokId}`, options: options });
    }

    /**
     * HTTP POST /aksjeklasse/oppdater/{aksjeeierbokId}
     * Java method: no.systemfabrikken.lederplan.resources.aksjeeierbok.AksjeklasseRessurs.oppdater
     */
    oppdater(aksjeeierbokId: AksjeeierbokId, arg1: OppdaterAksjeklasserSpesifikansjonModell, options?: RequestValg): RestResponse<AksjeklasseMedDetaljerModell[]> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`aksjeklasse/oppdater/${aksjeeierbokId}`, data: arg1, options: options });
    }
}

/**
 * Arkiv der dokumenter som ikke nødvendigvis skal behandles under sak kan lagres. Om du for testformål vil simulerer tregt nettverk kan du sette et breakpoint i {@link org.eclipse.jetty.server.HttpInput#read(byte[],int,int)} med Thread.sleep(100)
 */
export class ArkivRessursClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * HTTP GET /arkiv/fil/{filId}
     * Java method: no.systemfabrikken.lederplan.resources.arkiv.ArkivRessurs.filNode
     */
    filNode(filId: ArkivnodeId, options?: RequestValg): RestResponse<ArkivFilnodeModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`arkiv/fil/${filId}`, options: options });
    }

    /**
     * HTTP DELETE /arkiv/fil/{id}
     * Java method: no.systemfabrikken.lederplan.resources.arkiv.ArkivRessurs.slettFil
     */
    slettFil(id: ArkivnodeId, options?: RequestValg): RestResponse<ArkivMappenodeModell> {
        return this.httpClient.request({ method: 'DELETE', url: uriEncoding`arkiv/fil/${id}`, options: options });
    }

    /**
     * HTTP GET /arkiv/filTilknyttetDokumentId/{dokumentId}
     * Java method: no.systemfabrikken.lederplan.resources.arkiv.ArkivRessurs.filTilknyttetDokumentId
     */
    filTilknyttetDokumentId(dokumentId: DokumentId, options?: RequestValg): RestResponse<ArkivFilnodeModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`arkiv/filTilknyttetDokumentId/${dokumentId}`, options: options });
    }

    /**
     * HTTP GET /arkiv/filTilknyttetDokumentVersjonId/{dokumentVersjonId}
     * Java method: no.systemfabrikken.lederplan.resources.arkiv.ArkivRessurs.filTilknyttetDokumentVersjonId
     */
    filTilknyttetDokumentVersjonId(dokumentVersjonId: DokumentVersjonId, options?: RequestValg): RestResponse<ArkivFilnodeModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`arkiv/filTilknyttetDokumentVersjonId/${dokumentVersjonId}`, options: options });
    }

    /**
     * HTTP GET /arkiv/mappe/{mappeId}
     * Java method: no.systemfabrikken.lederplan.resources.arkiv.ArkivRessurs.mappe
     */
    mappe(mappeId: ArkivnodeId, options?: RequestValg): RestResponse<ArkivMappenodeModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`arkiv/mappe/${mappeId}`, options: options });
    }

    /**
     * HTTP POST /arkiv/mappe/{mappeId}
     * Java method: no.systemfabrikken.lederplan.resources.arkiv.ArkivRessurs.oppdaterMappe
     */
    oppdaterMappe(mappeId: ArkivnodeId, arg1: OppdaterMappeSpesifikasjon, options?: RequestValg): RestResponse<ArkivMappenodeModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`arkiv/mappe/${mappeId}`, data: arg1, options: options });
    }

    /**
     * Sletter angitt mappe, rekursivt dersom angitt. Returnerer foreldermappen
     * HTTP DELETE /arkiv/mappe/{mappeId}
     * Java method: no.systemfabrikken.lederplan.resources.arkiv.ArkivRessurs.slettMappe
     */
    slettMappe(mappeId: ArkivnodeId, queryParams?: { rekursivt?: boolean; }, options?: RequestValg): RestResponse<ArkivMappenodeModell> {
        return this.httpClient.request({ method: 'DELETE', url: uriEncoding`arkiv/mappe/${mappeId}`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /arkiv/mappe/{mappeId}/skjerming
     * Java method: no.systemfabrikken.lederplan.resources.arkiv.ArkivRessurs.hentSkjerming
     */
    hentSkjerming(mappeId: ArkivnodeId, options?: RequestValg): RestResponse<SkjermingDetaljerModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`arkiv/mappe/${mappeId}/skjerming`, options: options });
    }

    /**
     * HTTP POST /arkiv/mappe/{mappeId}/skjerming
     * Java method: no.systemfabrikken.lederplan.resources.arkiv.ArkivRessurs.oppdaterSkjerming
     */
    oppdaterSkjerming(mappeId: ArkivnodeId, arg1: OppdaterSkjermingSpesifikasjon, options?: RequestValg): RestResponse<SkjermingDetaljerMedValideringsresultatModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`arkiv/mappe/${mappeId}/skjerming`, data: arg1, options: options });
    }

    /**
     * Returner tilgjengelige gruppers arkiv-røtter. Merk at returnert mappenode har id=null. Returnert mappenode.barn inneholder ett innslag per gruppe ( {@link Gruppe#arkiv} ) bruker har tilgang til.
     * HTTP GET /arkiv/rot
     * Java method: no.systemfabrikken.lederplan.resources.arkiv.ArkivRessurs.rot
     */
    rot(options?: RequestValg): RestResponse<ArkivMappenodeModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`arkiv/rot`, options: options });
    }

    /**
     * Returner angit gruppes arkiv-rot
     * HTTP GET /arkiv/rot/{gruppeId}
     * Java method: no.systemfabrikken.lederplan.resources.arkiv.ArkivRessurs.rotForGruppe
     */
    rotForGruppe(gruppeId: GruppeId, options?: RequestValg): RestResponse<ArkivMappenodeModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`arkiv/rot/${gruppeId}`, options: options });
    }

    /**
     * HTTP GET /arkiv/sakerKnyttetTilArkivdokument/{dokumentId}
     * Java method: no.systemfabrikken.lederplan.resources.arkiv.ArkivRessurs.sakerKnyttetTilArkivdokument
     */
    sakerKnyttetTilArkivdokument(dokumentId: DokumentId, options?: RequestValg): RestResponse<DokumentVersjonOgSakerModell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`arkiv/sakerKnyttetTilArkivdokument/${dokumentId}`, options: options });
    }

    /**
     * HTTP GET /arkiv/sakerKnyttetTilArkivdokumenterIMappe/{mappeId}
     * Java method: no.systemfabrikken.lederplan.resources.arkiv.ArkivRessurs.sakerKnyttetTilArkivdokumenterIMappe
     */
    sakerKnyttetTilArkivdokumenterIMappe(mappeId: ArkivnodeId, options?: RequestValg): RestResponse<DokumentVersjonOgSakerModell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`arkiv/sakerKnyttetTilArkivdokumenterIMappe/${mappeId}`, options: options });
    }

    /**
     * Registrerer ny versjon av arkivdokument, kalt fra web-appen.
     * HTTP PUT /arkiv/{filId}/fil/versjon
     * Java method: no.systemfabrikken.lederplan.resources.arkiv.ArkivRessurs.opprettNyFilVersjon
     */
    opprettNyFilVersjon(filId: ArkivnodeId, arg1: any, options?: RequestValg): RestResponse<ArkivFilnodeModell> {
        return this.httpClient.request({ method: 'PUT', url: uriEncoding`arkiv/${filId}/fil/versjon`, data: arg1, options: options });
    }

    /**
     * HTTP PUT /arkiv/{forelderId}/mappe
     * Java method: no.systemfabrikken.lederplan.resources.arkiv.ArkivRessurs.opprettMappe
     */
    opprettMappe(forelderId: ArkivnodeId, arg1: NyMappeSpesifikasjon, options?: RequestValg): RestResponse<ArkivMappenodeModell> {
        return this.httpClient.request({ method: 'PUT', url: uriEncoding`arkiv/${forelderId}/mappe`, data: arg1, options: options });
    }

    /**
     * Flytter node angitt i url til mappe angitt i spesifikasjon.
@return mappen noden ble flyttet fra
     * HTTP POST /arkiv/{id}/flytt
     * Java method: no.systemfabrikken.lederplan.resources.arkiv.ArkivRessurs.flytt
     */
    flytt(id: ArkivnodeId, arg1: FlyttNodeSpesifikasjon, options?: RequestValg): RestResponse<ArkivMappenodeModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`arkiv/${id}/flytt`, data: arg1, options: options });
    }

    /**
     * Registrerer nytt arkivdokument, kalt fra web-appen.
     * HTTP PUT /arkiv/{mappeId}/fil
     * Java method: no.systemfabrikken.lederplan.resources.arkiv.ArkivRessurs.opprettFil
     */
    opprettFil(mappeId: ArkivnodeId, arg1: any, options?: RequestValg): RestResponse<ArkivFilnodeModell> {
        return this.httpClient.request({ method: 'PUT', url: uriEncoding`arkiv/${mappeId}/fil`, data: arg1, options: options });
    }

    /**
     * Importerer mapper og filer fra opplastet zip-fil. Merk at vi kaster {@link ValideringsfeilException} dersom reglene i {@link ArkivImportFraZip} ikke overholdes.
     * HTTP PUT /arkiv/{mappeId}/importer
     * Java method: no.systemfabrikken.lederplan.resources.arkiv.ArkivRessurs.importer
     */
    importer(mappeId: ArkivnodeId, arg1: any, options?: RequestValg): RestResponse<ImportresultatModell> {
        return this.httpClient.request({ method: 'PUT', url: uriEncoding`arkiv/${mappeId}/importer`, data: arg1, options: options });
    }
}

export class AsynkOppgaveRessursClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * HTTP GET /admin/asynkOppgaver
     * Java method: no.systemfabrikken.lederplan.resources.admin.AsynkOppgaveRessurs.hentAlle
     */
    hentAlle(queryParams?: { statusFilter?: Status; }, options?: RequestValg): RestResponse<AsynkOppgaveModell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`admin/asynkOppgaver`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP DELETE /admin/asynkOppgaver/{id}
     * Java method: no.systemfabrikken.lederplan.resources.admin.AsynkOppgaveRessurs.parkerJobb
     */
    parkerJobb(id: AsynkOppgaveId, options?: RequestValg): RestResponse<AsynkOppgaveModell> {
        return this.httpClient.request({ method: 'DELETE', url: uriEncoding`admin/asynkOppgaver/${id}`, options: options });
    }

    /**
     * HTTP POST /admin/asynkOppgaver/{id}/restart
     * Java method: no.systemfabrikken.lederplan.resources.admin.AsynkOppgaveRessurs.restartJobb
     */
    restartJobb(id: AsynkOppgaveId, options?: RequestValg): RestResponse<AsynkOppgaveModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`admin/asynkOppgaver/${id}/restart`, options: options });
    }
}

export class AutentiseringRessursClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * returnerer autentisert ok modell for innlogget bruker
     * HTTP GET /autentisering
     * Java method: no.systemfabrikken.lederplan.resources.autentisering.AutentiseringRessurs.hentKontekst
     */
    hentKontekst(options?: RequestValg): RestResponse<AutentisertOkModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`autentisering`, options: options });
    }

    /**
     * HTTP POST /autentisering/autentiserMedSmsOtpReservekode
     * Java method: no.systemfabrikken.lederplan.resources.autentisering.AutentiseringRessurs.autentiserMedSmsOtpReservekode
     */
    autentiserMedSmsOtpReservekode(arg0: SmsOtpReservekodeInnloggingsSpesifikasjon, options?: RequestValg): RestResponse<any> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`autentisering/autentiserMedSmsOtpReservekode`, data: arg0, options: options });
    }

    /**
     * HTTP POST /autentisering/autentiserMedTotpReservekode
     * Java method: no.systemfabrikken.lederplan.resources.autentisering.AutentiseringRessurs.autentiserMedTotpReservekode2
     */
    autentiserMedTotpReservekode2(arg0: TotpReservekodeInnloggingsSpesifikasjon, options?: RequestValg): RestResponse<any> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`autentisering/autentiserMedTotpReservekode`, data: arg0, options: options });
    }

    /**
     * Generer og returnerer nytt token. Merk at eksisterende token ikke svartelistes, vi antar at dette uansett snart løper ut på tid, og ved å ikke svarteliste det vil tilnærmet samtidige requester fra samme bruker ikke feile.
     * HTTP POST /autentisering/fornyTokenV2
     * Java method: no.systemfabrikken.lederplan.resources.autentisering.AutentiseringRessurs.fornyTokenV2
     */
    fornyTokenV2(arg0: FornyTokenSpesifikasjon, options?: RequestValg): RestResponse<any> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`autentisering/fornyTokenV2`, data: arg0, options: options });
    }

    /**
     * Svartelister kallender brukers token, logger hendelse. Returnerer cookie som nullstiller token-cookie på klient.
     * HTTP POST /autentisering/loggut
     * Java method: no.systemfabrikken.lederplan.resources.autentisering.AutentiseringRessurs.loggUtV2
     */
    loggUtV2(options?: RequestValg): RestResponse<any> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`autentisering/loggut`, options: options });
    }

    /**
     * Logger bruker ut fra alle enheter, logger hendelse.
     * HTTP POST /autentisering/loggutAlleEnheter
     * Java method: no.systemfabrikken.lederplan.resources.autentisering.AutentiseringRessurs.loggutAlleEnheter
     */
    loggutAlleEnheter(options?: RequestValg): RestResponse<any> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`autentisering/loggutAlleEnheter`, options: options });
    }

    /**
     * Logger bruker ut fra spesifikk enhet, logger hendelse.
     * HTTP POST /autentisering/loggutEnhet
     * Java method: no.systemfabrikken.lederplan.resources.autentisering.AutentiseringRessurs.loggutEnhet
     */
    loggutEnhet(arg0: TokenSpesifikasjon, options?: RequestValg): RestResponse<any> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`autentisering/loggutEnhet`, data: arg0, options: options });
    }

    /**
     * HTTP POST /autentisering/v2
     * Java method: no.systemfabrikken.lederplan.resources.autentisering.AutentiseringRessurs.autentiserv2
     */
    autentiserv2(arg0: InnloggingsSpesifikasjon, options?: RequestValg): RestResponse<any> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`autentisering/v2`, data: arg0, options: options });
    }

    /**
     * Validerer token sendt i request. Merk at vi ikke sjekker om token er svartelistet eller om brukers konto er deaktivert.
     * HTTP GET /autentisering/validerToken
     * Java method: no.systemfabrikken.lederplan.resources.autentisering.AutentiseringRessurs.validerToken
     */
    validerToken(options?: RequestValg): RestResponse<any> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`autentisering/validerToken`, options: options });
    }
}

export class AvstemningRessursClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * HTTP PUT /avstemning
     * Java method: no.systemfabrikken.lederplan.resources.sak.AvstemningRessurs.opprett
     */
    opprett(arg0: OpprettAvstemningSpesifikasjon, options?: RequestValg): RestResponse<AvstemningMedResultatOgStatuserModell> {
        return this.httpClient.request({ method: 'PUT', url: uriEncoding`avstemning`, data: arg0, options: options });
    }

    /**
     * HTTP GET /avstemning/finnAvstemningerAndreIkkeHarStemtPaa
     * Java method: no.systemfabrikken.lederplan.resources.sak.AvstemningRessurs.finnAvstemningerAndreIkkeHarStemtPå
     */
    finnAvstemningerAndreIkkeHarStemtPå(options?: RequestValg): RestResponse<ManglerStemmegivningModell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`avstemning/finnAvstemningerAndreIkkeHarStemtPaa`, options: options });
    }

    /**
     * HTTP GET /avstemning/finnAvstemningerBrukerIkkeHarStemtPaa
     * Java method: no.systemfabrikken.lederplan.resources.sak.AvstemningRessurs.finnAvstemningerBrukerIkkeHarStemtPå
     */
    finnAvstemningerBrukerIkkeHarStemtPå(options?: RequestValg): RestResponse<AvstemningMedMøteModell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`avstemning/finnAvstemningerBrukerIkkeHarStemtPaa`, options: options });
    }

    /**
     * HTTP GET /avstemning/finnAvstemningerKnyttetTilMoete/{moeteId}
     * Java method: no.systemfabrikken.lederplan.resources.sak.AvstemningRessurs.finnAvstemningerKnyttetTilMøte
     */
    finnAvstemningerKnyttetTilMøte(moeteId: MøteId, options?: RequestValg): RestResponse<AvstemningMedResultatModell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`avstemning/finnAvstemningerKnyttetTilMoete/${moeteId}`, options: options });
    }

    /**
     * HTTP GET /avstemning/{id}
     * Java method: no.systemfabrikken.lederplan.resources.sak.AvstemningRessurs.hent
     */
    hent(id: AvstemningId, options?: RequestValg): RestResponse<AvstemningMedResultatModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`avstemning/${id}`, options: options });
    }

    /**
     * HTTP POST /avstemning/{id}
     * Java method: no.systemfabrikken.lederplan.resources.sak.AvstemningRessurs.oppdater
     */
    oppdater(id: AvstemningId, arg1: OppdaterAvstemningSpesifikasjon, options?: RequestValg): RestResponse<AvstemningMedResultatOgStatuserModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`avstemning/${id}`, data: arg1, options: options });
    }

    /**
     * HTTP DELETE /avstemning/{id}
     * Java method: no.systemfabrikken.lederplan.resources.sak.AvstemningRessurs.slett
     */
    slett(id: AvstemningId, options?: RequestValg): RestResponse<AvstemningsstatusModell> {
        return this.httpClient.request({ method: 'DELETE', url: uriEncoding`avstemning/${id}`, options: options });
    }

    /**
     * HTTP POST /avstemning/{id}/aapneForAvstemning
     * Java method: no.systemfabrikken.lederplan.resources.sak.AvstemningRessurs.åpneForAvstemning
     */
    åpneForAvstemning(id: AvstemningId, options?: RequestValg): RestResponse<AvstemningMedResultatModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`avstemning/${id}/aapneForAvstemning`, options: options });
    }

    /**
     * HTTP POST /avstemning/{id}/avgiStemme
     * Java method: no.systemfabrikken.lederplan.resources.sak.AvstemningRessurs.avgiStemme
     */
    avgiStemme(id: AvstemningId, arg1: AvgiStemmeSpesifikasjon, options?: RequestValg): RestResponse<AvstemningMedResultatOgStatuserModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`avstemning/${id}/avgiStemme`, data: arg1, options: options });
    }

    /**
     * HTTP DELETE /avstemning/{id}/nullstillAvgitteStemmer
     * Java method: no.systemfabrikken.lederplan.resources.sak.AvstemningRessurs.nullstillAvgitteStemmer
     */
    nullstillAvgitteStemmer(id: AvstemningId, options?: RequestValg): RestResponse<AvstemningMedResultatOgStatuserModell> {
        return this.httpClient.request({ method: 'DELETE', url: uriEncoding`avstemning/${id}/nullstillAvgitteStemmer`, options: options });
    }

    /**
     * HTTP POST /avstemning/{id}/stengForAvstemning
     * Java method: no.systemfabrikken.lederplan.resources.sak.AvstemningRessurs.stengForAvstemning
     */
    stengForAvstemning(id: AvstemningId, options?: RequestValg): RestResponse<AvstemningMedResultatModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`avstemning/${id}/stengForAvstemning`, options: options });
    }
}

export class AvtaleRessursClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * HTTP GET /avtale/finnAlle
     * Java method: no.systemfabrikken.lederplan.resources.avtale.AvtaleRessurs.finnAlle
     */
    finnAlle(options?: RequestValg): RestResponse<AvtaleModell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`avtale/finnAlle`, options: options });
    }

    /**
     * Returnerer alle avtaler der kallende bruker er {@link Avtale#kontaktperson()} .
     * HTTP GET /avtale/finnAvtalerBrukerErKontaktpersonFor
     * Java method: no.systemfabrikken.lederplan.resources.avtale.AvtaleRessurs.finnAvtalerBrukerErKontaktpersonFor
     */
    finnAvtalerBrukerErKontaktpersonFor(options?: RequestValg): RestResponse<AvtaleModell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`avtale/finnAvtalerBrukerErKontaktpersonFor`, options: options });
    }

    /**
     * Returnerer alle avtaler der kallende bruker er medlem i en tilknyttet gruppe og medlemskapet ikke har {@link Medlem#harTilgang()} == false. Merk at grupper bruker er invitert til ikke inngår.
     * HTTP GET /avtale/finnAvtalerBrukerHarAktivtMedlemskapI
     * Java method: no.systemfabrikken.lederplan.resources.avtale.AvtaleRessurs.finnAvtalerBrukerHarAktivtMedlemskapI
     */
    finnAvtalerBrukerHarAktivtMedlemskapI(options?: RequestValg): RestResponse<AvtaleModell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`avtale/finnAvtalerBrukerHarAktivtMedlemskapI`, options: options });
    }

    /**
     * Returnerer informasjon om angitt avtale hentet fra brønøysundregistrene. Dersom enhet funnet returneres en liste med ett element, dersom ikke funnet returneres en tom liste.
     * HTTP GET /avtale/finnBrregAvtaleinformasjon
     * Java method: no.systemfabrikken.lederplan.resources.avtale.AvtaleRessurs.finnBrregAvtaleinformasjon
     */
    finnBrregAvtaleinformasjon(queryParams?: { firmanavn?: string; }, options?: RequestValg): RestResponse<BrregEnhet[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`avtale/finnBrregAvtaleinformasjon`, queryParams: queryParams, options: options });
    }

    /**
     * Returnerer vilkårstekst publisert i Webflow under adressen https://www.styreplan.no/avtaler/tjenesteavtale
     * HTTP GET /avtale/hentVilkaar
     * Java method: no.systemfabrikken.lederplan.resources.avtale.AvtaleRessurs.hentVilkår
     */
    hentVilkår(queryParams?: { spraak?: string; }, options?: RequestValg): RestResponse<BetingelserModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`avtale/hentVilkaar`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /avtale/{id}
     * Java method: no.systemfabrikken.lederplan.resources.avtale.AvtaleRessurs.hent
     */
    hent(id: AvtaleId, options?: RequestValg): RestResponse<AvtaledetaljerModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`avtale/${id}`, options: options });
    }

    /**
     * HTTP POST /avtale/{id}
     * Java method: no.systemfabrikken.lederplan.resources.avtale.AvtaleRessurs.oppdater
     */
    oppdater(id: AvtaleId, arg1: RedigerAvtalepesifikasjon, options?: RequestValg): RestResponse<AvtaledetaljerModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`avtale/${id}`, data: arg1, options: options });
    }

    /**
     * HTTP POST /avtale/{id}/adminTerminerAvtale
     * Java method: no.systemfabrikken.lederplan.resources.avtale.AvtaleRessurs.adminTerminerAvtale
     */
    adminTerminerAvtale(id: AvtaleId, options?: RequestValg): RestResponse<TerminerAvtaleResponsModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`avtale/${id}/adminTerminerAvtale`, options: options });
    }

    /**
     * Streamer zip-fil med alle data for angitt avtale til klient. Merk at ALLE data inkluderes, også data kallende bruker normalt ikke ville hatt tilgang til pga skjerming. Kun kontaktperson for avtale kan kalle denne metoden.
     * HTTP GET /avtale/{id}/datadump/{filnavn}
     * Java method: no.systemfabrikken.lederplan.resources.avtale.AvtaleRessurs.datadump
     */
    datadump(id: AvtaleId, filnavn: string, options?: RequestValg): RestResponse<any> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`avtale/${id}/datadump/${filnavn}`, options: options });
    }

    /**
     * HTTP GET /avtale/{id}/enkel
     * Java method: no.systemfabrikken.lederplan.resources.avtale.AvtaleRessurs.hentEnkel
     */
    hentEnkel(id: AvtaleId, options?: RequestValg): RestResponse<AvtaleModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`avtale/${id}/enkel`, options: options });
    }

    /**
     * HTTP GET /avtale/{id}/kanAvtaleTermineres
     * Java method: no.systemfabrikken.lederplan.resources.avtale.AvtaleRessurs.kanAvtaleTermineres
     */
    kanAvtaleTermineres(id: AvtaleId, options?: RequestValg): RestResponse<KanAvtaleTermineresInfoModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`avtale/${id}/kanAvtaleTermineres`, options: options });
    }

    /**
     * HTTP POST /avtale/{id}/oppdaterFaktureringsinformasjon
     * Java method: no.systemfabrikken.lederplan.resources.avtale.AvtaleRessurs.oppdaterFaktureringsinformasjon
     */
    oppdaterFaktureringsinformasjon(id: AvtaleId, arg1: RedigerFakturainformasjonSpesifikasjon, options?: RequestValg): RestResponse<AvtaledetaljerModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`avtale/${id}/oppdaterFaktureringsinformasjon`, data: arg1, options: options });
    }

    /**
     * HTTP POST /avtale/{id}/oppdaterProeveperiodeUtloepsdato
     * Java method: no.systemfabrikken.lederplan.resources.avtale.AvtaleRessurs.oppdaterProeveperiodeUtloepsdato
     */
    oppdaterProeveperiodeUtloepsdato(id: AvtaleId, arg1: PrøveperiodeUtløpsdatoSpesifikasjon, options?: RequestValg): RestResponse<AvtaleModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`avtale/${id}/oppdaterProeveperiodeUtloepsdato`, data: arg1, options: options });
    }

    /**
     * HTTP POST /avtale/{id}/reaktiverAvtale
     * Java method: no.systemfabrikken.lederplan.resources.avtale.AvtaleRessurs.reaktiverAvtale
     */
    reaktiverAvtale(id: AvtaleId, options?: RequestValg): RestResponse<AvtaleModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`avtale/${id}/reaktiverAvtale`, options: options });
    }

    /**
     * HTTP POST /avtale/{id}/terminerAvtale
     * Java method: no.systemfabrikken.lederplan.resources.avtale.AvtaleRessurs.terminerAvtale
     */
    terminerAvtale(id: AvtaleId, arg1: TerminerAvtaleSpesifikasjon, options?: RequestValg): RestResponse<TerminerAvtaleResponsModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`avtale/${id}/terminerAvtale`, data: arg1, options: options });
    }
}

export class BeslutningRessursClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * HTTP PUT /beslutning
     * Java method: no.systemfabrikken.lederplan.resources.sak.BeslutningRessurs.opprett
     */
    opprett(arg0: OpprettBeslutningSpesifikasjon, options?: RequestValg): RestResponse<BeslutningModell> {
        return this.httpClient.request({ method: 'PUT', url: uriEncoding`beslutning`, data: arg0, options: options });
    }

    /**
     * HTTP POST /beslutning/beslutningAggregater
     * Java method: no.systemfabrikken.lederplan.resources.sak.BeslutningRessurs.beslutningAggregater
     */
    beslutningAggregater(arg0: FinnBeslutningerSpesifikasjon, options?: RequestValg): RestResponse<BeslutningAggreatModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`beslutning/beslutningAggregater`, data: arg0, options: options });
    }

    /**
     * HTTP POST /beslutning/finn
     * Java method: no.systemfabrikken.lederplan.resources.sak.BeslutningRessurs.finnBeslutninger
     */
    finnBeslutninger(arg0: FinnBeslutningerSpesifikasjon, options?: RequestValg): RestResponse<BeslutningMedMøteModell[]> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`beslutning/finn`, data: arg0, options: options });
    }

    /**
     * @deprecated
     * HTTP POST /beslutning/finnAlle
     * Java method: no.systemfabrikken.lederplan.resources.sak.BeslutningRessurs.finnAlleBeslutninger
     */
    finnAlleBeslutninger(arg0: FinnBeslutningerSpørreSpesifikasjon, options?: RequestValg): RestResponse<MøterMedBeslutningerModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`beslutning/finnAlle`, data: arg0, options: options });
    }

    /**
     * HTTP GET /beslutning/{id}
     * Java method: no.systemfabrikken.lederplan.resources.sak.BeslutningRessurs.hent
     */
    hent(id: BeslutningId, options?: RequestValg): RestResponse<BeslutningModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`beslutning/${id}`, options: options });
    }

    /**
     * HTTP POST /beslutning/{id}
     * Java method: no.systemfabrikken.lederplan.resources.sak.BeslutningRessurs.oppdater
     */
    oppdater(id: BeslutningId, arg1: OppdaterBeslutningOgOppgaverSpesifikasjon, options?: RequestValg): RestResponse<BeslutningModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`beslutning/${id}`, data: arg1, options: options });
    }

    /**
     * HTTP DELETE /beslutning/{id}
     * Java method: no.systemfabrikken.lederplan.resources.sak.BeslutningRessurs.slett
     */
    slett(id: BeslutningId, options?: RequestValg): RestResponse<OkRespons> {
        return this.httpClient.request({ method: 'DELETE', url: uriEncoding`beslutning/${id}`, options: options });
    }

    /**
     * HTTP PUT /beslutning/{id}/opprettOppgave/
     * Java method: no.systemfabrikken.lederplan.resources.sak.BeslutningRessurs.opprettOppgave
     */
    opprettOppgave(id: BeslutningId, arg1: MuterendeOppgaveSpesifikasjon, options?: RequestValg): RestResponse<OppgaveModell> {
        return this.httpClient.request({ method: 'PUT', url: uriEncoding`beslutning/${id}/opprettOppgave/`, data: arg1, options: options });
    }

    /**
     * HTTP DELETE /beslutning/{id}/slettOppgave/{oppgaveId}
     * Java method: no.systemfabrikken.lederplan.resources.sak.BeslutningRessurs.slettOppgave
     */
    slettOppgave(id: BeslutningId, oppgaveId: OppgaveId, options?: RequestValg): RestResponse<OkRespons> {
        return this.httpClient.request({ method: 'DELETE', url: uriEncoding`beslutning/${id}/slettOppgave/${oppgaveId}`, options: options });
    }
}

export class BrukerRessursClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * @deprecated
     * HTTP GET /bruker/aktivitetHistogramAlleBrukere
     * Java method: no.systemfabrikken.lederplan.resources.bruker.BrukerRessurs.aktivitetHistogramAlleBrukere
     */
    aktivitetHistogramAlleBrukere(options?: RequestValg): RestResponse<any> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`bruker/aktivitetHistogramAlleBrukere`, options: options });
    }

    /**
     * HTTP POST /bruker/bekreftEpostadresse
     * Java method: no.systemfabrikken.lederplan.resources.bruker.BrukerRessurs.bekreftEpostadresse
     */
    bekreftEpostadresse(arg0: BekreftEpostTokenSpesifikasjon, options?: RequestValg): RestResponse<ValideringResponsModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`bruker/bekreftEpostadresse`, data: arg0, options: options });
    }

    /**
     * HTTP POST /bruker/bekreftMobilnummerOtp
     * Java method: no.systemfabrikken.lederplan.resources.bruker.BrukerRessurs.bekreftMobilnummerOtp
     */
    bekreftMobilnummerOtp(arg0: BekreftMobilnummerOtpSpesifikasjon, options?: RequestValg): RestResponse<ValideringResponsModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`bruker/bekreftMobilnummerOtp`, data: arg0, options: options });
    }

    /**
     * HTTP GET /bruker/finnAlle
     * Java method: no.systemfabrikken.lederplan.resources.bruker.BrukerRessurs.finnAlle
     */
    finnAlle(options?: RequestValg): RestResponse<EnkelBrukerModell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`bruker/finnAlle`, options: options });
    }

    /**
     * HTTP GET /bruker/finnBrukerMedBrukernavn/{brukernavn}
     * Java method: no.systemfabrikken.lederplan.resources.bruker.BrukerRessurs.finnBrukerMedBrukernavn
     */
    finnBrukerMedBrukernavn(brukernavn: Brukernavn, options?: RequestValg): RestResponse<BrukerModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`bruker/finnBrukerMedBrukernavn/${brukernavn}`, options: options });
    }

    /**
     * HTTP GET /bruker/hentTilgjengeligeTidssoner
     * Java method: no.systemfabrikken.lederplan.resources.bruker.BrukerRessurs.hentTilgjengeligeTidssoner
     */
    hentTilgjengeligeTidssoner(options?: RequestValg): RestResponse<Tidssone[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`bruker/hentTilgjengeligeTidssoner`, options: options });
    }

    /**
     * Returnerer liste med kallende brukers grupper.
     * HTTP GET /bruker/kallendeBrukersGrupper
     * Java method: no.systemfabrikken.lederplan.resources.bruker.BrukerRessurs.kallendeBrukersGrupper
     */
    kallendeBrukersGrupper(options?: RequestValg): RestResponse<MedlemsRolleIGruppeModell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`bruker/kallendeBrukersGrupper`, options: options });
    }

    /**
     * Validerer angitt spesifikasjon.
@return returnerer valideringsfeil av typen {@link SlåSammenBrukereValideringsfeil}
     * HTTP POST /bruker/kobleBrukere
     * Java method: no.systemfabrikken.lederplan.resources.bruker.BrukerRessurs.kobleBrukere
     */
    kobleBrukere(arg0: SlåSammenBrukereSpesifikasjon, options?: RequestValg): RestResponse<ValideringsresultatModell<SlåSammenBrukereValideringsfeil>> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`bruker/kobleBrukere`, data: arg0, options: options });
    }

    /**
     * Setter nytt passord for innlogget (kallende) bruker. Merk at alle eksisterende autentiseringstoken med UNNTAK av tokenet benyttet i denne requesten blir ugyldiggjort.
     * HTTP POST /bruker/nyttPassord
     * Java method: no.systemfabrikken.lederplan.resources.bruker.BrukerRessurs.nyttPassord
     */
    nyttPassord(arg0: NyttPassordSpesifikasjon, options?: RequestValg): RestResponse<any> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`bruker/nyttPassord`, data: arg0, options: options });
    }

    /**
     * Setter nytt passord for identifisert via passord reset token i angitt model. Merk at alle eksisterende autentiseringstoken blir ugyldiggjort. Se https://wiki.owasp.org/index.php/OWASP_Periodic_Table_of_Vulnerabilities_-_Insufficient_Password_Recovery
     * HTTP POST /bruker/nyttPassordAngitt
     * Java method: no.systemfabrikken.lederplan.resources.bruker.BrukerRessurs.nyttPassordAngitt
     */
    nyttPassordAngitt(arg0: NyttPassordFraTokenSpesifikasjon, options?: RequestValg): RestResponse<any> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`bruker/nyttPassordAngitt`, data: arg0, options: options });
    }

    /**
     * HTTP POST /bruker/onskerNyttPassord
     * Java method: no.systemfabrikken.lederplan.resources.bruker.BrukerRessurs.ønskerNyttPassord
     */
    ønskerNyttPassord(arg0: BrukernavnEllerEpostSpesifikasjon, options?: RequestValg): RestResponse<any> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`bruker/onskerNyttPassord`, data: arg0, options: options });
    }

    /**
     * Oppdaterer valgt språk for bruker. Språk kan kun oppdateres av brukeren selv
     * HTTP POST /bruker/oppdaterSpraak
     * Java method: no.systemfabrikken.lederplan.resources.bruker.BrukerRessurs.oppdaterSpråkkode
     */
    oppdaterSpråkkode(arg0: any, options?: RequestValg): RestResponse<OkRespons> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`bruker/oppdaterSpraak`, data: arg0, options: options });
    }

    /**
     * Oppdaterer tidssone for bruker. Tidssone kan kun oppdateres av brukeren selv
     * HTTP POST /bruker/oppdatertidssone
     * Java method: no.systemfabrikken.lederplan.resources.bruker.BrukerRessurs.oppdatertidssone
     */
    oppdatertidssone(arg0: Oppdatertidssone, options?: RequestValg): RestResponse<OkRespons> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`bruker/oppdatertidssone`, data: arg0, options: options });
    }

    /**
     * HTTP POST /bruker/persisterBrukervalg
     * Java method: no.systemfabrikken.lederplan.resources.bruker.BrukerRessurs.persisterBrukervalg
     */
    persisterBrukervalg(arg0: BrukervalgSpesifikasjon, options?: RequestValg): RestResponse<any> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`bruker/persisterBrukervalg`, data: arg0, options: options });
    }

    /**
     * HTTP POST /bruker/sendBekreftEpostadresseToken
     * Java method: no.systemfabrikken.lederplan.resources.bruker.BrukerRessurs.sendBekreftEpostadresseToken
     */
    sendBekreftEpostadresseToken(options?: RequestValg): RestResponse<BekreftEpostadresseSendtModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`bruker/sendBekreftEpostadresseToken`, options: options });
    }

    /**
     * HTTP POST /bruker/sendBekreftMobilnummerOtp
     * Java method: no.systemfabrikken.lederplan.resources.bruker.BrukerRessurs.sendBekreftMobilnummerOtp
     */
    sendBekreftMobilnummerOtp(options?: RequestValg): RestResponse<BekreftMobilnummerOtpSendtModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`bruker/sendBekreftMobilnummerOtp`, options: options });
    }

    /**
     * HTTP POST /bruker/validerBrukernavn
     * Java method: no.systemfabrikken.lederplan.resources.bruker.BrukerRessurs.validerBrukernavn
     */
    validerBrukernavn(arg0: BrukernavnSomStrengModell, options?: RequestValg): RestResponse<BrukernavnValideringsresultat> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`bruker/validerBrukernavn`, data: arg0, options: options });
    }

    /**
     * HTTP POST /bruker/validerPassord
     * Java method: no.systemfabrikken.lederplan.resources.bruker.BrukerRessurs.validerPassord
     */
    validerPassord(arg0: PassordSpesifikasjon, options?: RequestValg): RestResponse<PassordValideringsresultat> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`bruker/validerPassord`, data: arg0, options: options });
    }

    /**
     * HTTP GET /bruker/{brukerId}/aktiveAutentiseringstoken
     * Java method: no.systemfabrikken.lederplan.resources.bruker.BrukerRessurs.aktiveAutentiseringstoken
     */
    aktiveAutentiseringstoken(brukerId: BrukerId, options?: RequestValg): RestResponse<TokeninformasjonModell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`bruker/${brukerId}/aktiveAutentiseringstoken`, options: options });
    }

    /**
     * @deprecated
     * HTTP GET /bruker/{brukerId}/aktivitetHistogram
     * Java method: no.systemfabrikken.lederplan.resources.bruker.BrukerRessurs.brukeraktivitetHistogram
     */
    brukeraktivitetHistogram(brukerId: BrukerId, options?: RequestValg): RestResponse<any> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`bruker/${brukerId}/aktivitetHistogram`, options: options });
    }

    /**
     * Returnerer brukers avatar-bilde. Merk at avtarId er tatt med for å gjøre URLen unik slik at den kan cashes agressivt. Merk også at gruppemedlems avatar lastes via {@link no.systemfabrikken.lederplan.resources.gruppe.GruppeMedlemRessurs#avatar}
     * HTTP GET /bruker/{brukerId}/avatar/{avatarId}.jpg
     * Java method: no.systemfabrikken.lederplan.resources.bruker.BrukerRessurs.avatar
     */
    avatar(brukerId: BrukerId, avatarId: BildedataId, options?: RequestValg): RestResponse<any> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`bruker/${brukerId}/avatar/${avatarId}.jpg`, options: options });
    }

    /**
     * HTTP GET /bruker/{brukerId}/grupper
     * Java method: no.systemfabrikken.lederplan.resources.bruker.BrukerRessurs.brukersGrupper
     */
    brukersGrupper(brukerId: BrukerId, options?: RequestValg): RestResponse<GruppeMedlemModell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`bruker/${brukerId}/grupper`, options: options });
    }

    /**
     * HTTP PUT /bruker/{brukerId}/registrerAndroidPushMeldingstoken
     * Java method: no.systemfabrikken.lederplan.resources.bruker.BrukerRessurs.registrerAndroidPushMeldingstoken
     */
    registrerAndroidPushMeldingstoken(brukerId: BrukerId, arg1: RegistrerAndroidTokenSpesifikasjon, options?: RequestValg): RestResponse<any> {
        return this.httpClient.request({ method: 'PUT', url: uriEncoding`bruker/${brukerId}/registrerAndroidPushMeldingstoken`, data: arg1, options: options });
    }

    /**
     * HTTP PUT /bruker/{brukerId}/registrerIosPushMeldingstoken
     * Java method: no.systemfabrikken.lederplan.resources.bruker.BrukerRessurs.registrerIosPushMeldingstoken
     */
    registrerIosPushMeldingstoken(brukerId: BrukerId, arg1: RegistrerApnTokenSpesifikasjon, options?: RequestValg): RestResponse<any> {
        return this.httpClient.request({ method: 'PUT', url: uriEncoding`bruker/${brukerId}/registrerIosPushMeldingstoken`, data: arg1, options: options });
    }

    /**
     * HTTP PUT /bruker/{brukerId}/registrerPushToken
     * Java method: no.systemfabrikken.lederplan.resources.bruker.BrukerRessurs.registrerPushToken
     */
    registrerPushToken(brukerId: BrukerId, arg1: RegistrerAppPushTokenSpesifikasjon, options?: RequestValg): RestResponse<OkRespons> {
        return this.httpClient.request({ method: 'PUT', url: uriEncoding`bruker/${brukerId}/registrerPushToken`, data: arg1, options: options });
    }

    /**
     * Returnerer informasjon om hendelser (opprett/rediger/slett av entiteter) for angitt bruker de siste 6 måneder.
     * HTTP GET /bruker/{brukerId}/revisjonsloggAggregater
     * Java method: no.systemfabrikken.lederplan.resources.bruker.BrukerRessurs.revisjonsloggAggregater
     */
    revisjonsloggAggregater(brukerId: BrukerId, options?: RequestValg): RestResponse<HendelseAggregat[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`bruker/${brukerId}/revisjonsloggAggregater`, options: options });
    }

    /**
     * HTTP GET /bruker/{id}
     * Java method: no.systemfabrikken.lederplan.resources.bruker.BrukerRessurs.hentBruker
     */
    hentBruker(id: BrukerId, options?: RequestValg): RestResponse<BrukerModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`bruker/${id}`, options: options });
    }

    /**
     * Oppdaterer brukerinfo. Bruker kan kun oppdateres av brukeren selv
     * @deprecated
     * HTTP POST /bruker/{id}
     * Java method: no.systemfabrikken.lederplan.resources.bruker.BrukerRessurs.oppdater
     */
    oppdater(id: BrukerId, arg1: OppdaterBrukerSpesifikasjon, options?: RequestValg): RestResponse<BrukerModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`bruker/${id}`, data: arg1, options: options });
    }

    /**
     * Returnerer liste med grupper innlogget brukers grupper. Merk at angitt bruker må være den samme som innlogget bruker - for å hindre datalekasje
     * @deprecated
     * HTTP GET /bruker/{id}/finnBrukersGrupper
     * Java method: no.systemfabrikken.lederplan.resources.bruker.BrukerRessurs.finnBrukersGrupper
     */
    finnBrukersGrupper(id: BrukerId, options?: RequestValg): RestResponse<MedlemsRolleIGruppeModell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`bruker/${id}/finnBrukersGrupper`, options: options });
    }

    /**
     * Oppdaterer brukerinfo. Bruker kan kun oppdateres av brukeren selv
     * HTTP POST /bruker/{id}/oppdater
     * Java method: no.systemfabrikken.lederplan.resources.bruker.BrukerRessurs.oppdaterV2
     */
    oppdaterV2(id: BrukerId, arg1: OppdaterBrukerSpesifikasjonV2, options?: RequestValg): RestResponse<BrukerModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`bruker/${id}/oppdater`, data: arg1, options: options });
    }

    /**
     * HTTP POST /bruker/{id}/oppdaterMeldingsinnstillinger
     * Java method: no.systemfabrikken.lederplan.resources.bruker.BrukerRessurs.oppdaterMeldingsinnstillinger
     */
    oppdaterMeldingsinnstillinger(id: BrukerId, arg1: MeldingsinnstillingerSpesifikasjon, options?: RequestValg): RestResponse<BrukerModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`bruker/${id}/oppdaterMeldingsinnstillinger`, data: arg1, options: options });
    }

    /**
     * Oppdaterer brukerindo. Bruker kan kun oppdateres av brukeren selv
     * HTTP POST /bruker/{id}/oppdaterSensitiveData
     * Java method: no.systemfabrikken.lederplan.resources.bruker.BrukerRessurs.oppdaterSensitiveData
     */
    oppdaterSensitiveData(id: BrukerId, arg1: OppdaterBrukerSensitivSpesifikasjon, options?: RequestValg): RestResponse<OppdatertSensitiveDataModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`bruker/${id}/oppdaterSensitiveData`, data: arg1, options: options });
    }

    /**
     * HTTP POST /bruker/{id}/validerBrukernavnOppdateresTil
     * Java method: no.systemfabrikken.lederplan.resources.bruker.BrukerRessurs.validerBrukernavnOppdateresTil
     */
    validerBrukernavnOppdateresTil(id: BrukerId, arg1: BrukernavnSomStrengModell, options?: RequestValg): RestResponse<BrukernavnValideringsresultat> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`bruker/${id}/validerBrukernavnOppdateresTil`, data: arg1, options: options });
    }

    /**
     * HTTP POST /bruker/{id}/validerEpostOppdateresTil
     * Java method: no.systemfabrikken.lederplan.resources.bruker.BrukerRessurs.validerEpostOppdateresTil
     */
    validerEpostOppdateresTil(id: BrukerId, arg1: EpostModell, options?: RequestValg): RestResponse<EpostValideringsresultat> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`bruker/${id}/validerEpostOppdateresTil`, data: arg1, options: options });
    }
}

/**
 * Håndterer autentisering mot criipto.id - dvs openid connect/oauth2 mot nordiske bankid leverandører.
@see CriiptoOpenidAutentisering
@see Autentiser Se også /dokumentasjon/integrasjoner/criipto.md
 */
export class CriiptoOIDCRessursClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * Autentiserer mot criipto vhja code mottatt fra gui. <pre> Code byttes mot openid claims som inneholder bla subject. Dersom vi ikke finner noen bruker med denne subject signaliserer vi til kaller at bruker må knyttes til subject. Knytning mellom bruker og subject etableres vhja {@link #bindAutentisertBruker} . Returnerer en respons populert med en {@link CriiptoAutentiseringsResponsModell} . </pre>
     * HTTP POST /autentisering/criipto/autentiser
     * Java method: no.systemfabrikken.lederplan.resources.autentisering.CriiptoOIDCRessurs.autentiser
     */
    autentiser(arg0: CriiptoTokenInnloggingsSpesifikasjon, options?: RequestValg): RestResponse<any> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`autentisering/criipto/autentiser`, data: arg0, options: options });
    }

    /**
     * Håndterer callback (redirect etter fullført criipto autentisering) fra criipto. Returnerer html som propagerer parameter til lederplan klientapplikasjonen. Merk at denne URLen må være registrert i criipto admin gui under "callback URLs"
     * HTTP GET /autentisering/criipto/autentisert
     * Java method: no.systemfabrikken.lederplan.resources.autentisering.CriiptoOIDCRessurs.autentisert
     */
    autentisert(queryParams?: { code?: string; state?: string; error?: string; }, options?: RequestValg): RestResponse<string> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`autentisering/criipto/autentisert`, queryParams: queryParams, options: options });
    }

    /**
     * Returnerer url til criipto gui
     * HTTP GET /autentisering/criipto/authorizeUrl/{guimodus}/{tilbyder}
     * Java method: no.systemfabrikken.lederplan.resources.autentisering.CriiptoOIDCRessurs.authorizeUrl
     */
    authorizeUrl(guimodus: number, tilbyder: number, queryParams?: { redirect?: boolean; loginHint?: string; }, options?: RequestValg): RestResponse<any> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`autentisering/criipto/authorizeUrl/${guimodus}/${tilbyder}`, queryParams: queryParams, options: options });
    }

    /**
     * Binder nåværende innlogget bruker til openid subject angitt i spesifikasjon. Fører til at bruker blir registrert innlogget med openid. Token benyttet for å autentisere denne requesten blir svartelistet, dermed forventer vi at klient ikke gjør samtidige kall da dette kan føre til at disse kallene blir avvist og klient da viser innloggingssiden.
     * HTTP PUT /autentisering/criipto/bindAutentisertBruker
     * Java method: no.systemfabrikken.lederplan.resources.autentisering.CriiptoOIDCRessurs.bindAutentisertBruker
     */
    bindAutentisertBruker(arg0: CriiptoBindBrukerSpesifikasjon, options?: RequestValg): RestResponse<any> {
        return this.httpClient.request({ method: 'PUT', url: uriEncoding`autentisering/criipto/bindAutentisertBruker`, data: arg0, options: options });
    }

    /**
     * Binder angitt bruker fra nytt passord-token innlogget bruker til openid subject angitt i spesifikasjon. Fører til at bruker blir registrert innlogget med openid. Token benyttet for å autentisere denne requesten blir svartelistet, dermed forventer vi at klient ikke gjør samtidige kall da dette kan føre til at disse kallene blir avvist og klient da viser innloggingssiden.
     * HTTP PUT /autentisering/criipto/bindIkkeAutentisertBrukerFraToken
     * Java method: no.systemfabrikken.lederplan.resources.autentisering.CriiptoOIDCRessurs.bindIkkeAutentisertBrukerFraToken
     */
    bindIkkeAutentisertBrukerFraToken(arg0: CriiptoBindFraTokenSpesifikasjon, options?: RequestValg): RestResponse<any> {
        return this.httpClient.request({ method: 'PUT', url: uriEncoding`autentisering/criipto/bindIkkeAutentisertBrukerFraToken`, data: arg0, options: options });
    }

    /**
     * HTTP POST /autentisering/criipto/deaktiverOpenIdBinding
     * Java method: no.systemfabrikken.lederplan.resources.autentisering.CriiptoOIDCRessurs.deaktiverOpenIdBinding
     */
    deaktiverOpenIdBinding(arg0: DeaktiverOpenIdBindingSpesifikasjon, options?: RequestValg): RestResponse<DeaktivertOpenIdBindingModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`autentisering/criipto/deaktiverOpenIdBinding`, data: arg0, options: options });
    }
}

/**
 * Tilgang til Dokumenter. Om du for testformål vil simulerer tregt nettverk kan du sette et breakpoint i while-løkken i {@link org.apache.commons.io.IOUtils#copyLarge(java.io.InputStream,java.io.OutputStream,byte[])} med Thread.sleep(100). (kalles via {@link Datastrømmer#kopierOgLukkKilde(java.io.InputStream,java.io.OutputStream)} )
 */
export class DokumentRessursClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * Strømmer dokument data til klient. Filnavn kan inkluderes i url slik at "save as"/nedlasting i nettleser skal benytte ønsket filnavn. Content-type i respons vil bli satt til angitt mimetype
     * HTTP GET /dokument/data/{dokumentVersjonId}/{mimetype}/{filnavn}
     * Java method: no.systemfabrikken.lederplan.resources.dokument.DokumentRessurs.versjondata
     */
    versjondata(dokumentVersjonId: DokumentVersjonId, mimetype: string, filnavn: string, options?: RequestValg): RestResponse<any> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`dokument/data/${dokumentVersjonId}/${mimetype}/${filnavn}`, options: options });
    }

    /**
     * HTTP GET /dokument/hentDokumentVersjon/{dokumentVersjonId}
     * Java method: no.systemfabrikken.lederplan.resources.dokument.DokumentRessurs.hentDokumentVersjon
     */
    hentDokumentVersjon(dokumentVersjonId: DokumentVersjonId, options?: RequestValg): RestResponse<DokumentVersjonModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`dokument/hentDokumentVersjon/${dokumentVersjonId}`, options: options });
    }

    /**
     * HTTP GET /dokument/hentDokumentversjon/dokumentannotering/{annoteringId}
     * Java method: no.systemfabrikken.lederplan.resources.dokument.DokumentRessurs.hentDokumentversjonBasertPåDokumentAnnotering
     */
    hentDokumentversjonBasertPåDokumentAnnotering(annoteringId: DokumentAnnoteringId, options?: RequestValg): RestResponse<DokumentVersjonModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`dokument/hentDokumentversjon/dokumentannotering/${annoteringId}`, options: options });
    }

    /**
     * HTTP GET /dokument/hentGjeldendeDokumentversjon/{dokumentId}
     * Java method: no.systemfabrikken.lederplan.resources.dokument.DokumentRessurs.hentGjeldendeDokumentversjon
     */
    hentGjeldendeDokumentversjon(dokumentId: DokumentId, options?: RequestValg): RestResponse<DokumentVersjonModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`dokument/hentGjeldendeDokumentversjon/${dokumentId}`, options: options });
    }

    /**
     * HTTP GET /dokument/hentGjeldendeSaksdokument/{dokumentId}
     * Java method: no.systemfabrikken.lederplan.resources.dokument.DokumentRessurs.hentGjeldendeSaksdokument
     */
    hentGjeldendeSaksdokument(dokumentId: DokumentId, options?: RequestValg): RestResponse<SaksdokumentModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`dokument/hentGjeldendeSaksdokument/${dokumentId}`, options: options });
    }

    /**
     * HTTP GET /dokument/hentSaksdokument/dokumentannotering/{annoteringId}
     * Java method: no.systemfabrikken.lederplan.resources.dokument.DokumentRessurs.hentSaksdokumentBasertPåDokumentAnnotering
     */
    hentSaksdokumentBasertPåDokumentAnnotering(annoteringId: DokumentAnnoteringId, options?: RequestValg): RestResponse<SaksdokumentModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`dokument/hentSaksdokument/dokumentannotering/${annoteringId}`, options: options });
    }

    /**
     * HTTP GET /dokument/{dokumentId}/protokolldokumentdetaljer
     * Java method: no.systemfabrikken.lederplan.resources.dokument.DokumentRessurs.hentProtokolldokumentdetaljer
     */
    hentProtokolldokumentdetaljer(dokumentId: DokumentId, options?: RequestValg): RestResponse<ProtokolldokumentISakModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`dokument/${dokumentId}/protokolldokumentdetaljer`, options: options });
    }

    /**
     * HTTP GET /dokument/{dokumentId}/skjerming
     * Java method: no.systemfabrikken.lederplan.resources.dokument.DokumentRessurs.hentSkjerming
     */
    hentSkjerming(dokumentId: DokumentId, options?: RequestValg): RestResponse<SkjermingDetaljerModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`dokument/${dokumentId}/skjerming`, options: options });
    }

    /**
     * HTTP POST /dokument/{dokumentId}/skjerming
     * Java method: no.systemfabrikken.lederplan.resources.dokument.DokumentRessurs.oppdaterSkjerming
     */
    oppdaterSkjerming(dokumentId: DokumentId, arg1: OppdaterSkjermingSpesifikasjon, options?: RequestValg): RestResponse<SkjermingDetaljerMedValideringsresultatModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`dokument/${dokumentId}/skjerming`, data: arg1, options: options });
    }

    /**
     * HTTP GET /dokument/{dokumentId}/versjoner
     * Java method: no.systemfabrikken.lederplan.resources.dokument.DokumentRessurs.hentVersjoner
     */
    hentVersjoner(dokumentId: DokumentId, options?: RequestValg): RestResponse<DokumentVersjonModell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`dokument/${dokumentId}/versjoner`, options: options });
    }

    /**
     * @deprecated
     * HTTP GET /dokument/{dokumentVersjonId}
     * Java method: no.systemfabrikken.lederplan.resources.dokument.DokumentRessurs.hent
     */
    hent(dokumentVersjonId: DokumentVersjonId, options?: RequestValg): RestResponse<SaksdokumentModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`dokument/${dokumentVersjonId}`, options: options });
    }

    /**
     * HTTP PUT /dokument/{dokumentVersjonId}/annotering
     * Java method: no.systemfabrikken.lederplan.resources.dokument.DokumentRessurs.registrerAnnotering
     */
    registrerAnnotering(dokumentVersjonId: DokumentVersjonId, arg1: NyDokumentAnnoteringSpesifikasjon, options?: RequestValg): RestResponse<DokumentAnnoteringModell> {
        return this.httpClient.request({ method: 'PUT', url: uriEncoding`dokument/${dokumentVersjonId}/annotering`, data: arg1, options: options });
    }

    /**
     * HTTP GET /dokument/{dokumentVersjonId}/annotering/{annoteringId}
     * Java method: no.systemfabrikken.lederplan.resources.dokument.DokumentRessurs.hentAnnotering
     */
    hentAnnotering(dokumentVersjonId: DokumentVersjonId, annoteringId: DokumentAnnoteringId, options?: RequestValg): RestResponse<DokumentAnnoteringModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`dokument/${dokumentVersjonId}/annotering/${annoteringId}`, options: options });
    }

    /**
     * HTTP DELETE /dokument/{dokumentVersjonId}/annotering/{annoteringId}
     * Java method: no.systemfabrikken.lederplan.resources.dokument.DokumentRessurs.slettAnnoteringer
     */
    slettAnnoteringer(dokumentVersjonId: DokumentVersjonId, annoteringId: DokumentAnnoteringId, options?: RequestValg): RestResponse<DokumentAnnoteringModell[]> {
        return this.httpClient.request({ method: 'DELETE', url: uriEncoding`dokument/${dokumentVersjonId}/annotering/${annoteringId}`, options: options });
    }

    /**
     * HTTP PUT /dokument/{dokumentVersjonId}/annotering/{annoteringId}/opprettKommentar
     * Java method: no.systemfabrikken.lederplan.resources.dokument.DokumentRessurs.opprettKommentar
     */
    opprettKommentar(dokumentVersjonId: DokumentVersjonId, annoteringId: DokumentAnnoteringId, arg2: OpprettKommentarSpesifikasjon, options?: RequestValg): RestResponse<KommentarModell> {
        return this.httpClient.request({ method: 'PUT', url: uriEncoding`dokument/${dokumentVersjonId}/annotering/${annoteringId}/opprettKommentar`, data: arg2, options: options });
    }

    /**
     * HTTP POST /dokument/{dokumentVersjonId}/annotering/{annoteringId}/privat
     * Java method: no.systemfabrikken.lederplan.resources.dokument.DokumentRessurs.privat
     */
    privat(dokumentVersjonId: DokumentVersjonId, annoteringId: DokumentAnnoteringId, arg2: EndrePrivatSpesifikasjon, options?: RequestValg): RestResponse<DokumentAnnoteringModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`dokument/${dokumentVersjonId}/annotering/${annoteringId}/privat`, data: arg2, options: options });
    }

    /**
     * HTTP GET /dokument/{dokumentVersjonId}/annoteringer
     * Java method: no.systemfabrikken.lederplan.resources.dokument.DokumentRessurs.annoteringer
     */
    annoteringer(dokumentVersjonId: DokumentVersjonId, options?: RequestValg): RestResponse<DokumentAnnoteringModell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`dokument/${dokumentVersjonId}/annoteringer`, options: options });
    }

    /**
     * HTTP GET /dokument/{dokumentVersjonId}/forside
     * Java method: no.systemfabrikken.lederplan.resources.dokument.DokumentRessurs.dokumentversjonforside
     */
    dokumentversjonforside(dokumentVersjonId: DokumentVersjonId, queryParams?: { format?: string; bredde?: number; hoyde?: number; }, options?: RequestValg): RestResponse<any> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`dokument/${dokumentVersjonId}/forside`, queryParams: queryParams, options: options });
    }
}

/**
 * Håndtering av dokumentsignering. Merk at signering av protokoll håndteres via {@link no.systemfabrikken.lederplan.resources.møte.ProtokollRessurs} . For dokumentasjon av flyten knyttet til criipto-signering se {@link CriiptoSignering} .
 */
export class DokumentsigneringRessursClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * Håndterer kall fra klient når bruker har signert dokument hos BankID WYSIWYS. Klient må først poll via {@link #bankidPdfSignertStatus} for å sjekke om signering er ferdig.
     * HTTP GET /dokument/signering/bankidPdfSignert
     * Java method: no.systemfabrikken.lederplan.resources.dokument.DokumentsigneringRessurs.bankidPdfSignert
     */
    bankidPdfSignert(queryParams?: { dokumentId?: DokumentId; signatarId?: SignatarId; sign_id?: string; }, options?: RequestValg): RestResponse<BankidSigneringStatusModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`dokument/signering/bankidPdfSignert`, queryParams: queryParams, options: options });
    }

    /**
     * Håndterer callback (redirect etter brukerns handling) fra bankid wysiwys. Skjer når brukeren klikker på Fortsett til Styreplan e.l. på signeringssiden hos BankID. Kan også skje om brukeren avbryter BankID-signeringsflyten og klikker på knapp for å gå tilbake til Styreplan. Vi er aldri garantert at denne redirecten kommer til oss. Returnerer html som propagerer parameter til lederplan klientapplikasjonen. Forventer at et gyldig jwt-token er angitt query parameter `token`, satt ved tidligere kall til {@link #signerUrl} .
     * HTTP GET /dokument/signering/bankidPdfSignertRedirect
     * Java method: no.systemfabrikken.lederplan.resources.dokument.DokumentsigneringRessurs.bankidPdfSignertRedirect
     */
    bankidPdfSignertRedirect(queryParams?: { dokumentId?: DokumentId; signatarId?: SignatarId; token?: string; sign_id?: string; error_code?: string; }, options?: RequestValg): RestResponse<string> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`dokument/signering/bankidPdfSignertRedirect`, queryParams: queryParams, options: options });
    }

    /**
     * Håndterer poll-kall fra klient for å sjekke hvor bruker er i signeringsflyt.
     * HTTP GET /dokument/signering/bankidPdfSignertStatus
     * Java method: no.systemfabrikken.lederplan.resources.dokument.DokumentsigneringRessurs.bankidPdfSigneringStatus
     */
    bankidPdfSigneringStatus(queryParams?: { dokumentId?: DokumentId; signatarId?: SignatarId; sign_id?: string; }, options?: RequestValg): RestResponse<BankidSigneringStatusModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`dokument/signering/bankidPdfSignertStatus`, queryParams: queryParams, options: options });
    }

    /**
     * Finner dokumenter som kallende bruker skal signere
     * HTTP GET /dokument/signering/finnDokumenterBrukerIkkeHarSignert
     * Java method: no.systemfabrikken.lederplan.resources.dokument.DokumentsigneringRessurs.finnDokumenterBrukerIkkeHarSignert
     */
    finnDokumenterBrukerIkkeHarSignert(options?: RequestValg): RestResponse<DokumenterTilSigneringModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`dokument/signering/finnDokumenterBrukerIkkeHarSignert`, options: options });
    }

    /**
     * Finner dokumenter som mangler signaturer, uavhengig av hvorvidt kallende bruker skal signere
     * HTTP GET /dokument/signering/finnDokumenterSomManglerSignaturer
     * Java method: no.systemfabrikken.lederplan.resources.dokument.DokumentsigneringRessurs.finnDokumenterSomManglerSignaturer
     */
    finnDokumenterSomManglerSignaturer(options?: RequestValg): RestResponse<DokumenterTilSigneringModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`dokument/signering/finnDokumenterSomManglerSignaturer`, options: options });
    }

    /**
     * Håndterer callback (redirect etter FULLFØRT criipto PDF signering) fra criipto. Returnerer html som propagerer parameter til lederplan klientapplikasjonen. Merk at denne URLen må være registrert i criipto admin gui under "callback  URLs." Forventer at et gyldig jwt-token er angitt query parameter `token`, satt ved tidligere kall til {@link #signerUrl} .
     * HTTP POST /dokument/signering/pdfSignert
     * Java method: no.systemfabrikken.lederplan.resources.dokument.DokumentsigneringRessurs.pdfSignert
     */
    pdfSignert(queryParams?: { dokumentId?: DokumentId; signatarId?: SignatarId; token?: string; }, options?: RequestValg): RestResponse<string> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`dokument/signering/pdfSignert`, queryParams: queryParams, options: options });
    }

    /**
     * Håndterer callback (redirect etter FEILET criipto PDF signering) fra criipto. Returnerer html som propagerer parameter til lederplan klientapplikasjonen. Merk at denne URLen må være registrert i criipto admin gui under "callback  URLs." MERK at vi IKKE forventer noe jwt-token, dvs at dette endepunktet er åpent for alle. Dette anses som OK da vi ikke laster data eller på annet vis eksponerer kundes data her.
     * HTTP GET /dokument/signering/pdfSignert
     * Java method: no.systemfabrikken.lederplan.resources.dokument.DokumentsigneringRessurs.pdfSignertFeilet
     */
    pdfSignertFeilet(queryParams?: { dokumentId?: DokumentId; signatarId?: SignatarId; error?: string; error_description?: string; }, options?: RequestValg): RestResponse<string> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`dokument/signering/pdfSignert`, queryParams: queryParams, options: options });
    }

    /**
     * Håndterer callback (redirect etter FULLFØRT criipto TEKST signering) fra criipto. Returnerer html som propagerer parameter til lederplan klientapplikasjonen. Merk at denne URLen må være registrert i criipto admin gui under "callback  URLs." Forventer at et gyldig jwt-token er angitt query parameter `token`, satt ved tidligere kall til {@link #signerUrl} .
     * HTTP POST /dokument/signering/tekstSignert
     * Java method: no.systemfabrikken.lederplan.resources.dokument.DokumentsigneringRessurs.tekstSignert
     */
    tekstSignert(queryParams?: { dokumentId?: DokumentId; signatarId?: SignatarId; token?: string; }, options?: RequestValg): RestResponse<string> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`dokument/signering/tekstSignert`, queryParams: queryParams, options: options });
    }

    /**
     * Håndterer callback (redirect etter FEILET criipto signering) fra criipto. Returnerer html som propagerer parameter til lederplan klientapplikasjonen. Merk at denne URLen må være registrert i criipto admin gui under "callback  URLs." MERK at vi IKKE forventer noe jwt-token, dvs at dette endepunktet er åpent for alle. Dette anses som OK da vi ikke laster data eller på annet vis eksponerer kundes data her.
     * HTTP GET /dokument/signering/tekstSignert
     * Java method: no.systemfabrikken.lederplan.resources.dokument.DokumentsigneringRessurs.tekstSignertFeilet
     */
    tekstSignertFeilet(queryParams?: { dokumentId?: DokumentId; signatarId?: SignatarId; error?: string; error_description?: string; }, options?: RequestValg): RestResponse<string> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`dokument/signering/tekstSignert`, queryParams: queryParams, options: options });
    }

    /**
     * Låser opp dokument sendt til signering og setter gjeldende versjon til versjonen satt som {@link Signering#dokumentversjonTilSignering} . Merk at eventuelle registrerte signaturer vil bli slettet.
     * HTTP POST /dokument/signering/{dokumentId}/laasOpp
     * Java method: no.systemfabrikken.lederplan.resources.dokument.DokumentsigneringRessurs.låsOpp
     */
    låsOpp(dokumentId: DokumentId, arg1: LåsOppSigneringSpesifikasjon, options?: RequestValg): RestResponse<OkRespons> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`dokument/signering/${dokumentId}/laasOpp`, data: arg1, options: options });
    }

    /**
     * Sletter signatarer som ikke har signert og sørger for at dokument blir markert som ferdig signert og konvoluttert.
     * HTTP POST /dokument/signering/{dokumentId}/markerSomFerdigSignert
     * Java method: no.systemfabrikken.lederplan.resources.dokument.DokumentsigneringRessurs.markerSomFerdigSignert
     */
    markerSomFerdigSignert(dokumentId: DokumentId, options?: RequestValg): RestResponse<DokumentTilSigneringModell<DokumentVersjonModell>> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`dokument/signering/${dokumentId}/markerSomFerdigSignert`, options: options });
    }

    /**
     * Markerer at angitt dokument er åpnet/lest av kallende bruker.
     * HTTP POST /dokument/signering/{dokumentId}/markerSomLest
     * Java method: no.systemfabrikken.lederplan.resources.dokument.DokumentsigneringRessurs.markerSomLest
     */
    markerSomLest(dokumentId: DokumentId, options?: RequestValg): RestResponse<OkRespons> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`dokument/signering/${dokumentId}/markerSomLest`, options: options });
    }

    /**
     * Oppdaterer signatarer.
@return  valideringsfeil av typen {@link SignatarValideringsfeil}
     * HTTP POST /dokument/signering/{dokumentId}/oppdaterSignatarer
     * Java method: no.systemfabrikken.lederplan.resources.dokument.DokumentsigneringRessurs.oppdaterSignatarer
     */
    oppdaterSignatarer(dokumentId: DokumentId, arg1: OppdaterSignatarerSpesifikasjon, options?: RequestValg): RestResponse<ValideringsresultatModell<SignatarValideringsfeil>> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`dokument/signering/${dokumentId}/oppdaterSignatarer`, data: arg1, options: options });
    }

    /**
     * Sender epost med otp for signering. Påfølgende kall til {@link #signerMedOtp} vil markere epostadressen som bekreftet dersom det ikke allerede er bekreftet.
     * HTTP POST /dokument/signering/{dokumentId}/sendEpostOtp
     * Java method: no.systemfabrikken.lederplan.resources.dokument.DokumentsigneringRessurs.sendEpostOtp
     */
    sendEpostOtp(dokumentId: DokumentId, options?: RequestValg): RestResponse<SigneringOtpSendtModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`dokument/signering/${dokumentId}/sendEpostOtp`, options: options });
    }

    /**
     * HTTP POST /dokument/signering/{dokumentId}/sendPurring
     * Java method: no.systemfabrikken.lederplan.resources.dokument.DokumentsigneringRessurs.sendPurring
     */
    sendPurring(dokumentId: DokumentId, arg1: SendPurringSpesifikasjon, options?: RequestValg): RestResponse<AntallMeldingerSendtRespons> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`dokument/signering/${dokumentId}/sendPurring`, data: arg1, options: options });
    }

    /**
     * Sender sms med otp for signering. Dersom bruker ikke har satt mobilnummer fra før kan vedkommende angi dette samt passord i dette kallet og dermed få mobilnummer satt. Påfølgende kall til {@link #signerMedOtp} vil markere mobilnummeret som bekreftet dersom det ikke allerede er bekreftet.
     * HTTP POST /dokument/signering/{dokumentId}/sendSmsOtp
     * Java method: no.systemfabrikken.lederplan.resources.dokument.DokumentsigneringRessurs.sendSmsOtp
     */
    sendSmsOtp(dokumentId: DokumentId, arg1: SendSmsOtpSigneringSpesifikasjon, options?: RequestValg): RestResponse<SigneringOtpSendtModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`dokument/signering/${dokumentId}/sendSmsOtp`, data: arg1, options: options });
    }

    /**
     * Sender dokument til signering.
@return  valideringsfeil av typen {@link SignatarValideringsfeil}
     * HTTP POST /dokument/signering/{dokumentId}/sendTilSignering
     * Java method: no.systemfabrikken.lederplan.resources.dokument.DokumentsigneringRessurs.sendTilSignering
     */
    sendTilSignering(dokumentId: DokumentId, arg1: SendTilSigneringSpesifikasjon, options?: RequestValg): RestResponse<ValideringsresultatModell<SignatarValideringsfeil>> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`dokument/signering/${dokumentId}/sendTilSignering`, data: arg1, options: options });
    }

    /**
     * HTTP GET /dokument/signering/{dokumentId}/signatarer
     * Java method: no.systemfabrikken.lederplan.resources.dokument.DokumentsigneringRessurs.signatarer
     */
    signatarer(dokumentId: DokumentId, options?: RequestValg): RestResponse<DokumentSignatarerModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`dokument/signering/${dokumentId}/signatarer`, options: options });
    }

    /**
     * Returnerer DokumentSignatarModell for innlogget bruker for angitt dokument. Returnerer tom optional (som oversettes til 404 respons) dersom bruker ikke er registrert som signatar.
     * HTTP GET /dokument/signering/{dokumentId}/signatarinformasjonForAktivBruker
     * Java method: no.systemfabrikken.lederplan.resources.dokument.DokumentsigneringRessurs.signatarinformasjonForAktivBruker
     */
    signatarinformasjonForAktivBruker(dokumentId: DokumentId, options?: RequestValg): RestResponse<PotensiellDokumentSignatarModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`dokument/signering/${dokumentId}/signatarinformasjonForAktivBruker`, options: options });
    }

    /**
     * Håndterer validering av otp sendt per epost eller sms samt markering av dokument som signert. Dersom kanal er epost og brukers epost ikke er bekreftet vil dette kallet markere epostadressen som bekreftet. Dersom kanal er sms og brukers mobilnummer ikke er bekreftet vil dette kallet markere mobilnummeret som bekreftet.
     * HTTP POST /dokument/signering/{dokumentId}/signerMedOtp
     * Java method: no.systemfabrikken.lederplan.resources.dokument.DokumentsigneringRessurs.signerMedOtp
     */
    signerMedOtp(dokumentId: DokumentId, arg1: OtpSigneringSpesifikasjon, options?: RequestValg): RestResponse<OtpSigneringValideringResponsModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`dokument/signering/${dokumentId}/signerMedOtp`, data: arg1, options: options });
    }

    /**
     * Håndterer validering av sms otp samt markering av dokument som signert. Dersom brukers mobilnummer ikke er bekreftet vil dette kallet markere mobilnummeret som bekreftet.
     * @deprecated
     * HTTP POST /dokument/signering/{dokumentId}/signerMedSmsOtp
     * Java method: no.systemfabrikken.lederplan.resources.dokument.DokumentsigneringRessurs.signerMedSmsOtp
     */
    signerMedSmsOtp(dokumentId: DokumentId, arg1: SmsOtpSigneringSpesifikasjon, options?: RequestValg): RestResponse<OtpSigneringValideringResponsModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`dokument/signering/${dokumentId}/signerMedSmsOtp`, data: arg1, options: options });
    }

    /**
     * Returnerer url til criipto gui for signering
     * HTTP GET /dokument/signering/{dokumentId}/signerUrl/{metode}
     * Java method: no.systemfabrikken.lederplan.resources.dokument.DokumentsigneringRessurs.signerUrl
     */
    signerUrl(dokumentId: DokumentId, metode: number, queryParams?: { redirect?: boolean; }, options?: RequestValg): RestResponse<any> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`dokument/signering/${dokumentId}/signerUrl/${metode}`, queryParams: queryParams, options: options });
    }
}

export class FavorittRessursClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * HTTP GET /favoritt/brukers
     * Java method: no.systemfabrikken.lederplan.resources.favoritt.FavorittRessurs.brukersFavoritter
     */
    brukersFavoritter(options?: RequestValg): RestResponse<FavorittModell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`favoritt/brukers`, options: options });
    }

    /**
     * HTTP PUT /favoritt/{type}/{id}
     * Java method: no.systemfabrikken.lederplan.resources.favoritt.FavorittRessurs.markerSomFavoritt
     */
    markerSomFavoritt(type: FavorittType, id: string, options?: RequestValg): RestResponse<TynnFavorittModell[]> {
        return this.httpClient.request({ method: 'PUT', url: uriEncoding`favoritt/${type}/${id}`, options: options });
    }

    /**
     * HTTP DELETE /favoritt/{type}/{id}
     * Java method: no.systemfabrikken.lederplan.resources.favoritt.FavorittRessurs.slettSomFavoritt
     */
    slettSomFavoritt(type: FavorittType, id: string, options?: RequestValg): RestResponse<TynnFavorittModell[]> {
        return this.httpClient.request({ method: 'DELETE', url: uriEncoding`favoritt/${type}/${id}`, options: options });
    }
}

export class FellesAutentiseringRessursClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * Resetter passord for bruker i lederplan. Returnerer alltid status 200 selvom bruker ikke finnes, skal ikke kunne brukes til å sjekke om e-post brukernavn finnes.
     * HTTP POST /fellesautentisering/onskerNyttPassord
     * Java method: no.systemfabrikken.lederplan.resources.autentisering.FellesAutentiseringRessurs.ønskerNyttPassord
     */
    ønskerNyttPassord(arg0: ResetPassordSpesifikasjon, options?: RequestValg): RestResponse<PassordResetResponsModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`fellesautentisering/onskerNyttPassord`, data: arg0, options: options });
    }

    /**
     * True dersom angitt token er knyttet til en bruker der minst en av de tilknyttede gruppene KREVER eid.
     * HTTP GET /fellesautentisering/resettokenKreverEid/{resettoken}
     * Java method: no.systemfabrikken.lederplan.resources.autentisering.FellesAutentiseringRessurs.resettokenKreverEid
     */
    resettokenKreverEid(resettoken: string, options?: RequestValg): RestResponse<KreverEidModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`fellesautentisering/resettokenKreverEid/${resettoken}`, options: options });
    }
}

export class GruppeInvitasjonRessursClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * HTTP PUT /gruppeinvitasjon
     * Java method: no.systemfabrikken.lederplan.resources.gruppe.GruppeInvitasjonRessurs.inviterNyttMedlem
     */
    inviterNyttMedlem(arg0: OpprettGruppeInvitasjonSpesifikasjon, options?: RequestValg): RestResponse<GruppeMedlemModell> {
        return this.httpClient.request({ method: 'PUT', url: uriEncoding`gruppeinvitasjon`, data: arg0, options: options });
    }

    /**
     * Returnerer {@link GruppeInvitasjonStatusModell} , returnerer 404 dersom invitasjon ikke funnet.
     * HTTP GET /gruppeinvitasjon/finnInvitasjon/{token}
     * Java method: no.systemfabrikken.lederplan.resources.gruppe.GruppeInvitasjonRessurs.finnInvitasjonFraToken
     */
    finnInvitasjonFraToken(token: TidsstempletEngangstoken, queryParams?: { medlemId?: MedlemId; }, options?: RequestValg): RestResponse<any> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`gruppeinvitasjon/finnInvitasjon/${token}`, queryParams: queryParams, options: options });
    }

    /**
     * Returnerer alle invitasjoner med status {@link Invitasjon.Invitasjonsstatus#sendt} tilknyttet innlogget bruker. Dvs invitasjoner registrert på samme epostadresse som innloget bruker. Dersom brukers epostadresse ikke er godkjent vil ingen invitasjoner returneres.
     * HTTP GET /gruppeinvitasjon/finnInvitasjonerTilGodkjenning
     * Java method: no.systemfabrikken.lederplan.resources.gruppe.GruppeInvitasjonRessurs.finnInvitasjonerTilGodkjenning
     */
    finnInvitasjonerTilGodkjenning(options?: RequestValg): RestResponse<GruppeInvitasjonTilGodkjenningModell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`gruppeinvitasjon/finnInvitasjonerTilGodkjenning`, options: options });
    }

    /**
     * Returnerer alle invitasjoner med status {@link Invitasjon.Invitasjonsstatus#sendt} tilknyttet innlogget bruker
     * @deprecated
     * HTTP GET /gruppeinvitasjon/finnInvitasjonerTilGrupper
     * Java method: no.systemfabrikken.lederplan.resources.gruppe.GruppeInvitasjonRessurs.finnInvitasjonerTilGrupper
     */
    finnInvitasjonerTilGrupper(options?: RequestValg): RestResponse<UtvidetGruppeInvitasjonModell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`gruppeinvitasjon/finnInvitasjonerTilGrupper`, options: options });
    }

    /**
     * Ny bruker aksepterer invitasjon. Vi oppretter ny bruker og binder denne til gruppe-medlemmet.
     * HTTP PUT /gruppeinvitasjon/godtaInvitasjonTilNyBruker
     * Java method: no.systemfabrikken.lederplan.resources.gruppe.GruppeInvitasjonRessurs.godtaInvitasjonTilNyBruker
     */
    godtaInvitasjonTilNyBruker(arg0: GodtaInvitasjonTilNyBrukerSpesifikasjon, options?: RequestValg): RestResponse<any> {
        return this.httpClient.request({ method: 'PUT', url: uriEncoding`gruppeinvitasjon/godtaInvitasjonTilNyBruker`, data: arg0, options: options });
    }

    /**
     * Ny bruker aksepterer invitasjon. Vi oppretter ny bruker og binder denne til gruppe-medlemmet.
     * HTTP PUT /gruppeinvitasjon/godtaInvitasjonTilNyBrukerFraSubject
     * Java method: no.systemfabrikken.lederplan.resources.gruppe.GruppeInvitasjonRessurs.godtaInvitasjonTilNyBrukerFraSubject
     */
    godtaInvitasjonTilNyBrukerFraSubject(arg0: GodtaInvitasjonFraOpenidSubjectSpesifikasjon, options?: RequestValg): RestResponse<any> {
        return this.httpClient.request({ method: 'PUT', url: uriEncoding`gruppeinvitasjon/godtaInvitasjonTilNyBrukerFraSubject`, data: arg0, options: options });
    }

    /**
     * HTTP PUT /gruppeinvitasjon/invitasjoner
     * Java method: no.systemfabrikken.lederplan.resources.gruppe.GruppeInvitasjonRessurs.inviterNyeMedlemmer
     */
    inviterNyeMedlemmer(arg0: GruppeInvitasjonSpesifikasjoner, options?: RequestValg): RestResponse<GruppeModell> {
        return this.httpClient.request({ method: 'PUT', url: uriEncoding`gruppeinvitasjon/invitasjoner`, data: arg0, options: options });
    }

    /**
     * HTTP POST /gruppeinvitasjon/sendInvitasjon/{medlemId}
     * Java method: no.systemfabrikken.lederplan.resources.gruppe.GruppeInvitasjonRessurs.sendInvitasjon
     */
    sendInvitasjon(medlemId: MedlemId, options?: RequestValg): RestResponse<GruppeMedlemModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`gruppeinvitasjon/sendInvitasjon/${medlemId}`, options: options });
    }

    /**
     * Sender invitasjons-otp, returnerer 404 dersom invitasjon ikke funnet eller otp ikke kreves, ellers {@link InvitasjonOtpSendtModell} . Setter Cross-Site Request Forgery cookie
     * HTTP POST /gruppeinvitasjon/sendOtp/{token}
     * Java method: no.systemfabrikken.lederplan.resources.gruppe.GruppeInvitasjonRessurs.sendOtp
     */
    sendOtp(token: TidsstempletEngangstoken, options?: RequestValg): RestResponse<any> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`gruppeinvitasjon/sendOtp/${token}`, options: options });
    }

    /**
     * Validerer invitasjons-otp, returnerer 404 dersom invitasjon ikke funnet eller otp ikke kreves, ellers {@link GruppeInvitasjonTilGodkjenningModell}
     * HTTP POST /gruppeinvitasjon/validerOtp/{token}
     * Java method: no.systemfabrikken.lederplan.resources.gruppe.GruppeInvitasjonRessurs.validerOtp
     */
    validerOtp(token: TidsstempletEngangstoken, arg1: InvitasjonValiderOtpSpesifikasjon, options?: RequestValg): RestResponse<any> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`gruppeinvitasjon/validerOtp/${token}`, data: arg1, options: options });
    }

    /**
     * Returnerer forespurt invitasjon. Kaster exception dersom kallende brukers epost ikke er bekreftet eller invitasjon.epost != kallende-bruker.epost
     * HTTP GET /gruppeinvitasjon/{id}
     * Java method: no.systemfabrikken.lederplan.resources.gruppe.GruppeInvitasjonRessurs.hent
     */
    hent(id: MedlemId, options?: RequestValg): RestResponse<GruppeInvitasjonTilGodkjenningModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`gruppeinvitasjon/${id}`, options: options });
    }

    /**
     * HTTP POST /gruppeinvitasjon/{medlemId}
     * Java method: no.systemfabrikken.lederplan.resources.gruppe.GruppeInvitasjonRessurs.oppdaterInvitasjon
     */
    oppdaterInvitasjon(medlemId: MedlemId, arg1: RedigerGruppeInvitasjonSpesifikasjon, options?: RequestValg): RestResponse<GruppeMedlemModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`gruppeinvitasjon/${medlemId}`, data: arg1, options: options });
    }

    /**
     * Sletter invitasjon, kaster exception dersom invitasjonen ikke er slettbar, se {@link Medlem#kanSlettes} Bruk heller {@link #slettEllerAnonymiser}
     * HTTP DELETE /gruppeinvitasjon/{medlemId}
     * Java method: no.systemfabrikken.lederplan.resources.gruppe.GruppeInvitasjonRessurs.slett
     */
    slett(medlemId: MedlemId, options?: RequestValg): RestResponse<OkRespons> {
        return this.httpClient.request({ method: 'DELETE', url: uriEncoding`gruppeinvitasjon/${medlemId}`, options: options });
    }

    /**
     * Eksisterende bruker avslår invitasjon. Vi setter status som avslått.
     * HTTP PUT /gruppeinvitasjon/{medlemId}/avslaaInvitasjonSomEksisterendeBruker
     * Java method: no.systemfabrikken.lederplan.resources.gruppe.GruppeInvitasjonRessurs.avslåInvitasjonSomEksisterendeBruker
     */
    avslåInvitasjonSomEksisterendeBruker(medlemId: MedlemId, options?: RequestValg): RestResponse<OkRespons> {
        return this.httpClient.request({ method: 'PUT', url: uriEncoding`gruppeinvitasjon/${medlemId}/avslaaInvitasjonSomEksisterendeBruker`, options: options });
    }

    /**
     * Eksisterende bruker aksepterer invitasjon. Vi binder den eksisterende brukeren til gruppe-medlemmet i invitasjonen. Epostadresse i invitasjon MÅ være identisk med info registrert på bruker, og bruker må ha validert epost-adressen sin. Benyttes i flyt initiert via knapp i gui i listing av invitasjoner sendt til innlogget bruker.
     * HTTP PUT /gruppeinvitasjon/{medlemId}/godtaInvitasjonSomEksisterendeBruker
     * Java method: no.systemfabrikken.lederplan.resources.gruppe.GruppeInvitasjonRessurs.godtaInvitasjonSomEksisterendeBruker
     */
    godtaInvitasjonSomEksisterendeBruker(medlemId: MedlemId, arg1: GodtaInvitasjonTilEksisterendeBrukerSpesifikasjon, options?: RequestValg): RestResponse<GruppeInvitasjonTilGodkjenningModell> {
        return this.httpClient.request({ method: 'PUT', url: uriEncoding`gruppeinvitasjon/${medlemId}/godtaInvitasjonSomEksisterendeBruker`, data: arg1, options: options });
    }

    /**
     * bruk heller slettEllerAnonymiser
@todo må fjernes fra bruk i mobilklienten
     * @deprecated
     * HTTP GET /gruppeinvitasjon/{medlemId}/kanSlettes
     * Java method: no.systemfabrikken.lederplan.resources.gruppe.GruppeInvitasjonRessurs.kanSlettes
     */
    kanSlettes(medlemId: MedlemId, options?: RequestValg): RestResponse<KanSlettesModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`gruppeinvitasjon/${medlemId}/kanSlettes`, options: options });
    }

    /**
     * Sender invitasjons-otp når eksisterende bruker aksepterer invitasjon, returnerer 404 dersom otp ikke kreves. Benyttes i flyt initiert via knapp i gui i listing av invitasjoner sendt til innlogget bruker. Returnerer {@link InvitasjonOtpSendtModell}
     * HTTP POST /gruppeinvitasjon/{medlemId}/sendOtpTilInnloggetBruker
     * Java method: no.systemfabrikken.lederplan.resources.gruppe.GruppeInvitasjonRessurs.sendOtpTilInnloggetBruker
     */
    sendOtpTilInnloggetBruker(medlemId: MedlemId, options?: RequestValg): RestResponse<any> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`gruppeinvitasjon/${medlemId}/sendOtpTilInnloggetBruker`, options: options });
    }

    /**
     * HTTP POST /gruppeinvitasjon/{medlemId}/slettEllerAnonymiser
     * Java method: no.systemfabrikken.lederplan.resources.gruppe.GruppeInvitasjonRessurs.slettEllerAnonymiser
     */
    slettEllerAnonymiser(medlemId: MedlemId, arg1: InvitasjonSlettSpesifikasjon, options?: RequestValg): RestResponse<InvitasjonSlettetRespons> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`gruppeinvitasjon/${medlemId}/slettEllerAnonymiser`, data: arg1, options: options });
    }

    /**
     * Eksisterende bruker aksepterer invitasjon via token. Vi binder den eksisterende brukeren til gruppe-medlemmet i invitasjonen. Epostadresse i invitasjon trenger IKKE å være identisk med info registrert på bruker. Benyttes i flyt initiert via lenke med token i epost.
     * HTTP PUT /gruppeinvitasjon/{token}/godtaInvitasjonFraTokenSomEksisterendeBruker
     * Java method: no.systemfabrikken.lederplan.resources.gruppe.GruppeInvitasjonRessurs.godtaInvitasjonFraTokenSomEksisterendeBruker
     */
    godtaInvitasjonFraTokenSomEksisterendeBruker(token: TidsstempletEngangstoken, arg1: GodtaInvitasjonTilEksisterendeBrukerSpesifikasjon, options?: RequestValg): RestResponse<any> {
        return this.httpClient.request({ method: 'PUT', url: uriEncoding`gruppeinvitasjon/${token}/godtaInvitasjonFraTokenSomEksisterendeBruker`, data: arg1, options: options });
    }
}

export class GruppeMedlemRessursClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * HTTP GET /medlem/{medlemId}
     * Java method: no.systemfabrikken.lederplan.resources.gruppe.GruppeMedlemRessurs.hent
     */
    hent(medlemId: MedlemId, options?: RequestValg): RestResponse<GruppeMedlemModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`medlem/${medlemId}`, options: options });
    }

    /**
     * HTTP POST /medlem/{medlemId}
     * Java method: no.systemfabrikken.lederplan.resources.gruppe.GruppeMedlemRessurs.oppdater
     */
    oppdater(medlemId: MedlemId, arg1: OppdaterMedlemSpesifikasjon, options?: RequestValg): RestResponse<GruppeMedlemModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`medlem/${medlemId}`, data: arg1, options: options });
    }

    /**
     * HTTP POST /medlem/{medlemId}/aapneTilgang
     * Java method: no.systemfabrikken.lederplan.resources.gruppe.GruppeMedlemRessurs.åpneTilgang
     */
    åpneTilgang(medlemId: MedlemId, arg1: MedlemÅpneTilgangSpesifikasjon, options?: RequestValg): RestResponse<GruppeMedlemModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`medlem/${medlemId}/aapneTilgang`, data: arg1, options: options });
    }

    /**
     * HTTP POST /medlem/{medlemId}/anonymiser
     * Java method: no.systemfabrikken.lederplan.resources.gruppe.GruppeMedlemRessurs.anonymiser
     */
    anonymiser(medlemId: MedlemId, arg1: MedlemAnonymiserSpesifikasjon, options?: RequestValg): RestResponse<GruppeMedlemModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`medlem/${medlemId}/anonymiser`, data: arg1, options: options });
    }

    /**
     * HTTP GET /medlem/{medlemId}/assosiasjoner
     * Java method: no.systemfabrikken.lederplan.resources.gruppe.GruppeMedlemRessurs.assosiasjoner
     */
    assosiasjoner(medlemId: MedlemId, options?: RequestValg): RestResponse<MedlemAssosiasjonerModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`medlem/${medlemId}/assosiasjoner`, options: options });
    }

    /**
     * Returnerer medlemmets avatar-bilde. Merk at avtarId er tatt med for å gjøre URLen unik slik at den kan cashes aggressivt.
     * HTTP GET /medlem/{medlemId}/avatar/{avatarId}.jpg
     * Java method: no.systemfabrikken.lederplan.resources.gruppe.GruppeMedlemRessurs.avatar
     */
    avatar(medlemId: MedlemId, avatarId: BinærdataId, options?: RequestValg): RestResponse<any> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`medlem/${medlemId}/avatar/${avatarId}.jpg`, options: options });
    }

    /**
     * HTTP POST /medlem/{medlemId}/fjernTilgang
     * Java method: no.systemfabrikken.lederplan.resources.gruppe.GruppeMedlemRessurs.fjernTilgang
     */
    fjernTilgang(medlemId: MedlemId, arg1: MedlemStengTilgangSpesifikasjon, options?: RequestValg): RestResponse<GruppeMedlemModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`medlem/${medlemId}/fjernTilgang`, data: arg1, options: options });
    }

    /**
     * HTTP POST /medlem/{medlemId}/oppdaterAvatar
     * Java method: no.systemfabrikken.lederplan.resources.gruppe.GruppeMedlemRessurs.oppdaterAvatar
     */
    oppdaterAvatar(medlemId: MedlemId, arg1: any, options?: RequestValg): RestResponse<EntitetIdRespons> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`medlem/${medlemId}/oppdaterAvatar`, data: arg1, options: options });
    }

    /**
     * @deprecated
     * HTTP POST /medlem/{medlemId}/oppdaterTilgang
     * Java method: no.systemfabrikken.lederplan.resources.gruppe.GruppeMedlemRessurs.oppdaterTilgang
     */
    oppdaterTilgang(medlemId: MedlemId, arg1: OppdaterMedlemTilgangSpesifikasjon, options?: RequestValg): RestResponse<GruppeMedlemModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`medlem/${medlemId}/oppdaterTilgang`, data: arg1, options: options });
    }
}

export class GruppeRessursClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * HTTP GET /gruppe/finnAlle
     * Java method: no.systemfabrikken.lederplan.resources.gruppe.GruppeRessurs.finnAlle
     */
    finnAlle(options?: RequestValg): RestResponse<AdminEnkelGruppeModell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`gruppe/finnAlle`, options: options });
    }

    /**
     * HTTP GET /gruppe/finnMalgrupper
     * Java method: no.systemfabrikken.lederplan.resources.gruppe.GruppeRessurs.finnMalgrupper
     */
    finnMalgrupper(options?: RequestValg): RestResponse<EnkelGruppeModell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`gruppe/finnMalgrupper`, options: options });
    }

    /**
     * Returnerer alle grupper der kallende bruker er medlem og medlemskapet har {@link Medlem#harTilgang()} == sann. Merk at grupper bruker er invitert til ikke inngår. For grupper bruker er inviter til se {@link GruppeInvitasjonRessurs#finnInvitasjonerTilGrupper()}
     * HTTP GET /gruppe/finnTilgjengeligeGrupper
     * Java method: no.systemfabrikken.lederplan.resources.gruppe.GruppeRessurs.finnTilgjengeligeGrupper
     */
    finnTilgjengeligeGrupper(options?: RequestValg): RestResponse<GruppeModell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`gruppe/finnTilgjengeligeGrupper`, options: options });
    }

    /**
     * HTTP GET /gruppe/gruppeAggregaterForAvtale/{avtaleId}
     * Java method: no.systemfabrikken.lederplan.resources.gruppe.GruppeRessurs.gruppeAggregaterForAvtale
     */
    gruppeAggregaterForAvtale(avtaleId: AvtaleId, options?: RequestValg): RestResponse<GrupperAggreatModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`gruppe/gruppeAggregaterForAvtale/${avtaleId}`, options: options });
    }

    /**
     * HTTP PUT /gruppe/opprettAvtaleOgGruppeMedInnloggetBruker
     * Java method: no.systemfabrikken.lederplan.resources.gruppe.GruppeRessurs.opprettAvtaleOgGruppeMedInnloggetBruker
     */
    opprettAvtaleOgGruppeMedInnloggetBruker(arg0: NyAvtaleOgGruppeSpesifikasjon, options?: RequestValg): RestResponse<GruppeModell> {
        return this.httpClient.request({ method: 'PUT', url: uriEncoding`gruppe/opprettAvtaleOgGruppeMedInnloggetBruker`, data: arg0, options: options });
    }

    /**
     * HTTP PUT /gruppe/opprettGruppeMedInnloggetBruker
     * Java method: no.systemfabrikken.lederplan.resources.gruppe.GruppeRessurs.opprettGruppeMedInnloggetBruker
     */
    opprettGruppeMedInnloggetBruker(arg0: NyGruppeSpesifikasjon, options?: RequestValg): RestResponse<GruppeModell> {
        return this.httpClient.request({ method: 'PUT', url: uriEncoding`gruppe/opprettGruppeMedInnloggetBruker`, data: arg0, options: options });
    }

    /**
     * HTTP PUT /gruppe/opprettGruppeOgBruker
     * Java method: no.systemfabrikken.lederplan.resources.gruppe.GruppeRessurs.opprettGruppeOgBruker
     */
    opprettGruppeOgBruker(arg0: NyBrukerOgAvtaleOgGruppeSpesifikasjon, options?: RequestValg): RestResponse<any> {
        return this.httpClient.request({ method: 'PUT', url: uriEncoding`gruppe/opprettGruppeOgBruker`, data: arg0, options: options });
    }

    /**
     * Returnerer logo registrert på gruppe, eller gruppelogo-ikke-tilgjengelig.png dersom ingen logo registrert. Merk at logoId er med i ressursstien men benyttes ikke i håndteringen, logoId er kun med for å gi unike, cachbare stier
     * HTTP GET /gruppe/{gruppeId}/logo/{logoId}
     * Java method: no.systemfabrikken.lederplan.resources.gruppe.GruppeRessurs.hentLogo
     */
    hentLogo(gruppeId: GruppeId, logoId: string, queryParams?: { format?: string; bredde?: number; hoyde?: number; }, options?: RequestValg): RestResponse<any> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`gruppe/${gruppeId}/logo/${logoId}`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /gruppe/{gruppeId}/medlemMedBrukerId/{brukerId}
     * Java method: no.systemfabrikken.lederplan.resources.gruppe.GruppeRessurs.hentMedlemBasertPåBrukerOgGruppe
     */
    hentMedlemBasertPåBrukerOgGruppe(gruppeId: GruppeId, brukerId: BrukerId, options?: RequestValg): RestResponse<GruppeMedlemModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`gruppe/${gruppeId}/medlemMedBrukerId/${brukerId}`, options: options });
    }

    /**
     * HTTP GET /gruppe/{id}
     * Java method: no.systemfabrikken.lederplan.resources.gruppe.GruppeRessurs.hent
     */
    hent(id: GruppeId, options?: RequestValg): RestResponse<GruppeModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`gruppe/${id}`, options: options });
    }

    /**
     * HTTP POST /gruppe/{id}
     * Java method: no.systemfabrikken.lederplan.resources.gruppe.GruppeRessurs.oppdater
     */
    oppdater(id: GruppeId, arg1: OppdaterGruppeSpesifikasjon, options?: RequestValg): RestResponse<GruppeModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`gruppe/${id}`, data: arg1, options: options });
    }

    /**
     * Streamer zip-fil med alle data for angitt gruppe til klient. Merk at ALLE data inkluderes, også data kallende bruker normalt ikke ville hatt tilgang til pga skjerming. Kun kontaktperson for organisasjonen kan kalle denne metoden.
     * HTTP GET /gruppe/{id}/datadump/{filnavn}
     * Java method: no.systemfabrikken.lederplan.resources.gruppe.GruppeRessurs.datadump
     */
    datadump(id: GruppeId, filnavn: string, options?: RequestValg): RestResponse<any> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`gruppe/${id}/datadump/${filnavn}`, options: options });
    }

    /**
     * HTTP GET /gruppe/{id}/finnGrupperSomBrukerMal
     * Java method: no.systemfabrikken.lederplan.resources.gruppe.GruppeRessurs.finnGrupperSomBrukerMal
     */
    finnGrupperSomBrukerMal(id: GruppeId, queryParams?: { offset?: number; antall?: number; }, options?: RequestValg): RestResponse<SøkeresultatModell<AdminEnkelGruppeModell>> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`gruppe/${id}/finnGrupperSomBrukerMal`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /gruppe/{id}/finnMoeteVurderinger
     * Java method: no.systemfabrikken.lederplan.resources.gruppe.GruppeRessurs.finnMøteVurderinger
     */
    finnMøteVurderinger(id: GruppeId, queryParams?: { start?: ZonedDateTimeSerialisert; slutt?: ZonedDateTimeSerialisert; }, options?: RequestValg): RestResponse<MøtevurderingerModell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`gruppe/${id}/finnMoeteVurderinger`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /gruppe/{id}/finnTilgjengeligeMedlemmer
     * Java method: no.systemfabrikken.lederplan.resources.gruppe.GruppeRessurs.finnTilgjengeligeMedlemmer
     */
    finnTilgjengeligeMedlemmer(id: GruppeId, options?: RequestValg): RestResponse<GruppeMedlemListeModell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`gruppe/${id}/finnTilgjengeligeMedlemmer`, options: options });
    }

    /**
     * HTTP GET /gruppe/{id}/finnTilgjengeligeRoller
     * Java method: no.systemfabrikken.lederplan.resources.gruppe.GruppeRessurs.finnTilgjengeligeRoller
     */
    finnTilgjengeligeRoller(id: GruppeId, options?: RequestValg): RestResponse<MedlemsRolleModell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`gruppe/${id}/finnTilgjengeligeRoller`, options: options });
    }

    /**
     * HTTP GET /gruppe/{id}/gruppeAggregater
     * Java method: no.systemfabrikken.lederplan.resources.gruppe.GruppeRessurs.gruppeAggregater
     */
    gruppeAggregater(id: GruppeId, options?: RequestValg): RestResponse<GruppeAggreatModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`gruppe/${id}/gruppeAggregater`, options: options });
    }

    /**
     * HTTP GET /gruppe/{id}/hentRedigerSakKontekst
     * Java method: no.systemfabrikken.lederplan.resources.gruppe.GruppeRessurs.hentRedigerSakKontekst
     */
    hentRedigerSakKontekst(id: GruppeId, options?: RequestValg): RestResponse<RedigerSakKontekst> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`gruppe/${id}/hentRedigerSakKontekst`, options: options });
    }

    /**
     * HTTP GET /gruppe/{id}/moetedeltakelse.xlsx
     * Java method: no.systemfabrikken.lederplan.resources.gruppe.GruppeRessurs.møtedeltakelse
     */
    møtedeltakelse(id: GruppeId, queryParams?: { fom?: ZonedDateTimeSerialisert; tom?: ZonedDateTimeSerialisert; }, options?: RequestValg): RestResponse<any> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`gruppe/${id}/moetedeltakelse.xlsx`, queryParams: queryParams, options: options });
    }

    /**
     * Oppdaterer hvorvidt møtevurderingsfunksjonalitet er aktivert for gruppe.
     * HTTP POST /gruppe/{id}/oppdaterMoetevurderingAktivert
     * Java method: no.systemfabrikken.lederplan.resources.gruppe.GruppeRessurs.oppdaterMøtevurderingAktivert
     */
    oppdaterMøtevurderingAktivert(id: GruppeId, arg1: MøtevurderingAktivertSpesifikasjon, options?: RequestValg): RestResponse<GruppeModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`gruppe/${id}/oppdaterMoetevurderingAktivert`, data: arg1, options: options });
    }

    /**
     * Oppdaterer valgt språk for gruppe.
     * HTTP POST /gruppe/{id}/oppdaterSpraak
     * Java method: no.systemfabrikken.lederplan.resources.gruppe.GruppeRessurs.oppdaterSpråkkode
     */
    oppdaterSpråkkode(id: GruppeId, arg1: GruppeRessurs_Oppdaterspråkkode, options?: RequestValg): RestResponse<OkRespons> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`gruppe/${id}/oppdaterSpraak`, data: arg1, options: options });
    }

    /**
     * HTTP POST /gruppe/{id}/oppdaterTillatteAutentiseringsmetoder
     * Java method: no.systemfabrikken.lederplan.resources.gruppe.GruppeRessurs.oppdaterTillatteAutentiseringsmetoder
     */
    oppdaterTillatteAutentiseringsmetoder(id: GruppeId, arg1: TillatteAutentiseringsmetoderSpesifikasjon, options?: RequestValg): RestResponse<TillatteAutentiseringsmetoderOppdatertModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`gruppe/${id}/oppdaterTillatteAutentiseringsmetoder`, data: arg1, options: options });
    }

    /**
     * HTTP POST /gruppe/{id}/opprettAksjeeierbok
     * Java method: no.systemfabrikken.lederplan.resources.gruppe.GruppeRessurs.opprettAksjeeierbok
     */
    opprettAksjeeierbok(id: GruppeId, options?: RequestValg): RestResponse<GruppeModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`gruppe/${id}/opprettAksjeeierbok`, options: options });
    }

    /**
     * HTTP POST /gruppe/{id}/oppsett/agendadokument
     * Java method: no.systemfabrikken.lederplan.resources.gruppe.GruppeRessurs.oppdaterAgendadokumentValg
     */
    oppdaterAgendadokumentValg(id: GruppeId, arg1: AgendaDokumentValgSpesifikasjon, options?: RequestValg): RestResponse<AgendadokumentValgModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`gruppe/${id}/oppsett/agendadokument`, data: arg1, options: options });
    }

    /**
     * HTTP POST /gruppe/{id}/oppsett/forfalteOppgaverDokument
     * Java method: no.systemfabrikken.lederplan.resources.gruppe.GruppeRessurs.oppdaterForfalteOppgaverDokumentValg
     */
    oppdaterForfalteOppgaverDokumentValg(id: GruppeId, arg1: ForfalteOppgaverDokumentValgSpesifikasjon, options?: RequestValg): RestResponse<ForfalteOppgaverDokumentValgModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`gruppe/${id}/oppsett/forfalteOppgaverDokument`, data: arg1, options: options });
    }

    /**
     * HTTP POST /gruppe/{id}/oppsett/protokoll
     * Java method: no.systemfabrikken.lederplan.resources.gruppe.GruppeRessurs.oppdaterProtokollValg
     */
    oppdaterProtokollValg(id: GruppeId, arg1: ProtokollValgSpesifikasjon, options?: RequestValg): RestResponse<ProtokollValgModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`gruppe/${id}/oppsett/protokoll`, data: arg1, options: options });
    }

    /**
     * HTTP POST /gruppe/{id}/sendEpost
     * Java method: no.systemfabrikken.lederplan.resources.gruppe.GruppeRessurs.sendEpost
     */
    sendEpost(id: GruppeId, arg1: GenerellEpostTilMedlemmerSpesifikasjon, options?: RequestValg): RestResponse<SendEpostResultatModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`gruppe/${id}/sendEpost`, data: arg1, options: options });
    }

    /**
     * Sletter gruppe og alle tilknyttede data, inklusive møter, saker, dokumenter etc. Kun person registrert som kontaktperson på tilknyttet avtale kan slette gruppe. Brukere som var medlemmer vil bli slette såfremt de ikke er tilknyttet andre grupper eller avtaler, eller er kallende bruker. Merk: bruker ikke @DELETE da angular ikke støtter payload for DELETE kall
     * HTTP POST /gruppe/{id}/slett
     * Java method: no.systemfabrikken.lederplan.resources.gruppe.GruppeRessurs.slett
     */
    slett(id: GruppeId, arg1: SlettGruppeSpesifikasjon, options?: RequestValg): RestResponse<SlettGruppeResponsModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`gruppe/${id}/slett`, data: arg1, options: options });
    }
}

/**
 * Siden vi ikke har tilgang på admin port på webapps i azure, så legger jeg til en helsesjekk her også. På admin porten så er helsesjekk tilgjengelig på http://localhost:8081/healthcheck
 */
export class HelseRessursClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * HTTP GET /admin/helse/alle
     * Java method: no.systemfabrikken.lederplan.resources.admin.helse.HelseRessurs.alle
     */
    alle(options?: RequestValg): RestResponse<any> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`admin/helse/alle`, options: options });
    }

    /**
     * HTTP GET /admin/helse/status
     * Java method: no.systemfabrikken.lederplan.resources.admin.helse.HelseRessurs.status
     */
    status$GET$admin_helse_status(options?: RequestValg): RestResponse<any> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`admin/helse/status`, options: options });
    }

    /**
     * HTTP GET /admin/helse/status/{navn}
     * Java method: no.systemfabrikken.lederplan.resources.admin.helse.HelseRessurs.status
     */
    status$GET$admin_helse_status_navn(navn: string, options?: RequestValg): RestResponse<any> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`admin/helse/status/${navn}`, options: options });
    }
}

export class KommentarRessursClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * HTTP GET /kommentar/finnKommentarerDerJegDeltarIPerioden
     * Java method: no.systemfabrikken.lederplan.resources.kommentar.KommentarRessurs.finnKommentarerDerJegDeltarIPerioden
     */
    finnKommentarerDerJegDeltarIPerioden(queryParams?: { start?: ZonedDateTimeSerialisert; slutt?: ZonedDateTimeSerialisert; }, options?: RequestValg): RestResponse<KommentarModell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`kommentar/finnKommentarerDerJegDeltarIPerioden`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /kommentar/finnKommentarerDerJegIkkeDeltarIPerioden
     * Java method: no.systemfabrikken.lederplan.resources.kommentar.KommentarRessurs.finnKommentarerDerJegIkkeDeltarIPerioden
     */
    finnKommentarerDerJegIkkeDeltarIPerioden(queryParams?: { start?: ZonedDateTimeSerialisert; slutt?: ZonedDateTimeSerialisert; }, options?: RequestValg): RestResponse<KommentarModell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`kommentar/finnKommentarerDerJegIkkeDeltarIPerioden`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /kommentar/{id}
     * Java method: no.systemfabrikken.lederplan.resources.kommentar.KommentarRessurs.hent
     */
    hent(id: KommentarId, options?: RequestValg): RestResponse<KommentarModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`kommentar/${id}`, options: options });
    }

    /**
     * HTTP DELETE /kommentar/{id}
     * Java method: no.systemfabrikken.lederplan.resources.kommentar.KommentarRessurs.slettKommentar
     */
    slettKommentar(id: KommentarId, options?: RequestValg): RestResponse<OkRespons> {
        return this.httpClient.request({ method: 'DELETE', url: uriEncoding`kommentar/${id}`, options: options });
    }

    /**
     * HTTP POST /kommentar/{id}/privat
     * Java method: no.systemfabrikken.lederplan.resources.kommentar.KommentarRessurs.privat
     */
    privat(id: KommentarId, arg1: EndrePrivatSpesifikasjon, options?: RequestValg): RestResponse<KommentarModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`kommentar/${id}/privat`, data: arg1, options: options });
    }

    /**
     * HTTP PUT /kommentar/{id}/svar
     * Java method: no.systemfabrikken.lederplan.resources.kommentar.KommentarRessurs.registrerSvar
     */
    registrerSvar(id: KommentarId, arg1: OpprettKommentarSvarSpesifikasjon, options?: RequestValg): RestResponse<KommentarModell> {
        return this.httpClient.request({ method: 'PUT', url: uriEncoding`kommentar/${id}/svar`, data: arg1, options: options });
    }

    /**
     * @deprecated
     * HTTP POST /kommentar/{id}/svar
     * Java method: no.systemfabrikken.lederplan.resources.kommentar.KommentarRessurs.registrerSvar_post
     */
    registrerSvar_post(id: KommentarId, arg1: OpprettKommentarSvarSpesifikasjon, options?: RequestValg): RestResponse<KommentarModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`kommentar/${id}/svar`, data: arg1, options: options });
    }

    /**
     * HTTP DELETE /kommentar/{id}/svar/{svarId}
     * Java method: no.systemfabrikken.lederplan.resources.kommentar.KommentarRessurs.slettSvar
     */
    slettSvar(id: KommentarId, svarId: SvarId, options?: RequestValg): RestResponse<KommentarModell> {
        return this.httpClient.request({ method: 'DELETE', url: uriEncoding`kommentar/${id}/svar/${svarId}`, options: options });
    }
}

/**
 * Ressurs som gir tilgang til å endre loggnivåer <pre> For å endre loggnivåer kan følgende js uttrykk kjøres i nettleser der man er innlogget med bruker som har administrator rettigheter: angular.element(document.body).injector().get('$http').put('/api/admin/logger', {name:'<loggernavn>', level:'info'}).then(function(r){console.log(r)}) Du kan finne navn på loggere med følgende js uttrykk: angular.element(document.body).injector().get('$http').get('/api/admin/logger').then(function(r){console.log(r.data.filter(l => l.name.match(/NAVN_PÅ_LOGGER/)))}) der NAVN_PÅ_LOGGER er et regexp uttrykk, </pre>
@todo beskyttes bak aksesstoken med @KunIntern() ?
 */
export class LoggerRessursClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * HTTP PUT /admin/logger
     * Java method: no.systemfabrikken.lederplan.resources.admin.logger.LoggerRessurs.changeLevel
     */
    changeLevel(arg0: Modell, options?: RequestValg): RestResponse<Modell> {
        return this.httpClient.request({ method: 'PUT', url: uriEncoding`admin/logger`, data: arg0, options: options });
    }

    /**
     * HTTP GET /admin/logger
     * Java method: no.systemfabrikken.lederplan.resources.admin.logger.LoggerRessurs.getList
     */
    getList(options?: RequestValg): RestResponse<Modell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`admin/logger`, options: options });
    }
}

export class LoggingRessursClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * HTTP POST /logging
     * Java method: no.systemfabrikken.lederplan.resources.logging.LoggingRessurs.log
     */
    log(arg0: Melding[], options?: RequestValg): RestResponse<void> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`logging`, data: arg0, options: options });
    }
}

export class MalmøteRessursClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * HTTP GET /malmoete/{id}
     * Java method: no.systemfabrikken.lederplan.resources.møtemal.MalmøteRessurs.hent
     */
    hent(id: GruppeId, options?: RequestValg): RestResponse<MalmøteModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`malmoete/${id}`, options: options });
    }

    /**
     * HTTP POST /malmoete/{id}
     * Java method: no.systemfabrikken.lederplan.resources.møtemal.MalmøteRessurs.oppdater
     */
    oppdater(id: MalmøteId, arg1: OppdaterMalmøteSpesifikasjon, options?: RequestValg): RestResponse<MalmøteModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`malmoete/${id}`, data: arg1, options: options });
    }
}

export class MedlemsRolleRessursClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * HTTP POST /medlemsrolle/{gruppeId}/oppdaterRoller
     * Java method: no.systemfabrikken.lederplan.resources.gruppe.MedlemsRolleRessurs.oppdaterRoller
     */
    oppdaterRoller(gruppeId: GruppeId, arg1: MedlemsRolleSpesifikasjon[], options?: RequestValg): RestResponse<MedlemsRolleModell[]> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`medlemsrolle/${gruppeId}/oppdaterRoller`, data: arg1, options: options });
    }
}

/**
 * Eksponering av metrikker for konsumering av Prometheus. Denne ressursen er ubeskyttet og må skjermes via nginx. Se #1158
 */
export class MetrikkerRessursClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * HTTP GET /admin/metrikker/hazelcast
     * Java method: no.systemfabrikken.lederplan.resources.admin.metrikker.MetrikkerRessurs.rapporterForHazelcast
     */
    rapporterForHazelcast(options?: RequestValg): RestResponse<string> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`admin/metrikker/hazelcast`, options: options });
    }

    /**
     * HTTP GET /admin/metrikker/micrometer
     * Java method: no.systemfabrikken.lederplan.resources.admin.metrikker.MetrikkerRessurs.rapporterForMicrometer
     */
    rapporterForMicrometer(options?: RequestValg): RestResponse<string> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`admin/metrikker/micrometer`, options: options });
    }
}

/**
 * Ressurs for oversikt over kjørte migreringer
 */
export class MigreringerRessursClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * HTTP GET /admin/migreringer/alle
     * Java method: no.systemfabrikken.lederplan.resources.admin.migreringer.MigreringerRessurs.alle
     */
    alle(options?: RequestValg): RestResponse<DbMigrering[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`admin/migreringer/alle`, options: options });
    }
}

export class MøteRessursClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * HTTP PUT /moete
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøteRessurs.opprett
     */
    opprett(arg0: NyttMøteSpesifikasjon, options?: RequestValg): RestResponse<MøteModell> {
        return this.httpClient.request({ method: 'PUT', url: uriEncoding`moete`, data: arg0, options: options });
    }

    /**
     * Pakker protokoller i PDF-format for angitte møter i en ZIP og returnerer denne. Merk at 'filnavn'-leddet er kun med for at klient skal kunne styre filnavnet nedlastet ZIP-får hos klient.
     * HTTP GET /moete/eksporterProtokoller/{filnavn}
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøteRessurs.eksporterProtokoller
     */
    eksporterProtokoller(filnavn: string, queryParams?: { id?: MøteId[]; }, options?: RequestValg): RestResponse<any> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`moete/eksporterProtokoller/${filnavn}`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /moete/finnAlleKnyttetTilGruppe
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøteRessurs.finnAlleKnyttetTilGruppe
     */
    finnAlleKnyttetTilGruppe(queryParams?: { gruppeId?: GruppeId; }, options?: RequestValg): RestResponse<MøteModellEnkel[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`moete/finnAlleKnyttetTilGruppe`, queryParams: queryParams, options: options });
    }

    /**
     * Returnerer første møte med start etter angitt dato, dersom det ikke finnes noe slikt møte returneres siste møte med start før angitt dato, ellers null
     * HTTP GET /moete/finnFoersteMoeteEtterEllerFoer
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøteRessurs.finnFørsteMøteEtterEllerFør
     */
    finnFørsteMøteEtterEllerFør(queryParams?: { dato?: ZonedDateTimeSerialisert; }, options?: RequestValg): RestResponse<MøteModellEnkel> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`moete/finnFoersteMoeteEtterEllerFoer`, queryParams: queryParams, options: options });
    }

    /**
     * Returnerer seneste [maksAntall] møtene før angitt dato, samt de [maksAntall] første møtene fra og med angitt dato. Merk at det totale maks antall da blir 2x[maksAntall]
     * HTTP GET /moete/finnFoersteMoeteOgOmkringliggende
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøteRessurs.finnFørsteMøteOgOmkringliggende
     */
    finnFørsteMøteOgOmkringliggende(queryParams?: { gruppeIder?: GruppeId[]; maksAntall?: number; }, options?: RequestValg): RestResponse<OmkringliggendeMøterModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`moete/finnFoersteMoeteOgOmkringliggende`, queryParams: queryParams, options: options });
    }

    /**
     * Returnerer de seneste 10 møtene med start før 'nå' etterfulgt av de 10 første møtene med start lik eller etter 'nå'
     * @deprecated
     * HTTP GET /moete/finnFoersteMoeteOgOmkringliggende2
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøteRessurs.finnFørsteMøteOgOmkringliggende2
     */
    finnFørsteMøteOgOmkringliggende2(queryParams?: { gruppeIder?: GruppeId[]; }, options?: RequestValg): RestResponse<MøteMedAggregaterModell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`moete/finnFoersteMoeteOgOmkringliggende2`, queryParams: queryParams, options: options });
    }

    /**
     * Finner enten: <br /> * møte hvor angitt datoparameter er innenfor start eller slutt på ett møte, <br /> * neste møte frem i tid om det ikke pågår et møte <br /> * eller til sist det siste møtet som finnes.
@param dato som angir tidspunktet man vil søke etter møter utifra
@return MøteModellEnkel om treff, ellers null
     * HTTP GET /moete/finnForsteTilgjengeligeMote
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøteRessurs.finnFørsteTilgjengeligeMøte
     */
    finnFørsteTilgjengeligeMøte(queryParams?: { dato?: ZonedDateTimeSerialisert; }, options?: RequestValg): RestResponse<MøteModellEnkel> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`moete/finnForsteTilgjengeligeMote`, queryParams: queryParams, options: options });
    }

    /**
     * Returnerer en liste med møter som nye medlemmer kan legges til. Møter som er låst returners ikke.
     * HTTP GET /moete/finnIkkeAvholdteMoeterSomNyeMedlemmmerKanLeggesTil
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøteRessurs.finnIkkeAvholdteMøterSomNyeMedlemmmerKanLeggesTil
     */
    finnIkkeAvholdteMøterSomNyeMedlemmmerKanLeggesTil(queryParams?: { gruppeId?: GruppeId; }, options?: RequestValg): RestResponse<MøteNyeMedlemKanLeggesTilModell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`moete/finnIkkeAvholdteMoeterSomNyeMedlemmmerKanLeggesTil`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /moete/finnMoeteIdTilknyttetDeltaker/{id}
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøteRessurs.finnMøteIdTilknyttetDeltaker
     */
    finnMøteIdTilknyttetDeltaker(id: MøtedeltakerId, options?: RequestValg): RestResponse<EntitetIdRespons> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`moete/finnMoeteIdTilknyttetDeltaker/${id}`, options: options });
    }

    /**
     * HTTP GET /moete/finnMoeteIdTilknyttetProtokollfoertDeltaker/{id}
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøteRessurs.finnMøteIdTilknyttetProtokollførtDeltaker
     */
    finnMøteIdTilknyttetProtokollførtDeltaker(id: ProtokollførtMøtedeltakerId, options?: RequestValg): RestResponse<EntitetIdRespons> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`moete/finnMoeteIdTilknyttetProtokollfoertDeltaker/${id}`, options: options });
    }

    /**
     * HTTP GET /moete/finnMoeteIdTilknyttetSak/{id}
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøteRessurs.finnMøteIdTilknyttetSak
     */
    finnMøteIdTilknyttetSak(id: AgendaelementId, options?: RequestValg): RestResponse<EntitetIdRespons> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`moete/finnMoeteIdTilknyttetSak/${id}`, options: options });
    }

    /**
     * HTTP GET /moete/finnMoeteOgSakIdTilknyttetAvstemning/{id}
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøteRessurs.finnMøteOgSakIdTilknyttetAvstemning
     */
    finnMøteOgSakIdTilknyttetAvstemning(id: AvstemningId, options?: RequestValg): RestResponse<MøteIdOgSakIdModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`moete/finnMoeteOgSakIdTilknyttetAvstemning/${id}`, options: options });
    }

    /**
     * HTTP GET /moete/finnMoeteOgSakIdTilknyttetBeslutning/{id}
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøteRessurs.finnMøteOgSakIdTilknyttetBeslutning
     */
    finnMøteOgSakIdTilknyttetBeslutning(id: BeslutningId, options?: RequestValg): RestResponse<MøteIdOgSakIdModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`moete/finnMoeteOgSakIdTilknyttetBeslutning/${id}`, options: options });
    }

    /**
     * Returnerer informasjon om protokoll for møter med startdato i angitt periode. Seneste møte først.
     * HTTP GET /moete/finnMoeterEnkelMedProtokollinfoIPerioden
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøteRessurs.finnMoeterEnkelMedProtokollinfoIPerioden
     */
    finnMoeterEnkelMedProtokollinfoIPerioden(queryParams?: { start?: ZonedDateTimeSerialisert; slutt?: ZonedDateTimeSerialisert; grupper?: GruppeId[]; offset?: number; antall?: number; }, options?: RequestValg): RestResponse<SøkeresultatModell<MøteModellEnkelMedProtokollinfo>> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`moete/finnMoeterEnkelMedProtokollinfoIPerioden`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /moete/finnMoeterFoerDatoMedUbehandletProtokoll
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøteRessurs.finnMøterFørDatoMedUbehandletProtokoll
     */
    finnMøterFørDatoMedUbehandletProtokoll(queryParams?: { dato?: ZonedDateTimeSerialisert; gruppeId?: GruppeId; }, options?: RequestValg): RestResponse<MøteModellEnkel[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`moete/finnMoeterFoerDatoMedUbehandletProtokoll`, queryParams: queryParams, options: options });
    }

    /**
     * @deprecated
     * HTTP GET /moete/finnMoeterIPerioden
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøteRessurs.finnMøterIPerioden
     */
    finnMøterIPerioden(queryParams?: { start?: ZonedDateTimeSerialisert; slutt?: ZonedDateTimeSerialisert; }, options?: RequestValg): RestResponse<MøteModell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`moete/finnMoeterIPerioden`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /moete/finnMoeterIPerioden2
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøteRessurs.finnMøterIPerioden2
     */
    finnMøterIPerioden2(queryParams?: { start?: ZonedDateTimeSerialisert; slutt?: ZonedDateTimeSerialisert; }, options?: RequestValg): RestResponse<MøteMedAggregaterModell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`moete/finnMoeterIPerioden2`, queryParams: queryParams, options: options });
    }

    /**
     * Returnerer de [maksAntall] første møtene etter angitt dato
     * HTTP GET /moete/finnMoeterMedStartEtter
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøteRessurs.finnMøterMedStartEtter
     */
    finnMøterMedStartEtter(queryParams?: { dato?: ZonedDateTimeSerialisert; gruppeIder?: GruppeId[]; maksAntall?: number; }, options?: RequestValg): RestResponse<MøteMedAggregaterModell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`moete/finnMoeterMedStartEtter`, queryParams: queryParams, options: options });
    }

    /**
     * Returnerer de [maksAntall] første møtene etter angitt dato
     * @deprecated
     * HTTP GET /moete/finnMoeterMedStartEtter2
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøteRessurs.finnMøterMedStartEtter2
     */
    finnMøterMedStartEtter2(queryParams?: { dato?: ZonedDateTimeSerialisert; gruppeIder?: GruppeId[]; maksAntall?: number; }, options?: RequestValg): RestResponse<MøteMedAggregaterModell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`moete/finnMoeterMedStartEtter2`, queryParams: queryParams, options: options });
    }

    /**
     * Returnerer de [maksAntall] seneste møtene før angitt dato
     * HTTP GET /moete/finnMoeterMedStartFoer
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøteRessurs.finnMøterMedStartFør
     */
    finnMøterMedStartFør(queryParams?: { dato?: ZonedDateTimeSerialisert; gruppeIder?: GruppeId[]; maksAntall?: number; }, options?: RequestValg): RestResponse<MøteMedAggregaterModell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`moete/finnMoeterMedStartFoer`, queryParams: queryParams, options: options });
    }

    /**
     * Returnerer de [maksAntall] seneste møtene før angitt dato
     * HTTP GET /moete/finnMoeterMedStartFoer2
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøteRessurs.finnMøterMedStartFør2
     */
    finnMøterMedStartFør2(queryParams?: { dato?: ZonedDateTimeSerialisert; gruppeIder?: GruppeId[]; maksAntall?: number; }, options?: RequestValg): RestResponse<MøteMedAggregaterModell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`moete/finnMoeterMedStartFoer2`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /moete/finnMoeterTilhoerendeGruppeIPerioden
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøteRessurs.finnMøterTilhørendeGruppeIPerioden
     */
    finnMøterTilhørendeGruppeIPerioden(queryParams?: { start?: ZonedDateTimeSerialisert; slutt?: ZonedDateTimeSerialisert; gruppe?: GruppeId; }, options?: RequestValg): RestResponse<MøteModell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`moete/finnMoeterTilhoerendeGruppeIPerioden`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /moete/finnMoeterTilhoerendeGrupperIPerioden
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøteRessurs.finnMøterTilhørendeGrupperIPerioden
     */
    finnMøterTilhørendeGrupperIPerioden(queryParams?: { start?: ZonedDateTimeSerialisert; slutt?: ZonedDateTimeSerialisert; gruppeIder?: GruppeId[]; }, options?: RequestValg): RestResponse<MøteModellEnkel[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`moete/finnMoeterTilhoerendeGrupperIPerioden`, queryParams: queryParams, options: options });
    }

    /**
     * Returnerer seneste låste møte for angitt gruppe, null dersom intet slikt møte finnes
     * HTTP GET /moete/finnSenesteLaasteMoete
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøteRessurs.finnSenesteLåsteMøte
     */
    finnSenesteLåsteMøte(queryParams?: { gruppeId?: GruppeId; }, options?: RequestValg): RestResponse<MøteModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`moete/finnSenesteLaasteMoete`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /moete/oppdaterSaksrekkefoelge/{id}
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøteRessurs.oppdaterSaksrekkefølge
     */
    oppdaterSaksrekkefølge(id: MøteId, arg1: OppdaterSaksrekkefølgeSpesifikasjon, options?: RequestValg): RestResponse<MøteModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`moete/oppdaterSaksrekkefoelge/${id}`, data: arg1, options: options });
    }

    /**
     * Validerer nytt møte.
@return returnerer valideringsfeil av typen {@link OpprettMøteValideringsfeil} og {@link Valideringsfeilkode} . Siden valideringsfeilene kan være av forskjellige enum-typer angir vi '?' som generics type argument her, om vi angir eksplisitt type vil dette påvirke json-serialiseringen slik at kun verdier fra angitt type blir serialisert
     * HTTP POST /moete/validerNyttMoete
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøteRessurs.validerNyttMøte
     */
    validerNyttMøte(arg0: NyttMøteSpesifikasjon, options?: RequestValg): RestResponse<ValideringsresultatModell<any>> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`moete/validerNyttMoete`, data: arg0, options: options });
    }

    /**
     * HTTP GET /moete/{id}
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøteRessurs.hent
     */
    hent(id: MøteId, options?: RequestValg): RestResponse<MøteModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`moete/${id}`, options: options });
    }

    /**
     * HTTP POST /moete/{id}
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøteRessurs.oppdater
     */
    oppdater(id: MøteId, arg1: OppdaterMøteSpesifikasjon, options?: RequestValg): RestResponse<MøteModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`moete/${id}`, data: arg1, options: options });
    }

    /**
     * HTTP DELETE /moete/{id}
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøteRessurs.slett
     */
    slett(id: MøteId, options?: RequestValg): RestResponse<OkRespons> {
        return this.httpClient.request({ method: 'DELETE', url: uriEncoding`moete/${id}`, options: options });
    }

    /**
     * HTTP POST /moete/{id}/aapneForAvstemning
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøteRessurs.åpneForAvstemning
     */
    åpneForAvstemning(id: MøteId, arg1: ÅpneStengeForAvstemningSpesifikasjon, options?: RequestValg): RestResponse<AvstemningsstatusModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`moete/${id}/aapneForAvstemning`, data: arg1, options: options });
    }

    /**
     * Returnerer møtets agenda i PDF-format. Merk at 'filnavn'-leddet er kun med for at klient skal kunne styre filnavnet nedlastet PDF-får hos klient.
     * HTTP GET /moete/{id}/agenda/pdf/{filnavn}
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøteRessurs.lastNedAgendadokument
     */
    lastNedAgendadokument(id: MøteId, filnavn: string, options?: RequestValg): RestResponse<any> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`moete/${id}/agenda/pdf/${filnavn}`, options: options });
    }

    /**
     * @deprecated
     * HTTP POST /moete/{id}/annulerInnkalling/
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøteRessurs.annulerInnkalling
     */
    annulerInnkalling(id: MøteId, arg1: MøtedeltakereIdModell, options?: RequestValg): RestResponse<MøtedeltakereModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`moete/${id}/annulerInnkalling/`, data: arg1, options: options });
    }

    /**
     * HTTP GET /moete/{id}/avstemningsstatus
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøteRessurs.avstemningsstatus
     */
    avstemningsstatus(id: MøteId, options?: RequestValg): RestResponse<AvstemningsstatusModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`moete/${id}/avstemningsstatus`, options: options });
    }

    /**
     * HTTP GET /moete/{id}/deltakere
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøteRessurs.hentDeltakere
     */
    hentDeltakere(id: MøteId, options?: RequestValg): RestResponse<MøtedeltakereModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`moete/${id}/deltakere`, options: options });
    }

    /**
     * HTTP GET /moete/{id}/enkel
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøteRessurs.hentEnkel
     */
    hentEnkel(id: MøteId, options?: RequestValg): RestResponse<MøteModellEnkel> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`moete/${id}/enkel`, options: options });
    }

    /**
     * HTTP GET /moete/{id}/finnFoersteMoeteEtter
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøteRessurs.finnFørsteMøteEtter
     */
    finnFørsteMøteEtter(id: MøteId, queryParams?: { sammeGruppe?: boolean; }, options?: RequestValg): RestResponse<MøteModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`moete/${id}/finnFoersteMoeteEtter`, queryParams: queryParams, options: options });
    }

    /**
     * Returnerer forspurt møte samt de seneste 9 møtene før dette og de 10 første møtene etter dette
     * @deprecated
     * HTTP GET /moete/{id}/finnMoeteOgOmkringliggende
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøteRessurs.finnMøteOgOmkringliggende
     */
    finnMøteOgOmkringliggende(id: MøteId, options?: RequestValg): RestResponse<MøteMedAggregaterModell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`moete/${id}/finnMoeteOgOmkringliggende`, options: options });
    }

    /**
     * Returnerer seneste [maksAntall] møtene før angitt møte, samt de [maksAntall] første møtene fra og med angitt møte. Merk at det totale maks antall da blir 2x[maksAntall]
     * HTTP GET /moete/{id}/finnMoeteOgOmkringliggende2
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøteRessurs.finnMøteOgOmkringliggende2
     */
    finnMøteOgOmkringliggende2(id: MøteId, queryParams?: { maksAntall?: number; }, options?: RequestValg): RestResponse<OmkringliggendeMøterModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`moete/${id}/finnMoeteOgOmkringliggende2`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /moete/{id}/finnSisteMoeteFoer
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøteRessurs.finnSisteMøteFør
     */
    finnSisteMøteFør(id: MøteId, queryParams?: { sammeGruppe?: boolean; }, options?: RequestValg): RestResponse<MøteModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`moete/${id}/finnSisteMoeteFoer`, queryParams: queryParams, options: options });
    }

    /**
     * Kopierer angitt møte til angitte grupper ihht {@link KopierMøteTilGrupperSpesifikasjon}
     * HTTP PUT /moete/{id}/kopier
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøteRessurs.kopier
     */
    kopier(id: MøteId, arg1: KopierMøteTilGrupperSpesifikasjon, options?: RequestValg): RestResponse<MøteModell[]> {
        return this.httpClient.request({ method: 'PUT', url: uriEncoding`moete/${id}/kopier`, data: arg1, options: options });
    }

    /**
     * HTTP GET /moete/{id}/medAggregater
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøteRessurs.hentMedAggregater
     */
    hentMedAggregater(id: MøteId, options?: RequestValg): RestResponse<MøteMedAggregaterModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`moete/${id}/medAggregater`, options: options });
    }

    /**
     * HTTP GET /moete/{id}/moetedokumentvalg
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøteRessurs.moetedokumentvalg
     */
    moetedokumentvalg(id: MøteId, options?: RequestValg): RestResponse<MøtedokumentvalgModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`moete/${id}/moetedokumentvalg`, options: options });
    }

    /**
     * HTTP DELETE /moete/{id}/nullstillAvgitteStemmer
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøteRessurs.nullstillAvgitteStemmer
     */
    nullstillAvgitteStemmer$DELETE$moete_id_nullstillAvgitteStemmer(id: MøteId, options?: RequestValg): RestResponse<AvstemningsstatusModell> {
        return this.httpClient.request({ method: 'DELETE', url: uriEncoding`moete/${id}/nullstillAvgitteStemmer`, options: options });
    }

    /**
     * HTTP DELETE /moete/{id}/nullstillAvgitteStemmer/{deltakerId}
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøteRessurs.nullstillAvgitteStemmer
     */
    nullstillAvgitteStemmer$DELETE$moete_id_nullstillAvgitteStemmer_deltakerId(id: MøteId, deltakerId: MøtedeltakerId, options?: RequestValg): RestResponse<AvstemningsstatusModell> {
        return this.httpClient.request({ method: 'DELETE', url: uriEncoding`moete/${id}/nullstillAvgitteStemmer/${deltakerId}`, options: options });
    }

    /**
     * HTTP POST /moete/{id}/oppdaterDeltakere
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøteRessurs.oppdaterDeltakere
     */
    oppdaterDeltakere(id: MøteId, arg1: OppdaterMøtedeltakereSpesifikasjon, options?: RequestValg): RestResponse<MøtedeltakereModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`moete/${id}/oppdaterDeltakere`, data: arg1, options: options });
    }

    /**
     * HTTP POST /moete/{id}/oppdaterMoetedokumentvalg
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøteRessurs.oppdaterMøtedokumentvalg
     */
    oppdaterMøtedokumentvalg(id: MøteId, arg1: OppdaterMøtedokumentvalgSpesifikasjon, options?: RequestValg): RestResponse<MøtedokumentvalgModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`moete/${id}/oppdaterMoetedokumentvalg`, data: arg1, options: options });
    }

    /**
     * HTTP POST /moete/{id}/oppdaterStemmeberettigede
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøteRessurs.oppdaterStemmeberettigede
     */
    oppdaterStemmeberettigede(id: MøteId, arg1: StemmeberettigetMøtedeltakerSpesifikasjoner, options?: RequestValg): RestResponse<MøtedeltakereModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`moete/${id}/oppdaterStemmeberettigede`, data: arg1, options: options });
    }

    /**
     * Generer møtedokument (pdf). Leser {@link Møtedokumentvalg} fra queryparametere dersom angitt, benytter ellers verdier satt på sak/dokument/gruppe. Merk at 'filnavn'-leddet er kun med for at klient skal kunne styre filnavnet nedlastet PDF-får hos klient.
     * HTTP GET /moete/{id}/pdf/{filnavn}
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøteRessurs.lastNedMøtedokument
     */
    lastNedMøtedokument(id: MøteId, filnavn: string, queryParams?: { utelatteSaker?: string; utelatteSaksdokumenter?: string; genereMoetedokumentTosidig?: string; utelatteMoetedokumentdeler?: string; }, options?: RequestValg): RestResponse<any> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`moete/${id}/pdf/${filnavn}`, queryParams: queryParams, options: options });
    }

    /**
     * Returnerer møtets protokoll i PDF-format. Merk at 'filnavn'-leddet er kun med for at klient skal kunne styre filnavnet nedlastet PDF-får hos klient.
     * HTTP GET /moete/{id}/protokoll/pdf/{filnavn}
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøteRessurs.lastNedProtokolldokument
     */
    lastNedProtokolldokument(id: MøteId, filnavn: string, options?: RequestValg): RestResponse<any> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`moete/${id}/protokoll/pdf/${filnavn}`, options: options });
    }

    /**
     * Oppdaterer publiseringsstatus.
@return returnerer valideringsfeil av typen {@link OpprettMøteValideringsfeil} og {@link Valideringsfeilkode}
     * HTTP POST /moete/{id}/publiser
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøteRessurs.oppdaterPublisert
     */
    oppdaterPublisert(id: MøteId, arg1: MøtepubliseringSpesifikasjon, options?: RequestValg): RestResponse<ValideringsresultatModell<MøtePubliseringValideringsfeil>> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`moete/${id}/publiser`, data: arg1, options: options });
    }

    /**
     * HTTP POST /moete/{id}/registrerVurdering/{vurdering}
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøteRessurs.registrerVurdering
     */
    registrerVurdering(id: MøteId, vurdering: number, options?: RequestValg): RestResponse<MøteModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`moete/${id}/registrerVurdering/${vurdering}`, options: options });
    }

    /**
     * HTTP POST /moete/{id}/sendEpost
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøteRessurs.sendEpost
     */
    sendEpost(id: MøteId, arg1: GenerellEpostTilMedlemmerSpesifikasjon, options?: RequestValg): RestResponse<SendEpostResultatModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`moete/${id}/sendEpost`, data: arg1, options: options });
    }

    /**
     * @deprecated
     * HTTP POST /moete/{id}/sendInnkalling
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøteRessurs.sendInnkalling
     */
    sendInnkalling(id: MøteId, options?: RequestValg): RestResponse<MøtedeltakereModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`moete/${id}/sendInnkalling`, options: options });
    }

    /**
     * Sender innkalling til angitte deltakere. Merk at dersom gruppemedlem som ikke allerede er møtedeltaker vil bli lagt til som møtedeltaker
     * HTTP POST /moete/{id}/sendInnkallingV2
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøteRessurs.sendInnkallingV2
     */
    sendInnkallingV2(id: MøteId, arg1: SendInnkallingSpesifikasjon, options?: RequestValg): RestResponse<MøtedeltakereModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`moete/${id}/sendInnkallingV2`, data: arg1, options: options });
    }

    /**
     * HTTP POST /moete/{id}/sendPurring
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøteRessurs.sendPurring
     */
    sendPurring(id: MøteId, options?: RequestValg): RestResponse<MøtedeltakereModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`moete/${id}/sendPurring`, options: options });
    }

    /**
     * HTTP GET /moete/{id}/skjerming
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøteRessurs.hentSkjerming
     */
    hentSkjerming(id: MøteId, options?: RequestValg): RestResponse<SkjermingDetaljerModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`moete/${id}/skjerming`, options: options });
    }

    /**
     * HTTP POST /moete/{id}/skjerming
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøteRessurs.oppdaterSkjerming
     */
    oppdaterSkjerming(id: MøteId, arg1: OppdaterSkjermingSpesifikasjon, options?: RequestValg): RestResponse<SkjermingDetaljerMedValideringsresultatModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`moete/${id}/skjerming`, data: arg1, options: options });
    }

    /**
     * HTTP GET /moete/{id}/status
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøteRessurs.hentStatus
     */
    hentStatus(id: MøteId, options?: RequestValg): RestResponse<MoetestatusModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`moete/${id}/status`, options: options });
    }

    /**
     * HTTP POST /moete/{id}/stengForAvstemning
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøteRessurs.stengForAvstemning
     */
    stengForAvstemning(id: MøteId, arg1: ÅpneStengeForAvstemningSpesifikasjon, options?: RequestValg): RestResponse<AvstemningsstatusModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`moete/${id}/stengForAvstemning`, data: arg1, options: options });
    }

    /**
     * Validerer angitt spesifikasjon.
@return returnerer valideringsfeil av typen {@link OppdaterMøteValideringsfeil}
     * HTTP POST /moete/{id}/valider
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøteRessurs.validerOppdater
     */
    validerOppdater(id: MøteId, arg1: OppdaterMøteSpesifikasjon, options?: RequestValg): RestResponse<ValideringsresultatModell<OppdaterMøteValideringsfeil>> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`moete/${id}/valider`, data: arg1, options: options });
    }

    /**
     * HTTP POST /moete/{id}/validerKopierMoete
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøteRessurs.validerKopierMøte
     */
    validerKopierMøte(id: MøteId, arg1: KopierMøteTilGrupperSpesifikasjon, options?: RequestValg): RestResponse<KopierMøteTilGrupperValideringsfeil> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`moete/${id}/validerKopierMoete`, data: arg1, options: options });
    }
}

export class MøtedeltakerRessursClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * HTTP GET /moetedeltaker/deltaker/aksepterInnkalling/{versjon}/{krypterteData}
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøtedeltakerRessurs.aksepterInnkalling
     */
    aksepterInnkalling$GET$moetedeltaker_deltaker_aksepterInnkalling_versjon_krypterteData(versjon: string, krypterteData: string, options?: RequestValg): RestResponse<any> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`moetedeltaker/deltaker/aksepterInnkalling/${versjon}/${krypterteData}`, options: options });
    }

    /**
     * HTTP GET /moetedeltaker/deltaker/avslaaInnkalling/{versjon}/{krypterteData}
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøtedeltakerRessurs.avslåInnkalling
     */
    avslåInnkalling$GET$moetedeltaker_deltaker_avslaaInnkalling_versjon_krypterteData(versjon: string, krypterteData: string, options?: RequestValg): RestResponse<any> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`moetedeltaker/deltaker/avslaaInnkalling/${versjon}/${krypterteData}`, options: options });
    }

    /**
     * HTTP POST /moetedeltaker/{id}/aksepterInnkalling
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøtedeltakerRessurs.aksepterInnkalling
     */
    aksepterInnkalling$POST$moetedeltaker_id_aksepterInnkalling(id: MøteId, options?: RequestValg): RestResponse<MøtedeltakerModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`moetedeltaker/${id}/aksepterInnkalling`, options: options });
    }

    /**
     * HTTP POST /moetedeltaker/{id}/avslaaInnkalling
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøtedeltakerRessurs.avslåInnkalling
     */
    avslåInnkalling$POST$moetedeltaker_id_avslaaInnkalling(id: MøteId, options?: RequestValg): RestResponse<MøtedeltakerModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`moetedeltaker/${id}/avslaaInnkalling`, options: options });
    }
}

/**
 * Endepunkter for lydopptak av møtebehandlingen, transkripsjon av opptakene og generering av møtereferat på grunnlag av transkripsjonene.
 */
export class MøtetranskripsjonRessursClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * Oppretter et nytt lydopptak av møtebehandlingen fra opplastet lydfil og registrerer det på møtet.
@param varighet hvor lenge lydfila varer, målt av klienten mens opptaket gikk
@param språk    språket det snakkes i lydfila, valgt av bruker da opptaket ble startet. Uten verdi                brukes {@link I18nStøttedeSnakkedeSpråk#standard_språk} , slik at klienter som ikke sender språk fortsatt fungerer
@param oppgittStørrelse lydfilas størrelse oppgitt av klienten, gjør at for store lydfiler avvises før de leses
@throws ValideringsfeilException dersom den samlede opptakslengden inklusive dette opptaket overskrider {@link MøtebehandlingOpptak#maksimalVarighet}
@throws WebApplicationException med status 413 dersom lydfila ikke er mindre enn {@link Lydopptak#maksimalStørrelse}
     * HTTP PUT /moetetranskripsjon/{id}/nyttOpptak
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøtetranskripsjonRessurs.nyttOpptak
     */
    nyttOpptak(id: MøteId, arg4: any, queryParams?: { varighet?: DurationSerialisert; spraak?: SnakketSpråk; }, options?: RequestValg): RestResponse<LydopptakId> {
        return this.httpClient.request({ method: 'PUT', url: uriEncoding`moetetranskripsjon/${id}/nyttOpptak`, queryParams: queryParams, data: arg4, options: options });
    }

    /**
     * Møtereferatet llm-en har oppsummert på grunnlag av {@link MøtebehandlingOpptak} . Referatet genereres og lagres ved første kall, senere kall leverer den lagrede verdien.
@throws IkkeTilgangTilEntitetException dersom kallende bruker er skjermet for noen av sakene i møtet, eller for noe i sakene,                                       se {@link Møte.MøteTilgang#harIkkeOppsummerOpptakTilgang}
     * HTTP POST /moetetranskripsjon/{id}/oppsummerOpptak
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøtetranskripsjonRessurs.oppsummerOpptak
     */
    oppsummerOpptak(id: MøteId, options?: RequestValg): RestResponse<OppsummertTranskribertMøtereferatModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`moetetranskripsjon/${id}/oppsummerOpptak`, options: options });
    }

    /**
     * Metode som lar bruker diktere prompt og transkripsjon brukt for til generering av møtereferat, på sikt bør denne metoden fjernes.
@throws WebApplicationException med status 403 dersom kallende bruker ikke har featurevalg `ki` aktivert, se {@link #verifiserKiFeatureAktivert}
     * HTTP POST /moetetranskripsjon/{id}/oppsummerOpptakDebug
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøtetranskripsjonRessurs.oppsummerOpptakDebug
     */
    oppsummerOpptakDebug(id: MøteId, arg1: OppsummerMøtebehandlingsopptakDebugSpesifikasjon, options?: RequestValg): RestResponse<OppsummertTranskribertMøtereferatModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`moetetranskripsjon/${id}/oppsummerOpptakDebug`, data: arg1, options: options });
    }

    /**
     * Sletter alle lydopptakene av møtebehandlingen og det oppsummerte møtereferatet, slik at møtet kan transkriberes på nytt fra bunn. Slettingen er irreversibel.
     * HTTP DELETE /moetetranskripsjon/{id}/opptak
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøtetranskripsjonRessurs.slettOpptak
     */
    slettOpptak(id: MøteId, options?: RequestValg): RestResponse<OkRespons> {
        return this.httpClient.request({ method: 'DELETE', url: uriEncoding`moetetranskripsjon/${id}/opptak`, options: options });
    }

    /**
     * Transkripsjonene av lydopptakene som er gjort av møtebehandlingen, i opptaksrekkefølge, på sikt bør denne metoden fjernes. Opptak som ennå ikke er transkribert er med i lista, uten transkripsjon.
@throws WebApplicationException med status 403 dersom kallende bruker ikke har featurevalg `ki` aktivert, se {@link #verifiserKiFeatureAktivert}
     * HTTP GET /moetetranskripsjon/{id}/opptakTranskripsjoner
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøtetranskripsjonRessurs.opptakTranskripsjoner
     */
    opptakTranskripsjoner(id: MøteId, options?: RequestValg): RestResponse<MøtebehandlingsopptakTranskripsjonModell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`moetetranskripsjon/${id}/opptakTranskripsjoner`, options: options });
    }

    /**
     * Returnerer transkripsjonene av lydopptakene som er gjort av møtebehandlingen, samt promptet som normalt hadde blitt brukt for å generer oppsummert protokoll, på sikt bør denne metoden fjernes.
@throws WebApplicationException med status 403 dersom kallende bruker ikke har featurevalg `ki` aktivert, se {@link #verifiserKiFeatureAktivert}
     * HTTP GET /moetetranskripsjon/{id}/opptakTranskripsjonerOgPrompt
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøtetranskripsjonRessurs.opptakTranskripsjonerOgPrompt
     */
    opptakTranskripsjonerOgPrompt(id: MøteId, options?: RequestValg): RestResponse<{ [index: string]: string }> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`moetetranskripsjon/${id}/opptakTranskripsjonerOgPrompt`, options: options });
    }

    /**
     * Transkriberer et kort testopptak, slik at bruker kan verifisere at mikrofonen fungerer før opptaket av møtet startes. Tillater kun filer mindre enn 2 MB, for å unngå missbruk. Testopptaket lagres ikke og blir ikke en del av møtebehandlingen. Det knyttes likevel til møtet, slik at kun de som har redigeringstilgang til møtet – og dermed kan ta det opp – kan bruke transkripsjonstjenesten. Metoden er unntatt den implisitte transaksjonen ( {@link UtenImplisittTransaksjon} ) av samme grunn som {@link #nyttOpptak} , og fordi transkripsjonen tar tid: databasen brukes kun til tilgangskontrollen, som gjøres i en egen kortvarig transaksjon. Forbruket av transkripsjonen registreres på møtets gruppe, se {@link KiKallKontekst} .
@param varighet hvor lenge testopptaket varer, målt av klienten. Brukes for å registrere forbruket av transkripsjonen
@param språk    språket det snakkes i testopptaket, uten verdi brukes {@link I18nStøttedeSnakkedeSpråk#standard_språk}
@param oppgittStørrelse testopptakets størrelse oppgitt av klienten, gjør at for store testopptak avvises før de leses
@throws WebApplicationException med status 413 dersom testopptaket ikke er mindre enn {@link #MAKS_STØRRELSE_TESTOPPTAK}
     * HTTP PUT /moetetranskripsjon/{id}/testtranskriber
     * Java method: no.systemfabrikken.lederplan.resources.møte.MøtetranskripsjonRessurs.testtranskriber
     */
    testtranskriber(id: MøteId, arg4: any, queryParams?: { varighet?: DurationSerialisert; spraak?: SnakketSpråk; }, options?: RequestValg): RestResponse<TesttranskripsjonModell> {
        return this.httpClient.request({ method: 'PUT', url: uriEncoding`moetetranskripsjon/${id}/testtranskriber`, queryParams: queryParams, data: arg4, options: options });
    }
}

export class OppgaveRessursClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * Oppretter ny frittstående oppgave
     * HTTP PUT /oppgave
     * Java method: no.systemfabrikken.lederplan.resources.oppgave.OppgaveRessurs.opprett
     */
    opprett(arg0: MuterendeOppgaveSpesifikasjon, options?: RequestValg): RestResponse<OppgaveModell> {
        return this.httpClient.request({ method: 'PUT', url: uriEncoding`oppgave`, data: arg0, options: options });
    }

    /**
     * HTTP GET /oppgave/aggregerteOppgaverMedFristIPerioden
     * Java method: no.systemfabrikken.lederplan.resources.oppgave.OppgaveRessurs.aggregerteOppgaverMedFristIPerioden
     */
    aggregerteOppgaverMedFristIPerioden(queryParams?: { start?: ZonedDateTimeSerialisert; slutt?: ZonedDateTimeSerialisert; }, options?: RequestValg): RestResponse<AggregerteOppgaverModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`oppgave/aggregerteOppgaverMedFristIPerioden`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /oppgave/antallForfalteOppgaverForBruker
     * Java method: no.systemfabrikken.lederplan.resources.oppgave.OppgaveRessurs.antallForfalteOppgaverForBruker
     */
    antallForfalteOppgaverForBruker(options?: RequestValg): RestResponse<AntallForfalteOppgaver> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`oppgave/antallForfalteOppgaverForBruker`, options: options });
    }

    /**
     * Returnerer oversikt over antall oppgaver per bruker i gruppene kallende bruker har tilgang til. Brukere inkluderes i resultatet uavhengig av om de har tilgang ( {@link Medlem#harTilgang} ) eller ei. Merk at returnert liste kan inneholde ett innslag der {@link AntallOppgaverPerBrukerModell#bruker} er tom - dette representere oppgaver som ikke har ansvarlig satt eller som er tilknyttet inviterte medlemmer som ikke har akseptert invitasjonen.
     * HTTP GET /oppgave/antallOppgaverPerBruker
     * Java method: no.systemfabrikken.lederplan.resources.oppgave.OppgaveRessurs.antallOppgaverPerBruker
     */
    antallOppgaverPerBruker(options?: RequestValg): RestResponse<AntallOppgaverPerBrukerModell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`oppgave/antallOppgaverPerBruker`, options: options });
    }

    /**
     * Lister alle ikke-utførte oppgaver som forfalt før angitt dato, tilknyttet andre medlemmer i kallende brukers grupper
     * HTTP GET /oppgave/finnAndresIkkeUtfoerteOppgaverMedForfallFoer
     * Java method: no.systemfabrikken.lederplan.resources.oppgave.OppgaveRessurs.finnAndresIkkeUtførteOppgaverMedForfallFør
     */
    finnAndresIkkeUtførteOppgaverMedForfallFør(queryParams?: { forfallsdato?: ZonedDateTimeSerialisert; }, options?: RequestValg): RestResponse<OppgaveModell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`oppgave/finnAndresIkkeUtfoerteOppgaverMedForfallFoer`, queryParams: queryParams, options: options });
    }

    /**
     * Lister alle oppgaver med frist i angitt periode tilknyttet andre medlemmer i kallende brukers grupper
     * HTTP GET /oppgave/finnAndresOppgaverMedFristIPerioden
     * Java method: no.systemfabrikken.lederplan.resources.oppgave.OppgaveRessurs.finnAndresOppgaverMedFristIPerioden
     */
    finnAndresOppgaverMedFristIPerioden(queryParams?: { start?: ZonedDateTimeSerialisert; slutt?: ZonedDateTimeSerialisert; medUtforte?: boolean; }, options?: RequestValg): RestResponse<OppgaveModell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`oppgave/finnAndresOppgaverMedFristIPerioden`, queryParams: queryParams, options: options });
    }

    /**
     * Lister alle oppgaver med uten frist i angitt periode tilknyttet andre medlemmer i kallende brukers grupper
     * HTTP GET /oppgave/finnAndresOppgaverUtenFrist
     * Java method: no.systemfabrikken.lederplan.resources.oppgave.OppgaveRessurs.finnAndresOppgaverUtenFrist
     */
    finnAndresOppgaverUtenFrist(queryParams?: { medUtforte?: boolean; }, options?: RequestValg): RestResponse<OppgaveModell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`oppgave/finnAndresOppgaverUtenFrist`, queryParams: queryParams, options: options });
    }

    /**
     * Lister alle ikke-utførte oppgaver som forfalt før angitt dato, tilknyttet kallende bruker
     * HTTP GET /oppgave/finnIkkeUtfoerteOppgaverMedForfallFoer
     * Java method: no.systemfabrikken.lederplan.resources.oppgave.OppgaveRessurs.finnIkkeUtførteOppgaverMedForfallFør
     */
    finnIkkeUtførteOppgaverMedForfallFør(queryParams?: { forfallsdato?: ZonedDateTimeSerialisert; }, options?: RequestValg): RestResponse<OppgaveModell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`oppgave/finnIkkeUtfoerteOppgaverMedForfallFoer`, queryParams: queryParams, options: options });
    }

    /**
     * Lister alle ikke-utførte oppgaver som ikke har fått satt frist
     * HTTP GET /oppgave/finnIkkeUtfoerteOppgaverUtenFrist
     * Java method: no.systemfabrikken.lederplan.resources.oppgave.OppgaveRessurs.finnIkkeUtfoerteOppgaverUtenFrist
     */
    finnIkkeUtfoerteOppgaverUtenFrist(options?: RequestValg): RestResponse<OppgaveModell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`oppgave/finnIkkeUtfoerteOppgaverUtenFrist`, options: options });
    }

    /**
     * Lister oppgaver ihht angit spesifikasjon
     * HTTP POST /oppgave/finnOppgaver
     * Java method: no.systemfabrikken.lederplan.resources.oppgave.OppgaveRessurs.finnOppgaver
     */
    finnOppgaver(arg0: FinnOppgaverSpesifikasjon, options?: RequestValg): RestResponse<OppgaveModell[]> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`oppgave/finnOppgaver`, data: arg0, options: options });
    }

    /**
     * Lister alle oppgaver med frist i angitt periode tilknyttet kallende bruker
     * HTTP GET /oppgave/finnOppgaverMedFristIPerioden
     * Java method: no.systemfabrikken.lederplan.resources.oppgave.OppgaveRessurs.finnOppgaverMedFristIPerioden
     */
    finnOppgaverMedFristIPerioden(queryParams?: { start?: ZonedDateTimeSerialisert; slutt?: ZonedDateTimeSerialisert; medUtforte?: boolean; }, options?: RequestValg): RestResponse<OppgaveModell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`oppgave/finnOppgaverMedFristIPerioden`, queryParams: queryParams, options: options });
    }

    /**
     * Lister alle oppgaver med frist i angitt periode tilknyttet kallende bruker
     * HTTP POST /oppgave/finnOppgaverPaginert
     * Java method: no.systemfabrikken.lederplan.resources.oppgave.OppgaveRessurs.finnOppgaverPaginert
     */
    finnOppgaverPaginert(arg0: FinnOppgaverSpesifikasjon, options?: RequestValg): RestResponse<OppgaverMedPaginering> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`oppgave/finnOppgaverPaginert`, data: arg0, options: options });
    }

    /**
     * Lister alle oppgaver med uten frist i angitt periode tilknyttet kallende bruker
     * HTTP GET /oppgave/finnOppgaverUtenFrist
     * Java method: no.systemfabrikken.lederplan.resources.oppgave.OppgaveRessurs.finnOppgaverUtenFrist
     */
    finnOppgaverUtenFrist(queryParams?: { medUtforte?: boolean; }, options?: RequestValg): RestResponse<OppgaveModell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`oppgave/finnOppgaverUtenFrist`, queryParams: queryParams, options: options });
    }

    /**
     * Lister alle oppgaver med frist i angitt periode tilknyttet kallende bruker
     * HTTP GET /oppgave/finnUtfoerteOppgaverMedFristIPerioden
     * Java method: no.systemfabrikken.lederplan.resources.oppgave.OppgaveRessurs.finnUtførteOppgaverMedFristIPerioden
     */
    finnUtførteOppgaverMedFristIPerioden(queryParams?: { start?: ZonedDateTimeSerialisert; slutt?: ZonedDateTimeSerialisert; }, options?: RequestValg): RestResponse<OppgaveModell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`oppgave/finnUtfoerteOppgaverMedFristIPerioden`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /oppgave/markerSomUtfoert/{id}
     * Java method: no.systemfabrikken.lederplan.resources.oppgave.OppgaveRessurs.markerSomUtført
     */
    markerSomUtført(id: OppgaveId, arg1: OppdaterUtførSpesifikasjon, options?: RequestValg): RestResponse<AntallForfalteOppgaver> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`oppgave/markerSomUtfoert/${id}`, data: arg1, options: options });
    }

    /**
     * HTTP POST /oppgave/oppgaveAggregater
     * Java method: no.systemfabrikken.lederplan.resources.oppgave.OppgaveRessurs.oppgaveAggregater
     */
    oppgaveAggregater(arg0: FinnOppgaverSpesifikasjon, options?: RequestValg): RestResponse<OppgaveAggreatModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`oppgave/oppgaveAggregater`, data: arg0, options: options });
    }

    /**
     * HTTP GET /oppgave/{id}
     * Java method: no.systemfabrikken.lederplan.resources.oppgave.OppgaveRessurs.hent
     */
    hent(id: OppgaveId, options?: RequestValg): RestResponse<OppgaveModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`oppgave/${id}`, options: options });
    }

    /**
     * HTTP POST /oppgave/{id}
     * Java method: no.systemfabrikken.lederplan.resources.oppgave.OppgaveRessurs.oppdater
     */
    oppdater(id: OppgaveId, arg1: MuterendeOppgaveSpesifikasjon, options?: RequestValg): RestResponse<OppgaveModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`oppgave/${id}`, data: arg1, options: options });
    }

    /**
     * HTTP DELETE /oppgave/{id}
     * Java method: no.systemfabrikken.lederplan.resources.oppgave.OppgaveRessurs.slett
     */
    slett(id: OppgaveId, options?: RequestValg): RestResponse<OkRespons> {
        return this.httpClient.request({ method: 'DELETE', url: uriEncoding`oppgave/${id}`, options: options });
    }

    /**
     * HTTP PUT /oppgave/{id}/opprettKommentar
     * Java method: no.systemfabrikken.lederplan.resources.oppgave.OppgaveRessurs.opprettKommentar
     */
    opprettKommentar(id: OppgaveId, arg1: OpprettKommentarSpesifikasjon, options?: RequestValg): RestResponse<KommentarModell> {
        return this.httpClient.request({ method: 'PUT', url: uriEncoding`oppgave/${id}/opprettKommentar`, data: arg1, options: options });
    }

    /**
     * HTTP POST /oppgave/{id}/settStatus
     * Java method: no.systemfabrikken.lederplan.resources.oppgave.OppgaveRessurs.settStatus
     */
    settStatus(id: OppgaveId, arg1: OppdaterStatusSpesifikasjon, options?: RequestValg): RestResponse<OppgaveModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`oppgave/${id}/settStatus`, data: arg1, options: options });
    }
}

export class OtpOppsettRessursClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * HTTP POST /otpOppsett/aktiverSmsOtp
     * Java method: no.systemfabrikken.lederplan.resources.otpoppsett.OtpOppsettRessurs.aktiverSmsOtp
     */
    aktiverSmsOtp(options?: RequestValg): RestResponse<SmsOtpReservekoderModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`otpOppsett/aktiverSmsOtp`, options: options });
    }

    /**
     * Fullfører prosessen med å aktivere totp OTP for innlogget bruker.
     * HTTP POST /otpOppsett/bekreftOtpTotpOppsett
     * Java method: no.systemfabrikken.lederplan.resources.otpoppsett.OtpOppsettRessurs.bekreftOtpTotpOppsett
     */
    bekreftOtpTotpOppsett(arg0: OtpTotpKodeSpesifikasjon, options?: RequestValg): RestResponse<TotpOppsettBekreftetModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`otpOppsett/bekreftOtpTotpOppsett`, data: arg0, options: options });
    }

    /**
     * HTTP POST /otpOppsett/deaktiverSmsOtp
     * Java method: no.systemfabrikken.lederplan.resources.otpoppsett.OtpOppsettRessurs.deaktiverSmsOtp
     */
    deaktiverSmsOtp(arg0: Reautentiseringsinformasjon, options?: RequestValg): RestResponse<OtpDeaktivertModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`otpOppsett/deaktiverSmsOtp`, data: arg0, options: options });
    }

    /**
     * HTTP POST /otpOppsett/deaktiverTotp
     * Java method: no.systemfabrikken.lederplan.resources.otpoppsett.OtpOppsettRessurs.deaktiverTotp
     */
    deaktiverTotp(arg0: Reautentiseringsinformasjon, options?: RequestValg): RestResponse<OtpDeaktivertModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`otpOppsett/deaktiverTotp`, data: arg0, options: options });
    }

    /**
     * Starter prosessen med å aktivere totp OTP for innlogget bruker.
     * HTTP POST /otpOppsett/initierOtpTotpOppsett
     * Java method: no.systemfabrikken.lederplan.resources.otpoppsett.OtpOppsettRessurs.initierOtpTotpOppsett
     */
    initierOtpTotpOppsett(options?: RequestValg): RestResponse<InitierTotpQrkodeModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`otpOppsett/initierOtpTotpOppsett`, options: options });
    }

    /**
     * HTTP POST /otpOppsett/smsOtpReservekoder
     * Java method: no.systemfabrikken.lederplan.resources.otpoppsett.OtpOppsettRessurs.smsOtpReservekoder
     */
    smsOtpReservekoder(arg0: Reautentiseringsinformasjon, options?: RequestValg): RestResponse<SmsOtpReservekoderModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`otpOppsett/smsOtpReservekoder`, data: arg0, options: options });
    }

    /**
     * HTTP POST /otpOppsett/totpReservekoder
     * Java method: no.systemfabrikken.lederplan.resources.otpoppsett.OtpOppsettRessurs.totpReservekoder
     */
    totpReservekoder(arg0: Reautentiseringsinformasjon, options?: RequestValg): RestResponse<TotpReservekoderModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`otpOppsett/totpReservekoder`, data: arg0, options: options });
    }
}

/**
 * Ressurs som lar en sjekke om tjenesten svarer på http.
@todo beskyttes bak aksesstoken med @KunIntern() ?
 */
export class PingResourceClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * HTTP GET /admin/ping
     * Java method: no.systemfabrikken.lederplan.resources.admin.ping.PingResource.ping
     */
    ping(options?: RequestValg): RestResponse<Pong> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`admin/ping`, options: options });
    }
}

export class PlanRessursClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * HTTP GET /plan/hentAlle/{gruppeId}
     * Java method: no.systemfabrikken.lederplan.resources.plan.PlanRessurs.hentAlle
     */
    hentAlle(gruppeId: GruppeId, options?: RequestValg): RestResponse<PlanModell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`plan/hentAlle/${gruppeId}`, options: options });
    }

    /**
     * Henter alle planer knyttet til angitte grupper.
     * HTTP GET /plan/hentAlleForGrupper
     * Java method: no.systemfabrikken.lederplan.resources.plan.PlanRessurs.hentAlleForGrupper
     */
    hentAlleForGrupper(queryParams?: { gruppeIder?: GruppeId[]; }, options?: RequestValg): RestResponse<EnkelPlanModell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`plan/hentAlleForGrupper`, queryParams: queryParams, options: options });
    }

    /**
     * Returnerer planer som inneholder eller starter etter angitt dato, kun møter som avholdes på eller etter angitt dato er inkludert i returnerte planers møte-liste
     * HTTP GET /plan/hentPlanerFraOgMed/{gruppeId}
     * Java method: no.systemfabrikken.lederplan.resources.plan.PlanRessurs.hentPlanerFraOgMed
     */
    hentPlanerFraOgMed(gruppeId: GruppeId, queryParams?: { start?: ZonedDateTimeSerialisert; }, options?: RequestValg): RestResponse<PlanModell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`plan/hentPlanerFraOgMed/${gruppeId}`, queryParams: queryParams, options: options });
    }

    /**
     * Returnerer inneværende og fremtidige planer dersom de har minst ett ikke-passert møte, kun fremtidige møter er inkludert i returnerte planers møte-liste
     * HTTP GET /plan/hentPlanerFraOgMedNaa/{gruppeId}
     * Java method: no.systemfabrikken.lederplan.resources.plan.PlanRessurs.hentPlanerFraOgMedNå
     */
    hentPlanerFraOgMedNå(gruppeId: GruppeId, options?: RequestValg): RestResponse<PlanModell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`plan/hentPlanerFraOgMedNaa/${gruppeId}`, options: options });
    }

    /**
     * HTTP PUT /plan/{gruppeId}/medmoeter
     * Java method: no.systemfabrikken.lederplan.resources.plan.PlanRessurs.opprettPlanMedMøter
     */
    opprettPlanMedMøter(gruppeId: GruppeId, arg1: PlanMedMøterSpesifikasjon, options?: RequestValg): RestResponse<OkRespons> {
        return this.httpClient.request({ method: 'PUT', url: uriEncoding`plan/${gruppeId}/medmoeter`, data: arg1, options: options });
    }

    /**
     * HTTP GET /plan/{id}
     * Java method: no.systemfabrikken.lederplan.resources.plan.PlanRessurs.hent
     */
    hent(id: PlanId, options?: RequestValg): RestResponse<PlanModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`plan/${id}`, options: options });
    }

    /**
     * HTTP GET /plan/{id}/enkel
     * Java method: no.systemfabrikken.lederplan.resources.plan.PlanRessurs.hentEnkel
     */
    hentEnkel(id: PlanId, options?: RequestValg): RestResponse<EnkelPlanModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`plan/${id}/enkel`, options: options });
    }

    /**
     * HTTP POST /plan/{id}/settFoersteNummer
     * Java method: no.systemfabrikken.lederplan.resources.plan.PlanRessurs.oppdaterFørsteMoteOgSaksnummer
     */
    oppdaterFørsteMoteOgSaksnummer(id: PlanId, arg1: OppdaterFørsteSakOgMøtenummerSpesifikasjon, options?: RequestValg): RestResponse<PlanModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`plan/${id}/settFoersteNummer`, data: arg1, options: options });
    }
}

export class ProtokollRessursClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * HTTP GET /protokoll/finnMoeteProtokolldokumentGjelderFor/{dokumentId}
     * Java method: no.systemfabrikken.lederplan.resources.møte.ProtokollRessurs.finnMoeteProtokolldokumentGjelderFor
     */
    finnMoeteProtokolldokumentGjelderFor(dokumentId: DokumentId, options?: RequestValg): RestResponse<EntitetIdRespons> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`protokoll/finnMoeteProtokolldokumentGjelderFor/${dokumentId}`, options: options });
    }

    /**
     * HTTP GET /protokoll/finnMoeteProtokolldokumentISakGjelderFor/{dokumentId}
     * Java method: no.systemfabrikken.lederplan.resources.møte.ProtokollRessurs.finnMøteProtokolldokumentISakGjelderFor
     */
    finnMøteProtokolldokumentISakGjelderFor(dokumentId: DokumentId, options?: RequestValg): RestResponse<EntitetIdRespons> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`protokoll/finnMoeteProtokolldokumentISakGjelderFor/${dokumentId}`, options: options });
    }

    /**
     * HTTP GET /protokoll/finnMoetemodellProtokolldokumentISakGjelderFor/{dokumentId}
     * Java method: no.systemfabrikken.lederplan.resources.møte.ProtokollRessurs.finnMøtemodellProtokolldokumentISakGjelderFor
     */
    finnMøtemodellProtokolldokumentISakGjelderFor(dokumentId: DokumentId, options?: RequestValg): RestResponse<TynnMøteModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`protokoll/finnMoetemodellProtokolldokumentISakGjelderFor/${dokumentId}`, options: options });
    }

    /**
     * HTTP GET /protokoll/{id}
     * Java method: no.systemfabrikken.lederplan.resources.møte.ProtokollRessurs.hent
     */
    hent(id: MøteId, options?: RequestValg): RestResponse<ProtokollDetaljerModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`protokoll/${id}`, options: options });
    }

    /**
     * HTTP GET /protokoll/{id}/deltakere
     * Java method: no.systemfabrikken.lederplan.resources.møte.ProtokollRessurs.deltakere
     */
    deltakere(id: MøteId, options?: RequestValg): RestResponse<ProtokollførtMøtedeltakereModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`protokoll/${id}/deltakere`, options: options });
    }

    /**
     * HTTP POST /protokoll/{id}/laasOppProtokoll
     * Java method: no.systemfabrikken.lederplan.resources.møte.ProtokollRessurs.låsOppProtokoll
     */
    låsOppProtokoll(id: MøteId, arg1: LåsOppProtokollSpesifikasjon, options?: RequestValg): RestResponse<MøteModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`protokoll/${id}/laasOppProtokoll`, data: arg1, options: options });
    }

    /**
     * Oppdaterer protokoll i henhold til angitt spesifikasjon.
@return returnerer valideringsfeil av typen {@link MøteProtokollValideringsfeil}
     * HTTP POST /protokoll/{id}/oppdaterProtokoll
     * Java method: no.systemfabrikken.lederplan.resources.møte.ProtokollRessurs.oppdaterProtokoll
     */
    oppdaterProtokoll(id: MøteId, arg1: ProtokollSpesifikasjon, options?: RequestValg): RestResponse<ValideringsresultatModell<MøteProtokollValideringsfeil>> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`protokoll/${id}/oppdaterProtokoll`, data: arg1, options: options });
    }

    /**
     * HTTP POST /protokoll/{id}/publiser
     * Java method: no.systemfabrikken.lederplan.resources.møte.ProtokollRessurs.oppdaterPublisering
     */
    oppdaterPublisering(id: MøteId, arg1: MøtepubliseringSpesifikasjon, options?: RequestValg): RestResponse<MøteModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`protokoll/${id}/publiser`, data: arg1, options: options });
    }

    /**
     * HTTP POST /protokoll/{id}/registrerSignertProtokolldokument
     * Java method: no.systemfabrikken.lederplan.resources.møte.ProtokollRessurs.registrerSignertProtokolldokument
     */
    registrerSignertProtokolldokument(id: MøteId, arg1: any, options?: RequestValg): RestResponse<MøteModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`protokoll/${id}/registrerSignertProtokolldokument`, data: arg1, options: options });
    }

    /**
     * HTTP POST /protokoll/{id}/sendTilSignering
     * Java method: no.systemfabrikken.lederplan.resources.møte.ProtokollRessurs.sendTilSignering
     */
    sendTilSignering(id: MøteId, arg1: SendProtokollsigneringsInvitasjonSpesifikasjon, options?: RequestValg): RestResponse<MøteModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`protokoll/${id}/sendTilSignering`, data: arg1, options: options });
    }
}

export class RevisjonsloggRessursClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * HTTP GET /revisjonslogg/finnEndringerIPerioden
     * Java method: no.systemfabrikken.lederplan.resources.revisjonslogg.RevisjonsloggRessurs.finnEndringerIPerioden
     */
    finnEndringerIPerioden(queryParams?: { start?: ZonedDateTimeSerialisert; slutt?: ZonedDateTimeSerialisert; }, options?: RequestValg): RestResponse<EndringshendelseModell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`revisjonslogg/finnEndringerIPerioden`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /revisjonslogg/finnEndringerKnyttetTilGruppe
     * Java method: no.systemfabrikken.lederplan.resources.revisjonslogg.RevisjonsloggRessurs.finnEndringerKnyttetTilGruppe
     */
    finnEndringerKnyttetTilGruppe(queryParams?: { id?: GruppeId; offset?: number; antall?: number; }, options?: RequestValg): RestResponse<SøkeresultatModell<EndringshendelseModell>> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`revisjonslogg/finnEndringerKnyttetTilGruppe`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /revisjonslogg/finnEndringerKnyttetTilMoete
     * Java method: no.systemfabrikken.lederplan.resources.revisjonslogg.RevisjonsloggRessurs.finnEndringerKnyttetTilMøte
     */
    finnEndringerKnyttetTilMøte(queryParams?: { id?: MøteId; offset?: number; antall?: number; }, options?: RequestValg): RestResponse<SøkeresultatModell<EndringshendelseModell>> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`revisjonslogg/finnEndringerKnyttetTilMoete`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /revisjonslogg/finnEndringerKnyttetTilSak
     * Java method: no.systemfabrikken.lederplan.resources.revisjonslogg.RevisjonsloggRessurs.finnEndringerKnyttetTilSak
     */
    finnEndringerKnyttetTilSak(queryParams?: { id?: AgendaelementId; offset?: number; antall?: number; }, options?: RequestValg): RestResponse<SøkeresultatModell<EndringshendelseModell>> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`revisjonslogg/finnEndringerKnyttetTilSak`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /revisjonslogg/finnEndringerUtfoertAvBruker
     * Java method: no.systemfabrikken.lederplan.resources.revisjonslogg.RevisjonsloggRessurs.finnEndringerUtførtAvBruker
     */
    finnEndringerUtførtAvBruker(queryParams?: { brukerId?: BrukerId; sortering?: Sortering; antall?: number; offset?: number; }, options?: RequestValg): RestResponse<SøkeresultatModell<EndringshendelseModell>> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`revisjonslogg/finnEndringerUtfoertAvBruker`, queryParams: queryParams, options: options });
    }
}

export class SakRessursClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * HTTP PUT /sak
     * Java method: no.systemfabrikken.lederplan.resources.sak.SakRessurs.opprett
     */
    opprett(arg0: OpprettSakSpesifikasjon, options?: RequestValg): RestResponse<AgendaelementModell> {
        return this.httpClient.request({ method: 'PUT', url: uriEncoding`sak`, data: arg0, options: options });
    }

    /**
     * HTTP GET /sak/brukersAntallsaker
     * Java method: no.systemfabrikken.lederplan.resources.sak.SakRessurs.brukersAntallsaker
     */
    brukersAntallsaker(options?: RequestValg): RestResponse<BrukersSaksstatistikk> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`sak/brukersAntallsaker`, options: options });
    }

    /**
     * HTTP GET /sak/brukersSaksoversikt
     * Java method: no.systemfabrikken.lederplan.resources.sak.SakRessurs.brukersSaksoversikt
     */
    brukersSaksoversikt(options?: RequestValg): RestResponse<GruppertTynnSakModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`sak/brukersSaksoversikt`, options: options });
    }

    /**
     * HTTP POST /sak/finnSakerSomMaler
     * Java method: no.systemfabrikken.lederplan.resources.sak.SakRessurs.finnSakerSomMaler
     */
    finnSakerSomMaler(arg0: FinnSakerSomMalerSpesifikasjon, options?: RequestValg): RestResponse<FinnSakerOgMalsakerResultatModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`sak/finnSakerSomMaler`, data: arg0, options: options });
    }

    /**
     * HTTP GET /sak/finnSaksIdKnyttetTilBeslutning
     * Java method: no.systemfabrikken.lederplan.resources.sak.SakRessurs.finnSaksIdKnyttetTilBeslutning
     */
    finnSaksIdKnyttetTilBeslutning(queryParams?: { beslutningId?: BeslutningId; }, options?: RequestValg): RestResponse<EntitetIdRespons> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`sak/finnSaksIdKnyttetTilBeslutning`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP PUT /sak/opprettKommentar/{id}
     * Java method: no.systemfabrikken.lederplan.resources.sak.SakRessurs.opprettKommentar
     */
    opprettKommentar(id: AgendaelementId, arg1: OpprettKommentarSpesifikasjon, options?: RequestValg): RestResponse<KommentarModell> {
        return this.httpClient.request({ method: 'PUT', url: uriEncoding`sak/opprettKommentar/${id}`, data: arg1, options: options });
    }

    /**
     * HTTP PUT /sak/opprettOppgave/{id}
     * Java method: no.systemfabrikken.lederplan.resources.sak.SakRessurs.opprettOppgave
     */
    opprettOppgave(id: AgendaelementId, arg1: MuterendeOppgaveSpesifikasjon, options?: RequestValg): RestResponse<OppgaveModell> {
        return this.httpClient.request({ method: 'PUT', url: uriEncoding`sak/opprettOppgave/${id}`, data: arg1, options: options });
    }

    /**
     * @deprecated
     * HTTP PUT /sak/opprettSaker
     * Java method: no.systemfabrikken.lederplan.resources.sak.SakRessurs.opprettSaker
     */
    opprettSaker(arg0: OpprettSakSpesifikasjon[], options?: RequestValg): RestResponse<AgendaelementModell[]> {
        return this.httpClient.request({ method: 'PUT', url: uriEncoding`sak/opprettSaker`, data: arg0, options: options });
    }

    /**
     * Oppretter nye saker
@todo endre navn til opprettsaker når mobilklient oppdatert
     * HTTP PUT /sak/opprettSakerMedOpsjoner
     * Java method: no.systemfabrikken.lederplan.resources.sak.SakRessurs.opprettSakerMedOpsjoner
     */
    opprettSakerMedOpsjoner(arg0: OpprettSakerSpesifikasjon, options?: RequestValg): RestResponse<MøteModell> {
        return this.httpClient.request({ method: 'PUT', url: uriEncoding`sak/opprettSakerMedOpsjoner`, data: arg0, options: options });
    }

    /**
     * HTTP POST /sak/pause/{id}
     * Java method: no.systemfabrikken.lederplan.resources.sak.SakRessurs.oppdaterPause
     */
    oppdaterPause(id: AgendaelementId, arg1: OppdaterPauseSpesifikasjon, options?: RequestValg): RestResponse<AgendaelementModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`sak/pause/${id}`, data: arg1, options: options });
    }

    /**
     * HTTP GET /sak/{id}
     * Java method: no.systemfabrikken.lederplan.resources.sak.SakRessurs.hent
     */
    hent(id: AgendaelementId, options?: RequestValg): RestResponse<AgendaelementModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`sak/${id}`, options: options });
    }

    /**
     * HTTP POST /sak/{id}
     * Java method: no.systemfabrikken.lederplan.resources.sak.SakRessurs.oppdater
     */
    oppdater(id: AgendaelementId, arg1: OppdaterSakSpesifikasjon, options?: RequestValg): RestResponse<AgendaelementModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`sak/${id}`, data: arg1, options: options });
    }

    /**
     * HTTP DELETE /sak/{id}
     * Java method: no.systemfabrikken.lederplan.resources.sak.SakRessurs.slett
     */
    slett(id: AgendaelementId, options?: RequestValg): RestResponse<OkRespons> {
        return this.httpClient.request({ method: 'DELETE', url: uriEncoding`sak/${id}`, options: options });
    }

    /**
     * Returnerer saken før angitt sakId, null dersom ingen tidligere saker i samme møte Merk at vi "hopper over" skjermede saker.
     * HTTP GET /sak/{id}/finnForrigeSak
     * Java method: no.systemfabrikken.lederplan.resources.sak.SakRessurs.finnForrigeSak
     */
    finnForrigeSak(id: AgendaelementId, options?: RequestValg): RestResponse<AgendaelementModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`sak/${id}/finnForrigeSak`, options: options });
    }

    /**
     * Returnerer saken etter angitt sakId, null dersom ingen senere saker i samme møte Merk at vi "hopper over" skjermede saker.
     * HTTP GET /sak/{id}/finnNesteSak
     * Java method: no.systemfabrikken.lederplan.resources.sak.SakRessurs.finnNesteSak
     */
    finnNesteSak(id: AgendaelementId, options?: RequestValg): RestResponse<AgendaelementModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`sak/${id}/finnNesteSak`, options: options });
    }

    /**
     * HTTP POST /sak/{id}/flyttTil/{moeteId}
     * Java method: no.systemfabrikken.lederplan.resources.sak.SakRessurs.flyttTilMøte
     */
    flyttTilMøte(id: AgendaelementId, moeteId: MøteId, options?: RequestValg): RestResponse<SakFlyttetModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`sak/${id}/flyttTil/${moeteId}`, options: options });
    }

    /**
     * HTTP POST /sak/{id}/kopierTilMoeter
     * Java method: no.systemfabrikken.lederplan.resources.sak.SakRessurs.kopierTilMøter
     */
    kopierTilMøter(id: AgendaelementId, arg1: KopierTilMøterSpesifikasjon, options?: RequestValg): RestResponse<MøteOgNySakModell[]> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`sak/${id}/kopierTilMoeter`, data: arg1, options: options });
    }

    /**
     * Oppdaterer sak
@todo endre navn til oppdater når mobilklient oppdatert
     * HTTP POST /sak/{id}/medOpsjoner
     * Java method: no.systemfabrikken.lederplan.resources.sak.SakRessurs.oppdaterMedOpsjoner
     */
    oppdaterMedOpsjoner(id: AgendaelementId, arg1: OppdaterSakMedOpsjonerSpesifikasjon, options?: RequestValg): RestResponse<AgendaelementModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`sak/${id}/medOpsjoner`, data: arg1, options: options });
    }

    /**
     * HTTP POST /sak/{id}/oppdaterDokumentrekkefoelge
     * Java method: no.systemfabrikken.lederplan.resources.sak.SakRessurs.oppdaterDokumentrekkefølge
     */
    oppdaterDokumentrekkefølge(id: AgendaelementId, arg1: OppdaterDokumentrekkefølgeSpesifikasjon, options?: RequestValg): RestResponse<AgendaelementModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`sak/${id}/oppdaterDokumentrekkefoelge`, data: arg1, options: options });
    }

    /**
     * HTTP PUT /sak/{id}/opprettAgendaDokument
     * Java method: no.systemfabrikken.lederplan.resources.sak.SakRessurs.opprettAgendaDokument
     */
    opprettAgendaDokument(id: AgendaelementId, options?: RequestValg): RestResponse<SaksdokumentModell> {
        return this.httpClient.request({ method: 'PUT', url: uriEncoding`sak/${id}/opprettAgendaDokument`, options: options });
    }

    /**
     * HTTP PUT /sak/{id}/opprettArkivDokumentISak
     * Java method: no.systemfabrikken.lederplan.resources.sak.SakRessurs.opprettArkivDokumentISak
     */
    opprettArkivDokumentISak(id: AgendaelementId, arg1: OpprettArkivdokumentISakSpesifikasjon, options?: RequestValg): RestResponse<SaksdokumentModell> {
        return this.httpClient.request({ method: 'PUT', url: uriEncoding`sak/${id}/opprettArkivDokumentISak`, data: arg1, options: options });
    }

    /**
     * HTTP PUT /sak/{id}/opprettDokument
     * Java method: no.systemfabrikken.lederplan.resources.sak.SakRessurs.opprettDokument
     */
    opprettDokument$PUT$sak_id_opprettDokument(id: AgendaelementId, arg1: any, options?: RequestValg): RestResponse<SaksdokumentModell> {
        return this.httpClient.request({ method: 'PUT', url: uriEncoding`sak/${id}/opprettDokument`, data: arg1, options: options });
    }

    /**
     * HTTP POST /sak/{id}/opprettDokument
     * Java method: no.systemfabrikken.lederplan.resources.sak.SakRessurs.opprettDokument
     */
    opprettDokument$POST$sak_id_opprettDokument(id: AgendaelementId, arg1: any, options?: RequestValg): RestResponse<AgendaelementModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`sak/${id}/opprettDokument`, data: arg1, options: options });
    }

    /**
     * Registrerer ny versjon av et saksdokument, kalt fra web-appen.
     * HTTP PUT /sak/{id}/opprettDokumentVersjon/{dokumentId}
     * Java method: no.systemfabrikken.lederplan.resources.sak.SakRessurs.opprettDokumentVersjon
     */
    opprettDokumentVersjon(id: AgendaelementId, dokumentId: DokumentId, arg2: any, options?: RequestValg): RestResponse<SaksdokumentModell> {
        return this.httpClient.request({ method: 'PUT', url: uriEncoding`sak/${id}/opprettDokumentVersjon/${dokumentId}`, data: arg2, options: options });
    }

    /**
     * HTTP PUT /sak/{id}/opprettForfalteOppgaverDokument
     * Java method: no.systemfabrikken.lederplan.resources.sak.SakRessurs.opprettForfalteOppgaverDokument
     */
    opprettForfalteOppgaverDokument(id: AgendaelementId, options?: RequestValg): RestResponse<SaksdokumentModell> {
        return this.httpClient.request({ method: 'PUT', url: uriEncoding`sak/${id}/opprettForfalteOppgaverDokument`, options: options });
    }

    /**
     * HTTP PUT /sak/{id}/opprettProtokollDokumentISak/{moeteId}
     * Java method: no.systemfabrikken.lederplan.resources.sak.SakRessurs.opprettProtokollDokumentISak
     */
    opprettProtokollDokumentISak(id: AgendaelementId, moeteId: MøteId, options?: RequestValg): RestResponse<SaksdokumentModell> {
        return this.httpClient.request({ method: 'PUT', url: uriEncoding`sak/${id}/opprettProtokollDokumentISak/${moeteId}`, options: options });
    }

    /**
     * HTTP PUT /sak/{id}/opprettProtokollDokumenterISak
     * Java method: no.systemfabrikken.lederplan.resources.sak.SakRessurs.opprettProtokollDokumenterISak
     */
    opprettProtokollDokumenterISak(id: AgendaelementId, arg1: ProtokolldokumenterSpesifikasjon, options?: RequestValg): RestResponse<SaksdokumentModell[]> {
        return this.httpClient.request({ method: 'PUT', url: uriEncoding`sak/${id}/opprettProtokollDokumenterISak`, data: arg1, options: options });
    }

    /**
     * HTTP PUT /sak/{id}/opprettSpoerreundersoekelseRapportISak/
     * Java method: no.systemfabrikken.lederplan.resources.sak.SakRessurs.opprettSpørreundersøkelseRapportISak
     */
    opprettSpørreundersøkelseRapportISak(id: AgendaelementId, arg1: SpørreundersøkelseRapporterSpesifikasjon, options?: RequestValg): RestResponse<SaksdokumentModell[]> {
        return this.httpClient.request({ method: 'PUT', url: uriEncoding`sak/${id}/opprettSpoerreundersoekelseRapportISak/`, data: arg1, options: options });
    }

    /**
     * HTTP GET /sak/{id}/pdf/{filnavn}
     * Java method: no.systemfabrikken.lederplan.resources.sak.SakRessurs.lastNedSaksdokument
     */
    lastNedSaksdokument(id: AgendaelementId, filnavn: string, options?: RequestValg): RestResponse<any> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`sak/${id}/pdf/${filnavn}`, options: options });
    }

    /**
     * HTTP POST /sak/{id}/referat
     * Java method: no.systemfabrikken.lederplan.resources.sak.SakRessurs.oppdaterReferat
     */
    oppdaterReferat(id: AgendaelementId, arg1: OppdaterReferatSpesifikasjon, options?: RequestValg): RestResponse<OkRespons> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`sak/${id}/referat`, data: arg1, options: options });
    }

    /**
     * HTTP POST /sak/{id}/referatOgBeslutninger
     * Java method: no.systemfabrikken.lederplan.resources.sak.SakRessurs.oppdaterReferatOgBeslutninger
     */
    oppdaterReferatOgBeslutninger(id: AgendaelementId, arg1: SaksreferatSpesifikasjon, options?: RequestValg): RestResponse<AgendaelementModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`sak/${id}/referatOgBeslutninger`, data: arg1, options: options });
    }

    /**
     * HTTP GET /sak/{id}/skjerming
     * Java method: no.systemfabrikken.lederplan.resources.sak.SakRessurs.hentSkjerming
     */
    hentSkjerming(id: AgendaelementId, options?: RequestValg): RestResponse<SkjermingDetaljerModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`sak/${id}/skjerming`, options: options });
    }

    /**
     * HTTP POST /sak/{id}/skjerming
     * Java method: no.systemfabrikken.lederplan.resources.sak.SakRessurs.oppdaterSkjerming
     */
    oppdaterSkjerming(id: AgendaelementId, arg1: OppdaterSkjermingSpesifikasjon, options?: RequestValg): RestResponse<SkjermingDetaljerMedValideringsresultatModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`sak/${id}/skjerming`, data: arg1, options: options });
    }

    /**
     * HTTP DELETE /sak/{id}/slettDokument/{dokumentId}
     * Java method: no.systemfabrikken.lederplan.resources.sak.SakRessurs.slettDokument
     */
    slettDokument(id: AgendaelementId, dokumentId: DokumentId, options?: RequestValg): RestResponse<AgendaelementModell> {
        return this.httpClient.request({ method: 'DELETE', url: uriEncoding`sak/${id}/slettDokument/${dokumentId}`, options: options });
    }

    /**
     * HTTP DELETE /sak/{id}/slettOppgave/{oppgaveId}
     * Java method: no.systemfabrikken.lederplan.resources.sak.SakRessurs.slettOppgave
     */
    slettOppgave(id: AgendaelementId, oppgaveId: OppgaveId, options?: RequestValg): RestResponse<OkRespons> {
        return this.httpClient.request({ method: 'DELETE', url: uriEncoding`sak/${id}/slettOppgave/${oppgaveId}`, options: options });
    }

    /**
     * HTTP POST /sak/{id}/validerKopierTilMoeter
     * Java method: no.systemfabrikken.lederplan.resources.sak.SakRessurs.validerKopierTilMøter
     */
    validerKopierTilMøter(id: AgendaelementId, arg1: KopierTilMøterSpesifikasjon, options?: RequestValg): RestResponse<KopierSakTilMøterValideringsfeil> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`sak/${id}/validerKopierTilMoeter`, data: arg1, options: options });
    }
}

export class SakSkyfilOpplastingRessursClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * HTTP GET /sakskyfilopplasting/googlePickerKonfigurasjon
     * Java method: no.systemfabrikken.lederplan.resources.sak.SakSkyfilOpplastingRessurs.googlePickerKonfigurasjon
     */
    googlePickerKonfigurasjon(options?: RequestValg): RestResponse<GooglePickerKonfigurasjonModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`sakskyfilopplasting/googlePickerKonfigurasjon`, options: options });
    }

    /**
     * HTTP GET /sakskyfilopplasting/microsoftMsalAuthRespons
     * Java method: no.systemfabrikken.lederplan.resources.sak.SakSkyfilOpplastingRessurs.microsoftOneDriveAuthRespons
     */
    microsoftOneDriveAuthRespons(options?: RequestValg): RestResponse<string> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`sakskyfilopplasting/microsoftMsalAuthRespons`, options: options });
    }

    /**
     * HTTP GET /sakskyfilopplasting/microsoftOneDrivePickerKonfigurasjon
     * Java method: no.systemfabrikken.lederplan.resources.sak.SakSkyfilOpplastingRessurs.microsoftOneDrivePickerKonfigurasjon
     */
    microsoftOneDrivePickerKonfigurasjon(options?: RequestValg): RestResponse<MicrosoftOneDrivePickerKonfigurasjonModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`sakskyfilopplasting/microsoftOneDrivePickerKonfigurasjon`, options: options });
    }

    /**
     * Importerer dokument fra google drive, registrerer nytt saksdokument, kalt fra web-appen.
     * HTTP PUT /sakskyfilopplasting/{id}/importerGoogleDokumentISak
     * Java method: no.systemfabrikken.lederplan.resources.sak.SakSkyfilOpplastingRessurs.importerGoogleDokumentISak
     */
    importerGoogleDokumentISak(id: AgendaelementId, arg1: ImporterGoogleDokumentISakSpesifikasjon, options?: RequestValg): RestResponse<any> {
        return this.httpClient.request({ method: 'PUT', url: uriEncoding`sakskyfilopplasting/${id}/importerGoogleDokumentISak`, data: arg1, options: options });
    }

    /**
     * Importerer dokument fra google drive, registrerer ny versjon av et saksdokument, kalt fra web-appen.
     * HTTP PUT /sakskyfilopplasting/{id}/importerGoogleDokumentSomDokumentversjon/{dokumentId}
     * Java method: no.systemfabrikken.lederplan.resources.sak.SakSkyfilOpplastingRessurs.importerGoogleDokumentSomDokumentversjon
     */
    importerGoogleDokumentSomDokumentversjon(id: AgendaelementId, dokumentId: DokumentId, arg2: ImporterGoogleDokumentISakSpesifikasjon, options?: RequestValg): RestResponse<any> {
        return this.httpClient.request({ method: 'PUT', url: uriEncoding`sakskyfilopplasting/${id}/importerGoogleDokumentSomDokumentversjon/${dokumentId}`, data: arg2, options: options });
    }

    /**
     * Importerer dokument fra microsoft one drive, registrerer nytt saksdokument, kalt fra web-appen.
     * HTTP PUT /sakskyfilopplasting/{id}/importerMicrosoftOneDriveDokumentISak
     * Java method: no.systemfabrikken.lederplan.resources.sak.SakSkyfilOpplastingRessurs.importerMicrosoftOneDriveDokumentISak
     */
    importerMicrosoftOneDriveDokumentISak(id: AgendaelementId, arg1: ImporterMicrosoftOneDriveDokumentISakSpesifikasjon, options?: RequestValg): RestResponse<any> {
        return this.httpClient.request({ method: 'PUT', url: uriEncoding`sakskyfilopplasting/${id}/importerMicrosoftOneDriveDokumentISak`, data: arg1, options: options });
    }

    /**
     * Importerer dokument fra microsoft one drive, registrerer ny versjon av et saksdokument, kalt fra web-appen.
     * HTTP PUT /sakskyfilopplasting/{id}/importerMicrosoftOneDriveSomDokumentversjon/{dokumentId}
     * Java method: no.systemfabrikken.lederplan.resources.sak.SakSkyfilOpplastingRessurs.importerMicrosoftOneDriveSomDokumentversjon
     */
    importerMicrosoftOneDriveSomDokumentversjon(id: AgendaelementId, dokumentId: DokumentId, arg2: ImporterMicrosoftOneDriveDokumentISakSpesifikasjon, options?: RequestValg): RestResponse<any> {
        return this.httpClient.request({ method: 'PUT', url: uriEncoding`sakskyfilopplasting/${id}/importerMicrosoftOneDriveSomDokumentversjon/${dokumentId}`, data: arg2, options: options });
    }
}

export class SakstypeRessursClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * HTTP POST /sakstype/oppdater
     * Java method: no.systemfabrikken.lederplan.resources.sakstype.SakstypeRessurs.oppdater
     */
    oppdater(arg0: OppdaterSakstypeSpesifikasjon, options?: RequestValg): RestResponse<SakstypeModell[]> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`sakstype/oppdater`, data: arg0, options: options });
    }

    /**
     * HTTP GET /sakstype/{gruppeId}
     * Java method: no.systemfabrikken.lederplan.resources.sakstype.SakstypeRessurs.finnAlle
     */
    finnAlle(gruppeId: GruppeId, options?: RequestValg): RestResponse<SakstypeModell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`sakstype/${gruppeId}`, options: options });
    }
}

export class SkatteetatenAksjeeierbokRessursClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * HTTP GET /skatteetaten/{orgnummer}
     * Java method: no.systemfabrikken.lederplan.resources.aksjeeierbok.SkatteetatenAksjeeierbokRessurs.finn
     */
    finn(orgnummer: Organisasjonsnummer, options?: RequestValg): RestResponse<SkatteetatenAksjeeierbokModellResponse> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`skatteetaten/${orgnummer}`, options: options });
    }

    /**
     * HTTP GET /skatteetaten/{orgnummer}/sammendrag
     * Java method: no.systemfabrikken.lederplan.resources.aksjeeierbok.SkatteetatenAksjeeierbokRessurs.sammendrag
     */
    sammendrag(orgnummer: Organisasjonsnummer, options?: RequestValg): RestResponse<SkatteetatenAksjeeierbokSammendragModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`skatteetaten/${orgnummer}/sammendrag`, options: options });
    }
}

export class SkjemalåsRessursClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * Returnerer liste med skjemalåser som matcher angitte paramter. Merk at angitt `rotentitetId` av typen {@link EntitetReferanseSpesifikasjon} må være på serialisert form `type:id`, feks `møte:0276149c-c7ba-429a-9ec6-5ac772be5125`
     * HTTP GET /skjemalaas/finn
     * Java method: no.systemfabrikken.lederplan.resources.skjemalås.SkjemalåsRessurs.finn
     */
    finn(queryParams?: { gruppeId?: GruppeId; rotentitetId?: EntitetReferanseSpesifikasjon; skjemaId?: SkjemalåsSkjemaId; }, options?: RequestValg): RestResponse<SkjemalåsModell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`skjemalaas/finn`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP DELETE /skjemalaas/frigi
     * Java method: no.systemfabrikken.lederplan.resources.skjemalås.SkjemalåsRessurs.frigi
     */
    frigi(queryParams?: { id?: SkjemalåsId; klientId?: KlientId; }, options?: RequestValg): RestResponse<OkRespons> {
        return this.httpClient.request({ method: 'DELETE', url: uriEncoding`skjemalaas/frigi`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /skjemalaas/oppdater
     * Java method: no.systemfabrikken.lederplan.resources.skjemalås.SkjemalåsRessurs.oppdater
     */
    oppdater(arg0: OppdaterSkjemalåsSpesifikasjon, options?: RequestValg): RestResponse<OppdaterSkjemalåsResponsModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`skjemalaas/oppdater`, data: arg0, options: options });
    }

    /**
     * HTTP PUT /skjemalaas/opprett
     * Java method: no.systemfabrikken.lederplan.resources.skjemalås.SkjemalåsRessurs.opprett
     */
    opprett(arg0: OpprettSkjemalåsSpesifikasjon, options?: RequestValg): RestResponse<OpprettSkjemalåsResponsModell> {
        return this.httpClient.request({ method: 'PUT', url: uriEncoding`skjemalaas/opprett`, data: arg0, options: options });
    }
}

/**
 * Administrasjon (opprettelse, redigering og sletting) av spørreskjemaer, kun tilgjengelig for systemadministratorer. Skjemaer som er i bruk av en eller flere undersøkelser kan ikke slettes, og kun tekster kan endres, se {@link Spørreskjema#oppdater} . Skjemaer kan begrenses til et sett av avtaler, se {@link Spørreskjema#begrensTilAvtaler} .
 */
export class SpørreskjemaAdministrasjonRessursClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * HTTP GET /admin/spoerreskjema
     * Java method: no.systemfabrikken.lederplan.resources.admin.spørreskjema.SpørreskjemaAdministrasjonRessurs.finnAlle
     */
    finnAlle(options?: RequestValg): RestResponse<SpørreskjemaAdministrasjonModell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`admin/spoerreskjema`, options: options });
    }

    /**
     * HTTP PUT /admin/spoerreskjema
     * Java method: no.systemfabrikken.lederplan.resources.admin.spørreskjema.SpørreskjemaAdministrasjonRessurs.opprett
     */
    opprett(arg0: LagreSpørreskjemaSpesifikasjon, options?: RequestValg): RestResponse<SpørreskjemaAdministrasjonModell> {
        return this.httpClient.request({ method: 'PUT', url: uriEncoding`admin/spoerreskjema`, data: arg0, options: options });
    }

    /**
     * HTTP GET /admin/spoerreskjema/{id}
     * Java method: no.systemfabrikken.lederplan.resources.admin.spørreskjema.SpørreskjemaAdministrasjonRessurs.hent
     */
    hent(id: SpørreskjemaId, options?: RequestValg): RestResponse<SpørreskjemaAdministrasjonModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`admin/spoerreskjema/${id}`, options: options });
    }

    /**
     * Oppdaterer skjemaet, se {@link Spørreskjema#oppdater} . Spørsmål som beholder korrelasjonen med spørsmål i andre skjemaer må ha samme type og oppsett som disse, se {@link LagreSpørreskjemaSpesifikasjon#spoersmaal} .
     * HTTP POST /admin/spoerreskjema/{id}
     * Java method: no.systemfabrikken.lederplan.resources.admin.spørreskjema.SpørreskjemaAdministrasjonRessurs.oppdater
     */
    oppdater(id: SpørreskjemaId, arg1: LagreSpørreskjemaSpesifikasjon, options?: RequestValg): RestResponse<SpørreskjemaAdministrasjonModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`admin/spoerreskjema/${id}`, data: arg1, options: options });
    }

    /**
     * HTTP DELETE /admin/spoerreskjema/{id}
     * Java method: no.systemfabrikken.lederplan.resources.admin.spørreskjema.SpørreskjemaAdministrasjonRessurs.slett
     */
    slett(id: SpørreskjemaId, options?: RequestValg): RestResponse<OkRespons> {
        return this.httpClient.request({ method: 'DELETE', url: uriEncoding`admin/spoerreskjema/${id}`, options: options });
    }

    /**
     * Aktiverer deaktivert skjema, se {@link Spørreskjema#aktiver()}
     * HTTP POST /admin/spoerreskjema/{id}/aktiver
     * Java method: no.systemfabrikken.lederplan.resources.admin.spørreskjema.SpørreskjemaAdministrasjonRessurs.aktiver
     */
    aktiver(id: SpørreskjemaId, options?: RequestValg): RestResponse<SpørreskjemaAdministrasjonModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`admin/spoerreskjema/${id}/aktiver`, options: options });
    }

    /**
     * Deaktiverer skjemaet slik at det ikke kan benyttes i nye undersøkelser, se {@link Spørreskjema#deaktiver()}
     * HTTP POST /admin/spoerreskjema/{id}/deaktiver
     * Java method: no.systemfabrikken.lederplan.resources.admin.spørreskjema.SpørreskjemaAdministrasjonRessurs.deaktiver
     */
    deaktiver(id: SpørreskjemaId, options?: RequestValg): RestResponse<SpørreskjemaAdministrasjonModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`admin/spoerreskjema/${id}/deaktiver`, options: options });
    }

    /**
     * Oppretter en kopi av skjemaet med angitt tittel, se {@link Spørreskjema#somKopi}
     * HTTP PUT /admin/spoerreskjema/{id}/kopi
     * Java method: no.systemfabrikken.lederplan.resources.admin.spørreskjema.SpørreskjemaAdministrasjonRessurs.kopier
     */
    kopier(id: SpørreskjemaId, arg1: KopierSpørreskjemaSpesifikasjon, options?: RequestValg): RestResponse<SpørreskjemaAdministrasjonModell> {
        return this.httpClient.request({ method: 'PUT', url: uriEncoding`admin/spoerreskjema/${id}/kopi`, data: arg1, options: options });
    }
}

export class SpørreskjemaRessursClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * Returnerer alle skjemaer som kan benyttes i nye undersøkelser i angitt gruppe, se {@link Spørreskjema#kanBenyttesAv}
     * HTTP GET /spoerreskjema
     * Java method: no.systemfabrikken.lederplan.resources.spørreundersøkelse.SpørreskjemaRessurs.finnAlle
     */
    finnAlle(queryParams?: { gruppeId?: GruppeId; }, options?: RequestValg): RestResponse<SpørreskjemaModell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`spoerreskjema`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /spoerreskjema/{id}
     * Java method: no.systemfabrikken.lederplan.resources.spørreundersøkelse.SpørreskjemaRessurs.hent
     */
    hent(id: SpørreskjemaId, options?: RequestValg): RestResponse<SpørreskjemaModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`spoerreskjema/${id}`, options: options });
    }
}

export class SpørreundersøkelseRessursClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * Oppretter ny undersøkelse. Sender invitasjon til respondenter dersom {@link OpprettUndersøkelseSpesifikasjon#antallDagerTilStenging} er satt.
     * HTTP PUT /spoerreundersoekelse
     * Java method: no.systemfabrikken.lederplan.resources.spørreundersøkelse.SpørreundersøkelseRessurs.opprettUndersøkelse
     */
    opprettUndersøkelse(arg0: OpprettUndersøkelseSpesifikasjon, options?: RequestValg): RestResponse<SpørreundersøkelseModell> {
        return this.httpClient.request({ method: 'PUT', url: uriEncoding`spoerreundersoekelse`, data: arg0, options: options });
    }

    /**
     * Returnerer angitt respondents besvarelse av undersøkelsen
     * HTTP GET /spoerreundersoekelse/besvarelse/{respondentId}
     * Java method: no.systemfabrikken.lederplan.resources.spørreundersøkelse.SpørreundersøkelseRessurs.hentBesvarelse
     */
    hentBesvarelse(respondentId: RespondentId, options?: RequestValg): RestResponse<RespondentBesvarelseModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`spoerreundersoekelse/besvarelse/${respondentId}`, options: options });
    }

    /**
     * Registrerer angitt besvarelse. Merk at eventuell eksisterende besvarelse overskrives. Returnerer 410 dersom respondent ikke finnes, of 417 med {@link RegistrerBesvarelseValideringsfeil#undersøkelse_ikke_åpen} dersom undersøkelsen ikke er åpen for besvarelse.
     * HTTP PUT /spoerreundersoekelse/besvarelse/{respondentId}
     * Java method: no.systemfabrikken.lederplan.resources.spørreundersøkelse.SpørreundersøkelseRessurs.registrerBesvarelse
     */
    registrerBesvarelse(respondentId: RespondentId, arg1: RegistrerRespondentsBesvarelseSpesifikasjon, options?: RequestValg): RestResponse<OkRespons> {
        return this.httpClient.request({ method: 'PUT', url: uriEncoding`spoerreundersoekelse/besvarelse/${respondentId}`, data: arg1, options: options });
    }

    /**
     * Finner alle undersøkelser knyttet til angitt gruppe, sortert etter responsperiode.start slik at pågående undersøkelser kommer før avsluttede
     * HTTP GET /spoerreundersoekelse/finnTilknyttetGruppe
     * Java method: no.systemfabrikken.lederplan.resources.spørreundersøkelse.SpørreundersøkelseRessurs.finnTilknyttetGruppe
     */
    finnTilknyttetGruppe(queryParams?: { id?: GruppeId; }, options?: RequestValg): RestResponse<SpørreundersøkelseEnkelModell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`spoerreundersoekelse/finnTilknyttetGruppe`, queryParams: queryParams, options: options });
    }

    /**
     * Finner alle undersøkelser knyttet til angitt gruppe, samt informasjon om hvilke saker undesøkelsen er til behandling i. Sortert etter responsperiode.start slik at pågående undersøkelser kommer før avsluttede.
     * HTTP GET /spoerreundersoekelse/finnTilknyttetGruppeMedBehandlinger
     * Java method: no.systemfabrikken.lederplan.resources.spørreundersøkelse.SpørreundersøkelseRessurs.finnTilknyttetGruppeMedBehandlinger
     */
    finnTilknyttetGruppeMedBehandlinger(queryParams?: { id?: GruppeId; }, options?: RequestValg): RestResponse<SpørreundersøkelseEnkelMedBehandlingerModell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`spoerreundersoekelse/finnTilknyttetGruppeMedBehandlinger`, queryParams: queryParams, options: options });
    }

    /**
     * Finner alle åpne undersøkelser som kallende bruker ikke har besvart, eller er tilknyttet grupper kallende bruker har skrive-rettigheter i og der ikke alle respondenter har bevart
     * HTTP GET /spoerreundersoekelse/finnUbesvarte
     * Java method: no.systemfabrikken.lederplan.resources.spørreundersøkelse.SpørreundersøkelseRessurs.finnUbesvarte
     */
    finnUbesvarte(options?: RequestValg): RestResponse<ManglerBesvarelsePåSpørreundersøkelseModell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`spoerreundersoekelse/finnUbesvarte`, options: options });
    }

    /**
     * HTTP GET /spoerreundersoekelse/{id}
     * Java method: no.systemfabrikken.lederplan.resources.spørreundersøkelse.SpørreundersøkelseRessurs.hent
     */
    hent(id: SpørreundersøkelseId, options?: RequestValg): RestResponse<SpørreundersøkelseModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`spoerreundersoekelse/${id}`, options: options });
    }

    /**
     * Oppdaterer eksisterende undersøkelse. Åpner undersøkelsen for besvarelse dersom den var stengt og {@link OpprettUndersøkelseSpesifikasjon#antallDagerTilStenging} ble angitt, sender da også invitasjon til alle respondenter dersom {@link OpprettUndersøkelseSpesifikasjon#informerRespondenter} =true. Sender invitasjon til nye respondenter dersom undersøkelsen var åpen og {@link OpprettUndersøkelseSpesifikasjon#informerRespondenter} =true.
     * HTTP POST /spoerreundersoekelse/{id}
     * Java method: no.systemfabrikken.lederplan.resources.spørreundersøkelse.SpørreundersøkelseRessurs.oppdater
     */
    oppdater(id: SpørreundersøkelseId, arg1: RedigerUndersøkelseSpesifikasjon, options?: RequestValg): RestResponse<SpørreundersøkelseModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`spoerreundersoekelse/${id}`, data: arg1, options: options });
    }

    /**
     * Sletter undersøkelsen og tilknyttede besvarelser. Dersom undersøkelsen er åpen for besvarelse sendes det melding om at undersøkelsen er stengt til alle respondentene.
     * HTTP DELETE /spoerreundersoekelse/{id}
     * Java method: no.systemfabrikken.lederplan.resources.spørreundersøkelse.SpørreundersøkelseRessurs.slett
     */
    slett(id: SpørreundersøkelseId, options?: RequestValg): RestResponse<OkRespons> {
        return this.httpClient.request({ method: 'DELETE', url: uriEncoding`spoerreundersoekelse/${id}`, options: options });
    }

    /**
     * Åpner undersøkelsen for besvarelse. Sender invitasjon til alle respondenter dersom {@link ÅpneForBesvarelseSpesifikasjon#informerRespondenter} =true
     * HTTP POST /spoerreundersoekelse/{id}/aapne
     * Java method: no.systemfabrikken.lederplan.resources.spørreundersøkelse.SpørreundersøkelseRessurs.åpneForBesvarelse
     */
    åpneForBesvarelse(id: SpørreundersøkelseId, arg1: ÅpneForBesvarelseSpesifikasjon, options?: RequestValg): RestResponse<SpørreundersøkelseModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`spoerreundersoekelse/${id}/aapne`, data: arg1, options: options });
    }

    /**
     * Genererer analyse av resultatet av undersøkelsen vhja llm, eventuell eksisterende analyse blir erstattet. Forutsetter at undersøkelsen er stengt for besvarelse og at minst én respondent har besvart undersøkelsen. Merk at kallet kan ta lang tid (opptil flere minutter).
     * HTTP POST /spoerreundersoekelse/{id}/analyse
     * Java method: no.systemfabrikken.lederplan.resources.spørreundersøkelse.SpørreundersøkelseRessurs.genererAnalyse
     */
    genererAnalyse(id: SpørreundersøkelseId, options?: RequestValg): RestResponse<SpørreundersøkelseAnalyseModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`spoerreundersoekelse/${id}/analyse`, options: options });
    }

    /**
     * Oppdaterer analysen av resultatet av undersøkelsen, feks etter at bruker har redigert generert analyse.
     * HTTP PUT /spoerreundersoekelse/{id}/analyse
     * Java method: no.systemfabrikken.lederplan.resources.spørreundersøkelse.SpørreundersøkelseRessurs.oppdaterAnalyse
     */
    oppdaterAnalyse(id: SpørreundersøkelseId, arg1: OppdaterAnalyseSpesifikasjon, options?: RequestValg): RestResponse<SpørreundersøkelseAnalyseModell> {
        return this.httpClient.request({ method: 'PUT', url: uriEncoding`spoerreundersoekelse/${id}/analyse`, data: arg1, options: options });
    }

    /**
     * Returnerer promptet som normalt hadde blitt brukt ved generering av analyse av resultatet, se {@link Spørreundersøkelse#genererAnalyse} . Kun tilgjengelig for brukere med featurevalg `ki` aktivert, på sikt bør denne metoden fjernes.
     * HTTP GET /spoerreundersoekelse/{id}/analysepromptDebug
     * Java method: no.systemfabrikken.lederplan.resources.spørreundersøkelse.SpørreundersøkelseRessurs.analysepromptDebug
     */
    analysepromptDebug(id: SpørreundersøkelseId, options?: RequestValg): RestResponse<AnalysepromptDebugModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`spoerreundersoekelse/${id}/analysepromptDebug`, options: options });
    }

    /**
     * Returnerer samling med saker der denne undersøkelsen er behandlet. Ved at et dokument av typen {@link SpørreundersøkelseRapportISak} som peker til denne undersøkelsen er inkludert som saksdokument i saken
     * HTTP GET /spoerreundersoekelse/{id}/behandlingerISak
     * Java method: no.systemfabrikken.lederplan.resources.spørreundersøkelse.SpørreundersøkelseRessurs.hentBehandlingerISak
     */
    hentBehandlingerISak(id: SpørreundersøkelseId, options?: RequestValg): RestResponse<TynnSakModell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`spoerreundersoekelse/${id}/behandlingerISak`, options: options });
    }

    /**
     * Genererer analyse av resultatet med angitt prompt, på samme vis som {@link Spørreundersøkelse#genererAnalyse} . Generert analyse blir ikke lagret. Kun tilgjengelig for brukere med featurevalg `ki` aktivert, på sikt bør denne metoden fjernes.
     * HTTP POST /spoerreundersoekelse/{id}/genererAnalyseDebug
     * Java method: no.systemfabrikken.lederplan.resources.spørreundersøkelse.SpørreundersøkelseRessurs.genererAnalyseDebug
     */
    genererAnalyseDebug(id: SpørreundersøkelseId, arg1: GenererAnalyseDebugSpesifikasjon, options?: RequestValg): RestResponse<GenerertAnalyseDebugModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`spoerreundersoekelse/${id}/genererAnalyseDebug`, data: arg1, options: options });
    }

    /**
     * Returnerer korellert resultat for undersøkelser som er basert på skjemaer som korellerer med skjema benyttet i angitt undersøkelse. Kun resultater for avsluttede undersøkelser vil bli inkludert.
     * HTTP GET /spoerreundersoekelse/{id}/korrelertGruppertResultat
     * Java method: no.systemfabrikken.lederplan.resources.spørreundersøkelse.SpørreundersøkelseRessurs.hentKorrelertGruppertResultat
     */
    hentKorrelertGruppertResultat(id: SpørreundersøkelseId, options?: RequestValg): RestResponse<KorellertGruppertSpørreundersøkelseResultatModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`spoerreundersoekelse/${id}/korrelertGruppertResultat`, options: options });
    }

    /**
     * Returnerer undersøkelsesrapport med svardata i PDF-format. Merk at 'filnavn'-leddet er kun med for at klient skal kunne styre filnavnet nedlastet PDF-får hos klient.
     * HTTP GET /spoerreundersoekelse/{id}/pdfRapport/{filnavn}
     * Java method: no.systemfabrikken.lederplan.resources.spørreundersøkelse.SpørreundersøkelseRessurs.lastNedPdfRapport
     */
    lastNedPdfRapport(id: SpørreundersøkelseId, filnavn: string, options?: RequestValg): RestResponse<any> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`spoerreundersoekelse/${id}/pdfRapport/${filnavn}`, options: options });
    }

    /**
     * Stenger undersøkelsen for besvarelse. Sender informasjon til alle respondenter dersom {@link ÅpneForBesvarelseSpesifikasjon#informerRespondenter} =true
     * HTTP POST /spoerreundersoekelse/{id}/steng
     * Java method: no.systemfabrikken.lederplan.resources.spørreundersøkelse.SpørreundersøkelseRessurs.stengForBesvarelse
     */
    stengForBesvarelse(id: SpørreundersøkelseId, arg1: StengForBesvarelseSpesifikasjon, options?: RequestValg): RestResponse<SpørreundersøkelseModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`spoerreundersoekelse/${id}/steng`, data: arg1, options: options });
    }
}

/**
 * Skal kalles av nginx eller av ny hjemmeside som kan forwarde requester fra sp2 til dette endepunktet.
 */
export class Styreplan2UrlMappingRessursClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * HTTP GET /styreplan2url/sp2Redirect/{sp2Path}
     * Java method: no.systemfabrikken.lederplan.resources.styreplanintegrasjon.Styreplan2UrlMappingRessurs.urlFor
     */
    urlFor(sp2Path: string, options?: RequestValg): RestResponse<any> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`styreplan2url/sp2Redirect/${sp2Path}`, options: options });
    }
}

export class SystemmeldingRessursClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * HTTP PUT /admin/melding
     * Java method: no.systemfabrikken.lederplan.resources.admin.systemmelding.SystemmeldingRessurs.opprett
     */
    opprett(arg0: OpprettSystemMeldingSpesifikasjon, options?: RequestValg): RestResponse<SystemMeldingModell> {
        return this.httpClient.request({ method: 'PUT', url: uriEncoding`admin/melding`, data: arg0, options: options });
    }

    /**
     * HTTP GET /admin/melding/finnAlle
     * Java method: no.systemfabrikken.lederplan.resources.admin.systemmelding.SystemmeldingRessurs.finnAlle
     */
    finnAlle(options?: RequestValg): RestResponse<SystemMeldingModell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`admin/melding/finnAlle`, options: options });
    }

    /**
     * Returnerer systemmeldinger som har en av angittet typer. Typer må være en jsonformatert array med Meldingstype-tallrepresentasjon.
@return
     * HTTP GET /admin/melding/hentMedType/{typer}
     * Java method: no.systemfabrikken.lederplan.resources.admin.systemmelding.SystemmeldingRessurs.hentMedType
     */
    hentMedType(typer: string, options?: RequestValg): RestResponse<SystemMeldingModell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`admin/melding/hentMedType/${typer}`, options: options });
    }

    /**
     * HTTP GET /admin/melding/{id}
     * Java method: no.systemfabrikken.lederplan.resources.admin.systemmelding.SystemmeldingRessurs.hent
     */
    hent(id: SystemMeldingId, options?: RequestValg): RestResponse<SystemMeldingModell> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`admin/melding/${id}`, options: options });
    }

    /**
     * HTTP DELETE /admin/melding/{id}
     * Java method: no.systemfabrikken.lederplan.resources.admin.systemmelding.SystemmeldingRessurs.slett
     */
    slett(id: SystemMeldingId, options?: RequestValg): RestResponse<void> {
        return this.httpClient.request({ method: 'DELETE', url: uriEncoding`admin/melding/${id}`, options: options });
    }
}

export class SøkRessursClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * HTTP POST /soek
     * Java method: no.systemfabrikken.lederplan.resources.søk.SøkRessurs.søk
     */
    søk(arg0: SøkSpesifikasjon, options?: RequestValg): RestResponse<any> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`soek`, data: arg0, options: options });
    }

    /**
     * HTTP POST /soek/admin
     * Java method: no.systemfabrikken.lederplan.resources.søk.SøkRessurs.adminSøk
     */
    adminSøk(arg0: SøkSpesifikasjon, options?: RequestValg): RestResponse<any> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`soek/admin`, data: arg0, options: options });
    }

    /**
     * Returnerer forespurt entitet fra søkeindeks. Returnerer {@link jakarta.ws.rs.core.Response.Status#GONE 410} dersom entitet ikke finnes i indeksen eller bruker ikke har tilgang. (endret fra 404 så vi ikke skal logge dette som en feil i klienten)
     * HTTP GET /soek/enitet
     * Java method: no.systemfabrikken.lederplan.resources.søk.SøkRessurs.entitet
     */
    entitet(queryParams?: { id?: string; type?: IndeksertEntitet; }, options?: RequestValg): RestResponse<ElasticSearchTreff<any>> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`soek/enitet`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /soek/finnEntiteter
     * Java method: no.systemfabrikken.lederplan.resources.søk.SøkRessurs.finnEntiteter
     */
    finnEntiteter(arg0: SøkEntitetSpesifikasjon, options?: RequestValg): RestResponse<any> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`soek/finnEntiteter`, data: arg0, options: options });
    }

    /**
     * HTTP GET /soek/finnLiknende
     * Java method: no.systemfabrikken.lederplan.resources.søk.SøkRessurs.finnLiknende
     */
    finnLiknende(queryParams?: { id?: string; type?: string; }, options?: RequestValg): RestResponse<any> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`soek/finnLiknende`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /soek/finnliknende/dokumentversjon/{id}
     * Java method: no.systemfabrikken.lederplan.resources.søk.SøkRessurs.finnLiknendeDokumentversjoner
     */
    finnLiknendeDokumentversjoner(id: DokumentVersjonId, options?: RequestValg): RestResponse<LiknendeDokumentModell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`soek/finnliknende/dokumentversjon/${id}`, options: options });
    }
}

export class TemaRessursClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * HTTP POST /tema/oppdater
     * Java method: no.systemfabrikken.lederplan.resources.tema.TemaRessurs.oppdater
     */
    oppdater(arg0: OppdaterTemaerSpesifikasjon, options?: RequestValg): RestResponse<TemaModell[]> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`tema/oppdater`, data: arg0, options: options });
    }

    /**
     * HTTP GET /tema/{gruppeId}
     * Java method: no.systemfabrikken.lederplan.resources.tema.TemaRessurs.finnAlle
     */
    finnAlle(gruppeId: GruppeId, options?: RequestValg): RestResponse<TemaModell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`tema/${gruppeId}`, options: options });
    }
}

export class ÅrshjulRessursClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * HTTP PUT /aarshjul/{gruppeId}
     * Java method: no.systemfabrikken.lederplan.resources.årshjul.ÅrshjulRessurs.opprett
     */
    opprett(gruppeId: GruppeId, arg1: ÅrshjulinnslagSpesifikasjon, options?: RequestValg): RestResponse<ÅrshjulInnslagModell> {
        return this.httpClient.request({ method: 'PUT', url: uriEncoding`aarshjul/${gruppeId}`, data: arg1, options: options });
    }

    /**
     * HTTP GET /aarshjul/{gruppeId}/hentalle
     * Java method: no.systemfabrikken.lederplan.resources.årshjul.ÅrshjulRessurs.hentAlle
     */
    hentAlle(gruppeId: GruppeId, options?: RequestValg): RestResponse<ÅrshjulInnslagModell[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`aarshjul/${gruppeId}/hentalle`, options: options });
    }

    /**
     * HTTP POST /aarshjul/{gruppeId}/oppdateralle
     * Java method: no.systemfabrikken.lederplan.resources.årshjul.ÅrshjulRessurs.oppdateralle
     */
    oppdateralle(gruppeId: GruppeId, arg1: OppdaterÅrshjulinnslagSpesifikasjon, options?: RequestValg): RestResponse<ÅrshjulInnslagModell[]> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`aarshjul/${gruppeId}/oppdateralle`, data: arg1, options: options });
    }

    /**
     * HTTP POST /aarshjul/{id}
     * Java method: no.systemfabrikken.lederplan.resources.årshjul.ÅrshjulRessurs.oppdater
     */
    oppdater(id: ÅrshjulinnslagId, arg1: ÅrshjulinnslagSpesifikasjon, options?: RequestValg): RestResponse<ÅrshjulInnslagModell> {
        return this.httpClient.request({ method: 'POST', url: uriEncoding`aarshjul/${id}`, data: arg1, options: options });
    }

    /**
     * HTTP DELETE /aarshjul/{id}
     * Java method: no.systemfabrikken.lederplan.resources.årshjul.ÅrshjulRessurs.slett
     */
    slett(id: ÅrshjulinnslagId, options?: RequestValg): RestResponse<OkRespons> {
        return this.httpClient.request({ method: 'DELETE', url: uriEncoding`aarshjul/${id}`, options: options });
    }
}

export interface AdminEnkelGruppeModell extends EnkelGruppeModell {
    opprettendeBruker: EnkelBrukerModell;
    opprettelsesTidspunkt: ZonedDateTimeSerialisert;
    avtalenavn: LitenIkkeTomStreng;
}

export interface AgendaDokumentValgSpesifikasjon {
    utelatteDeler: AgendaDokumentDel[];
}

export interface AgendadokumentValgModell {
    utelatteDeler: AgendaDokumentDel[];
}

export interface AgendaelementModell {
    id: AgendaelementId;
    moete: TynnMøteModell;
    eiendeGruppeId: GruppeId;
    tittel: LitenStreng;
    beskrivelse: HtmlTekst;
    dag: number | null;
    starttidspunkt: ZonedDateTimeSerialisert | null;
    varighet: number | null;
    erPause: boolean;
    /**
     * Elementets rekkefølge i møte. Merk at dette kan være forskjellig fra nummerIMoete da pause-elementer ikke har noe verdi for nummerIMoete.
     */
    indeks: number;
    /**
     * Formatert saksnummer, kun satt for Sak
     */
    nummer: LitenIkkeTomStreng;
    /**
     * Nummeret innenfor tilknyttet møte, 1-basert, kun satt for Sak
     */
    nummerIMoete: number;
    /**
     * Referattekst, kun satt for Sak
     */
    referat: HtmlTekst;
    tema: TemaModell | null;
    /**
     * Tilknyttet tema, kun satt for Sak
     */
    sakstype: SakstypeModell | null;
    /**
     * Tilknyttede sakskommentarer, kun satt for Sak
     */
    kommentarer: KommentarModell[];
    /**
     * Tilknyttede beslutninger, kun satt for Sak
     */
    beslutninger: BeslutningModell[];
    /**
     * Tilknyttede avstemninger, kun satt for Sak
     */
    avstemninger: AvstemningMedResultatModell[];
    /**
     * Tilknyttede oppgaver, kun satt for Sak
     */
    oppgaver: OppgaveModell[];
    /**
     * Tilknyttede dokumenter, kun satt for Sak
     */
    dokumenter: SaksdokumentModell[];
    /**
     * Tilknyttet ansvarlig, kun satt for Sak
     */
    ansvarlig: GruppeMedlemListeModell | null;
    /**
     * Tilknyttet sp2Ansvarlig (fra sp2 der saksansvarlig var fritekst), kun satt for Sak
     */
    sp2Ansvarlig: LitenIkkeTomStreng | null;
    /**
     * Informasjon om brukere som har markert saken som favoritt, kun satt for Sak
     */
    favoritter: TynnFavorittModell[];
    /**
     * Liste med internlenker som peker til denne saken, kun satt for Sak
     */
    referertFra: LenkerelasjonModell[];
    /**
     * Informasjon skjerming av tilknyttet Dokument
     */
    tilgang: TilgangModell;
}

export interface AggregertMøtevurderingModell {
    antallVurderinger: number;
    gjennomsnittligVurdering: FemdeltVurdering;
}

export interface AggregertOppgaveInfoModell {
    forfalte: number;
    utforte: number;
    totalt: number;
}

export interface AggregertResultatModell {
    rangering: FordelingAggregatModell | null;
    velgEnAvFlere: FordelingAggregatModell | null;
    velgNoenAvFlere: FordelingAggregatModell | null;
    boolsk: BoolskAggregatModell | null;
    fritekst: HtmlTekst[] | null;
}

export interface AggregerteOppgaverModell {
    bruker: AggregertOppgaveInfoModell;
    alle: AggregertOppgaveInfoModell;
}

export interface AksjeeierBeholdningModell {
    id: AksjebeholdningId;
    aksjenummer: string;
    antall: number;
    eierandel: string;
    aksjeklasse: AksjeklasseModell | null;
    gyldigFraTil: DatoPeriodeUtenTid;
    kommentar: HtmlTekst | null;
}

export interface AksjeeierEnkelModell {
    id: AksjeeierId;
    aksjeeierbokId: AksjeeierbokId;
    type: Aksjeeiertype;
    navn: LitenIkkeTomStreng;
    epost: Epost | null;
    adresse: StorStreng;
    /**
     * Kun angitt hvis type er organisasjon.
     */
    organisasjonsnummer: Organisasjonsnummer | null;
    /**
     * Kun angitt hvis type er person.
     */
    foedselsdato: PlainDateSerialisert | null;
    /**
     * Summene av alle aksjeeieres nåværende beholdning, målt i antall aksjer
     */
    totalBeholdning: number;
    /**
     * Aksjeeiers nåværende beholdning
     */
    naavaerendeBeholdning: AksjeeierBeholdningModell | null;
    representertAv: EnkelGruppeMedlemModell | null;
}

export interface AksjeeierIMøteModell {
    aksjeeierId: AksjeeierId;
    type: Aksjeeiertype;
    navn: LitenIkkeTomStreng;
    /**
     * Antall aksjer aksjeeier hadde på møtedato
     */
    beholdning: number;
    /**
     * Eierandel på møtedato som et tall mellom 0 og 100 med maksimalt to desimaler.
     */
    eierandel: number;
}

export interface AksjeeierMedSlettSisteBeholdningInfoModell {
    aksjeeier: AksjeeierEnkelModell;
    /**
     * beholdningsinnslaget som vil bli slettet av 'slett siste beholdning' operasjonen, tom dersom aksjeeiers beholdning ikke berøres av denne operasjonen.
     */
    beholdningSomSlettes: AksjeeierBeholdningModell | null;
    /**
     * beholdningsinnslaget som overtar rollen som gjeldende beholdning, tom dersom denne aksjeeieren ikke har andre beholdningsinnslag enn beholdningSomSlettes, eller dersom denne ikke får sin beholdning endret av 'slett siste beholdning' operasjonen.
     */
    nyNaavaerendeBeholdning: AksjeeierBeholdningModell | null;
}

export interface AksjeeierModell extends AksjeeierEnkelModell {
    beholdningshistorikk: AksjeeierBeholdningModell[];
}

export interface AksjeeierbokModell {
    id: AksjeeierbokId;
    totalBeholdning: number;
    aksjeeiere: AksjeeierEnkelModell[];
    aksjeklasser: AksjeklasseModell[];
}

export interface AksjeklasseMedDetaljerModell extends AksjeklasseModell {
    iBrukIBeholdning: boolean;
    arkivert: boolean;
}

export interface AksjeklasseModell {
    id: AksjeklasseId;
    navn: LitenIkkeTomStreng;
    beskrivelse: HtmlTekst;
}

/**
 * Samling av aksjenummer serier. Objektet er immutable. Felt av denne typen må mappes for bruk i hibernate vhja `@Convert(converter = AksjenummerSamlingConverter.class)`
 */
export interface AksjenummerSamling {
}

export interface AlternativOgAntallModell {
    alternativ: RangeringValg;
    /**
     * antall respondenter som har valgt dette alternativet
     */
    antall: number;
    /**
     * totalt antall respondenter som har besvart spørsmålet
     */
    totaltAntallRespondenter: number;
}

export interface AnalysepromptDebugModell {
    prompt: string;
}

/**
 * Inneholder informasjon visualisering av annotering. Kan mappes med @Column da denne typen er registrert i {@link no.systemfabrikken.lederplan.infrastruktur.datalager.hibernate.HibernateRessurser} vhja {@link IkkeMuterbarJsonType#registrerIkkeMuterbarJsonTypeLongvarchar}
 */
export interface AnnoteringVisualisering {
    '@type': 'ikon' | 'rektangel' | 'tekst';
}

export interface AnsvarligAggregatModell {
    totalAntall: number;
    antallPerMedlem: { [index: string]: number };
}

export interface AnsvarligBruker {
    navn: LitenIkkeTomStreng;
}

export interface AntallForfalteOppgaver {
    antallForfalteOppgaver: number;
}

export interface AntallMeldingerSendtRespons {
    antall: number;
}

export interface AntallOppgaverPerBrukerModell {
    bruker: EnkelBrukerModell | null;
    antallIkkeUtfoerte: number;
    antallForfalte: number;
}

export interface ArkivFilnodeModell extends ArkivNodeModell {
    dokument: ArkivdokumentModell;
}

export interface ArkivMappenodeModell extends ArkivNodeModell {
    beskrivelse: HtmlTekst;
    barn: ArkivNodeModell[];
    skjerming: SkjermingModell;
}

export interface ArkivNodeModell {
    id: ArkivnodeId;
    navn: LitenIkkeTomStreng;
    /**
     * Mappen denne noden ligger i, alle noder med unntak av rot ( {@link Gruppe#arkiv()} ) har en forelder.
     */
    forelder: ArkivMappenodeModell | null;
    erMappe: boolean;
    erRotMappe: boolean;
    eiendeGruppeId: GruppeId;
}

export interface ArkivdokumentModell extends DokumentVersjonModell {
}

export interface AsynkOppgaveModell {
    id: AsynkOppgaveId;
    status: Status;
    statusSistEndretDato: ZonedDateTimeSerialisert;
    type: string;
    konfigurasjon: { [index: string]: string };
    kanParkeres: boolean;
    kanRestartes: boolean;
}

export interface AutentiseringResponsModell {
    status: AutentiseringStatus;
    autentisertBruker: AutentisertOkModell;
    ukjentSubject: SubjectIdIkkeKnyttetTilBrukerModell;
    kreverOppgarderingTilAutentiseringsmetoder: Autentiseringsmetode[];
    /**
     * Maskert versjon av mobilnummerert sms med otp er sendt til
     */
    otpSmsSendtTil: string;
}

export interface AutentisertOkModell {
    bruker: BrukerModell;
    brukervalg: Object;
    featurevalg: Object;
    /**
     * Alle gruppene autentisert bruker har tilgang til, dvs har et aktivt medlemskap i, og som nåværende innloggingsnivå gir tilgang til
     */
    tilgjengeligeGrupper: TilgjengeligGruppeModell[];
    grupperSomKreverAnnenAutentiseringsmetode: GruppeSomKreverAnnenAutentiseringsmetodeModell[];
    invitasjonerTilGodkjenning: GruppeInvitasjonTilGodkjenningModell[];
    kontaktpersonForAvtaler: AvtaleModell[];
    jwtTokenInfo: JwtTokenInfoModell;
}

export interface AvgiStemmeSpesifikasjon {
    avstemningsalternativId: AvstemningsalternativId | null;
}

export interface AvsluttRolleperiodeSpesifikasjon {
    id: RollePeriodeId;
    slutt: PlainDateSerialisert;
}

export interface AvstemningMedMøteModell {
    avstemning: AvstemningMedResultatModell;
    moeteId: MøteId;
    moetenummer: LitenIkkeTomStreng;
    moetetittel: LitenIkkeTomStreng;
    moeteDatoStart: ZonedDateTimeSerialisert;
    sakId: AgendaelementId;
    saksnummer: LitenIkkeTomStreng;
    sakstittel: LitenIkkeTomStreng;
}

export interface AvstemningMedResultatModell {
    eiendeGruppeId: GruppeId;
    sakId: AgendaelementId;
    id: AvstemningId;
    tittel: LitenIkkeTomStreng;
    beskrivelse: HtmlTekst | null;
    erAapenForAvstemning: boolean;
    deltakerErStemmeberettiget: boolean;
    avstemningsalternativer: AvstemningsalternativMedResultatModell[];
}

export interface AvstemningMedResultatOgStatuserModell {
    avstemningMedResultat: AvstemningMedResultatModell;
    avstemningsstatus: AvstemningsstatusModell;
}

export interface AvstemningsalternativMedResultatModell {
    id: AvstemningsalternativId;
    tittel: LitenIkkeTomStreng;
    erDeltakersValg: boolean;
    /**
     * Antall stemmer dette alternativet har fått, kun definert dersom avstemningsresultat er synlig for kallende bruker, se {@link AvstemningTilgang#harIkkeTilgangTilStemmeresultat}
     */
    antallStemmer: number;
    /**
     * Sann dersom dette alternativet vant avstemningen, kun definert dersom avstemningsresultat er synlig for kallende bruker, se {@link AvstemningTilgang#harIkkeTilgangTilStemmeresultat}
     */
    erVinner: boolean;
}

export interface AvstemningsalternativSpesifikasjon {
    id: AvstemningsalternativId;
    tittel: LitenIkkeTomStreng;
}

export interface AvstemningsstatusModell {
    moeteId: MøteId;
    appentForStemmegivning: boolean;
    antallStemmeberettigedeDeltakere: number;
    antallAvstemninger: number;
    antallStemmerAvgittPerDeltaker: { [index: string]: number };
    antallDeltakereStemtFerdig: number;
    antallDeltakereStemtDelvis: number;
    antallDeltakereStemtIngen: number;
    antallStemmerAvgittPerAvstemning: { [index: string]: number };
    antallAvstemningerStemtFerdig: number;
    antallAvstemningerStemtDelvis: number;
    antallAvstemningerStemtIngen: number;
}

export interface AvtaleModell {
    id: AvtaleId;
    navn: LitenIkkeTomStreng;
    kontaktperson: EnkelBrukerModell;
    opprettetDato: ZonedDateTimeSerialisert;
    proeveperiodeUtloepsdato: ZonedDateTimeSerialisert;
    slettesDato: ZonedDateTimeSerialisert;
    avtalestatus: Avtalestatus;
    faktureringsinformasjonAngitt: boolean;
    grupper: EnkelGruppeModell[];
    antallGrupper: number;
    antallBrukere: number;
    nedlastningsTidspunkt: ZonedDateTimeSerialisert | null;
}

export interface AvtaledetaljerModell {
    id: AvtaleId;
    navn: LitenIkkeTomStreng;
    kontaktperson: EnkelBrukerModell;
    aksepterteBetingelser: HtmlTekst;
    opprettetDato: ZonedDateTimeSerialisert;
    proeveperiodeUtloepsdato: ZonedDateTimeSerialisert;
    slettesDato: ZonedDateTimeSerialisert;
    avtalestatus: Avtalestatus;
    laastForRedigering: boolean;
    faktureringsinformasjonAngitt: boolean;
    faktureringsinformasjon: FaktureringsinformasjonModell;
    aktiveBrukere: EnkelBrukerModell[];
    grupper: GruppeModell[];
    nedlastningsTidspunkt: ZonedDateTimeSerialisert | null;
}

export interface BankidSigneringStatusModell {
    signeringId: string;
    status: BankIdSigneringStatus;
}

export interface BekreftEpostTokenSpesifikasjon {
    token: Engangstoken;
}

export interface BekreftEpostadresseSendtModell {
    epostadresse: string;
    meldingstittel: string;
    sendt: boolean;
}

export interface BekreftMobilnummerOtpSendtModell {
    otpSendtTil: Mobilnummer;
    sendt: boolean;
}

export interface BekreftMobilnummerOtpSpesifikasjon {
    otp: string;
}

export interface BeslutningAggreatModell {
    gruppe: BeslutningGruppeAggregatModell;
    moetedato: BeslutningPerMøtedatoAggregatModell;
}

export interface BeslutningForelderinfoIndeksfelter {
    /**
     * Møtets tittel (feks 'Styremøte')
     */
    moete: string;
    /**
     * Møtets startdato
     */
    moetedato: ZonedDateTimeSerialisert;
    /**
     * Sakens tittel
     */
    sak: string;
}

export interface BeslutningGruppeAggregatModell {
    antallPerGruppe: { [index: string]: number };
}

/**
 * Ekstrahert beslutning fra saksreferat.
@param tittel      Oppgavens tittel, merk at denne ikke er typet som LitenStreng da vi ikke vil kaste exception dersom LLM returnerer lengre strenger.
@param beskrivelse Beskrivelse av en enkelt beslutning. LLM-en svarer med markdown, som konverteres til sanitert html, se {@link MarkdownTekst#somHtml} .
@param oppgaver    Liste over oppgaver omtalt i referatet, tilknyttet beslutningen.
 */
export interface BeslutningITranskribertSaksreferatModell {
    tittel: string;
    beskrivelse: HtmlTekst;
    oppgaver: OppgaveITranskribertSaksreferatModell[];
}

/**
 * Typedefinisjon for _source feltet i json-struktur returnert for treff på indeks-innslag generert via {@link BeslutningIndeksAdapter} . Primært inkludert for å produsere typescript typedefinsjon
 */
export interface BeslutningIndeksfelter {
    tittel: string;
    beskrivelse: string;
    /**
     * Tilknyttet møte sin startdato i millis siden epoc, UTC.
     */
    dato: number;
    sakId: AgendaelementId;
    møteId: MøteId;
    /**
     * Info om entitet saken og møtet beslutningen er registrert under
     */
    forelderinfo: BeslutningForelderinfoIndeksfelter;
    /**
     * Hvorvidt tilknyttet møte er publisert
     */
    publisertMøte: boolean;
    /**
     * Komma-sepparert lisste med medlemId til medlemmer som er skjermet (ikke har tilgang)
     */
    skjerming: string;
    /**
     * Tilknyttet gruppe
     */
    gruppe: GruppeId;
}

export interface BeslutningMedMøteModell {
    id: BeslutningId;
    tittel: StorStreng;
    beskrivelse: HtmlTekst;
    erForslag: boolean;
    favoritter: TynnFavorittModell[];
    oppgaver: OppgaveModell[];
    eiendeGruppeId: GruppeId;
    moeteId: MøteId;
    moetenummer: LitenIkkeTomStreng;
    moetetittel: LitenIkkeTomStreng;
    moeteDatoStart: ZonedDateTimeSerialisert;
    sakId: AgendaelementId;
    saksnummer: LitenIkkeTomStreng;
    sakstittel: LitenIkkeTomStreng;
}

export interface BeslutningModell {
    eiendeGruppeId: GruppeId;
    id: BeslutningId;
    /**
     * Forslag til beslutningstittel, kan være dersom beslutning er migrert fra sp2
     */
    tittelForslag: StorStreng | null;
    /**
     * Beslutningstittel, kan være dersom beslutning er migrert fra sp2
     */
    tittel: StorStreng | null;
    beskrivelseForslag: HtmlTekst;
    beskrivelse: HtmlTekst;
    erForslag: boolean;
    sakId: AgendaelementId;
    sakstittel: LitenIkkeTomStreng;
    moetetittel: LitenIkkeTomStreng;
    favoritter: TynnFavorittModell[];
    oppgaver: OppgaveModell[];
    /**
     * Liste med internlenker som peker til denne oppgaven
     */
    referertFra: LenkerelasjonModell[];
    laastForRedigering: boolean;
}

export interface BeslutningPerMøtedatoAggregatModell {
    totalAntall: number;
    antallPerMoeteDato: { [index: string]: number };
}

/**
 * Spesifikasjon for opprettelse eller redigering av beslutning. Merk at beslutninger opprettet eller redigert via denne mekanismen ALLTID bli markert som IKKE forslag.
 */
export interface BeslutningSpesifikasjon {
    id: BeslutningId;
    tittel: StorStreng;
    beskrivelse: HtmlTekst;
    slettet: boolean;
    oppgaver: OppgaverSpesifikasjoner;
}

export interface BeslutningsSpesifikasjoner {
    eksisterendeBeslutninger: BeslutningSpesifikasjon[];
    nyeBeslutninger: BeslutningSpesifikasjon[];
}

/**
 * Spesifikasjon for opprettelse eller redigering av beslutningsforslag. Merk at beslutninger opprettet eller redigert via denne mekanismen ALLTID bli markert som FORSLAG.
 */
export interface BeslutningsforslagSpesifikasjon {
    id: BeslutningId;
    tittel: StorStreng;
    beskrivelse: HtmlTekst;
    slettet: boolean;
}

export interface BeslutningsforslagSpesifikasjoner {
    eksisterendeBeslutninger: BeslutningsforslagSpesifikasjon[];
    nyeBeslutninger: BeslutningsforslagSpesifikasjon[];
}

export interface BetingelserModell {
    betingelser: HtmlTekst;
}

export interface BoolskAggregatModell {
    sann: number;
    usann: number;
}

export interface BrregAdresse {
    land: string;
    landkode: string;
    postnummer: string;
    poststed: string;
    adresse: string[];
    kommune: string;
    kommunenummer: string;
}

export interface BrregEnhet {
    organisasjonsnummer: string;
    navn: string;
    forretningsadresse: BrregAdresse;
    postadresse: BrregAdresse;
}

export interface BrukerModell {
    id: BrukerId;
    brukernavn: Brukernavn;
    epost: Epost;
    epostErBekreftet: boolean;
    navn: LitenIkkeTomStreng | null;
    navnEllerEpost: LitenIkkeTomStreng;
    tilgangsroller: TilgangsrolleBruker[];
    autentiseringsmetoder: Autentiseringsmetode[];
    openIdAutentiseringsmetoder: BenyttetAutentiseringsmetode[];
    avatarId: BildedataId;
    mobilnummer: Mobilnummer | null;
    mobilnummerErBekreftet: boolean;
    spraak: Språk;
    tidssone: Tidssone;
    deaktiverteMeldingstyper: DeaktivertMeldingstype[];
}

export interface BrukernavnEllerEpost {
}

export interface BrukernavnEllerEpostSpesifikasjon {
    /**
     * @deprecated
     */
    brukernavn: Brukernavn | null;
    brukernavnEllerEpost: BrukernavnEllerEpost | null;
}

export interface BrukernavnSomStrengModell {
    brukernavn: string;
}

export interface BrukernavnValideringsresultat {
    gyldig: boolean;
    feilkoder: string[];
}

export interface BrukersSaksstatistikk {
    kommende: number;
    tidligere: number;
}

export interface BrukervalgSpesifikasjon {
    brukervalg: Object;
}

/**
 * Egen modell for criipto autentisering da vi ved criipto autentisering også må returnere info om mulig styreplan bruker
 */
export interface CriiptoAutentiseringsResponsModell {
    lederplanRespons: AutentiseringResponsModell;
    styreplanRespons: any | null;
    erBrukerILederplan: boolean;
    erBrukerIStyreplan: boolean;
}

export interface CriiptoBindBrukerSpesifikasjon {
    kryptertOpenIdIdentitet: string;
    tokenvarighet: Tokenvarighet;
}

export interface CriiptoBindFraTokenSpesifikasjon {
    kryptertOpenIdIdentitet: string;
    tokenvarighet: Tokenvarighet;
    token: TidsstempletEngangstoken;
}

export interface CriiptoTokenInnloggingsSpesifikasjon {
    kode: LitenIkkeTomStreng;
    tokenvarighet: Tokenvarighet;
    guiModus: CriiptoGuiModus;
    tilbyder: CriiptoIdTilbyder;
    styreplanLoginAktivert: boolean;
}

/**
 * Representasjon av en datoperiode med start og slutt. En periode sies å ha "åpen slutt" dersom sluttdato er satt til verdien {@link Dato#maxZonedDateTime} . DatoPeriode kan persisteres til hibernate (som embedded) og serialiserer/deserialiseres via jackson uten videre konfig i hibernate/jackson
 */
export interface DatoPeriode<D> {
    slutt: ZonedDateTimeSerialisert | null;
    start: ZonedDateTimeSerialisert;
}

/**
 * Representasjon av en datoperiode med start og slutt. En periode sies å ha "åpen slutt" dersom sluttdato er satt til verdien {@link Dato#maxLocalDate} . DatoPeriodeUtenTid kan persisteres til hibernate (som embedded) og serialiserer/deserialiseres via jackson uten videre konfig i hibernate/jackson
 */
export interface DatoPeriodeUtenTid {
    slutt: PlainDateSerialisert | null;
    start: PlainDateSerialisert;
}

export interface DbMigrering {
    version: string;
    description: string;
    type: string;
    script: string;
    installed_by: string;
    installed_on: Date;
    execution_time: number;
    success: boolean;
}

export interface DeaktiverOpenIdBindingSpesifikasjon {
    metode: BenyttetAutentiseringsmetode;
    autentiseringsinfo: Reautentiseringsinformasjon;
}

export interface DeaktivertOpenIdBindingModell {
    autentiseringOk: boolean;
}

export interface DokumentAnnoteringModell {
    id: DokumentAnnoteringId;
    gruppeId: GruppeId;
    registrertDato: ZonedDateTimeSerialisert;
    registrertAv: GruppeMedlemListeModell;
    sidenummer: number;
    type: Annoteringstype;
    visualisering: AnnoteringVisualiseringUnion;
    markertTekst: LitenStreng | null;
    privat: boolean;
    kommentarer: KommentarModell[];
}

export interface DokumentSignatarModell {
    id: SignatarId;
    harSignert: boolean;
    signaturinformasjon: SignaturinformasjonModell | null;
    medlem: GruppeMedlemListeModell;
}

export interface DokumentSignatarerModell {
    dokumentId: DokumentId;
    signeringsInvitasjonSendt: ZonedDateTimeSerialisert | null;
    dagerTilNestePurring: number;
    nestePurringSendes: ZonedDateTimeSerialisert;
    signatarer: DokumentSignatarModell[];
}

export interface DokumentTilSigneringModell<T> {
    tilSignering: T;
    signatarer: DokumentSignatarerModell;
}

export interface DokumentVersjonForelderModell {
    /**
     * Satt dersom dokumentet er et {@link Saksdokument}
     */
    sakId: AgendaelementId | null;
    /**
     * Satt dersom dokumentet er et {@link ProtokolldokumentISak} , merk at siden ProtokolldokumentISak også er et Saksdokument vil sakId også være satt.
     */
    protokolldokumentId: DokumentId | null;
    /**
     * Satt dersom dokumentet er et {@link ArkivdokumentISak} , merk at siden ArkivdokumentISak også er et Saksdokument vil sakId også være satt.
     */
    arkivdokumentId: DokumentId | null;
    /**
     * Satt dersom dokumentet er et {@link Arkivdokument}
     */
    arkivfilnodeId: ArkivnodeId | null;
}

/**
 * En utflating av DokumentVersjonModell og tilknyttet Dokument
 */
export interface DokumentVersjonModell {
    /**
     * Tilknyttet Dokument
     */
    dokumentId: DokumentId;
    /**
     * Tilknyttet Gruppe
     */
    gruppeId: GruppeId;
    /**
     * typen til tilknyttet Dokument
     */
    type: DokumentType;
    /**
     * Informasjon om brukere som har markert tilknyttet Dokument som favoritt
     */
    favoritter: TynnFavorittModell[];
    /**
     * Informasjon eventuell signering av tilknyttet Dokument
     */
    signeringStatus: SigneringStatus;
    /**
     * Signeringsmetoder som kan benyttes for signering av tilknyttet Dokument
     */
    aksepterteSignaturmetoder: AkseptertSignaturmetode[];
    /**
     * Informasjon om hvilken annen entitet tilknyttet Dokument er assosiert med
     */
    foreldre: DokumentVersjonForelderModell;
    /**
     * Informasjon skjerming av tilknyttet Dokument
     */
    skjerming: SkjermingModell;
    id: DokumentVersjonId;
    harPdfRepresentasjon: boolean;
    /**
     * id til bildet av dokumentets forside, dersom slik finnes
     */
    forsideBildeId: BildedataId | null;
    antallSider: number | null;
    /**
     * filnavnet til filen i orginalformat
     */
    filnavn: string;
    /**
     * filnavn til pdf-representasjonen, dersom slik finnes
     */
    pdfFilnavn: string | null;
    filstoerrelse: number | null;
    pdfFilstoerrelse: number | null;
    orginalformat: Mimetype;
    /**
     * 1-basert versjonsnummer
     */
    versjonsnummer: number;
    virussjekkStatus: VirussjekkStatus;
    antallAnnotasjoner: number;
    erLestAv: boolean;
    googleDriveUrl: Url | null;
    microsoftOneDriveUrl: Url | null;
    registrertAv: EnkelGruppeMedlemModell | null;
    registreringsdato: ZonedDateTimeSerialisert;
}

export interface DokumentVersjonOgSakerModell {
    dokumentVersjon: DokumentVersjonModell;
    tilknyttedeSaker: TynnSakModell[];
}

export interface DokumenterTilSigneringModell {
    arkivdokumenter: DokumentTilSigneringModell<DokumentVersjonModell>[];
    saksdokumenter: DokumentTilSigneringModell<DokumentVersjonModell>[];
    moeter: DokumentTilSigneringModell<MøteModellEnkel>[];
}

export interface EidInformasjon {
    autentiseringskode: LitenIkkeTomStreng;
    guiModus: CriiptoGuiModus;
    tilbyder: CriiptoIdTilbyder;
}

export interface EksternMøtedeltakerModell {
    id: EksternMøtedeltakerId;
    moeteId: MøteId;
    gruppeId: GruppeId;
    navn: LitenIkkeTomStreng;
    rolle: LitenStreng;
    kommentar: LitenStreng;
}

export interface EksternMøtedeltakerSpesifikasjon {
    id: EksternMøtedeltakerId;
    navn: LitenIkkeTomStreng;
    rolle: LitenStreng | null;
    kommentar: LitenStreng | null;
}

export interface EksternProtokollførtMøtedeltakerModell {
    id: EksternProtokollførtMøtedeltakerId;
    moeteId: MøteId;
    gruppeId: GruppeId;
    navn: LitenIkkeTomStreng;
    rolle: LitenStreng;
    kommentar: LitenStreng;
    skalSignere: boolean;
}

export interface EksternProtokollførtMøtedeltakerSpesifikasjon {
    id: EksternProtokollførtMøtedeltakerId;
    navn: LitenIkkeTomStreng;
    rolle: LitenStreng | null;
    kommentar: LitenStreng | null;
    skalSignere: boolean;
}

export interface ElasticSearchResultat {
    hits: ElasticSearchTreffsamling;
}

/**
 * Typedefinisjon for json-struktur returnert av søke-metoder i SøkRessurs. Primært inkludert for å produsere typescript typedefinsjon
 */
export interface ElasticSearchTreff<T> {
    /**
     * Id til tilknyttet entitet
     */
    _id: string;
    /**
     * Verdien som benyttes som 'document type' i ES indeksen. Klassenavnet til entiteten.
     */
    _type: IndeksertEntitet;
    _score: number;
    /**
     * Rådata lagret i indeksen, feks {@link no.systemfabrikken.lederplan.infrastruktur.indeksering.Adaptere.SakIndeksfelter} . Hvilke felter som er tilgjengelig her er definert av de entitet-spesifikke adapterne definert i {@link Adaptere} , feks {@link no.systemfabrikken.lederplan.infrastruktur.indeksering.Adaptere.SakIndeksAdapter}
     */
    _source: T;
    /**
     * Map med tekstutdrag for felter som har aktivert 'highlighting' via {@link Bygger#medStøtterHighlighting()} . Eks for dokument-innslag: ['innhold': ["– se søknad med <em>oppgaven</em> med Forstørret skrift", "Sitte skjermet med <em>Oppgaver</em> på eget"]]
     */
    highlight: { [index: string]: string[] };
}

export interface ElasticSearchTreffsamling {
    total: number;
    hits: ElasticSearchTreff<any>[];
}

export interface EndrePrivatSpesifikasjon {
    privat: boolean;
}

export interface EndringshendelseModell {
    id: EndringshendelseId;
    gruppeId: GruppeId | null;
    entitetReferanse: EntitetReferanseModell;
    endringstype: Endringstype;
    subEndringstype: SubEndringstype;
    bruker: EnkelBrukerModell | null;
    utfoertDato: ZonedDateTimeSerialisert;
    beskrivelse: StrengMal;
    foreldre: EntitetReferanseModell[];
}

export interface EnkelBrukerModell {
    id: BrukerId;
    brukernavn: Brukernavn;
    epost: Epost;
    epostErBekreftet: boolean;
    navn: LitenIkkeTomStreng | null;
    navnEllerEpost: LitenIkkeTomStreng;
    avatarId: BildedataId;
    mobilnummer: Mobilnummer | null;
    mobilnummerErBekreftet: boolean;
    tidssone: Tidssone;
    spraak: Språk;
}

/**
 * Minimal gruppemedlem-representasjon
 */
export interface EnkelGruppeMedlemModell {
    id: MedlemId;
    navn: LitenIkkeTomStreng;
    harTilgang: boolean;
    anonymisert: boolean;
    medlemstatus: Medlemstatus;
}

export interface EnkelGruppeModell {
    id: GruppeId;
    tittel: LitenIkkeTomStreng;
    organisasjonsnavn: LitenIkkeTomStreng;
    moetenavn: LitenIkkeTomStreng;
    gruppemal: GruppemalModell | null;
    oppsett: OppsettModell;
    farge: FargeHex;
    gruppetype: Gruppetype;
    avtaleId: AvtaleId;
    logoId: BildedataId | null;
    nedlastningsTidspunkt: ZonedDateTimeSerialisert | null;
}

export interface EnkelPlanModell {
    id: PlanId;
    gruppeId: GruppeId;
    periode: PeriodeModell;
    foersteMoetenummer: number;
    foersteSaksnummer: number;
}

export interface EntitetIdRespons {
    id: string;
}

export interface EntitetReferanseModell {
    id: string;
    type: EntitetType;
}

export interface EntitetReferanseSpesifikasjon {
    id: string;
    type: EntitetType;
}

export interface EpostModell {
    epost: string;
}

export interface EpostValideringsresultat {
    feilkoder: string[];
}

export interface FaktureringsinformasjonModell {
    adresseLinje1: LitenIkkeTomStreng;
    adresseLinje2: LitenIkkeTomStreng | null;
    postnummer: LitenIkkeTomStreng;
    poststed: LitenIkkeTomStreng;
    landkode: LitenIkkeTomStreng;
    epostadresse: Epost;
    organisasjonsnummer: Organisasjonsnummer | null;
}

export interface FavorittModell {
    id: FavorittId;
    type: FavorittType;
    gruppeId: GruppeId;
    opprettetDato: ZonedDateTimeSerialisert;
    assosiertEntitet: EntitetReferanseModell;
    assosiertEntitetBeskrivelse: any;
}

export interface FinnBeslutningerSpesifikasjon {
    grupper: GruppeId[];
    oppgavestatuser: BeslutningOppgavestatus[];
}

export interface FinnBeslutningerSpørreSpesifikasjon {
    fraDato: ZonedDateTimeSerialisert;
}

export interface FinnOppgaverSpesifikasjon {
    grupper: GruppeId[];
    ansvarlige: MedlemId[];
    statuser: OppgavestatusKriterie[];
    sortering: OppgaveSorteringSpesifikasjon;
    paginering: OppgavePagineringSpesifikasjon;
}

export interface FinnSakerOgMalsakerResultatModell {
    malsaker: MalsakModell[];
    ordinaereSaker: SakSøkTreffModell[];
}

export interface FinnSakerSomMalerSpesifikasjon {
    gruppeId: GruppeId;
    soekestreng: string;
}

export interface FlyttNodeSpesifikasjon {
    målmappe: ArkivnodeId;
}

export interface FordelingAggregatModell {
    fordeling: AlternativOgAntallModell[];
    vinnere: AlternativOgAntallModell[];
}

export interface ForelderModell {
    harForelder: boolean;
    entitetRef: EntitetReferanseModell;
    beskrivelse: StrengMal;
}

export interface ForfalteOppgaverDokumentValgModell {
    utelatteForelderTyper: OppgaveForelderType[];
}

export interface ForfalteOppgaverDokumentValgSpesifikasjon {
    utelatteForelderTyper: OppgaveForelderType[];
}

export interface FornyTokenSpesifikasjon {
    /**
     * @deprecated
     */
    token: string;
    tokenvarighet: Tokenvarighet;
}

export interface FristAggregatModell {
    totalAntall: number;
    antallIkkeUtført: number;
    antallPerFristDato: { [index: string]: number };
}

export interface GenerellEpostTilMedlemmerSpesifikasjon {
    beskjed: HtmlTekst;
    mottakere: MedlemId[];
}

/**
 * Prompt brukt ved generering av analyse
 */
export interface GenererAnalyseDebugSpesifikasjon {
    prompt: string;
}

/**
 * @param analyse        generert analyse, formatert som markdown
@param analyseSomHtml generert analyse konvertert til html
 */
export interface GenerertAnalyseDebugModell {
    analyse: MarkdownTekst;
    analyseSomHtml: HtmlTekst;
}

export interface GodtaInvitasjonFraOpenidSubjectSpesifikasjon {
    criiptoSpesifikasjon: CriiptoBindBrukerSpesifikasjon;
    invitasjonstoken: TidsstempletEngangstoken;
    brukernavnOgEpost: Epost;
    engangskode: string;
    spraak: Språk;
    tidssone: LitenIkkeTomStreng;
}

export interface GodtaInvitasjonTilEksisterendeBrukerSpesifikasjon {
    engangskode: string;
}

export interface GodtaInvitasjonTilNyBrukerSpesifikasjon {
    brukernavnOgEpost: Epost;
    passord: Passord;
    engangskode: string;
    token: TidsstempletEngangstoken;
    spraak: Språk;
    tidssone: LitenIkkeTomStreng;
}

export interface GooglePickerKonfigurasjonModell {
    /**
     * Google api-nøkkel, se https://console.cloud.google.com/apis/credentials?project=lederplan-picker-api
     */
    developerKey: string;
    /**
     * Google oauth klient id, se https://console.cloud.google.com/apis/credentials?project=lederplan-picker-api
     */
    clientId: string;
    /**
     * Google prosjektnummer, se https://console.cloud.google.com/iam-admin/iam?project=lederplan-picker-api
     */
    appId: string;
}

export interface GruppeAggreatModell {
    gruppeId: GruppeId;
    antallMoeter: number;
    antallMoeterAvholdt: number;
    antallSaker: number;
    antallDokumenter: number;
    antallOppgaver: number;
    antallOppgaverForfalt: number;
    antallOppgaverIkkeForfalt: number;
    antallOppgaverUtenFrist: number;
    antallOppgaverUtfoert: number;
    antallBeslutninger: number;
    antallMedlemmer: number;
    antallKommentarer: number;
    antallSvar: number;
}

export interface GruppeAggregatModell {
    totalAntall: number;
    antallPerGruppe: { [index: string]: number };
}

/**
 * @deprecated
 */
export interface GruppeInvitasjonModell {
    id: MedlemId;
    epost: Epost;
    navn: LitenIkkeTomStreng | null;
    navnEllerEpost: LitenIkkeTomStreng;
    mobilnummer: Mobilnummer | null;
    status: number;
    opprettetDato: ZonedDateTimeSerialisert;
    rolle: MedlemsRollePeriodeModell | null;
    avatarId: BildedataId | null;
    tilgangsroller: TilgangsrolleMedlem[];
}

export interface GruppeInvitasjonSpesifikasjoner {
    gruppeId: GruppeId;
    invitasjoner: OpprettGruppeInvitasjonSpesifikasjon[];
}

export interface GruppeInvitasjonTilGodkjenningModell {
    id: MedlemId;
    gruppeId: GruppeId;
    token: TidsstempletEngangstoken | null;
    epost: Epost;
    navnEllerEpost: LitenIkkeTomStreng;
    rolle: MedlemsRolleModell;
    opprettetDato: ZonedDateTimeSerialisert;
    gruppeTittel: LitenIkkeTomStreng;
    gruppeOrganisasjonsnavn: LitenIkkeTomStreng;
    kreverOtpGodkjenning: boolean;
    kreverEid: boolean;
    otpValidert: boolean;
}

export interface GruppeMedlemListeModell extends EnkelGruppeMedlemModell {
    gruppeId: GruppeId;
    brukerId: BrukerId | null;
    epost: Epost;
    mobilnummer: Mobilnummer | null;
    tidssone: Tidssone | null;
    spraak: Språk | null;
    avatarId: BildedataId | null;
    /**
     * bruk invitasjonsstatus
     * @deprecated
     */
    status: Invitasjonsstatus;
    invitasjonsstatus: Invitasjonsstatus;
    /**
     * bruk første rolle fra aktiveMedlemsroller
     * @deprecated
     */
    rolle: MedlemsRolleModell | null;
    /**
     * bruk aktiveMedlemsroller/inaktiveMedlemsroller
     * @deprecated
     */
    roller: MedlemsRollePeriodeModell[];
    aktiveMedlemsroller: MedlemsRollePeriode2Modell[];
    inaktiveMedlemsroller: MedlemsRollePeriode2Modell[];
    tilgangsroller: TilgangsrolleMedlem[];
    medlemstatusSistEndret: ZonedDateTimeSerialisert;
}

export interface GruppeMedlemModell extends GruppeMedlemListeModell {
    gruppe: EnkelGruppeModell;
}

export interface GruppeModell extends EnkelGruppeModell {
    foreldergruppenavn: LitenIkkeTomStreng | null;
    aksjeeierbokId: AksjeeierbokId | null;
    harAksjeeierbok: boolean;
    alleMedlemmer: GruppeMedlemListeModell[];
    /**
     * bruk alleMedlemmer og filtrer til aktive
     * @deprecated
     */
    medlemmer: GruppeMedlemListeModell[];
    /**
     * bruk alleMedlemmer og filtrer til inaktive (Medlemstatus != tilgang_stengt/anonymisert & invitasjon.status =! avslått)
     * @deprecated
     */
    inaktiveMedlemmer: GruppeMedlemListeModell[];
    /**
     * bruk alleMedlemmer og filtrer til aktiveInvitasjoner (harTilgang & status != akseptert
     * @deprecated
     */
    invitasjoner: GruppeInvitasjonModell[];
    antallMoeterInnevaerendeAar: number;
    tillatteAutentiseringsmetoder: Autentiseringsmetode[];
}

export interface GruppeRessurs_Oppdaterspråkkode {
    spraak: Språk;
}

export interface GruppeSomKreverAnnenAutentiseringsmetodeModell {
    gruppe: EnkelGruppeModell;
    tillatteMetoder: Autentiseringsmetode[];
}

export interface GruppemalModell {
    navn: LitenIkkeTomStreng;
    beskrivelse: LitenIkkeTomStreng;
}

export interface GrupperAggreatModell {
    grupper: GruppeAggreatModell[];
}

export interface GruppertTynnSakModell {
    kommende: TynnSakModell[];
    tidligere: TynnSakModell[];
}

export interface HendelseAggregat {
    entitetType: Class;
    endringstype: Endringstype;
    subEndringstype: SubEndringstype | null;
    antall: number;
}

export interface IkonmarkeringVisualisering extends AnnoteringVisualisering {
    '@type': 'ikon';
    farge: Tekstmarkeringsfarge;
    plassering: PdfKoordinat;
}

export interface ImporterGoogleDokumentISakSpesifikasjon {
    filId: string;
    mimetype: Mimetype;
    navn: LitenIkkeTomStreng;
    url: HttpsUrl;
    /**
     * brukers google oauth-token som gir tilgang til å lese dokumentet via google drive-api
     */
    oauthToken: string;
}

export interface ImporterMicrosoftOneDriveDokumentISakSpesifikasjon {
    filId: string;
    sharePointEndpoint: SharepointUrl;
    driveId: string;
    navn: LitenIkkeTomStreng;
    /**
     * Url for å åpne dokumentet i microsoft one drive for visning
     */
    url: HttpsUrl;
    /**
     * brukers microsoft oauth-token som gir tilgang til å lese dokumentet via microsoft graph-api
     */
    oauthToken: string;
}

export interface ImportresultatModell {
    rotmappe: ArkivMappenodeModell;
    importerteFiler: string[];
    filerSomAlleredeEksisterte: string[];
    filerSomBleIgnorert: string[];
    filerSomVarForStore: string[];
}

export interface InitierTotpQrkodeModell {
    qrKodeBilde: string;
}

export interface InnloggingsSpesifikasjon {
    brukernavn: Brukernavn;
    passord: string;
    totpOtpKode: string;
    smsOtpKode: string;
    tokenvarighet: Tokenvarighet;
    forespurtMetode: Autentiseringsmetode;
}

export interface InvitasjonOtpSendtModell {
    /**
     * Maskert versjon av mobilnummerert sms med otp er sendt til
     */
    otpSmsSendtTil: string;
}

export interface InvitasjonSlettSpesifikasjon {
    aarsak: LitenIkkeTomStreng;
}

export interface InvitasjonSlettetRespons {
    slettet: boolean;
    anonymisertInvitasjon: GruppeMedlemModell | null;
}

export interface InvitasjonValiderOtpSpesifikasjon {
    engangskode: string;
}

/**
 * Informasjon om en IPs lokasjon. Kan persisteres som @Column da typen er mappet i {@link no.systemfabrikken.lederplan.infrastruktur.datalager.hibernate.HibernateRessurser.HibernateRessurserBygger} Merk at endringer i feltnavn derfor krever migrering.
 */
export interface IpLokasjon {
    ip: string;
    kontinent: string;
    land: string;
    region: string;
    by: string;
}

export interface JwtTokenInfoModell {
    id: LitenIkkeTomStreng;
    utloepstidspunkt: ZonedDateTimeSerialisert;
    utstedelsestidspunkt: ZonedDateTimeSerialisert;
    tokenvarighet: Tokenvarighet;
    autentiseringsmetode: BenyttetAutentiseringsmetode;
    tidTilUtloeper: number;
}

export interface KallendeMoetedeltakerModell {
    brukersDeltakerStatus: Deltakerstatus;
    brukersProtokollsignaturMangler: boolean;
    brukersStemmegivningMangler: boolean;
}

export interface KanAvtaleTermineresInfoModell {
    status: KanTermineresStatus;
    antallDagerFoerSletting: number;
    beregnetSlettedato: ZonedDateTimeSerialisert;
    nedlastningMaaVaereNyereEnn: ZonedDateTimeSerialisert;
    maaAvsluttesFoer: ZonedDateTimeSerialisert | null;
}

/**
 * @deprecated
 */
export interface KanSlettesModell {
    kanSlettes: boolean;
    antallOppgaverSomAnsvarlig: number;
    antallKommentarerSomForfatter: number;
}

export interface KommentarModell {
    id: KommentarId;
    kommentar: StorStreng;
    privat: boolean;
    publisertAv: GruppeMedlemListeModell;
    publisertDato: ZonedDateTimeSerialisert;
    gruppeId: GruppeId;
    forelder: ForelderModell;
    varslede: GruppeMedlemListeModell[];
    svar: SvarModell[];
    senesteSvar: SvarModell | null;
    senestePubliseringsdato: ZonedDateTimeSerialisert;
}

export interface KopierMøteSpesifikasjon {
    id: MøteId;
    kopiAvMoeteId: MøteId;
    gruppeId: GruppeId;
    tittel: LitenIkkeTomStreng;
    dato: MøteDato;
    formaal: HtmlTekst;
    behandlingsSted: Behandlingssted;
    behandlingsMaate: StorStreng;
    erMoetePublisert: boolean;
    erProtokollPublisert: boolean;
    deltakere: MedlemId[];
    deltakereSomSkalSignereProtokoll: MedlemId[];
    eksterneDeltakere: EksternMøtedeltakerSpesifikasjon[];
    valgteSaker: AgendaelementId[];
}

export interface KopierMøteTilGrupperSpesifikasjon {
    startdato: ZonedDateTimeSerialisert;
    gruppeIdr: GruppeId[];
}

export interface KopierMøteTilGrupperValideringsfeil {
    harFeil: boolean;
    /**
     * Valideringsfeil av typen {@link OpprettMøteValideringsfeil} og {@link Valideringsfeilkode}
     */
    feil: { [index: string]: ValideringsresultatModell<any> };
}

export interface KopierSakTilMøterValideringsfeil {
    harFeil: boolean;
    /**
     * Valideringsfeil av typen {@link OpprettAgendaelementValideringsfeil} og {@link Valideringsfeilkode} . Siden valideringsfeilene kan være av forskjellige enum-typer angir vi '?' som generics type argument her, om vi angir eksplisitt type vil dette påvirke json-serialiseringen slik at kun verdier fra angitt type blir serialisert
     */
    feil: { [index: string]: ValideringsresultatModell<any> };
}

export interface KopierSpørreskjemaSpesifikasjon {
    tittel: LitenIkkeTomStreng;
}

export interface KopierTilMøterSpesifikasjon {
    moeter: MøteId[];
}

/**
 * Resultatet for et sett av korrelerende undersøkelser der spørsmålene er gruppert i hht {@link Spørsmålsamling#grupperinger()} . MERK at spørsmål som ligger før første spørsmål av typen {@link Spørsmålstype#grupperingstittel} i skjemaet ikke vil være inkludert i resultatet. MERK at spørsmålsgrupper som ikke inneholder noen spørsmål blir ekskludert
 */
export interface KorellertGruppertSpørreundersøkelseResultatModell {
    primaerUndersoekelse: SpørreundersøkelseEnkelModell;
    sekundaereUndersoekelser: SpørreundersøkelseEnkelModell[];
    grupper: SpørsmålsgruppeMedResultaterModell[];
    /**
     * Analyse av resultatet til primærundersøkelsen, se {@link Spørreundersøkelse#analyse()} . Tom optional dersom analyse ikke er generert.
     */
    analyse: HtmlTekst | null;
}

/**
 * Spørsmål i et annet skjema som korrelerer med et spørsmål, se {@link SpørsmålKorrelasjonModell}
 */
export interface KorrelertSpørsmålModell {
    skjemaId: SpørreskjemaId;
    skjematittel: LitenIkkeTomStreng;
    spoersmaal: SpørsmålModell;
}

export interface KreverEidModell {
    kreverEid: boolean;
}

export interface LagreSpørreskjemaSpesifikasjon {
    tittel: LitenIkkeTomStreng;
    beskrivelse: HtmlTekst;
    ekstraAnalyseprompt: StorIkkeTomStreng | null;
    /**
     * Skjemaets spørsmål i ønsket rekkefølge
     */
    spoersmaal: SpørsmålSpesifikasjon[];
    /**
     * Avtaler skjemaet skal begrenses til, tomt sett gjør skjemaet tilgjengelig for alle grupper
     */
    avtaleIder: AvtaleId[];
}

export interface LenkerelasjonModell {
    id: LenkerelasjonId;
    kildeentitet: EntitetReferanseModell;
    kildefelt: FeltMedInternlenker;
    lenketekst: LitenIkkeTomStreng;
    kildeentitetBeskrivelse: StrengMal;
}

export interface LiknendeDokumentModell {
    sak: TynnSakModell;
    dokumentversjon: DokumentVersjonModell;
}

export interface LåsOppProtokollSpesifikasjon {
    aarsak: LitenIkkeTomStreng;
}

export interface LåsOppSigneringSpesifikasjon {
    aarsak: LitenIkkeTomStreng;
}

export interface MalmøteDeltakerModell {
    medlem: GruppeMedlemListeModell;
    skalSignere: boolean;
}

export interface MalmøteModell {
    id: MalmøteId;
    eiendeGruppeId: GruppeId;
    tittel: LitenIkkeTomStreng;
    starttidspunkt: KlokkeslettUTC | null;
    varighet: Minutter | null;
    behandlingsSted: LitenStreng | null;
    behandlingsMaate: LitenStreng | null;
    erMoetePublisert: boolean;
    erProtokollPublisert: boolean;
    saker: MalsakModell[];
    deltakere: MalmøteDeltakerModell[];
}

export interface MalsakModell {
    id: MalsakId;
    eiendeGruppeId: GruppeId;
    tittel: LitenIkkeTomStreng;
    beskrivelse: HtmlTekst;
    varighet: Minutter | null;
    tema: TemaModell | null;
    sakstype: SakstypeModell | null;
    ansvarlig: GruppeMedlemListeModell | null;
    inkludertGenerertDokument: InkludertGenerertDokument;
    beslutningsforslagtittel: StorIkkeTomStreng | null;
    beslutningsforslagbeskrivelse: HtmlTekst | null;
    erPause: boolean;
    standardIMoete: boolean;
}

export interface ManglerBesvarelsePåSpørreundersøkelseModell {
    undersoekelse: SpørreundersøkelseEnkelModell;
    respondenter: SpørreundersøkelseRespondentModell[];
}

export interface ManglerStemmegivningModell {
    moete: MøteModellEnkel;
    antallAvstemninger: number;
    /**
     * Ett innslag per stemmeberettiget møtedeltaker med informasjon om hvorvidt vedkommende har avgitt stemme på alle avstemninger eller ei
     */
    stemmegivere: StemmegivningInfoModell[];
}

export interface MedlemAnonymiserSpesifikasjon {
    aarsak: LitenIkkeTomStreng;
}

export interface MedlemAssosiasjonerModell {
    antTilknyttetMoeteSomArrangoer: number;
    antTilknyttetAvholdtEllerLaastMoeteSomDeltaker: number;
    antTilknyttetFremtidigIkkelaastMoeteSomDeltaker: number;
    antTilknyttetAvholdtEllerLaastProtokollSomDeltaker: number;
    antTilknyttetFremtidigIkkelaastProtokollSomDeltaker: number;
    antTilknyttetAvholdtEllerLaastSakSomAnsvarlig: number;
    antTilknyttetFremtidigIkkelaastSakSomAnsvarlig: number;
    antTilknyttetOppgaverSomAnsvarlig: number;
    antTilknyttetKommentarerSomForfatter: number;
    antTilknyttetDokument: number;
    antTilknyttetDokumentSomSignatarSomIkkeHarSignert: number;
    erTilknyttetMalmoete: boolean;
}

export interface MedlemStengTilgangSpesifikasjon {
    oppdaterMoetemal: boolean;
    oppdaterFremtidigeMoeter: boolean;
    avsluttedeRolleperioder: AvsluttRolleperiodeSpesifikasjon[];
}

export interface MedlemsRolleIGruppeModell {
    rolle: MedlemsRolleModell;
    gruppe: EnkelGruppeModell;
}

export interface MedlemsRolleModell {
    id: MedlemsRolleId;
    tittel: LitenIkkeTomStreng;
    indeks: number;
    kanIkkeSlettes: boolean;
}

/**
 * Representerer et gruppemedlems rolletilknytning med info om rolletilknytningens varighet (periode)
 */
export interface MedlemsRollePeriode2Modell {
    id: RollePeriodeId;
    medlemsrolleId: MedlemsRolleId;
    tittel: LitenIkkeTomStreng;
    indeks: number;
    periode: DatoPeriodeUtenTid;
}

/**
 * Representerer et gruppemedlems rolletilknytning med info om rolletilknytningens varighet (periode)
 * @deprecated
 */
export interface MedlemsRollePeriodeModell {
    id: RollePeriodeId;
    medlemsrolleId: MedlemsRolleId;
    tittel: LitenIkkeTomStreng;
    indeks: number;
    periode: DatoPeriode<any>;
}

export interface MedlemsRolleSpesifikasjon {
    id: MedlemsRolleId;
    tittel: LitenIkkeTomStreng;
}

export interface MedlemÅpneTilgangSpesifikasjon {
    oppdaterMoetemal: boolean;
    oppdaterFremtidigeMoeter: boolean;
    skalSignereSomStandard: boolean;
    sendInnkallingTilMoeter: boolean;
}

export interface Melding {
    /**
     * meldingen
     */
    msg: string;
    /**
     * meldingstypen på javascriptsiden, en av string, number, boolean, undefined, object, error, unknown
     */
    type: string;
    /**
     * stacktrace fra klienten, kun satt når typen er error
     */
    stack: string;
    /**
     * lognivå, en av trace, debug, info, warn, error
     */
    lvl: string;
    /**
     * tidsstempel, som millisekunder siden EPOC, i UTC-tid
     */
    ts: number;
    /**
     * Byggenummer
     */
    bn: string;
    /**
     * Autentisert brukers id
     */
    usri: string;
    /**
     * Autentisert brukers brukernavn
     */
    usrn: string;
    /**
     * Url meldingen ble sendt fra (applikasjonens daværende href)
     */
    url: string;
    tsDate: string;
}

export interface MeldingsinnstillingerSpesifikasjon {
    deaktiverteMeldingstyper: DeaktivertMeldingstype[];
}

export interface MicrosoftOneDrivePickerKonfigurasjonModell {
    /**
     * microsoft app klient id, slik denne er definert i Azure Entra ID under App Registrations. Se https://github.com/systemfabrikken/styreplan-infrastruktur for provisjonering av denne ressursen
     */
    clientId: string;
    redirectUrl: HttpUrl;
}

export interface Modell {
    name: string;
    level: string;
}

/**
 * Modell som representerer endringen, denne serialiseres og sendes til klienten. **Merk** at den også serialiseres/deserialiseres ved bruk av {@link HazelcastSerialisertModelloppdatering} i transport mellom instanser av lederplan tjenester, da via hazelcast.
 */
export interface Modelloppdatering<T> {
    status: number;
    /**
     * Type av modell oppdatering (merk at dersom status != 200) kan type være null.
     */
    type: ModelloppdateringType;
    /**
     * Detaljer om oppdateringen. Normalt referer vi til berørte entiteter via deres ider slik at klient kan vurdere hvorvidt endringen er relevant eller ei, feks om endret entitet skal lastes på nytt for å oppdatere lokalt datalager.
     */
    modell: T;
    /**
     * gruppen denne hendelsen er knyttet til, enten {@link #gruppeId} eller {@link #avtaleId} må være ikke-null
     */
    gruppeId: GruppeId;
    /**
     * avtalen denne hendelsen er knyttet til, enten {@link #gruppeId} eller {@link #avtaleId} må være ikke-null
     */
    avtaleId: AvtaleId;
    /**
     * Identifiserer klienten som initierte denne modelloppdateringen. Kan benyttes på klientsiden til å identifisere pushmeldingen kom som resultat av denne klientens operasjon.
     */
    klientId: KlientId | null;
    /**
     * Identifiserer brukeren (om noen) som initierte denne modelloppdateringen.
     */
    ansvarligBruker: AnsvarligBruker | null;
}

export interface MoetestatusModell {
    muligeSteg: MoetestegModell[];
    aktivtSteg: MoetestegModell;
    moetePublisert: boolean;
    protokollPublisert: boolean;
    /**
     * Signeringsstatus for møtets protokoll, ikkeAktivert indikere at protokoll ikke er sendt til signering, alle øvrige tilstander representerer et låst møte
     */
    protokollSigneringStatus: SigneringStatus;
    /**
     * Sigeringsstatus for kallende bruker
     */
    protokollSigneringsstatusForBruker: SignatarStatus;
    /**
     * Deltakerstatus for kallende bruker, empty dersom bruker ikke er invitert til møtet
     */
    deltakerstatusForBruker: Deltakerstatus | null;
}

export interface MoetestegModell {
    steg: Moetesteg;
    progresjon: MoetestegProgresjon;
}

export interface MoetestegProgresjon {
    totalt: number;
    andel: number;
}

export interface MuterendeOppgaveSpesifikasjon {
    id: OppgaveId;
    tittel: LitenIkkeTomStreng;
    beskrivelse: HtmlTekst | null;
    ansvarligId: MedlemId;
    frist: ZonedDateTimeSerialisert | null;
    status: Oppgavestatus | null;
    utfoertDato: ZonedDateTimeSerialisert | null;
}

export interface MøteAggregaterModell {
    antallSaker: number;
    antallSakerMine: number;
    antallInvitert: number;
    antallInvitertAkseptert: number;
    antallInvitertAvslaatt: number;
    antallKommentarer: number;
    antallDokumenter: number;
    antallUlesteDokumenter: number;
    antallOppgaver: number;
    /**
     * Totalt antall oppgaver som har forfalt, uavhengig av ansvarlig
     */
    antallOppgaverForfalt: number;
}

export interface MøteDato extends DatoPeriode<MøteDato> {
}

export interface MøteIdOgSakIdModell {
    moeteId: MøteId;
    sakId: AgendaelementId;
}

export interface MøteMedAggregaterModell {
    id: MøteId;
    moete: MøteModellEnkel;
    agregater: MøteAggregaterModell;
    kallendeMoetedeltakerModell: KallendeMoetedeltakerModell;
}

export interface MøteModell extends MøteModellEnkel {
    saker: AgendaelementModell[];
    deltakere: MøtedeltakerModell[];
    eksterneDeltakere: EksternMøtedeltakerModell[];
    /**
     * Antall aksjeeiere som ikke er representert av noen deltaker, tom optional for avholdte møter eller dersom tilknyttet gruppe ikke har noen aksjeeierbok. Merk at vi kun har et forhold til hvordan aksjeeierboken ser ut per dags dato, i motsetning til å beregne hvem som hadde beholdning på møtets dato. Dette er et designvalg som ble tatt ved impl av aksjeeierboken. Av denne grunn beregner vi kun antallIkkeRepresenterteAksjeeiere for ikke-avholdte møter.
     */
    antallIkkeRepresenterteAksjeeiere: number | null;
    moetevurdering: AggregertMøtevurderingModell;
    appentForStemmegivning: boolean;
    protokollAksepterteSignaturmetoder: AkseptertSignaturmetode[];
    favoritter: TynnFavorittModell[];
    tilgang: TilgangModell;
    /**
     * Sann dersom dette eller et påfølgende møte er låst for redigering
     */
    detteEllerPaafoelgendeMoeteLaast: boolean;
}

export interface MøteModellEnkel extends TynnMøteModell {
    behandlingsSted: Behandlingssted;
    behandlingsMaate: StorStreng;
    formaal: HtmlTekst;
    protokolldokumentId: DokumentId;
    eiendeGruppeId: GruppeId;
    protokollSigneringStatus: SigneringStatus;
    erMoetePublisert: boolean;
    erProtokollPublisert: boolean;
}

export interface MøteModellEnkelMedProtokollinfo {
    moete: MøteModellEnkel;
    protokolSigneringStatus: SigneringStatus;
    protokollErTilBehandling: boolean;
    protokollBehandlesI: TynnSakModell[];
}

export interface MøteNyeMedlemKanLeggesTilModell extends TynnMøteModell {
    moeteInnkallingSendt: boolean;
}

export interface MøteOgNySakModell {
    /**
     * møtet den nye saken er tilknyttet
     */
    moete: MøteModell;
    /**
     * nyopprettet sak
     */
    nySak: AgendaelementModell;
}

export interface MøteOgSaksNummerFormatModell {
    moetenummerformat: string;
    saksnummerformat: string;
}

/**
 * Ett lydopptak av møtebehandlingen, med transkripsjonen av det.
@param tidspunkt     tidspunktet opptaket ble gjort
@param transkripsjon teksten opptaket er transkribert til, null før opptaket er transkribert
 */
export interface MøtebehandlingsopptakTranskripsjonModell {
    id: LydopptakId;
    tidspunkt: ZonedDateTimeSerialisert;
    transkripsjon: StorStreng | null;
}

export interface MøtedeltakerGruppeInvitasjonSpesifikasjon {
    id?: MedlemId;
    navn: LitenStreng | null;
    epost: Epost;
    mobilnummer: Mobilnummer | null;
    rolleId: MedlemsRolleId | null;
    skalSignere: boolean;
}

export interface MøtedeltakerModell {
    id: MøtedeltakerId;
    medlem: GruppeMedlemListeModell;
    /**
     * Medlemmets aktive roller på møtedato
     */
    aktiveMedlemsroller: MedlemsRollePeriode2Modell[];
    aksjeeierRepresentasjoner: AksjeeierEnkelModell[];
    status: Deltakerstatus;
    sistOppdatert: ZonedDateTimeSerialisert;
    vurdering: FemdeltVurdering;
    erStemmeberettiget: boolean;
    stemmevekt: number;
    stemmekommentar: LitenStreng;
}

/**
 * Spesifikasjon av deltakere ved opprettelse/redigering av møte. Merk at en av medlemId og medlemInvitasjon må være angitt.
 */
export interface MøtedeltakerSpesifikasjon {
    medlemId: MedlemId | null;
    medlemInvitasjon: MøtedeltakerGruppeInvitasjonSpesifikasjon | null;
    representerteAksjeeiere: AksjeeierId[] | null;
}

export interface MøtedeltakereIdModell {
    deltakerIder: MøtedeltakerId[];
}

export interface MøtedeltakereModell {
    deltakere: MøtedeltakerModell[];
}

export interface MøtedokumentvalgModell {
    utelatteSaker: AgendaelementId[];
    utelatteSaksdokumenter: DokumentId[];
    genereMoetedokumentTosidig: boolean;
    utelatteMoetedokumentdeler: Møtedokumentdel[];
}

export interface MøtepubliseringSpesifikasjon {
    erPublisert: boolean;
    /**
     * Hvorvidt melding (epost) skal sendes til deltakere, kun benyttet når erPublisert=true
     */
    sendMelding?: boolean;
    /**
     * Eventuell beskjed som skal inkluderes i melding til deltakere, kun benyttet når erPublisert=true
     */
    beskjed?: HtmlTekst;
    /**
     * Møtedeltakerne eventuell melding skal sendes til, kun benyttet når erPublisert=true
     */
    mottakere?: MedlemId[];
}

export interface MøterMedBeslutningerModell {
    moeter: MøtesSakerMedBeslutningerModell[];
    ikkeFlerMoeter: boolean;
}

export interface MøtesSakerMedBeslutningerModell {
    id: MøteId;
    dato: MøteDato;
    nummer: LitenIkkeTomStreng;
    moetenavn: LitenIkkeTomStreng;
    gruppenavn: LitenIkkeTomStreng;
    organisasjonsnavn: string;
    saker: SaksBeslutningerModell[];
}

export interface MøtevurderingAktivertSpesifikasjon {
    aktivert: boolean;
}

export interface MøtevurderingerModell {
    moeteId: MøteId;
    moetestart: ZonedDateTimeSerialisert;
    moetetittel: LitenIkkeTomStreng;
    moetenummer: LitenIkkeTomStreng;
    vurderinger: FemdeltVurdering[];
    snittvurdering: number;
}

export interface NyAvtaleOgGruppeSpesifikasjon {
    avtale: NyAvtalespesifikasjon;
    gruppe: NyGruppeSpesifikasjon;
}

export interface NyAvtalespesifikasjon {
    navn: LitenIkkeTomStreng;
    lisensAkseptert: boolean;
    aksepterteBetingelser: HtmlTekst;
}

export interface NyBrukerOgAvtaleOgGruppeSpesifikasjon {
    avtale: NyAvtalespesifikasjon;
    gruppe: NyGruppeSpesifikasjon;
    bruker: NyBrukerSpesifikasjon;
}

export interface NyBrukerSpesifikasjon {
    epost: Epost;
    passord: Passord;
    navn: LitenIkkeTomStreng;
    spraak: Språk;
    tidssone: LitenIkkeTomStreng;
}

export interface NyDokumentAnnoteringSpesifikasjon {
    sidenummer: number;
    type: Annoteringstype;
    visualisering: any;
    privat: boolean;
    markertTekst: LitenStreng;
    kommentar: StorStreng;
    varslede: MedlemId[];
}

export interface NyEllerOppdaterAksjeklasseSpesifikasjon {
    aksjeklasseId: AksjeklasseId;
    navn: LitenIkkeTomStreng;
    beskrivelse: HtmlTekst;
    arkivert: boolean;
}

export interface NyGruppeSpesifikasjon {
    gruppenavn: LitenIkkeTomStreng;
    organisasjonsnavn: LitenIkkeTomStreng;
    moetenavn: LitenIkkeTomStreng;
    farge: FargeHex | null;
    logoBase64: Base64DataUrl | null;
    spraak: Språk;
    tidssone: Tidssone;
    mal: GruppeId | null;
    /**
     * avtale gruppen skal knyttes til, ikke satt ved {@link NyAvtaleOgGruppeSpesifikasjon}
     */
    avtale: AvtaleId;
}

export interface NyMappeSpesifikasjon {
    navn: LitenIkkeTomStreng;
    beskrivelse: HtmlTekst;
}

export interface NyRolleSpesifikasjon {
    id: RollePeriodeId;
    rolleId: MedlemsRolleId;
    start: PlainDateSerialisert;
    slutt: PlainDateSerialisert | null;
}

export interface NySakBeslutningsforslagSpesifikasjon {
    tittel: StorIkkeTomStreng;
    beskrivelse: HtmlTekst | null;
}

export interface NyttMøteSpesifikasjon {
    id: MøteId;
    gruppeId: GruppeId;
    tittel: LitenIkkeTomStreng;
    dato: MøteDato;
    formaal: HtmlTekst;
    behandlingsSted: Behandlingssted;
    behandlingsMaate: StorStreng;
    erMoetePublisert: boolean;
    erProtokollPublisert: boolean;
    deltakere: MøtedeltakerSpesifikasjon[];
    deltakereSomSkalSignereProtokoll: MedlemId[];
    eksterneDeltakere: EksternMøtedeltakerSpesifikasjon[];
    valgteMalsaker: MalsakId[];
}

export interface NyttPassordFraTokenSpesifikasjon {
    token: TidsstempletEngangstoken;
    passord: Passord;
}

export interface NyttPassordSpesifikasjon {
    eksisterendePassord: string;
    nyttPassord: Passord;
}

export interface OkRespons {
    respons: string;
}

export interface OmkringliggendeMøterModell {
    moeter: MøteMedAggregaterModell[];
    antallTidligere: number;
    antallSenere: number;
}

export interface OppdaterAksjeeierSpesifikasjon {
    type: Aksjeeiertype;
    navn: LitenIkkeTomStreng;
    adresse: StorStreng | null;
    epost: Epost | null;
    organisasjonsnummer: Organisasjonsnummer | null;
    foedselsdato: PlainDateSerialisert | null;
    representertAv: MedlemId | null;
    invitasjon: OpprettMedlemInvitasjonSpesifikasjon | null;
}

export interface OppdaterAksjeklasserSpesifikansjonModell {
    aksjeeierbokId: AksjeeierbokId;
    oppdateres: NyEllerOppdaterAksjeklasseSpesifikasjon[];
    nye: NyEllerOppdaterAksjeklasseSpesifikasjon[];
    slettes: AksjeklasseId[];
}

/**
 * @param analyse tom, eller uten tekstlig innhold, for å fjerne analysen, se {@link Spørreundersøkelse#oppdaterAnalyse}
 */
export interface OppdaterAnalyseSpesifikasjon {
    analyse: HtmlTekst | null;
}

export interface OppdaterAvstemningSpesifikasjon {
    tittel: LitenIkkeTomStreng;
    beskrivelse: HtmlTekst | null;
    alternativer: AvstemningsalternativSpesifikasjon[];
}

export interface OppdaterBeholdningKommentarSpesifikasjon {
    kommentar: HtmlTekst;
}

export interface OppdaterBeholdningSpesifikasjon {
    aksjeeierId: AksjeeierId;
    aksjenummer: AksjenummerSamling;
    aksjeklasseId: AksjeklasseId | null;
}

export interface OppdaterBeholdningerSpesifikasjon {
    innfoeringsdato: PlainDateSerialisert;
    endringsaarsak: LitenIkkeTomStreng;
    beholdninger: OppdaterBeholdningSpesifikasjon[];
}

export interface OppdaterBeslutningOgOppgaverSpesifikasjon {
    id: BeslutningId;
    sakId: AgendaelementId;
    tittel: StorStreng;
    beskrivelse: HtmlTekst;
    erForslag: boolean;
    /**
     * Benyttes kun av mobil-klient, dersom ikke oppgitt (undefined eller null i JS, Optional.empty() i java) oppdateres ikke oppgaver
     */
    oppgaver?: MuterendeOppgaveSpesifikasjon[];
}

export interface OppdaterBrukerSensitivSpesifikasjon {
    mobilnummer: Mobilnummer;
    /**
     * Dersom epost og brukernavn er like, så kan det være brukernavn sendes med fra klienten. hvis bruker.epost == bruker.brukernavn så vil ikke dette feltet benyttes i oppdatering!
     */
    brukernavn: Brukernavn;
    epost: Epost;
    autentiseringsinfo: Reautentiseringsinformasjon;
}

/**
 * @deprecated
 */
export interface OppdaterBrukerSpesifikasjon {
    navn: LitenIkkeTomStreng;
    mobilnummer: string;
    avatarBase64: string;
}

export interface OppdaterBrukerSpesifikasjonV2 {
    navn: LitenIkkeTomStreng;
    avatarBase64: Base64DataUrl | null;
}

export interface OppdaterDokumentrekkefølgeSpesifikasjon {
    dokumentrekkefoelge: DokumentId[];
}

export interface OppdaterFørsteSakOgMøtenummerSpesifikasjon {
    førsteMøtenummer: number;
    førsteSaksnummer: number;
}

export interface OppdaterGruppeSpesifikasjon {
    tittel: LitenIkkeTomStreng;
    organisasjonsnavn: LitenIkkeTomStreng;
    moetenavn: LitenIkkeTomStreng;
    /**
     * Gruppe logo i base64 format, dersom empty oppdateres ikke gruppelogo
     */
    logoBase64: Base64DataUrl | null;
    spraak: Språk;
    tidssone: Tidssone;
    farge: FargeHex;
    /**
     * mobil-appen sender ikke med gruppetype
     */
    gruppetype: Gruppetype;
    /**
     * Kun satt dersom gruppetype == mal, mobil-appen sender ikke med gruppemal
     */
    gruppemal: OppdaterGruppemalSpesifikasjon | null;
}

export interface OppdaterGruppemalSpesifikasjon {
    navn: LitenIkkeTomStreng;
    beskrivelse: LitenIkkeTomStreng;
}

export interface OppdaterMalmøteDeltakerSpesifikasjon {
    medlemId: MedlemId;
    skalSignere: boolean;
}

export interface OppdaterMalmøteSpesifikasjon {
    starttidspunkt: KlokkeslettUTC | null;
    varighet: Minutter | null;
    behandlingsSted: LitenStreng | null;
    behandlingsMaate: LitenStreng | null;
    erMoetePublisert: boolean;
    erProtokollPublisert: boolean;
    deltakere: OppdaterMalmøteDeltakerSpesifikasjon[];
    saker: OppdaterMalsakSpesifikasjon[];
}

export interface OppdaterMalsakSpesifikasjon {
    id: MalsakId;
    tittel: LitenIkkeTomStreng;
    beskrivelse: HtmlTekst;
    varighet: Minutter | null;
    temaId: TemaId | null;
    sakstypeId: SakstypeId | null;
    ansvarligId: MedlemId | null;
    inkludertGenerertDokument: InkludertGenerertDokument;
    beslutningsforslagtittel: StorIkkeTomStreng | null;
    beslutningsforslagbeskrivelse: HtmlTekst | null;
    erPause: boolean;
    standardIMoete: boolean;
}

export interface OppdaterMappeSpesifikasjon {
    navn: LitenIkkeTomStreng;
    beskrivelse: HtmlTekst;
}

export interface OppdaterMedlemSpesifikasjon {
    /**
     * @deprecated
     */
    rolleId: MedlemsRolleId;
    nyeMedlemsrolleperioder: NyRolleSpesifikasjon[];
    oppdaterteMedlemsrolleperioder: RedigerRolleSpesifikasjon[];
    tilgangsroller: TilgangsrolleMedlem[];
}

export interface OppdaterMedlemTilgangSpesifikasjon {
    harTilgang: boolean;
}

export interface OppdaterMøteSpesifikasjon {
    dato: MøteDato;
    behandlingsMaate: StorStreng;
    behandlingsSted: Behandlingssted;
    formaal: HtmlTekst;
    /**
     * Liste over deltakere, kan være null da mobil-app setter deltakere via eget kall
     */
    deltakere: MøtedeltakerSpesifikasjon[];
    /**
     * Liste over eksterne deltakere, kan være null da mobil-app ikke støtter eksterne deltakere
     */
    eksterneDeltakere: EksternMøtedeltakerSpesifikasjon[];
}

export interface OppdaterMøtedeltakereSpesifikasjon {
    deltakere: MedlemId[];
}

export interface OppdaterMøtedokumentvalgSpesifikasjon {
    utelatteSaker: AgendaelementId[];
    utelatteSaksdokumenter: DokumentId[];
    settSomStandardForGruppe: boolean;
    genereMoetedokumentTosidig: boolean;
    utelatteMoetedokumentdeler: Møtedokumentdel[];
}

export interface OppdaterPauseSpesifikasjon {
    tittel: LitenIkkeTomStreng;
    beskrivelse: HtmlTekst;
    varighet: number | null;
    /**
     * kun aktuell ved flerdagsmøter
     */
    dag: number | null;
    /**
     * kun aktuell ved flerdagsmøter
     */
    startklokkeslett: KlokkeslettUTC | null;
}

export interface OppdaterReferatSpesifikasjon {
    referat: HtmlTekst;
}

export interface OppdaterSakMedOpsjonerSpesifikasjon {
    sak: OppdaterSakSpesifikasjon;
    sorterEtterSakstype: boolean;
    informerSaksansvarlig: boolean;
    huskSorterEtterSakstypeValg: boolean;
}

export interface OppdaterSakSpesifikasjon {
    moeteId: MøteId;
    tittel: LitenIkkeTomStreng;
    beskrivelse: HtmlTekst;
    temaId: TemaId | null;
    sakstypeId: SakstypeId | null;
    varighet: number | null;
    ansvarligId: MedlemId | null;
    beslutningsforslag: BeslutningsforslagSpesifikasjoner | null;
    /**
     * kun aktuell ved flerdagsmøter
     */
    dag: number | null;
    /**
     * kun aktuell ved flerdagsmøter
     */
    startklokkeslett: KlokkeslettUTC | null;
}

export interface OppdaterSaksrekkefølgeSpesifikasjon {
    /**
     * @deprecated
     */
    saksrekkefoelge: AgendaelementId[];
    saker: SakSpesifikasjon[];
}

export interface OppdaterSakstypeSpesifikasjon {
    gruppeId: GruppeId;
    sakstyper: SakstypeSpesifikasjon[];
}

export interface OppdaterSignatarerSpesifikasjon {
    signatarer: MedlemId[];
    beskjed: HtmlTekst | null;
    /**
     * Årsak til endring, påkrevd ved fjerning av signatar som har signert
     */
    aarsak?: LitenIkkeTomStreng;
    signaturmetoder: AkseptertSignaturmetode[];
    huskSignaturmetodeValg: boolean;
}

export interface OppdaterSkjemalåsResponsModell {
    /**
     * Oppdatert skjemalås, tom dersom status er låstAvSammeBrukerAnnetVindu eller låstAvAnnenBruker
     */
    oppdatertLaas: SkjemalåsModell | null;
    /**
     * Eksisterende lås som er i konflikt, tom dersom ingen konflikt eksisterer (status = låsOppdatert)
     */
    laasIKonflikt: SkjemalåsModell | null;
    status: OppdaterSkjemalåsStatus;
}

export interface OppdaterSkjemalåsSpesifikasjon {
    id: SkjemalåsId;
    skjema: Object;
    klientId: KlientId;
}

export interface OppdaterSkjermingSpesifikasjon {
    medlemmerUtenTilgang: MedlemId[];
    aarsak: LitenStreng;
}

export interface OppdaterStatusSpesifikasjon {
    status: Oppgavestatus;
    utfoertDato: ZonedDateTimeSerialisert | null;
}

export interface OppdaterTemaerSpesifikasjon {
    gruppeId: GruppeId;
    temaer: TemaSpesifikasjon[];
}

export interface OppdaterUtførSpesifikasjon {
    utfoert: boolean;
}

export interface OppdateringmodellArkivnode {
    arkivnodeId: ArkivnodeId;
    mappe: boolean;
    forelderId: ArkivnodeId | null;
}

export interface OppdateringmodellArkivnodeSlettet {
    arkivnodeId: ArkivnodeId;
    mappe: boolean;
    forelderId: ArkivnodeId | null;
    navn: LitenIkkeTomStreng;
}

export interface OppdateringmodellAvstemning {
    avstemningId: AvstemningId;
    sakId: AgendaelementId;
    moeteId: MøteId;
}

export interface OppdateringmodellAvstemningsresultatDeltakerEndret {
    moetedeltakerId: MøtedeltakerId;
    avstemningId: AvstemningId;
    moeteId: MøteId;
}

export interface OppdateringmodellAvstemningsresultatDeltakerNullstilt {
    moetedeltakerId: MøtedeltakerId;
    moeteId: MøteId;
}

export interface OppdateringmodellBeslutning {
    beslutningId: BeslutningId;
    sakId: AgendaelementId;
}

/**
 * Arkiv-feltene er satt dersom arkivdokument, sakId/moeteId-feltene er satt dersom saksdokument.
@param arkivfilId   Kun satt for arkivdokumenter
@param arkivmappeId Kun satt for arkivdokumenter
@param sakId        Kun satt for saksdokumenter
@param moeteId      Kun satt for saksdokumenter
 */
export interface OppdateringmodellDokument {
    dokumentId: DokumentId;
    arkivfilId: ArkivnodeId | null;
    arkivmappeId: ArkivnodeId | null;
    sakId: AgendaelementId | null;
    moeteId: MøteId | null;
}

export interface OppdateringmodellDokumentAnnotering {
    dokumentAnnoteringId: DokumentAnnoteringId;
    dokumentVersjonId: DokumentVersjonId;
}

/**
 * @param arkivfilId   Kun satt for arkivdokumenter
@param arkivmappeId Kun satt for arkivdokumenter
@param sakId        Kun satt for saksdokumenter
@param moeteId      Kun satt for saksdokumenter
 */
export interface OppdateringmodellDokumentversjon {
    dokumentVersjonId: DokumentVersjonId;
    arkivfilId: ArkivnodeId | null;
    arkivmappeId: ArkivnodeId | null;
    sakId: AgendaelementId | null;
    moeteId: MøteId | null;
}

export interface OppdateringmodellEntitetMedForelder {
    endretEntitet: EntitetReferanseModell;
    foreldre: EntitetReferanseModell[];
}

export interface OppdateringmodellKommentarDokument {
    kommentarId: KommentarId;
    dokumentAnnoteringId: DokumentAnnoteringId;
}

export interface OppdateringmodellKommentarMedForelder {
    kommentarId: KommentarId;
    forelderId: string;
}

export interface OppdateringmodellKommentarOppgave {
    kommentarId: KommentarId;
    oppgaveId: OppgaveId;
}

export interface OppdateringmodellKommentarSak {
    kommentarId: KommentarId;
    forelderId: AgendaelementId;
    moeteId: MøteId;
}

export interface OppdateringmodellMøteOgAvstemninger {
    moeteId: MøteId;
    saker: AgendaelementId[];
    avstemninger: AvstemningId[];
}

export interface OppdateringmodellMøteOgSak {
    sakId: AgendaelementId;
    moeteId: MøteId;
}

export interface OppdateringmodellMøtedeltakerOppdatert {
    moetedeltakerId: MøtedeltakerId;
    moeteId: MøteId;
}

export interface OppdateringmodellNyttSaksdokument {
    dokumentId: DokumentId;
    dokumentVersjonId: DokumentVersjonId;
    sakId: AgendaelementId;
    moeteId: MøteId;
}

/**
 * @param moeteId           kun satt dersom oppgaven er knyttet til en sak
@param oppgaveForelderId kun satt dersom oppgaven har en forelder (sak eller beslutning)
 */
export interface OppdateringmodellOppgave {
    oppgaveId: OppgaveId;
    moeteId: MøteId | null;
    oppgaveForelderId: string | null;
}

export interface OppdateringmodellSakFlyttetTilMøte {
    sakId: AgendaelementId;
    moeteId: MøteId;
    opprinneligMoeteId: MøteId;
}

export interface OppdateringmodellSaksdokumentSlettet {
    dokumentId: DokumentId;
    forelderId: AgendaelementId;
    moeteId: MøteId;
}

export interface OppdateringmodellSignatarSignert {
    signatarId: SignatarId;
    dokumentId: DokumentId;
}

export interface OppdateringmodellSvarMedForelder {
    svarId: SvarId;
    kommentarId: KommentarId;
    forelderId: string;
}

export interface OppdatertSensitiveDataModell {
    autentiseringOk: boolean;
    mobilnummerKreverValidering: boolean;
    brukerModell: BrukerModell;
}

export interface Oppdatertidssone {
    tidssone: Tidssone;
}

export interface OppdaterÅrshjulinnslagSpesifikasjon {
    innslag: ÅrshjulinnslagSpesifikasjon[];
}

export interface OppgaveAggreatModell {
    gruppe: GruppeAggregatModell;
    ansvarlig: AnsvarligAggregatModell;
    frist: FristAggregatModell;
    status: StatusAggregatModell;
}

export interface OppgaveForelderinfoIndeksfelter {
    /**
     * navn på strengmal som kan brukes for å generer brukerorientert representasjon av forelder, se {@link no.systemfabrikken.lederplan.domene.StrengMal#malnavn}
     */
    malnavn: string;
    /**
     * Map med nøkler og verdier som benyttes i angitt strengnmal
     */
    noeklerOgVerdier: { [index: string]: any };
    /**
     * Entitet-id til forelder
     */
    id: any;
    /**
     * Entitet-type til forelder
     */
    type: EntitetType;
}

/**
 * Ekstrahert oppgave fra saksreferat.
@param tittel      Kort, beskrivende tittel for oppgaven, maksimalt en linje, uten formatering, merk at denne ikke er typet som LitenStreng da vi ikke vil kaste exception dersom LLM returnerer lengre strenger.
@param beskrivelse Kortfattet og presis beskrivelse av oppgaven. LLM-en svarer med markdown, som konverteres til sanitert html, se {@link MarkdownTekst#somHtml} .
@param ansvarlig   Ansvarlig person, eller null hvis uklart.
@param frist       Dato oppgaven må utføres innen, eller null hvis ingen frist oppgitt.
 */
export interface OppgaveITranskribertSaksreferatModell {
    tittel: string;
    beskrivelse: HtmlTekst;
    ansvarlig: GruppeMedlemListeModell | null;
    frist: PlainDateSerialisert | null;
}

/**
 * Typedefinisjon for _source feltet i json-struktur returnert for treff på indeks-innslag generert via {@link OppgaveIndeksAdapter} . Primært inkludert for å produsere typescript typedefinsjon
 */
export interface OppgaveIndeksfelter {
    tittel: string;
    beskrivelse: string;
    /**
     * {@link Oppgave#navnPåAnsvarlig()}
     */
    ansvarlig: string;
    /**
     * Id til ansvarlig, dersom ansvarlig er angitt
     */
    ansvarligId: MedlemId | null;
    /**
     * {@link Oppgave#frist}  i millis siden epoc, UTC.
     */
    dato: number;
    /**
     * Angir foreldretype, bruker simpleName av foreldreklassen som kan være {@link Sak} , {@link Beslutning} eller null (for frittstående oppgave)
     */
    foreldertype: EntitetType | null;
    /**
     * Info om entitet oppgaven er registrert under
     */
    forelderinfo: OppgaveForelderinfoIndeksfelter | null;
    /**
     * Hvorvidt tilknyttet møte er publisert
     */
    publisert: boolean;
    /**
     * Komma-sepparert lisste med medlemId til medlemmer som er skjermet (ikke har tilgang)
     */
    skjerming: string;
    /**
     * Tilknyttet gruppe
     */
    gruppe: GruppeId;
}

export interface OppgaveModell {
    id: OppgaveId;
    eiendeGruppeId: GruppeId;
    tittel: LitenIkkeTomStreng;
    frist: ZonedDateTimeSerialisert | null;
    utfoertDato: ZonedDateTimeSerialisert | null;
    utfoert: boolean;
    status: Oppgavestatus;
    beskrivelse: HtmlTekst | null;
    ansvarlig: GruppeMedlemListeModell | null;
    sp2Ansvarlig: LitenIkkeTomStreng | null;
    kommentarer: KommentarModell[];
    favoritter: TynnFavorittModell[];
    /**
     * Liste med internlenker som peker til denne oppgaven
     */
    referertFra: LenkerelasjonModell[];
    /**
     * Hvorvidt denne oppgaven har en forelder (sak eller beslutning)
     */
    harForelder: boolean;
    /**
     * Referanse til oppgavens forelder. For oppgave knyttet til sak vil dette være sakens entitetreferanse, for oppgave knyttet til beslutning vil dette være beslutningens entitetreferanse. For frittstående oppgaver vil forelderRef være null og harForelder=false.
     */
    forelderRef: EntitetReferanseModell | null;
    /**
     * Beskrivelse av oppgavens forelder, dersom slik finnes .
     */
    forelderBeskrivelse: StrengMal | null;
}

export interface OppgavePagineringSpesifikasjon {
    offsett: number;
    maksAntall: number;
}

export interface OppgaveSorteringSpesifikasjon {
    kolonne: Oppgavesorteringskolonne;
    retning: Sortering;
}

export interface OppgaveSpesifikasjon {
    id: OppgaveId;
    tittel: LitenIkkeTomStreng;
    beskrivelse: HtmlTekst | null;
    frist: ZonedDateTimeSerialisert | null;
    ansvarligId: MedlemId;
    slettet: boolean;
}

export interface OppgaverMedPaginering {
    oppgaver: OppgaveModell[];
    antallOppgaver: number;
}

export interface OppgaverSpesifikasjoner {
    eksisterendeOppgaver: OppgaveSpesifikasjon[];
    nyeOppgaver: OppgaveSpesifikasjon[];
}

/**
 * Typedefinisjon for _source feltet i json-struktur returnert for treff på indeks-innslag generert via {@link OpplastetDokumentVersjonIndeksAdapter} . Primært inkludert for å produsere typescript typedefinsjon
 */
export interface OpplastetDokumentVersjonIndeksfelter {
    filnavn_fritekst: string;
    filnavn: string;
    pdfFilnavn: string;
    /**
     * {@link no.systemfabrikken.lederplan.domene.dokument.DokumentVersjon#registreringsdato } i millis siden epoc, UTC.
     */
    dato: number;
    /**
     * Dokumentets tekstlige innholde. @todo dette er vel unødvendig å returnere?
     */
    innhold: string;
    /**
     * Id til fildata for orginalformat
     */
    dataid: BinærdataId;
    /**
     * Id til fildata for dokumentets pdf-representasjon, tom streng dersom slik ikke eksisterer
     */
    pdfdataid: BinærdataId;
    /**
     * Dokumentets orginalformat (mimetype), se {@link Mimetype#somTekstrepresentasjon()}
     */
    originalformat: string;
    /**
     * Angir typen til tilknytet {@link no.systemfabrikken.lederplan.domene.dokument.Dokument}
     */
    dokforeldertype: DokumentType;
    /**
     * id til {@link ArkivMappenode} dokumentet ligger i dersom arkivdokument, id til {@link Sak} dersom saksdokument
     */
    dokforelderid: any;
    /**
     * Informasjon om hvilken entitet dette dokumenet er barn av. Ved {@link Saksdokument} : [moete: {@link Møte#tittel} , moetedato: møte.dato.start, sak: {@link Sak#tittel} ]}], ved {@link Arkivdokument} : [mappenavn: <navn på foreldermappe>]
     */
    forelderinfo: { [index: string]: string };
    /**
     * Hvorvidt tilknyttet møte er publisert
     */
    publisert: boolean;
    /**
     * Komma-sepparert lisste med medlemId til medlemmer som er skjermet (ikke har tilgang)
     */
    skjerming: string;
    /**
     * Tilknyttet gruppe
     */
    gruppe: GruppeId;
}

export interface OpprettAksjeeierOgBeholdningSpesifikasjon {
    id: AksjeeierId;
    type: Aksjeeiertype;
    navn: LitenIkkeTomStreng;
    organisasjonsnummer: Organisasjonsnummer | null;
    foedselsdato: PlainDateSerialisert | null;
    epost: Epost | null;
    adresse: StorStreng | null;
    innfoeringsdato: PlainDateSerialisert;
    antallAksjer: number;
    aksjeklasse: LitenIkkeTomStreng | null;
}

export interface OpprettAksjeeierSpesifikasjon {
    id: AksjeeierId;
    type: Aksjeeiertype;
    navn: LitenIkkeTomStreng;
    adresse: StorStreng | null;
    epost: Epost | null;
    organisasjonsnummer: Organisasjonsnummer | null;
    foedselsdato: PlainDateSerialisert | null;
    representertAv: MedlemId | null;
    invitasjon: OpprettMedlemInvitasjonSpesifikasjon | null;
}

export interface OpprettAksjeeiereOgBeholdningerSpesifikasjon {
    beholdninger: OpprettAksjeeierOgBeholdningSpesifikasjon[];
}

export interface OpprettArkivdokumentISakSpesifikasjon {
    arkivFilnodeId: ArkivnodeId;
    dokumentVersjonId: DokumentVersjonId;
}

export interface OpprettAvstemningSpesifikasjon {
    id: AvstemningId;
    sakId: AgendaelementId;
    tittel: LitenIkkeTomStreng;
    beskrivelse: HtmlTekst | null;
    alternativer: AvstemningsalternativSpesifikasjon[];
}

export interface OpprettBeslutningSpesifikasjon {
    id: BeslutningId;
    sakId: AgendaelementId;
    tittel: StorStreng;
    beskrivelse: HtmlTekst;
    erForslag: boolean;
    oppgaver: MuterendeOppgaveSpesifikasjon[];
}

export interface OpprettGruppeInvitasjonSpesifikasjon {
    gruppeId: GruppeId;
    navn: LitenIkkeTomStreng | null;
    epost: Epost;
    mobilnummer: Mobilnummer | null;
    rolleId: MedlemsRolleId;
    rolleStartdato: PlainDateSerialisert;
    tilgangsroller: TilgangsrolleMedlem[];
    oppdaterMoetemal: boolean;
    skalSignereSomStandard: boolean;
    oppdaterFremtidigeMoeter: boolean;
    sendInvitasjon: boolean;
    sendInnkallingTilMoeter: boolean;
}

export interface OpprettKommentarSpesifikasjon {
    id: KommentarId;
    kommentar: StorStreng;
    privat: boolean;
    varslede: MedlemId[];
}

export interface OpprettKommentarSvarSpesifikasjon {
    svar: StorIkkeTomStreng;
}

export interface OpprettMedlemInvitasjonSpesifikasjon {
    navn: LitenStreng | null;
    epost: Epost;
    mobilnummer: Mobilnummer | null;
    rolleId: MedlemsRolleId | null;
    sendInvitasjon: boolean;
}

export interface OpprettSakSpesifikasjon {
    id: AgendaelementId;
    moeteId: MøteId;
    tittel: LitenIkkeTomStreng;
    beskrivelse: HtmlTekst;
    varighet: number | null;
    erPause: boolean;
    /**
     * kun aktuell ved flerdagsmøter
     */
    dag: number | null;
    /**
     * kun aktuell ved flerdagsmøter
     */
    startklokkeslett: KlokkeslettUTC | null;
    /**
     * kun aktuell når erPause=false
     */
    temaId: TemaId | null;
    /**
     * kun aktuell når erPause=false
     */
    sakstypeId: SakstypeId | null;
    /**
     * kun aktuell når erPause=false
     */
    ansvarligId: MedlemId | null;
    /**
     * kun aktuell når erPause=false
     */
    inkludertGenerertDokument: InkludertGenerertDokument | null;
    /**
     * kun aktuell når erPause=false
     * @deprecated
     */
    beslutningsforslagTittel?: StorIkkeTomStreng;
    /**
     * kun aktuell når erPause=false
     * @deprecated
     */
    beslutningsforslagBeskrivelse?: HtmlTekst;
    /**
     * kun aktuell når erPause=false - erstatter beslutningsforslagTittel og beslutningsforslagBeskrivelse
     */
    beslutningsforslag: NySakBeslutningsforslagSpesifikasjon[] | null;
    /**
     * kun aktuell når erPause=false
     */
    kopierFraMalsakId: MalsakId | null;
    /**
     * kun aktuell når erPause=false
     */
    kopierFraSakId: AgendaelementId | null;
}

export interface OpprettSakerSpesifikasjon {
    saker: OpprettSakSpesifikasjon[];
    sorterEtterSakstype: boolean;
    huskSorterEtterSakstypeValg: boolean;
    informerSaksansvarlig: boolean;
}

export interface OpprettSkjemalåsResponsModell {
    /**
     * Opprettet skjemalås, tom dersom status er låstAvSammeBrukerAnnetVindu eller låstAvAnnenBruker
     */
    ervervetLaas: SkjemalåsModell | null;
    /**
     * Eksisterende lås som er i konflikt, tom dersom ingen konflikt eksisterer (status = låsOpprettet)
     */
    laasIKonflikt: SkjemalåsModell | null;
    status: OpprettSkjemalåsStatus;
}

export interface OpprettSkjemalåsSpesifikasjon {
    eiendeGruppeId: GruppeId;
    rotentitetId: EntitetReferanseSpesifikasjon;
    skjemaId: SkjemalåsSkjemaId;
    klientId: KlientId;
    /**
     * Dersom true vil situasjonen der det finnes en eksisterende skjemalås opprettet av kallende bruker, men lagrede data har blitt endret etter at denne låsen ble opprettet føre til at vi returnerer status {@link OpprettSkjemalåsStatus#ingenEndringerLåsOvertatt} istedenfor {@link OpprettSkjemalåsStatus#låstAvSammeBrukerAnnetVindu} eller {@link OpprettSkjemalåsStatus#låstAvAnnenBruker} . Merk at kaller kan kun overta eksisterende lås dersom denne er OPPRETTET av kallende bruker.
     */
    overtaEksisterendeLaas: boolean;
    /**
     * Skjemaet-verdiene som en json-struktur.
     */
    skjema: Object;
}

export interface OpprettSystemMeldingSpesifikasjon {
    meldingstype: Meldingstype;
    varseltype: Varseltype;
    melding: HtmlTekst;
    varighetIMinutter: number;
}

export interface OpprettUndersøkelseSpesifikasjon {
    id: SpørreundersøkelseId;
    tittel: LitenIkkeTomStreng;
    respondenter: MedlemId[];
    skjemaId: SpørreskjemaId;
    gruppeId: GruppeId;
    /**
     * Antall dager (fra i dag) undersøkelsen skal være åpen for besvarelse. Dersom angitt sendes invitasjon til respondentene
     */
    antallDagerTilStenging: number | null;
    informerRespondenter: boolean;
    /**
     * Beskjed som inkluderes i invitasjonen til respondenter dersom slik sendes
     */
    beskjedIInvitasjon: HtmlTekst | null;
}

export interface OppsettModell {
    agendaDokumentValg: AgendadokumentValgModell;
    forfalteOppgaverDokumentValg: ForfalteOppgaverDokumentValgModell;
    protokollValg: ProtokollValgModell;
    moeteOgSaksNummerFormat: MøteOgSaksNummerFormatModell;
    inkluderAgendaIInnkalling: boolean;
    aksepterteSignaturmetoder: AkseptertSignaturmetode[];
    skjulSensitivInformasjonIMeldinger: boolean;
    genereMoetedokumentTosidig: boolean;
    utelatteMoetedokumentdeler: Møtedokumentdel[];
    moetevurderingAktivert: boolean;
    sorterSakerEtterSakstype: boolean;
    spraak: Språk;
    tidssone: Tidssone;
}

/**
 * Prompt og transkripsjon brukt ved generering av møtereferat
 */
export interface OppsummerMøtebehandlingsopptakDebugSpesifikasjon {
    prompt: string;
    transkripsjon: string;
}

/**
 * Møtereferat gennerert basert på transkripsjonen av lydopptaket, oppsummert vhja KI
@param saker referat for de enkelte sakene
 */
export interface OppsummertTranskribertMøtereferatModell {
    saker: OppsummertTranskribertSaksreferatModell[];
}

/**
 * @param tittel       Sakstittel, merk at denne ikke er typet som LitenStreng da vi ikke vil kaste exception dersom LLM returnerer lengre strenger.
@param oppsummering Oppsummering av hva som ble diskutert. LLM-en svarer med markdown, som konverteres til sanitert html, se {@link MarkdownTekst#somHtml} .
@param beslutninger Liste over beslutninger omtalt i referatet.
 */
export interface OppsummertTranskribertSaksreferatModell {
    sakId: AgendaelementId | null;
    tittel: string;
    oppsummering: HtmlTekst;
    beslutninger: BeslutningITranskribertSaksreferatModell[];
}

export interface OtpDeaktivertModell {
    autentiseringOk: boolean;
}

export interface OtpSigneringSpesifikasjon {
    otp: string;
    kanal: TofaktorSigneringskodeKanal;
}

export interface OtpSigneringValideringResponsModell {
    validert: boolean;
}

export interface OtpTotpKodeSpesifikasjon {
    kode: string;
}

export interface PassordResetResponsModell {
    eksistererIBegge: boolean;
}

export interface PassordSpesifikasjon {
    passord: string;
}

export interface PassordValideringsresultat {
    gyldig: boolean;
    feilkoder: string[];
}

export interface PdfKoordinat {
    x: number;
    y: number;
    tlx: number;
    tly: number;
}

export interface PdfRektangel {
    tlx: number;
    tly: number;
    brx: number;
    bry: number;
}

export interface PeriodeModell {
    start: ZonedDateTimeSerialisert;
    slutt: ZonedDateTimeSerialisert;
}

export interface PlanMedMøterSpesifikasjon {
    periode: PlanPeriode;
    nyeMoeter: NyttMøteSpesifikasjon[];
    kopierteMoeter: KopierMøteSpesifikasjon[];
}

export interface PlanModell extends EnkelPlanModell {
    moeter: MøteModellEnkel[];
}

export interface PlanPeriode {
    start: PlainDateSerialisert;
    slutt: PlainDateSerialisert;
}

export interface Pong {
    status: string;
}

export interface PotensiellDokumentSignatarModell {
    signatarFunnet: boolean;
    /**
     * Angitt dersom signaturFunnet
     */
    signatar: DokumentSignatarModell | null;
    /**
     * Set av Signeringsmetode som er tillatt for signering av det aktuelle dokumentet samt antatt at kan benyttes av aktuell bruker
     */
    antattStoettedeSigneringsmetoder: Signeringsmetode[];
}

export interface ProtokollDetaljerModell {
    dato: MøteDato;
    behandlingsSted: Behandlingssted;
    behandlingsMaate: StorStreng;
    behandletISakene: TynnSakModell[];
    erTilBehandling: boolean;
    dokumentVersjon: DokumentVersjonModell;
    transkripsjonInformasjon: ProtokollTranskripsjonInformasjonModell;
}

export interface ProtokollSpesifikasjon {
    dato: MøteDato;
    behandlingsMaate: StorStreng;
    behandlingsSted: Behandlingssted;
    deltakere: ProtokollførtMøtedeltakerSpesifikasjon[];
    eksterneDeltakere: EksternProtokollførtMøtedeltakerSpesifikasjon[];
    saker: SaksreferatSpesifikasjon[];
}

export interface ProtokollTranskripsjonInformasjonModell {
    totalVarighet: DurationSerialisert;
    varighetTranskribert: DurationSerialisert;
    varighetTranskripsjonFeilet: DurationSerialisert;
    antallOpptak: number;
    antallOpptakTranskribert: number;
    antallOpptakTranskripsjonFeilet: number;
    oppsummertMoetereferatTilgjengelig: boolean;
}

export interface ProtokollValgModell {
    beslutningOrdlydEntall: LitenIkkeTomStreng;
    beslutningOrdlydFlertall: LitenIkkeTomStreng;
}

export interface ProtokollValgSpesifikasjon {
    /**
     * Beslutningsordlyd entall, dersom tom resettes ordlyd til standard ordlyd, se {@link ProtokollValg#beslutningOrdlydEntall()}
     */
    beslutningOrdlydEntall: LitenIkkeTomStreng | null;
    /**
     * Beslutningsordlyd flertall, dersom tom resettes ordlyd til standard ordlyd, se {@link ProtokollValg#beslutningOrdlydFlertall()}
     */
    beslutningOrdlydFlertall: LitenIkkeTomStreng | null;
}

export interface ProtokolldokumentISakModell extends SaksdokumentModell {
    sakerProtokollBehandlesI: TynnSakModell[];
    protokollForMoete: TynnMøteModell;
}

export interface ProtokolldokumenterSpesifikasjon {
    moeteIder: MøteId[];
}

export interface ProtokollførtMøtedeltakerModell {
    id: ProtokollførtMøtedeltakerId;
    medlem: GruppeMedlemListeModell;
    /**
     * Medlemmets aktive roller på protokollført møtedato
     */
    aktiveMedlemsroller: MedlemsRollePeriode2Modell[];
    moeteId: MøteId;
    gruppeId: GruppeId;
    status: ProtokollførtDeltakerstatus;
    skalSignere: boolean;
    /**
     * Kun satt dersom {@link #skalSignere}
     */
    signatar: DokumentSignatarModell | null;
    harSignert: boolean;
    /**
     * Kun satt dersom {@link #harSignert}
     */
    signaturinformasjon: SignaturinformasjonModell | null;
    kommentar: LitenStreng;
    aksjeeierRepresentasjoner: AksjeeierIMøteModell[];
}

export interface ProtokollførtMøtedeltakerSpesifikasjon {
    medlemId: MedlemId;
    status: ProtokollførtDeltakerstatus;
    kommentar: LitenStreng | null;
    skalSignere: boolean;
}

export interface ProtokollførtMøtedeltakereModell {
    moeteId: MøteId;
    deltatte: ProtokollførtMøtedeltakerModell[];
    forfalte: ProtokollførtMøtedeltakerModell[];
    /**
     * Merk at ikkeInnkalte inneholder alle gruppemedlemmer som ikke er markert som deltatte eller forfalte. Innslagene her vil ikke nødvendigvis ha {@link ProtokollførtMøtedeltakerModell#id} satt
     */
    ikkeInnkalte: ProtokollførtMøtedeltakerModell[];
    eksterne: EksternProtokollførtMøtedeltakerModell[];
}

export interface PrøveperiodeUtløpsdatoSpesifikasjon {
    proeveperiodeUtloepsdato: ZonedDateTimeSerialisert;
}

export interface RangeringOppsett {
    alternativer: RangeringValg[];
}

export interface RangeringValg {
    tittel: LitenIkkeTomStreng;
    verdi: number;
    farge: FargeHex;
}

export interface Reautentiseringsinformasjon {
    metode: BenyttetAutentiseringsmetode;
    /**
     * Angis dersom metode = passord
     */
    passord?: string;
    /**
     * Angis dersom metode = bankidNorsk/bankidSvensk
     */
    eid?: EidInformasjon;
}

export interface RedigerAvtalepesifikasjon {
    navn: LitenIkkeTomStreng;
    kontaktperson: BrukerId;
}

export interface RedigerFakturainformasjonSpesifikasjon {
    adresseLinje1: LitenIkkeTomStreng;
    adresseLinje2: LitenIkkeTomStreng | null;
    postnummer: LitenIkkeTomStreng;
    poststed: LitenIkkeTomStreng;
    landkode: LitenIkkeTomStreng;
    epostadresse: Epost;
    organisasjonsnummer: Organisasjonsnummer | null;
}

export interface RedigerGruppeInvitasjonSpesifikasjon {
    navn: LitenIkkeTomStreng | null;
    epost: Epost;
    mobilnummer: Mobilnummer | null;
    rolleId: MedlemsRolleId;
    rolleStartdato: PlainDateSerialisert;
    tilgangsroller: TilgangsrolleMedlem[];
    sendInvitasjon: boolean;
}

export interface RedigerRolleSpesifikasjon {
    id: RollePeriodeId;
    slettet: boolean;
    start: PlainDateSerialisert;
    slutt: PlainDateSerialisert | null;
}

export interface RedigerSakKontekst {
    tilgjengeligeAnsvarlige: GruppeMedlemListeModell[];
    forsteSakstype: SakstypeModell;
}

export interface RedigerUndersøkelseSpesifikasjon {
    tittel: LitenIkkeTomStreng;
    respondenter: MedlemId[];
    skjemaId: SpørreskjemaId;
    /**
     * Antall dager (fra i dag) undersøkelsen skal være åpen for besvarelse. Dersom angitt og undersøkelsen ikke er åpen for besvarelse åpnes den invitasjon sendes til respondentene. Dersom undersøkelsen er åpen oppdateres varigheten i henhold til angitt antall dager.
     */
    antallDagerTilStenging: number | null;
    informerNyeRespondenter: boolean;
    /**
     * Beskjed som inkluderes i invitasjonen til respondenter dersom slik sendes
     */
    beskjedIInvitasjon: HtmlTekst | null;
}

export interface RegistrerAndroidTokenSpesifikasjon {
}

export interface RegistrerApnTokenSpesifikasjon {
}

export interface RegistrerAppPushTokenSpesifikasjon {
    deviceId: AppDeviceId;
    type: AppPushTokenType;
    token: AppPushToken;
}

export interface RegistrerRespondentsBesvarelseSpesifikasjon {
    /**
     * Map med innslag av typen SpørsmålId -> svar, der svar er en strengrepresentasjon av svarverdien eller null
     */
    besvarelser: { [index: string]: string };
}

export interface RektangelmarkeringVisualisering extends AnnoteringVisualisering {
    '@type': 'rektangel';
    farge: Tekstmarkeringsfarge;
    markertOmraade: PdfRektangel;
}

export interface ResetPassordSpesifikasjon extends BrukernavnEllerEpostSpesifikasjon {
}

export interface RespondentBesvarelseModell {
    /**
     * Map med innslag av typen SpørsmålId -> svar
     */
    besvarelser: { [index: string]: string };
}

export interface SakFlyttetModell {
    /**
     * møte saken opprinnelig var tilknyttet
     */
    opprineligMoete: MøteModell;
    /**
     * møte saken har blitt flyttet til
     */
    nyttMoete: MøteModell;
    /**
     * den flyttede, oppdaterte saken
     */
    flyttetSak: AgendaelementModell;
}

export interface SakForelderinfoIndeksfelter {
    /**
     * {@link Møte#tittel}
     */
    moete: string;
    moetenummer: string;
}

/**
 * Typedefinisjon for _source feltet i json-struktur returnert for treff på indeks-innslag generert via {@link OpplastetDokumentVersjonIndeksAdapter} . Primært inkludert for å produsere typescript typedefinsjon
 */
export interface SakIndeksfelter {
    nummer: string;
    tittel: string;
    beskrivelse: string;
    /**
     * Navn på ansvarlig, tom streng dersom ikke angitt
     */
    ansvarlig: string;
    /**
     * Navn på tema
     */
    tema: string;
    /**
     * Navn på sakstype
     */
    sakstype: string;
    /**
     * Møtets startdato i millis siden epoc, UTC.
     */
    dato: number;
    forelderinfo: SakForelderinfoIndeksfelter;
    møteId: MøteId;
    /**
     * Hvorvidt tilknyttet møte er publisert
     */
    publisert: boolean;
    /**
     * Komma-sepparert lisste med medlemId til medlemmer som er skjermet (ikke har tilgang)
     */
    skjerming: string;
    /**
     * Tilknyttet gruppe
     */
    gruppe: GruppeId;
}

export interface SakSpesifikasjon {
    id: AgendaelementId;
    dag: number;
    starttidspunkt: KlokkeslettUTC | null;
    varighet: number | null;
}

export interface SakSøkTreffModell {
    id: AgendaelementId;
    saksnummer: string;
    tittel: string;
    beskrivelse: string;
    tema: string;
    sakstype: string;
    moetetittel: string;
    moetenummer: string;
    moetedato: ZonedDateTimeSerialisert;
}

export interface SaksBeslutningerModell {
    id: AgendaelementId;
    tittel: LitenIkkeTomStreng;
    nummer: LitenIkkeTomStreng;
    beslutninger: TynnBeslutningModell[];
}

export interface SaksdokumentModell extends DokumentVersjonModell {
    sakId: AgendaelementId;
    /**
     * @deprecated
     */
    gjeldendeVersjonId: DokumentVersjonId;
    /**
     * @deprecated
     */
    dataId: BinærdataId;
    /**
     * @deprecated
     */
    pdfDataId: BinærdataId;
    /**
     * @deprecated
     */
    forelderRef: EntitetReferanseModell;
    /**
     * Angir sortering for Saksdokumentet innenfor tilknyttet sak
     */
    indeks: number;
}

export interface SaksreferatSpesifikasjon {
    sakId: AgendaelementId;
    referat: HtmlTekst;
    beslutninger: BeslutningsSpesifikasjoner;
}

export interface SakstypeModell {
    id: SakstypeId;
    navn: LitenIkkeTomStreng;
    indeks: number;
    kanIkkeSlettes: boolean;
}

export interface SakstypeSpesifikasjon {
    id: SakstypeId;
    navn: LitenIkkeTomStreng;
}

export interface SendEpostResultatModell {
    sendt: any[];
    ikkeSendt: any[];
}

export interface SendInnkallingSpesifikasjon {
    mottakere: MedlemId[];
    beskjed: HtmlTekst;
    inkluderAgenda: boolean;
    huskInkluderAgendaValg: boolean;
    publiserMoete: boolean;
}

export interface SendProtokollsigneringsInvitasjonSpesifikasjon {
    beskjed: HtmlTekst;
    signaturmetoder: AkseptertSignaturmetode[];
    huskSignaturmetodeValg: boolean;
}

export interface SendPurringSpesifikasjon {
    beskjed: HtmlTekst;
}

export interface SendSmsOtpSigneringSpesifikasjon {
    /**
     * Dersom mobilnummer ikke er angitt før signering med sms har bruker anledning til å angi mobilnummer - nummeret vil bli indirekte bekreftet via validering av engangskode
     */
    mobilnummer?: Mobilnummer;
    /**
     * Må oppgis dersom mobilnummer er oppgitt, bekrefter at kaller har tilgang til aktuell brukerkonto
     */
    autentiseringsinfo?: Reautentiseringsinformasjon;
}

export interface SendTilSigneringSpesifikasjon {
    signatarer: MedlemId[];
    beskjed: HtmlTekst;
    signaturmetoder: AkseptertSignaturmetode[];
    huskSignaturmetodeValg: boolean;
}

export interface SignaturinformasjonModell {
    signaturtype: BenyttetSigneringsmetode;
    signertDato: ZonedDateTimeSerialisert;
    signertAv: string;
}

export interface SigneringOtpSendtModell {
    /**
     * Obfuskert Telefonnummer eller e-post koden har blitt sendt til, tom optional dersom sendt=false
     */
    otpSendtTil: string | null;
    sendt: boolean;
    /**
     * Hvor lenge koden er gyldig, tom optional dersom sendt=false
     */
    varighet: DurationSerialisert | null;
    /**
     * Kun relevant ved sending av otp per SMS der spesifikasjon hadde {@link SendSmsOtpSigneringSpesifikasjon#autentiseringsinfo} angitt ifbm oppdatering av telefonnummer otp skal sendes til
     */
    autentiseringOk: boolean;
}

export interface SkatteetatenAksjeeierModell {
    id: SkatteetatenAksjonærId;
    navn: LitenIkkeTomStreng | null;
    orgnummer: Organisasjonsnummer | null;
    foedselsAar: LitenIkkeTomStreng | null;
    postNummerOgSted: LitenIkkeTomStreng | null;
    landkode: LitenIkkeTomStreng | null;
    aksjeklasse: LitenIkkeTomStreng | null;
    antallAksjer: number;
}

export interface SkatteetatenAksjeeierbokModell {
    orgnummer: Organisasjonsnummer;
    orgnavn: LitenIkkeTomStreng;
    antallAksjerTotalt: number;
    aksjeeiere: SkatteetatenAksjeeierModell[];
}

export interface SkatteetatenAksjeeierbokModellResponse {
    status: SkatteetatenStatus;
    skatteetatenDato: PlainDateSerialisert;
    aksjeeierbokModell: SkatteetatenAksjeeierbokModell | null;
}

export interface SkatteetatenAksjeeierbokSammendragModell {
    orgnummer: Organisasjonsnummer;
    orgnavn: LitenIkkeTomStreng | null;
    antallAksjerTotalt: number;
    antallAksjeeiere: number;
    status: SkatteetatenStatus;
    skatteetatenDato: PlainDateSerialisert;
}

export interface SkjemalåsModell {
    id: SkjemalåsId;
    eiendeGruppeId: GruppeId;
    rotentitetId: EntitetReferanseModell;
    skjemaId: SkjemalåsSkjemaId;
    /**
     * Skjemaet (som et json-objekt) slik det så ut når låsen ble opprettet
     */
    initieltSkjema: Object;
    /**
     * Skjemaet (som et json-objekt) slik det så ut ved siste oppdatering
     */
    skjema: Object;
    oppdatertDato: ZonedDateTimeSerialisert;
    opprettetDato: ZonedDateTimeSerialisert;
    eier: EnkelGruppeMedlemModell;
    klientId: KlientId;
}

export interface SkjermingDetaljerMedValideringsresultatModell {
    valideringsresultat: ValideringsresultatModell<SkjermingValideringsfeil>;
    skjermingsdetaljer: SkjermingDetaljerModell;
}

export interface SkjermingDetaljerModell extends SkjermingModell {
    harSkjermetForelderForKallendeBruker: boolean;
    medlemmerIdUtenTilgangTilForelder: MedlemId[];
    /**
     * Samling med medlemmer som ikke har tilgang, samme som {@link SkjermingModell#skjermedeMedlemmerId} , bortsett fra at `medlemmerUtenTilgang` også vil kunne inneholde deaktiverte medlemmer.
     */
    medlemmerUtenTilgang: GruppeMedlemListeModell[];
}

export interface SkjermingModell {
    erSkjermetForKallendeBruker: boolean;
    inneholderSkjermedeBarn: boolean;
    inneholderBarnSkjermetForKallendeBruker: boolean;
    /**
     * Samling med aktive medlemmer som ikke har tilgang,
     */
    skjermedeMedlemmerId: MedlemId[];
    aarsak: LitenStreng;
}

export interface SlettGruppeResponsModell {
    gruppeId: GruppeId;
    valideringOk: boolean;
    slettet: boolean;
}

export interface SlettGruppeSpesifikasjon {
    verifiseringskode: LitenIkkeTomStreng;
}

export interface SlettSisteBeholdningsendringModell {
    aksjeeiere: AksjeeierMedSlettSisteBeholdningInfoModell[];
    sisteInnfoeringsdato: PlainDateSerialisert | null;
    aksjeklasser: AksjeklasseModell[];
}

export interface SlettSisteBeholdningsendringSpesifikasjon {
    innfoeringsdatoSomSlettes: PlainDateSerialisert;
}

export interface SlåSammenBrukereSpesifikasjon {
    beholdesId: BrukerId;
    slettesId: BrukerId;
}

export interface SmsOtpReservekodeInnloggingsSpesifikasjon {
    brukernavn: Brukernavn;
    passord: string;
    smsOtpReservekode: string;
}

export interface SmsOtpReservekoderModell {
    autentiseringOk: boolean;
    reservekoder: { [index: string]: boolean };
}

/**
 * @deprecated
 */
export interface SmsOtpSigneringSpesifikasjon {
    otp: string;
}

export interface SpørreskjemaAdministrasjonModell extends SpørreskjemaModell {
    ekstraAnalyseprompt: StorIkkeTomStreng | null;
    /**
     * Antall undersøkelser som benytter skjemaet. Skjema som er i bruk kan ikke slettes, og kun tekster kan endres
     */
    antallUndersoekelser: number;
    /**
     * Deaktiverte skjemaer kan ikke benyttes i nye undersøkelser
     */
    deaktivert: boolean;
    /**
     * Avtaler skjemaet er begrenset til, tom dersom skjemaet er tilgjengelig for alle grupper
     */
    avtaler: SpørreskjemaAvtaleModell[];
    /**
     * Korrelasjon for hvert av skjemaets spørsmål, i samme rekkefølge som {@link #spoersmaal}
     */
    korrelasjoner: SpørsmålKorrelasjonModell[];
}

export interface SpørreskjemaAvtaleModell {
    id: AvtaleId;
    navn: LitenIkkeTomStreng;
    avtalestatus: Avtalestatus;
}

export interface SpørreskjemaEnkelModell {
    id: SpørreskjemaId;
    tittel: LitenIkkeTomStreng;
    beskrivelse: HtmlTekst;
}

export interface SpørreskjemaModell extends SpørreskjemaEnkelModell {
    spoersmaal: SpørsmålModell[];
}

/**
 * Analysen av resultatet av en spørreundersøkelse
@param analyse analysen, tom dersom analyse ikke er generert
 */
export interface SpørreundersøkelseAnalyseModell {
    analyse: HtmlTekst | null;
}

export interface SpørreundersøkelseEnkelMedBehandlingerModell extends SpørreundersøkelseEnkelModell {
    behandlinger: TynnSakModell[];
}

export interface SpørreundersøkelseEnkelModell {
    id: SpørreundersøkelseId;
    eiendeGruppeId: GruppeId;
    tittel: LitenIkkeTomStreng;
    /**
     * Perioden som respondenter kan besvare undersøkelsen, som en lukket periode (med slutt). Tom optional dersom undersøkelsen aldri har vært åpnet for besvarelse.
     */
    responsperiode: DatoPeriode<any> | null;
    /**
     * Antall dager respondenter kan besvare undersøkelsen. Tom optional dersom undersøkelsen aldri har vært åpnet for besvarelse
     */
    responsperiodeAntallDager: number | null;
    erAapenForRespons: boolean;
    /**
     * Merk at !erAapenForRespons ikke nødvendigvis impliserer at erAvsluttet==true, en undersøkelse som aldri har vært åpnet for respons vil har både erAapenForRespons==false og erAvsluttet==false
     */
    erAvsluttet: boolean;
    /**
     * Antall gruppemedlemmer registrert som respondenter
     */
    antallRespondenter: number;
    /**
     * Antall respondenter som har besvart undersøkelsen
     */
    antallRespondenterSvart: number;
    /**
     * Kallende brukers respondent id, dersom kallende bruker er registrert som respondent, tom optional ellers
     */
    kallendeBrukersRespondentId: RespondentId | null;
    skjemaId: SpørreskjemaId;
    skjemaTittel: LitenIkkeTomStreng;
}

export interface SpørreundersøkelseModell extends SpørreundersøkelseEnkelModell {
    skjema: SpørreskjemaModell;
    respondenter: GruppeMedlemListeModell[];
}

export interface SpørreundersøkelseOgResultatModell {
    undersoekelseId: SpørreundersøkelseId;
    /**
     * Fulle tittelen til undersøkelsen
     */
    undersoekelseTittel: LitenIkkeTomStreng;
    /**
     * Kort tittel basert på startdato for undersøkelsen. Brukes for å synliggjøre forskjellen mellom ulike spørreundersøkelser når {@link SpørsmålOgResultaterModell#resultater} inneholder multiple innslag. Se {@link Spørreundersøkelse#responsperiodeStart}
     */
    undersoekelseTittelKort: string;
    /**
     * Aggregert resultat for et spørsmål i undersøkelsen. Tom optional dersom det ikke finnes responser for dette spørsmålet i undersøkelsen, eller dersom undersøkelsen er åpen for besvarelse
     */
    resultat: AggregertResultatModell | null;
}

export interface SpørreundersøkelseRapporterSpesifikasjon {
    spoerreundersoekelseIder: SpørreundersøkelseId[];
}

export interface SpørreundersøkelseRespondentModell {
    medlem: GruppeMedlemListeModell;
    status: RespondentStatus;
}

/**
 * Spørsmålets korellasjonsId og spørsmål i andre skjemaer som korrelerer med spørsmålet, se {@link KorrelerteSpørsmål}
 */
export interface SpørsmålKorrelasjonModell {
    spoersmaalId: SpørsmålId;
    /**
     * Sendes med ved lagring, se {@link SpørsmålSpesifikasjon#korellasjonsId} , for å beholde korrelasjonen
     */
    korellasjonsId: Uuid;
    /**
     * Spørsmål i andre skjemaer med samme korellasjonsId, tom dersom spørsmålet ikke korrelerer med andre spørsmål
     */
    korrelerteSpoersmaal: KorrelertSpørsmålModell[];
}

export interface SpørsmålModell {
    id: SpørsmålId;
    tittel: LitenIkkeTomStreng;
    beskrivelse: HtmlTekst;
    type: Spørsmålstype;
    oppsett: SpørsmålOppsett;
}

/**
 * Spørsmål og aggregerte resultater for dette spørsmålet i et sett av korrelerende undersøkelser.
 */
export interface SpørsmålOgResultaterModell {
    spoersmaal: SpørsmålModell;
    /**
     * Liste med ett innslag per undersøkelse med resultatene for dette spørsmålet i undersøkelsen. Første innslag vil være den primære undersøkelsen, etterfulgt av de sekundære.
     */
    resultater: SpørreundersøkelseOgResultatModell[];
    forrigeSpoersmaalHarSammeOppsett: boolean;
    nesteSpoersmaalHarSammeOppsett: boolean;
}

/**
 * Spørsmålstype-spesifikke oppsett-data. Kan mappes med @Column da denne typen er registrert i {@link no.systemfabrikken.lederplan.infrastruktur.datalager.hibernate.HibernateRessurser} vhja {@link IkkeMuterbarJsonType#registrerIkkeMuterbarJsonTypeLongvarchar}
 */
export interface SpørsmålOppsett {
    rangering?: RangeringOppsett;
    velgEnAvFlere?: VelgEnAvFlereOppsett;
    velgNoenAvFlere?: VelgNoenAvFlereOppsett;
}

export interface SpørsmålSpesifikasjon {
    /**
     * Id til eksisterende spørsmål, tom for nytt spørsmål
     */
    id: SpørsmålId | null;
    tittel: LitenIkkeTomStreng;
    beskrivelse: HtmlTekst;
    type: Spørsmålstype;
    oppsett: SpørsmålOppsett | null;
    /**
     * Korellasjonsid til eksisterende spørsmål, se {@link SpørsmålKorrelasjonModell#korellasjonsId} , for å beholde korrelasjonen med spørsmål i andre skjemaer. Tom for nytt spørsmål, eller for å bryte korrelasjonen, se {@link Spørsmålsdefinisjon#korellasjonsId()} . Korrelasjonen må brytes dersom type eller oppsett avviker fra de korrelerte spørsmålene, ellers avvises lagringen med valideringsfeilen {@link no.systemfabrikken.lederplan.domene.spørreundersøkelse.Spørreskjema.SpørreskjemaValideringsfeil#korrelert_spørsmål_har_annen_type_eller_oppsett}
     */
    korellasjonsId: Uuid | null;
}

/**
 * En gruppe bestående av en grupperingstittel og tilhørende spørsmål/aggregater for korrelerende undersøkelser
 */
export interface SpørsmålsgruppeMedResultaterModell {
    /**
     * Spørsmålet som representerer denne gruppen (med type = {@link Spørsmålstype#grupperingstittel} ), samt aggregerte resultater dannet over alle spørsmålene i gruppen så fremt alle spørsmålene i gruppen har samme type og oppsett.
     */
    gruppe: SpørsmålOgResultaterModell;
    /**
     * Spørsmålene i denne gruppen, samt resultater for disse per undersøkelse, vil alltid ha minst ett innslag.
     */
    spoersmaalsamling: SpørsmålOgResultaterModell[];
    alleSpoersmaalErAvSammeTypeOgOppsett: boolean;
    /**
     * Spørsmålstype for spørsmålene i denne gruppen, tom optional dersom ikke alle spørsmålene i denne gruppen har samme type.
     */
    spoersmaalstype: Spørsmålstype | null;
    /**
     * Spørsmålsoppsett for spørsmålene i denne gruppen, tom optional dersom ikke alle spørsmålene i denne gruppen har samme type og har samme oppsett.
     */
    spoersmaalsoppsett: SpørsmålOppsett | null;
}

export interface StatusAggregatModell {
    totalAntall: number;
    antallUtenFrist: number;
    antallForfalt: number;
    antallUtført: number;
    antallIkkeForfalt: number;
}

export interface StemmeberettigetMøtedeltakerSpesifikasjon {
    deltakerId: MøtedeltakerId;
    erStemmeberettiget: boolean;
    stemmevekt: number;
    stemmekommentar: LitenStreng;
}

export interface StemmeberettigetMøtedeltakerSpesifikasjoner {
    deltakere: StemmeberettigetMøtedeltakerSpesifikasjon[];
}

export interface StemmegivningInfoModell {
    medlem: GruppeMedlemListeModell;
    status: StemmegivningStatus;
}

export interface StengForBesvarelseSpesifikasjon {
    informerRespondenter: boolean;
    beskjed: HtmlTekst | null;
}

/**
 * Representerer en internasjonalisert streng vhja en tekstnøkkel (malnavn) og et sett av navngitte erstatningverdier. Se Strengmaler.ts for håndtering på klientsiden. Kan persisteres som @Column da typen er mappet i HibernateTjenester og blir lagret som serialisert json-representasjon.
 */
export interface StrengMal {
    noeklerOgVerdier: { [index: string]: any };
    malnavn: string;
}

/**
 * Signaliser til klient at subject ikke er knyttet til noen konto
 */
export interface SubjectIdIkkeKnyttetTilBrukerModell {
    kryptertOpenIdIdentitet: string;
    openIdNavn: LitenStreng;
    autentiseringsmetode: BenyttetAutentiseringsmetode;
    tokenvarighet: Tokenvarighet;
}

export interface SvarModell {
    id: SvarId;
    svar: StorIkkeTomStreng;
    publisertDato: ZonedDateTimeSerialisert;
    publisertAv: GruppeMedlemListeModell;
}

export interface SystemMeldingModell {
    id: SystemMeldingId;
    melding: HtmlTekst;
    meldingstype: Meldingstype;
    varseltype: Varseltype;
    gyldigTil: ZonedDateTimeSerialisert | null;
}

export interface SøkEntitetSpesifikasjon {
    sokestreng: string;
    entitetType: SøkEntitetType;
    gruppeId: GruppeId;
}

export interface SøkSpesifikasjon {
    soekestreng: string;
    periode: DatoPeriode<any> | null;
    inkluderteEntiteter: SøkEntitetType[];
    inkluderteGrupper: GruppeId[];
}

export interface SøkeresultatModell<E> {
    treff: E[];
    totalantall: number;
}

export interface TekstmarkeringVisualisering extends AnnoteringVisualisering {
    '@type': 'tekst';
    farge: Tekstmarkeringsfarge;
    markertOmraade: PdfRektangel[];
}

export interface TemaModell {
    id: TemaId;
    navn: LitenIkkeTomStreng;
    beskrivelse: HtmlTekst;
    indeks: number;
    arkivert: boolean;
    harForelder: boolean;
    kanIkkeSlettes: boolean;
}

export interface TemaSpesifikasjon {
    id: TemaId;
    navn: LitenIkkeTomStreng;
    beskrivelse: HtmlTekst;
    arkivert: boolean;
}

export interface TerminerAvtaleResponsModell {
    avtale: AvtaleModell;
    feilKode: boolean;
    terminert: boolean;
    ikkeLastetNed: boolean;
    forGammelNedlastning: boolean;
}

export interface TerminerAvtaleSpesifikasjon {
    verifiseringskode: LitenIkkeTomStreng;
}

/**
 * Transkripsjonen av et testopptak, se {@link #testtranskriber} .
@param transkripsjon teksten testopptaket er transkribert til, tom dersom det ikke ble gjenkjent noe tale
 */
export interface TesttranskripsjonModell {
    transkripsjon: StorStreng;
}

/**
 * Variant av {@link Engangstoken} som inneholder et kryptert tidsstempel slik at man kan forkaste token basert på alder. Kan benyttes i hibernate-mappinger og json-serialisering/deserialiseringer. - Deklareres med `@Column(length = TidsstempletEngangstoken.MAX_LENGDE)` - Felt av denne typen må mappes for bruk i hibernate vhja `@Convert(converter = TidsstempletEngangstokenConverter.class)`
 */
export interface TidsstempletEngangstoken {
}

export interface TilgangModell {
    erMoetePublisert: boolean;
    erProtokollPublisert: boolean;
    skjerming: SkjermingModell;
}

export interface TilgjengeligGruppeModell {
    gruppe: EnkelGruppeModell;
    aktiveMedlemmer: GruppeMedlemListeModell[];
    medlemskap: GruppeMedlemListeModell;
}

export interface TillatteAutentiseringsmetoderOppdatertModell {
    autentiseringOk: boolean;
    tillatteAutentiseringsmetoder: Autentiseringsmetode[];
}

export interface TillatteAutentiseringsmetoderSpesifikasjon {
    metoder: Autentiseringsmetode[];
    autentiseringsinfo: Reautentiseringsinformasjon;
}

export interface TokenSpesifikasjon {
    tokenId: TokeninformasjonTokenId;
}

export interface TokeninformasjonModell {
    id: TokeninformasjonTokenId;
    utstedelsestidspunkt: ZonedDateTimeSerialisert;
    utloepstidspunkt: ZonedDateTimeSerialisert;
    ipLokasjon: IpLokasjon;
    userAgent: LitenStreng;
    klientType: KlientType;
    autentiseringmetode: BenyttetAutentiseringsmetode;
}

export interface TotpOppsettBekreftetModell {
    verifisert: boolean;
    reservekoder: { [index: string]: boolean };
}

export interface TotpReservekodeInnloggingsSpesifikasjon {
    brukernavn: Brukernavn;
    passord: string;
    totpReservekode: string;
}

export interface TotpReservekoderModell {
    autentiseringOk: boolean;
    reservekoder: { [index: string]: boolean };
}

export interface TynnBeslutningModell {
    id: BeslutningId;
    tittel: StorStreng;
    erForslag: boolean;
    antallOppgaver: number;
    antallOppgaverUtfort: number;
}

export interface TynnFavorittModell {
    id: FavorittId;
    brukerId: BrukerId;
    opprettetDato: ZonedDateTimeSerialisert;
}

export interface TynnMøteModell {
    id: MøteId;
    nummer: LitenIkkeTomStreng;
    /**
     * 1-basert nummer på møte i plan
     */
    nummerIPlan: number;
    tittel: LitenIkkeTomStreng;
    dato: MøteDato;
    planId: PlanId;
    laastForRedigering: boolean;
}

export interface TynnSakModell {
    id: AgendaelementId;
    nummer: LitenIkkeTomStreng;
    tittel: LitenIkkeTomStreng;
    sakstype: LitenIkkeTomStreng;
    moete: TynnMøteModell;
    gruppe: EnkelGruppeModell;
}

export interface UtvidetGruppeInvitasjonModell {
    invitasjon: GruppeInvitasjonModell;
    gruppe: EnkelGruppeModell;
}

export interface ValideringResponsModell {
    validert: boolean;
}

export interface ValideringsfeilModell<V> {
    feilkode: V;
    data: { [index: string]: any };
}

/**
 * Modell for valideringsfeil. Merk at om vi gjør ValideringsfeilModell.feilkode generisk via feks 'ValideringsresultatModell<V extends ValideringsfeilEnum>' vil dette føre til at jackson alltid serialiserer dette feltet som den enum som er angitt via generics - dette vil føre til uventede resultater dersom den faktiske verdi er en annen ValideringsfeilEnum type en den angitt via generics - noe som forekommer ofte i vår kode.
 */
export interface ValideringsresultatModell<V> {
    harFeil: boolean;
    feil: ValideringsfeilModell<V>[];
}

export interface VelgEnAvFlereOppsett {
    alternativer: RangeringValg[];
}

export interface VelgNoenAvFlereOppsett {
    alternativer: RangeringValg[];
    /**
     * Maksimalt antall alternativer respondenten kan velge, tom dersom det ikke er noen begrensning
     */
    maksimaltAntallValg?: number;
}

export interface ÅpneForBesvarelseSpesifikasjon {
    antallDagerTilStenging: number;
    informerRespondenter: boolean;
    beskjed: HtmlTekst | null;
}

export interface ÅpneStengeForAvstemningSpesifikasjon {
    informerStemmeberettigede: boolean;
    beskjed: HtmlTekst;
}

export interface ÅrshjulInnslagModell {
    id: ÅrshjulinnslagId;
    tittel: LitenIkkeTomStreng;
    beskrivelse: HtmlTekst;
    startuke: number;
    antallUker: number;
    harForelder: boolean;
    gruppeId: GruppeId;
}

export interface ÅrshjulinnslagSpesifikasjon {
    id: ÅrshjulinnslagId;
    tittel: LitenIkkeTomStreng;
    beskrivelse: HtmlTekst;
    startuke: number;
    antallUker: number;
}

export type AnnoteringVisualiseringUnion = IkonmarkeringVisualisering | RektangelmarkeringVisualisering | TekstmarkeringVisualisering;

export type Class = string;

export type DurationSerialisert = string;

export type PlainDateSerialisert = string;

export type PlainTimeSerialisert = string;

export type RestResponse<R> = RequestRespons<R>;

export type ValideringsfeilEnum = string;

export type ZonedDateTimeSerialisert = string;

function uriEncoding(template: TemplateStringsArray, ...substitutions: any[]): string {
    let result = '';
    for (let i = 0; i < substitutions.length; i++) {
        result += template[i];
        result += encodeURIComponent(substitutions[i]);
    }
    result += template[template.length - 1];
    return result;
}


// Added by 'TsGeneratorLederplanUtvidelse' extension

/** @see no.systemfabrikken.lederplan.infrastruktur.datatyper.Strenger$LitenIkkeTomStreng */
export type LitenIkkeTomStreng = string;

/** @see no.systemfabrikken.lederplan.infrastruktur.atmosphere.KlientIdTilbyder$KlientId */
export type KlientId = string;

/** @see no.systemfabrikken.lederplan.infrastruktur.datatyper.Organisasjonsnummer */
export type Organisasjonsnummer = string;

/** @see no.systemfabrikken.lederplan.domene.bruker.Brukernavn */
export type Brukernavn = string;

/** @see no.systemfabrikken.lederplan.infrastruktur.datatyper.Strenger$LitenStreng */
export type LitenStreng = string;

/** @see no.systemfabrikken.lederplan.infrastruktur.datatyper.Strenger$HtmlTekst */
export type HtmlTekst = string;

/** @see no.systemfabrikken.lederplan.infrastruktur.datatyper.Strenger$StorIkkeTomStreng */
export type StorIkkeTomStreng = string;

/** @see no.systemfabrikken.lederplan.domene.bruker.Epost */
export type Epost = string;

/** @see no.systemfabrikken.lederplan.infrastruktur.datatyper.Strenger$StorStreng */
export type StorStreng = string;

/** @see no.systemfabrikken.lederplan.infrastruktur.datatyper.Engangstoken */
export type Engangstoken = string;

/** @see no.systemfabrikken.lederplan.infrastruktur.datatyper.Mobilnummer */
export type Mobilnummer = string;

/** @see no.systemfabrikken.lederplan.domene.bruker.Tidssone */
export type Tidssone = string;

/** @see no.systemfabrikken.lederplan.domene.bruker.Passord */
export type Passord = string;

/** @see no.systemfabrikken.lederplan.infrastruktur.datatyper.Base64DataUrl */
export type Base64DataUrl = string;

/** @see no.systemfabrikken.lederplan.domene.bruker.Bruker$AppPushTokenInfo$AppDeviceId */
export type AppDeviceId = string;

/** @see no.systemfabrikken.lederplan.domene.bruker.Bruker$AppPushTokenInfo$AppPushToken */
export type AppPushToken = string;

/** @see no.systemfabrikken.lederplan.infrastruktur.datatyper.Mimetype */
export type Mimetype = string;

/** @see no.systemfabrikken.lederplan.infrastruktur.datatyper.Url */
export type Url = string;

/** @see no.systemfabrikken.lederplan.infrastruktur.datatyper.FargeHex */
export type FargeHex = string;

/** @see no.systemfabrikken.lederplan.infrastruktur.datatyper.Behandlingssted */
export type Behandlingssted = string;

/** @see no.systemfabrikken.lederplan.infrastruktur.datatyper.KlokkeslettUTC */
export type KlokkeslettUTC = PlainTimeSerialisert;

/** @see no.systemfabrikken.lederplan.infrastruktur.datatyper.Minutter */
export type Minutter = number;

/** @see no.systemfabrikken.lederplan.infrastruktur.datatyper.HttpsUrl */
export type HttpsUrl = string;

/** @see no.systemfabrikken.lederplan.tjenester.microsoftintegrasjon.MicrosoftOneDriveNedlasting$SharepointUrl */
export type SharepointUrl = string;

/** @see no.systemfabrikken.lederplan.infrastruktur.datatyper.HttpUrl */
export type HttpUrl = string;

/** @see no.systemfabrikken.lederplan.infrastruktur.datatyper.Strenger$MarkdownTekst */
export type MarkdownTekst = string;

/** @see no.systemfabrikken.lederplan.infrastruktur.datatyper.Uuid */
export type Uuid = string;

/** @see no.systemfabrikken.lederplan.domene.sak.Agendaelement$AgendaelementId */
export type AgendaelementId = string;

/** @see no.systemfabrikken.lederplan.domene.møte.MøteId */
export type MøteId = string;

/** @see no.systemfabrikken.lederplan.domene.gruppe.GruppeId */
export type GruppeId = string;

/** @see no.systemfabrikken.lederplan.domene.gruppe.Medlem$MedlemId */
export type MedlemId = string;

/** @see no.systemfabrikken.lederplan.domene.dokument.Binærdata$BinærdataId */
export type BinærdataId = string;

/** @see no.systemfabrikken.lederplan.domene.arkiv.Arkivnode$ArkivnodeId */
export type ArkivnodeId = string;

/** @see no.systemfabrikken.lederplan.domene.sak.Avstemning$AvstemningId */
export type AvstemningId = string;

/** @see no.systemfabrikken.lederplan.domene.møte.MøtedeltakerId */
export type MøtedeltakerId = string;

/** @see no.systemfabrikken.lederplan.domene.sak.BeslutningId */
export type BeslutningId = string;

/** @see no.systemfabrikken.lederplan.domene.dokument.Dokument$DokumentId */
export type DokumentId = string;

/** @see no.systemfabrikken.lederplan.domene.dokument.DokumentAnnotering$DokumentAnnoteringId */
export type DokumentAnnoteringId = string;

/** @see no.systemfabrikken.lederplan.domene.dokument.DokumentVersjon$DokumentVersjonId */
export type DokumentVersjonId = string;

/** @see no.systemfabrikken.lederplan.domene.kommentar.Kommentar$KommentarId */
export type KommentarId = string;

/** @see no.systemfabrikken.lederplan.domene.oppgave.OppgaveId */
export type OppgaveId = string;

/** @see no.systemfabrikken.lederplan.domene.dokument.Signatar$SignatarId */
export type SignatarId = string;

/** @see no.systemfabrikken.lederplan.domene.kommentar.Svar$SvarId */
export type SvarId = string;

/** @see no.systemfabrikken.lederplan.domene.avtale.Avtale$AvtaleId */
export type AvtaleId = string;

/** @see no.systemfabrikken.lederplan.infrastruktur.asynkrontArbeid.AsynkOppgaveId */
export type AsynkOppgaveId = string;

/** @see no.systemfabrikken.lederplan.domene.spørreundersøkelse.Spørreskjema$SpørreskjemaId */
export type SpørreskjemaId = string;

/** @see no.systemfabrikken.lederplan.domene.systemmelding.SystemMelding$SystemMeldingId */
export type SystemMeldingId = string;

/** @see no.systemfabrikken.lederplan.domene.aksjeeierbok.Aksjeeierbok$AksjeeierbokId */
export type AksjeeierbokId = string;

/** @see no.systemfabrikken.lederplan.domene.aksjeeierbok.Aksjeeier$AksjeeierId */
export type AksjeeierId = string;

/** @see no.systemfabrikken.lederplan.domene.bruker.BrukerId */
export type BrukerId = string;

/** @see no.systemfabrikken.lederplan.domene.dokument.Bildedata$BildedataId */
export type BildedataId = string;

/** @see no.systemfabrikken.lederplan.domene.møte.ProtokollførtMøtedeltaker$ProtokollførtMøtedeltakerId */
export type ProtokollførtMøtedeltakerId = string;

/** @see no.systemfabrikken.lederplan.domene.lydopptak.Lydopptak$LydopptakId */
export type LydopptakId = string;

/** @see no.systemfabrikken.lederplan.domene.møtemal.Malmøte$MalmøteId */
export type MalmøteId = string;

/** @see no.systemfabrikken.lederplan.domene.plan.Plan$PlanId */
export type PlanId = string;

/** @see no.systemfabrikken.lederplan.domene.skjemalås.Skjemalås$SkjemalåsId */
export type SkjemalåsId = string;

/** @see no.systemfabrikken.lederplan.domene.spørreundersøkelse.Spørreundersøkelse$SpørreundersøkelseId */
export type SpørreundersøkelseId = string;

/** @see no.systemfabrikken.lederplan.domene.spørreundersøkelse.Respondent$RespondentId */
export type RespondentId = string;

/** @see no.systemfabrikken.lederplan.domene.gruppe.Årshjulinnslag$ÅrshjulinnslagId */
export type ÅrshjulinnslagId = string;

/** @see no.systemfabrikken.lederplan.domene.aksjeeierbok.Aksjeklasse$AksjeklasseId */
export type AksjeklasseId = string;

/** @see no.systemfabrikken.lederplan.domene.bruker.Tokeninformasjon$TokeninformasjonTokenId */
export type TokeninformasjonTokenId = string;

/** @see no.systemfabrikken.lederplan.domene.gruppe.MedlemsRolleId */
export type MedlemsRolleId = string;

/** @see no.systemfabrikken.lederplan.domene.møtemal.Malsak$MalsakId */
export type MalsakId = string;

/** @see no.systemfabrikken.lederplan.domene.sak.Avstemningsalternativ$AvstemningsalternativId */
export type AvstemningsalternativId = string;

/** @see no.systemfabrikken.lederplan.domene.gruppe.tema.TemaId */
export type TemaId = string;

/** @see no.systemfabrikken.lederplan.domene.gruppe.sakstype.SakstypeId */
export type SakstypeId = string;

/** @see no.systemfabrikken.lederplan.domene.spørreundersøkelse.Spørsmål$SpørsmålId */
export type SpørsmålId = string;

/** @see no.systemfabrikken.lederplan.domene.aksjeeierbok.Aksjebeholdning$AksjebeholdningId */
export type AksjebeholdningId = string;

/** @see no.systemfabrikken.lederplan.domene.favoritt.Favoritt$FavorittId */
export type FavorittId = string;

/** @see no.systemfabrikken.lederplan.domene.gruppe.RollePeriode$RollePeriodeId */
export type RollePeriodeId = string;

/** @see no.systemfabrikken.lederplan.domene.møte.EksternMøtedeltaker$EksternMøtedeltakerId */
export type EksternMøtedeltakerId = string;

/** @see no.systemfabrikken.lederplan.domene.møte.EksternProtokollførtMøtedeltaker$EksternProtokollførtMøtedeltakerId */
export type EksternProtokollførtMøtedeltakerId = string;

/** @see no.systemfabrikken.lederplan.domene.lenkerelasjon.Lenkerelasjon$LenkerelasjonId */
export type LenkerelasjonId = string;

/** @see no.systemfabrikken.lederplan.domene.revisjonslogg.Endringshendelse$EndringshendelseId */
export type EndringshendelseId = string;

/** @see no.systemfabrikken.lederplan.domene.aksjeeierbok.SkatteetatenAksjonær$SkatteetatenAksjonærId */
export type SkatteetatenAksjonærId = string;

/** Møtedokumentdeler som kan utelates fra møtedokument MERK: tallRepresentasjon må holdes i synk med tilsvarende enum i JS koden
 * @see no.systemfabrikken.lederplan.tjenester.dokumentgenerering.generatorer.AgendaDocumentGenerator$AgendaDokumentDel (enum annotert med @JsonValue) */
export enum AgendaDokumentDel {
    saksbeskrivelse = 0,
    beslutningsforslag = 1,
    planlagte_deltakere = 2,
}

/** Angir hvilke {@link Signeringsmetode} signatarer skal kunne signerer med.
 * @see no.systemfabrikken.lederplan.domene.dokument.Signering$AkseptertSignaturmetode (enum annotert med @JsonValue) */
export enum AkseptertSignaturmetode {
    enkelelektronisk = 0,
    avansertelektronisk = 1,
}

/** NB: Denne typen må holdes i synk med motsvarende enum på javascript-siden
 * @see no.systemfabrikken.lederplan.domene.aksjeeierbok.Aksjeeier$Aksjeeiertype (enum annotert med @JsonValue) */
export enum Aksjeeiertype {
    person = 0,
    organisasjon = 1,
}

/** MERK!! tallRepresentasjon må holdes i synk med tilsvarende enum i JS koden!!
 * @see no.systemfabrikken.lederplan.domene.dokument.DokumentAnnotering$Annoteringstype (enum annotert med @JsonValue) */
export enum Annoteringstype {
    tekstmarkering = 0,
    rektangelmarkering = 1,
    ikonmarkering = 2,
}

/**  @see no.systemfabrikken.lederplan.domene.bruker.Bruker$AppPushTokenInfo$AppPushTokenType (enum annotert med @JsonValue) */
export enum AppPushTokenType {
    /** Apple Push Notification*/
    apn = 0,
    /** Android Google Cloud Messaging*/
    gcm = 1,
}

/** Angir status for en autentiseringsrespons
 * @see no.systemfabrikken.lederplan.resources.autentisering.Autentiser$AutentiseringStatus (enum annotert med @JsonValue) */
export enum AutentiseringStatus {
    autentisert = 0,
    kontostengt = 1,
    ikkeStøttetMetode = 2,
    ukjentSubject = 3,
    ugyldigSpesifikasjon = 4,
    kreverOppgradering = 5,
    avbrutt = 6,
}

/** Autentiseringsmetoder en bruker kan benytte. **MERK - tallRepresentasjon må holdes i synk med tilsvarende enum i JS koden!! - deklarasjonsrekkefølgen på enumene er av betydning - senere enum representerer et høyere sikkerhetsnivå enn tidligere enum Felt av denne typen må mappes for bruk i hibernate vhja `@Convert(converter = AutentiseringsmetodeSamlingConverter.class)`
 * @see no.systemfabrikken.lederplan.domene.bruker.Bruker$Autentiseringsmetode (enum annotert med @JsonValue) */
export enum Autentiseringsmetode {
    /** Autentisering med brukernavn og passord, laveste nivå*/
    passord = 0,
    /** Autentisering med totp OTP (feks Google Authenticator) i tillegg til brukernavn og passord*/
    totpOtp = 1,
    /** Autentisering med SMS OTP i tillegg til brukernavn og passord*/
    smsOtp = 3,
    /** Autentisering mot criipto openid (nordisk bankid), høyeste nivå*/
    criiptoOpenId = 2,
}

/**  @see no.systemfabrikken.lederplan.domene.avtale.Avtale$Avtalestatus (enum annotert med @JsonValue) */
export enum Avtalestatus {
    prøveperiode = 0,
    prøveperiodeUtløpt = 1,
    aktiv = 2,
    terminert = 3,
}

/** NB: Denne typen må holdes i synk med motsvarende enum på javascript-siden
 * @see no.systemfabrikken.lederplan.tjenester.bankid.BankIDSignering$BankIdSigneringStatus */
export enum BankIdSigneringStatus {
    ordre_mottatt = 'ordre_mottatt',
    bruker_signerer = 'bruker_signerer',
    avvist = 'avvist',
    feilet = 'feilet',
    utlopt = 'utlopt',
    signering_fullfort = 'signering_fullfort',
    UKJENT = 'UKJENT',
}

/** NB: Denne typen må holdes i synk med motsvarende enum på javascript-siden
 * @see no.systemfabrikken.lederplan.tjenester.bankid.BankIDSignering$BankidResponsStatus (enum annotert med @JsonValue) */
export enum BankidResponsStatus {
    ok = 0,
    avbrutt_av_bruker = 1,
    feil = 2,
}

/** Autentiseringsmetode benyttet ved innlogging. Merk at enum-navnet er benyttet i {@link Autentiseringshendelser} , navn kan således ikke endres uten migrering. - **HUSK:** å oppdatere js-ekvivalent. - **HUSK:** å legge til nye innslag også i lederplan-tjenester/src/main/resources/no/systemfabrikken/lederplan/tjenester/tekstmal/maler/includes/enum\_makroer.ftl
 * @see no.systemfabrikken.lederplan.domene.bruker.Bruker$Autentiseringshendelser$BenyttetAutentiseringsmetode (enum annotert med @JsonValue) */
export enum BenyttetAutentiseringsmetode {
    passord = 0,
    totp = 1,
    totpReserverkode = 2,
    sms = 5,
    smsReservekode = 6,
    bankidNorsk = 3,
    bankidSvensk = 4,
}

/** Enum som angir faktisk benyttet e-id ved signering. Se {@link no.systemfabrikken.lederplan.domene.dokument.Signering.Signeringsmetode} for enum som representerer forespurt e-id ved signering. NB: Denne typen må holdes i synk med motsvarende enum på javascript-siden
 * @see no.systemfabrikken.lederplan.domene.dokument.Signatar$BenyttetSigneringsmetode (enum annotert med @JsonValue) */
export enum BenyttetSigneringsmetode {
    /** Signert med at bruker er innlogget. Representerer en 'SIMPLE ELECTRONIC SIGNATURE'. {@link Signatar#eksterntSignaturbevis} vil være tomt, revisjonsloggen fungerer som bevisførsel*/
    legacy_autentisert = 0,
    /** Signert med norsk bankid (web) med vår egen bankid-integrasjon. Representerer en 'ADVANCED ELECTRONIC SIGNATURES' Den tekniske signaturen er over PDFen ( {@link Signering#dokumentversjonTilSignering()} ). {@link Signatar#eksterntSignaturbevis} inneholder PAdES kompatibel PDF-fil med embedded signatur.*/
    legacy_no_bankid_central_pdf = 1,
    /** Signert med tofaktor levert per sms. Representerer en 'SIMPLE ELECTRONIC SIGNATURE'. {@link Signatar#eksterntSignaturbevis} vil være tomt, revisjonsloggen fungerer som bevisførsel*/
    lederplan_autentisert_tofakt_sms = 2,
    /** Signert med tofaktor levert per epost. Representerer en 'SIMPLE ELECTRONIC SIGNATURE'. {@link Signatar#eksterntSignaturbevis} vil være tomt, revisjonsloggen fungerer som bevisførsel*/
    lederplan_autentisert_tofakt_epost = 13,
    /** Signert med norsk bankid mobil. Representerer en 'ADVANCED ELECTRONIC SIGNATURES' Den tekniske signaturen er over en tekst som inneholder dokumentets navn og hash (se bruk av {@link TekstTilSignering#tekstTilSigneringMedDokumenthash } . {@link Signatar#eksterntSignaturbevis} inneholder SEID-SDO-fil med xml-data returnert fra norsk bankid. SEID SDO er basert på ETSI TS 101 733 (CAdES) og ETSI 101 903 (XAdES), se https://www.nkom.no/internett/elektronisk-id-og-tillitstjenester/seid-prosjektet*/
    criipto_no_bankid_mobil_tekst = 3,
    /** Signert med norsk bankid web. Representerer en 'ADVANCED ELECTRONIC SIGNATURES' Den tekniske signaturen er over en tekst som inneholder dokumentets navn og hash (se bruk av {@link TekstTilSignering#tekstTilSigneringMedDokumenthash } . {@link Signatar#eksterntSignaturbevis} inneholder SEID-SDO-fil med xml-data returnert fra norsk bankid. SEID SDO er basert på ETSI TS 101 733 (CAdES) og ETSI 101 903 (XAdES), se https://www.nkom.no/internett/elektronisk-id-og-tillitstjenester/seid-prosjektet*/
    criipto_no_bankid_central_tekst = 6,
    /** Signert med norsk bankid (web). Representerer en 'ADVANCED ELECTRONIC SIGNATURES' Den tekniske signaturen er over PDFen ( {@link Signering#dokumentversjonTilSignering()} ). {@link Signatar#eksterntSignaturbevis} inneholder PAdES kompatibel PDF-fil med embedded signatur.*/
    criipto_no_bankid_central_pdf = 4,
    /** Signert med norsk bankid (web). Representerer en 'ADVANCED ELECTRONIC SIGNATURES' Den tekniske signaturen er over PDFen ( {@link Signering#dokumentversjonTilSignering()} ). {@link Signatar#eksterntSignaturbevis} inneholder PAdES kompatibel PDF-fil med embedded signatur.*/
    criipto_no_bankid_pdf = 11,
    /** Signert med norsk bankid (web). Representerer en 'ADVANCED ELECTRONIC SIGNATURES' Den tekniske signaturen er over PDFen ( {@link Signering#dokumentversjonTilSignering()} ). {@link Signatar#eksterntSignaturbevis} inneholder PAdES kompatibel PDF-fil med embedded signatur.*/
    criipto_no_bankid_high_pdf = 12,
    /** Signert med svensk bankid (web eller mobil). Representerer en 'ADVANCED ELECTRONIC SIGNATURES' Den tekniske signaturen er over en tekst som inneholder dokumentets navn og hash (se bruk av {@link TekstTilSignering#tekstTilSigneringMedDokumenthash } . {@link Signatar#eksterntSignaturbevis} inneholder fil med xml-data returnert fra svensk bankid.*/
    criipto_se_bankid_samedevice = 5,
    /** Signert med svensk bankid (web eller mobil). Representerer en 'ADVANCED ELECTRONIC SIGNATURES' Den tekniske signaturen er over en tekst som inneholder dokumentets navn og hash (se bruk av {@link TekstTilSignering#tekstTilSigneringMedDokumenthash } . {@link Signatar#eksterntSignaturbevis} inneholder fil med xml-data returnert fra svensk bankid.*/
    criipto_se_bankid_anotherdevice = 7,
    /** Signert med svensk bankid (web eller mobil). Representerer en 'ADVANCED ELECTRONIC SIGNATURES' Den tekniske signaturen er over en tekst som inneholder dokumentets navn og hash (se bruk av {@link TekstTilSignering#tekstTilSigneringMedDokumenthash } . {@link Signatar#eksterntSignaturbevis} inneholder fil med xml-data returnert fra svensk bankid.*/
    criipto_se_bankid_anotherdevice_qr = 8,
    /** Signert med bankid i SP2 i SDO-format. Representerer en 'ADVANCED ELECTRONIC SIGNATURES'. Den tekniske signaturen er PDFen og signatur og PDF er pakket inn i en SDO. {@link Signatar#eksterntSignaturbevis} inneholder SDO-fil returnert fra norsk bankid.*/
    sp2_bankid = 9,
    /** Signert med enkelt signatur (klikke på knapp) i SP2. Representerer en 'SIMPLE ELECTRONIC SIGNATURE'. {@link Signatar#eksterntSignaturbevis} vil være tomt, revisjonsloggen fungerer som bevisførsel @todo stemmer dette?*/
    sp2_enkel = 10,
    bankid_qes = 14,
}

/** NB: Denne typen må holdes i synk med motsvarende enum på javascript-siden Støtter foreløpig ikke ES søk.
 * @see no.systemfabrikken.lederplan.domene.sak.IndeksbasertBeslutningSøk$FinnBeslutningerKriterie$BeslutningOppgavestatus (enum annotert med @JsonValue) */
export enum BeslutningOppgavestatus {
    forfalt = 0,
    ikke_forfalt = 1,
    utfoert = 2,
    uten_frist = 3,
    uten_oppgaver = 4,
}

/** Definere hvordan criipto gui vises og dermed også hvordan callback parameter skal propagere tilbake til klient NB: Denne typen må holdes i synk med motsvarende enum på javascript-siden
 * @see no.systemfabrikken.lederplan.tjenester.openid.CriiptoOpenidAutentisering$CriiptoGuiModus (enum annotert med @JsonValue) */
export enum CriiptoGuiModus {
    erstatt = 0,
    popup = 1,
    cordova = 2,
}

/** Enum som angir tilgjengelig eid-tilbydere via criipto. <pre> Mulige tilbydere (fra criiptos hjemmesider): Se https://docs.criipto.com/verify/guides/authorize-url-builder/ og https://docs-old.criipto.com/how-to/acr-values/ Login method	                                acr_values Norwegian BankID - Mobile or Web (user choice): 	        urn:grn:authn:no:bankid Norwegian Vipps Login - Login with Vipps app: 	                urn:grn:authn:no:vipps Swedish BankID - All options (user chooses): 	            urn:grn:authn:se:bankid - Same device:	                            urn:grn:authn:se:bankid:same-device - Another device (aka mobile): 	        urn:grn:authn:se:bankid:another-device - QR code: 	                            urn:grn:authn:se:bankid:another-device:qr Danish NemID - Personal with code card: 	            urn:grn:authn:dk:nemid:poces - Employee with code card: 	            urn:grn:authn:dk:nemid:moces - Employee with code file: 	            urn:grn:authn:dk:nemid:moces:codefile Danish MitID - Level low: 	                            urn:grn:authn:dk:mitid:low - Level substantial: 	                    urn:grn:authn:dk:mitid:substantial Finish e-ID - BankID:	                                urn:grn:authn:fi:bank-id - Mobile certificate (Mobiilivarmenne): 	urn:grn:authn:fi:mobile-id - Both of the above:	                    urn:grn:authn:fi:all Itsme - Basic:	                                urn:grn:authn:itsme:basic - Advanced:	                            urn:grn:authn:itsme:advanced Belgium - erified e-ID	                            urn:grn:authn:be:eid:verified Germany - Sofort (with Schufa check)	            urn:grn:authn:de:sofort NB: Denne typen må holdes i synk med motsvarende enum på javascript-siden </pre>
 * @see no.systemfabrikken.lederplan.tjenester.criipto.CriiptoBasis$CriiptoIdTilbyder (enum annotert med @JsonValue) */
export enum CriiptoIdTilbyder {
    /** Norsk BankID. Gui lar bruker velge mellom ordinær (netsentrisk) og mobil. MERK for signering gjelder: In order to use BankID on mobile, the authorization request must contain login_hint=BIM[:[phoneNumber][:birthDate]] as a query parameter. Se https://confluence.bankidnorge.no/confluence/pdoidcl/technical-documentation/core-concepts/identity-providers
@see CriiptoLoginHint*/
    norsk_bankid_web_og_mobil = 0,
    svensk_bankid_samedevice = 1,
    svensk_bankid_anotherdevice = 2,
    svensk_bankid_anotherdeviceqr = 3,
}

/** NB: Denne typen må holdes i synk med motsvarende enum på javascript-siden
 * @see no.systemfabrikken.lederplan.tjenester.criipto.CriiptoSignering$CriiptoResponsStatus (enum annotert med @JsonValue) */
export enum CriiptoResponsStatus {
    ok = 0,
    avbrutt_av_bruker = 1,
    feil = 2,
}

/** Meldingstyper som kan deaktiveres.
 * @see no.systemfabrikken.lederplan.domene.bruker.MeldingerTilBruker$DeaktivertMeldingstype (enum annotert med @JsonValue) */
export enum DeaktivertMeldingstype {
    forfalteOppgaver = 0,
    sakTildelt = 1,
    oppgaveTildelt = 2,
}

/** NB: Denne typen må holdes i synk med motsvarende enum på javascript-siden
 * @see no.systemfabrikken.lederplan.domene.møte.Møtedeltaker$Deltakerstatus (enum annotert med @JsonValue) */
export enum Deltakerstatus {
    innkalling_ikke_sendt = 0,
    innkalling_sendt = 1,
    akseptert = 2,
    avslaatt = 3,
}

/** NB: Denne typen må holdes i synk med motsvarende enum på javascript-siden
 * @see no.systemfabrikken.lederplan.domene.dokument.Dokument$DokumentType (enum annotert med @JsonValue) */
export enum DokumentType {
    generiskDokument = 0,
    opplastetSaksdokument = 1,
    generertAgendaDokument = 2,
    protokolldokumentISak = 3,
    arkivdokumentISak = 4,
    arkivdokument = 5,
    protokolldokument = 6,
    generertForfalteOppgaverDokument = 7,
    generertSpørreundersøkelseResultaterDokument = 8,
}

/** NB: Denne typen må holdes i synk med motsvarende enum på javascript-siden
 * @see no.systemfabrikken.lederplan.domene.revisjonslogg.Endringshendelse$Endringstype (enum annotert med @JsonValue) */
export enum Endringstype {
    opprett = 0,
    rediger = 1,
    slett = 2,
    innlogging = 3,
    innlogging_feilet = 4,
    utlogging = 5,
    epost = 6,
    eksport = 7,
}

/** Enum med innslag for alle entiteter
 * @see no.systemfabrikken.lederplan.resources.modell.EntitetReferanseModell$EntitetType */
export enum EntitetType {
    endringshendelse = 'Endringshendelse',
    dokument = 'Dokument',
    signatar = 'Signatar',
    saksdokument = 'Saksdokument',
    arkivdokument = 'Arkivdokument',
    protokolldokument = 'Protokolldokument',
    protokolldokumentISak = 'ProtokolldokumentISak',
    arkivdokumentISak = 'ArkivdokumentISak',
    dokumentVersjon = 'DokumentVersjon',
    generertAgendaDokumentVersjon = 'GenerertAgendaDokumentVersjon',
    generertProtokollDokumentVersjon = 'GenerertProtokollDokumentVersjon',
    generertForfalteOppgaverDokumentVersjon = 'GenerertForfalteOppgaverDokumentVersjon',
    opplastetDokumentVersjon = 'OpplastetDokumentVersjon',
    dokumentAnnotering = 'DokumentAnnotering',
    binærdata = 'Binærdata',
    bildedata = 'Bildedata',
    virussjekkDokumentOppgave = 'VirussjekkDokumentOppgave',
    genererBilderAvPdfOppgave = 'GenererBilderAvPdfOppgave',
    konverterDokumentTilPdfOppgave = 'KonverterDokumentTilPdfOppgave',
    ekstraherTekstFraDokumentOppgave = 'EkstraherTekstFraDokumentOppgave',
    sendEpostOppgave = 'SendEpostOppgave',
    sendSmsOppgave = 'SendSmsOppgave',
    genererSignertDokumentDokumentasjonOppgave = 'GenererSignertDokumentDokumentasjonOppgave',
    transkriberLydopptakOppgave = 'TranskriberLydopptakOppgave',
    plan = 'Plan',
    møte = 'Møte',
    møtedeltaker = 'Møtedeltaker',
    eksternMøtedeltaker = 'EksternMøtedeltaker',
    protokollførtMøtedeltaker = 'ProtokollførtMøtedeltaker',
    eksternProtokollførtMøtedeltaker = 'EksternProtokollførtMøtedeltaker',
    sak = 'Sak',
    pause = 'Pause',
    kommentar = 'Kommentar',
    svar = 'Svar',
    beslutning = 'Beslutning',
    sakstype = 'Sakstype',
    tema = 'Tema',
    oppgave = 'Oppgave',
    årshjulinnslag = 'Årshjulinnslag',
    bruker = 'Bruker',
    favoritt = 'Favoritt',
    favorittMøte = 'FavorittMøte',
    favorittSak = 'FavorittSak',
    favorittDokument = 'FavorittDokument',
    favorittBeslutning = 'FavorittBeslutning',
    favorittOppgave = 'FavorittOppgave',
    avtale = 'Avtale',
    gruppe = 'Gruppe',
    medlem = 'Medlem',
    medlemsRolle = 'MedlemsRolle',
    rollePeriode = 'RollePeriode',
    malmøte = 'Malmøte',
    malsak = 'Malsak',
    arkivnode = 'Arkivnode',
    arkivMappenode = 'ArkivMappenode',
    arkivFilnode = 'ArkivFilnode',
    avstemning = 'Avstemning',
    avstemningsalternativ = 'Avstemningsalternativ',
    aksjeeierbok = 'Aksjeeierbok',
    aksjeeier = 'Aksjeeier',
    aksjeklasse = 'Aksjeklasse',
    aksjebeholdning = 'Aksjebeholdning',
    skatteetatenAksjonær = 'SkatteetatenAksjonær',
    svartelistetToken = 'SvartelistetToken',
    tokeninformasjon = 'Tokeninformasjon',
    systemMelding = 'SystemMelding',
    skjemalås = 'Skjemalås',
    nøkkelOgVerdi = 'NøkkelOgVerdi',
    spørreskjema = 'Spørreskjema',
    spørreundersøkelse = 'Spørreundersøkelse',
}

/**  @see no.systemfabrikken.lederplan.resources.favoritt.FavorittRessurs$FavorittType */
export enum FavorittType {
    moete = 'moete',
    sak = 'sak',
    dokument = 'dokument',
    oppgave = 'oppgave',
    beslutning = 'beslutning',
}

/** Identifiserer alle felt som støtter internlenker
 * @see no.systemfabrikken.lederplan.domene.lenkerelasjon.Lenkerelasjon$FeltMedInternlenker (enum annotert med @JsonValue) */
export enum FeltMedInternlenker {
    /** Representerer feltet {@link Møte#formål}*/
    møteFormål = 0,
    /** Representerer feltet {@link Sak#beskrivelse}*/
    sakBeskrivelse = 1,
    /** Representerer feltet {@link Sak#referat }*/
    sakReferat = 2,
    /** Representerer feltet {@link Beslutning#beskrivelse} / {@link Beslutning#beskrivelseForslag}*/
    beslutningBeskrivelse = 3,
    /** Representerer feltet {@link Oppgave#oppgaveBeskrivelse}*/
    oppgaveBeskrivelse = 4,
}

/** NB: Denne typen må holdes i synk med motsvarende enum på javascript-siden
 * @see no.systemfabrikken.lederplan.domene.møte.Møtedeltaker$FemdeltVurdering (enum annotert med @JsonValue) */
export enum FemdeltVurdering {
    dårligst = 1,
    dårlig = 2,
    nøytral = 3,
    bra = 4,
    best = 5,
}

/** NB: Denne typen må holdes i synk med motsvarende enum på javascript-siden
 * @see no.systemfabrikken.lederplan.domene.gruppe.Gruppetype (enum annotert med @JsonValue) */
export enum Gruppetype {
    ordinær = 0,
    mal = 1,
}

/**  @see no.systemfabrikken.lederplan.resources.arkiv.ArkivImportFraZip$ImportValideringsfeil */
export enum ImportValideringsfeil {
    maks_dybde_overskredet = 'maks_dybde_overskredet',
    maks_antallfiler_overskredet = 'maks_antallfiler_overskredet',
}

/** Enum med alle tilgjengelige {@link EntitetIndeksAdapter} implementasjoner, og dermed også alle indekserte entitet-typer. I generert typscript-representasjon benyttes {@link IndeksertEntitet#indekstype()} som verdi (som er entitens klassenavn)
 * @see no.systemfabrikken.lederplan.infrastruktur.indeksering.Adaptere$IndeksertEntitet (enum annotert med @JsonValue) */
export enum IndeksertEntitet {
    møte = "Møte",
    sak = "Sak",
    opplastetDokumentVersjon = "OpplastetDokumentVersjon",
    oppgave = "Oppgave",
    beslutning = "Beslutning",
    kommentar = "Kommentar",
    svar = "Svar",
    gruppe = "Gruppe",
    medlem = "Medlem",
    bruker = "Bruker",
}

/** NB: Denne typen må holdes i synk med motsvarende enum på javascript-siden
 * @see no.systemfabrikken.lederplan.domene.sak.Sak$InkludertGenerertDokument (enum annotert med @JsonValue) */
export enum InkludertGenerertDokument {
    ingen = 0,
    agenda = 1,
    protokoll = 2,
    forfalteOppgaver = 3,
}

/** Subset av {@link EntitetType} som representerer entitet-typene internlenker kan peke til.
 * @see no.systemfabrikken.lederplan.domene.lenkerelasjon.Internlenke$InternlenkeMålEntitetType (enum annotert med @JsonValue) */
export enum InternlenkeMålEntitetType {
    sak = "Sak",
    opplastetDokumentVersjon = "OpplastetDokumentVersjon",
    beslutning = "Beslutning",
    oppgave = "Oppgave",
}

/**  @see no.systemfabrikken.lederplan.domene.gruppe.Invitasjon$Invitasjonsstatus (enum annotert med @JsonValue) */
export enum Invitasjonsstatus {
    ikke_sendt = 0,
    sendt = 1,
    akseptert = 2,
    avslått = 3,
}

/**  @see no.systemfabrikken.lederplan.domene.avtale.Avtale$KanTermineresStatus (enum annotert med @JsonValue) */
export enum KanTermineresStatus {
    IKKE_LASTET_NED = 0,
    NEDLASTING_FOR_GAMMEL = 1,
    OK = 2,
}

/**  @see no.systemfabrikken.lederplan.domene.bruker.Bruker$Autentiseringshendelser$KlientInformasjon$KlientType (enum annotert med @JsonValue) */
export enum KlientType {
    web = 0,
    app = 1,
}

/**  @see no.systemfabrikken.lederplan.domene.gruppe.Medlem$Medlemstatus (enum annotert med @JsonValue) */
export enum Medlemstatus {
    /** Medlem har tilgang til gruppen*/
    normal_tilgang = 0,
    /** Tilgang til gruppen har blitt stengt, man kan gjenåpnes*/
    tilgang_stengt = 1,
    /** Tilgang til gruppen har blitt stengt og medlemmet har blitt anonymisert. Dvs koblet fra bruker dersom invitasjon var akseptert, samt fjernet mobiltelefon og epost fra invitasjon. Denne tilstanden er endelig.*/
    anonymisert = 2,
}

/**  @see no.systemfabrikken.lederplan.domene.systemmelding.SystemMelding$Meldingstype (enum annotert med @JsonValue) */
export enum Meldingstype {
    /** Maler som enkelt skal kunne kopieres til nye meldinger.*/
    mal = 0,
    /** ligger på autentisering.html*/
    loggInnBankId = 1,
    /** ligger på autentisering.html*/
    loggInnHoved = 2,
    detteErNyttForMedlem = 3,
    detteErNyttForAdmin = 4,
    detteErNyttForTesting = 5,
    applikasjonHoved = 6,
}

/** Enum som representere de ulike modelloppdateringstypene vi pusher til klienter.
 * @see no.systemfabrikken.lederplan.tjenester.pushmeldinger.WebPushModellOppdatertEndepunkt$ModelloppdateringType (enum annotert med @JsonValue) */
export enum ModelloppdateringType {
    /** Tilhørende Modelloppdatering.modell: PlanId*/
    PLAN_OPPDATERT = "modelloppdatering.plan.oppdatert",
    AVTALE_OPPDATERT = "modelloppdatering.avtale.oppdatert",
    AVTALE_AVTALE_TERMINERT = "modelloppdatering.avtale.avtaleterminert",
    GRUPPE_OPPDATERT = "modelloppdatering.gruppe.oppdatert",
    /** Tilhørende Modelloppdatering.modell: MøteId*/
    NYTT_MØTE = "modelloppdatering.møte.nytt",
    /** Tilhørende Modelloppdatering.modell: MøteId*/
    MØTE_OPPDATERT = "modelloppdatering.møte.oppdatert",
    /** Tilhørende Modelloppdatering.modell: {@link no.systemfabrikken.lederplan.tjenester.pushmeldinger.ModelloppdateringBygger.OppdateringmodellMøteOgAvstemninger}*/
    MØTE_AVSTEMNING_ÅPNET = "modelloppdatering.møte.avstemningÅpnet",
    /** Tilhørende Modelloppdatering.modell: {@link no.systemfabrikken.lederplan.tjenester.pushmeldinger.ModelloppdateringBygger.OppdateringmodellMøteOgAvstemninger}*/
    MØTE_AVSTEMNING_STENGT = "modelloppdatering.møte.avstemningStengt",
    /** Tilhørende Modelloppdatering.modell: MøteId*/
    MØTE_SLETTET = "modelloppdatering.møte.slettet",
    /** Tilhørende Modelloppdatering.modell: MøteId*/
    SAKSREKKEFØLGE_OPPDATERT = "modelloppdatering.saksrekkefølge.oppdatert",
    /** Tilhørende Modelloppdatering.modell: MøteId*/
    MØTEDELTAKERE_OPPDATERT = "modelloppdatering.møtedeltakere.oppdatert",
    /** Tilhørende Modelloppdatering.modell: {@link no.systemfabrikken.lederplan.tjenester.pushmeldinger.ModelloppdateringBygger.OppdateringmodellAvstemningsresultatDeltakerNullstilt}*/
    MØTEDELTAKER_AVSTEMNINGSRESULTAT_NULLSTILT = "modelloppdatering.møtedeltaker.avstemningsresultatnullstilt",
    /** Tilhørende Modelloppdatering.modell: {@link no.systemfabrikken.lederplan.tjenester.pushmeldinger.ModelloppdateringBygger.OppdateringmodellAvstemningsresultatDeltakerEndret}*/
    MØTEDELTAKER_AVSTEMNINGSRESULTAT_ENDRET = "modelloppdatering.møtedeltaker.avstemningsresultatendret",
    MØTEDELTAKER_OPPDATERT = "modelloppdatering.møtedeltaker.oppdatert",
    PROTOKOLLFØRT_MØTEDELTAKER_OPPDATERT = "modelloppdatering.protokollførtmøtedeltaker.oppdatert",
    /** Tilhørende Modelloppdatering.modell: MøteId*/
    MØTEPROTOKOLL_OPPTAK_TRANSKRIBERT = "modelloppdatering.møteprotokoll.opptakTranskribert",
    /** Tilhørende Modelloppdatering.modell: MøteId*/
    MØTEPROTOKOLL_TRANSKRIPSJON_OPPSUMMERT = "modelloppdatering.møteprotokoll.transkripsjonOppsummert",
    /** Tilhørende Modelloppdatering.modell: MøteId*/
    MØTEPROTOKOLL_OPPTAK_SLETTET = "modelloppdatering.møteprotokoll.opptakSlettet",
    /** Tilhørende Modelloppdatering.modell: {@link no.systemfabrikken.lederplan.tjenester.pushmeldinger.ModelloppdateringBygger.OppdateringmodellEntitetMedForelder}*/
    NY_SAK = "modelloppdatering.sak.ny",
    /** Tilhørende Modelloppdatering.modell: {@link no.systemfabrikken.lederplan.tjenester.pushmeldinger.ModelloppdateringBygger.OppdateringmodellSakFlyttetTilMøte}*/
    SAK_FLYTTET_TIL_MØTE = "modelloppdatering.sak.flyttetTilMøte",
    /** Tilhørende Modelloppdatering.modell: {@link no.systemfabrikken.lederplan.tjenester.pushmeldinger.ModelloppdateringBygger.OppdateringmodellMøteOgSak}*/
    SAK_REFERAT_OPPDATERT = "modelloppdatering.sak.referatOppdatert",
    /** Tilhørende Modelloppdatering.modell: {@link no.systemfabrikken.lederplan.tjenester.pushmeldinger.ModelloppdateringBygger.OppdateringmodellEntitetMedForelder}*/
    SAK_OPPDATERT = "modelloppdatering.sak.oppdatert",
    /** Tilhørende Modelloppdatering.modell: {@link no.systemfabrikken.lederplan.tjenester.pushmeldinger.ModelloppdateringBygger.OppdateringmodellMøteOgSak}*/
    SAK_SLETTET = "modelloppdatering.sak.slettet",
    /** Tilhørende Modelloppdatering.modell: {@link no.systemfabrikken.lederplan.tjenester.pushmeldinger.ModelloppdateringBygger.OppdateringmodellBeslutning}*/
    NY_BESLUTNING = "modelloppdatering.beslutning.ny",
    /** Tilhørende Modelloppdatering.modell: {@link no.systemfabrikken.lederplan.tjenester.pushmeldinger.ModelloppdateringBygger.OppdateringmodellBeslutning}*/
    BESLUTNING_OPPDATERT = "modelloppdatering.beslutning.oppdatert",
    /** Tilhørende Modelloppdatering.modell: BeslutningId*/
    BESLUTNING_SLETTET = "modelloppdatering.beslutning.slettet",
    /** Tilhørende Modelloppdatering.modell {@link OppdateringmodellAvstemning}*/
    NY_AVSTEMNING = "modelloppdatering.avstemning.ny",
    /** Tilhørende Modelloppdatering.modell {@link OppdateringmodellAvstemning}*/
    AVSTEMNING_OPPDATERT = "modelloppdatering.avstemning.oppdatert",
    /** Tilhørende Modelloppdatering.modell: AvstemningId*/
    AVSTEMNING_SLETTET = "modelloppdatering.avstemning.slettet",
    /** Tilhørende Modelloppdatering.modell {@link OppdateringmodellAvstemning}*/
    AVSTEMNING_ÅPNET = "modelloppdatering.avstemning.åpnet",
    /** Tilhørende Modelloppdatering.modell {@link OppdateringmodellAvstemning}*/
    AVSTEMNING_STENGT = "modelloppdatering.avstemning.stengt",
    /** Tilhørende Modelloppdatering.modell: {@link no.systemfabrikken.lederplan.tjenester.pushmeldinger.ModelloppdateringBygger.OppdateringmodellOppgave}*/
    NY_OPPGAVE = "modelloppdatering.oppgave.ny",
    /** Tilhørende Modelloppdatering.modell: {@link no.systemfabrikken.lederplan.tjenester.pushmeldinger.ModelloppdateringBygger.OppdateringmodellOppgave}*/
    OPPGAVE_OPPDATERT = "modelloppdatering.oppgave.oppdatert",
    /** Tilhørende Modelloppdatering.modell: {@link no.systemfabrikken.lederplan.tjenester.pushmeldinger.ModelloppdateringBygger.OppdateringmodellOppgave}*/
    OPPGAVE_SLETTET = "modelloppdatering.oppgave.slettet",
    /** Tilhørende Modelloppdatering.modell: {@link no.systemfabrikken.lederplan.tjenester.pushmeldinger.ModelloppdateringBygger.OppdateringmodellNyttSaksdokument}*/
    NYTT_DOKUMENT = "modelloppdatering.dokument.nytt",
    /** Til'hørende Modelloppdatering.modell: {@link no.systemfabrikken.lederplan.tjenester.pushmeldinger.ModelloppdateringBygger.OppdateringmodellSaksdokumentSlettet}*/
    DOKUMENT_SLETTET = "modelloppdatering.dokument.slettet",
    /** Tilhørende Modelloppdatering.modell: {@link no.systemfabrikken.lederplan.tjenester.pushmeldinger.ModelloppdateringBygger.OppdateringmodellDokumentversjon}*/
    DOKUMENT_VIRUSSJEKKET = "modelloppdatering.dokument.virussjekket",
    /** Tilhørende Modelloppdatering.modell: {@link no.systemfabrikken.lederplan.tjenester.pushmeldinger.ModelloppdateringBygger.OppdateringmodellDokumentversjon}*/
    DOKUMENT_KONVERTERTPDF = "modelloppdatering.dokument.konvertertpdf",
    /** Tilhørende Modelloppdatering.modell: {@link no.systemfabrikken.lederplan.tjenester.pushmeldinger.ModelloppdateringBygger.OppdateringmodellDokumentversjon}*/
    DOKUMENT_FORSIDEBILDEOPPRETTET = "modelloppdatering.dokument.forsidebildeopprettet",
    /** Tilhørende Modelloppdatering.modell: {@link no.systemfabrikken.lederplan.tjenester.pushmeldinger.ModelloppdateringBygger.OppdateringmodellDokument}*/
    DOKUMENT_TILSIGNERING = "modelloppdatering.dokument.tilsignering",
    /** Tilhørende Modelloppdatering.modell: {@link no.systemfabrikken.lederplan.tjenester.pushmeldinger.ModelloppdateringBygger.OppdateringmodellDokument}*/
    DOKUMENT_KOMPLETTSIGNERT = "modelloppdatering.dokument.komplettsignert",
    /** Tilhørende Modelloppdatering.modell: {@link no.systemfabrikken.lederplan.tjenester.pushmeldinger.ModelloppdateringBygger.OppdateringmodellDokument}*/
    DOKUMENT_LÅSTOPP = "modelloppdatering.dokument.låstopp",
    /** Tilhørende Modelloppdatering.modell: {@link no.systemfabrikken.lederplan.tjenester.pushmeldinger.ModelloppdateringBygger.OppdateringmodellDokumentAnnotering}*/
    NY_DOKUMENTANNOTERING = "modelloppdatering.dokumentannotering.ny",
    /** Tilhørende Modelloppdatering.modell: {@link no.systemfabrikken.lederplan.tjenester.pushmeldinger.ModelloppdateringBygger.OppdateringmodellDokumentAnnotering}*/
    DOKUMENTANNOTERING_SLETTET = "modelloppdatering.dokumentannotering.slettet",
    /** Tilhørende Modelloppdatering.modell: {@link no.systemfabrikken.lederplan.tjenester.pushmeldinger.ModelloppdateringBygger.OppdateringmodellSignatarSignert}*/
    SIGNATAR_SIGNERT = "modelloppdatering.signatar.signert",
    /** Tilhørende Modelloppdatering.modell: {@link no.systemfabrikken.lederplan.tjenester.pushmeldinger.ModelloppdateringBygger.OppdateringmodellArkivnode}*/
    NY_ARKIVNODE = "modelloppdatering.arkivnode.ny",
    /** Tilhørende Modelloppdatering.modell: {@link no.systemfabrikken.lederplan.tjenester.pushmeldinger.ModelloppdateringBygger.OppdateringmodellArkivnode}*/
    ARKIVNODE_OPPDATERT = "modelloppdatering.arkivnode.oppdatert",
    /** Tilhørende Modelloppdatering.modell: {@link no.systemfabrikken.lederplan.tjenester.pushmeldinger.ModelloppdateringBygger.OppdateringmodellArkivnodeSlettet}*/
    ARKIVNODE_SLETTET = "modelloppdatering.arkivnode.slettet",
    /** Tilhørende Modelloppdatering.modell: {@link no.systemfabrikken.lederplan.tjenester.pushmeldinger.ModelloppdateringBygger.OppdateringmodellKommentarSak}*/
    NY_KOMMENTAR_SAK = "modelloppdatering.kommentarsak.ny",
    /** Tilhørende Modelloppdatering.modell: {@link no.systemfabrikken.lederplan.tjenester.pushmeldinger.ModelloppdateringBygger.OppdateringmodellKommentarDokument}*/
    NY_KOMMENTAR_DOKUMENT_ANNOTERING = "modelloppdatering.kommentardokumentannotering.ny",
    /** Tilhørende Modelloppdatering.modell: {@link no.systemfabrikken.lederplan.tjenester.pushmeldinger.ModelloppdateringBygger.OppdateringmodellKommentarOppgave}*/
    NY_KOMMENTAR_OPPGAVE = "modelloppdatering.kommentaroppgave.ny",
    /** Tilhørende Modelloppdatering.modell: {@link no.systemfabrikken.lederplan.tjenester.pushmeldinger.ModelloppdateringBygger.OppdateringmodellKommentarMedForelder}*/
    NYTT_SVAR = "modelloppdatering.kommentar.nyttSvar",
    /** Tilhørende Modelloppdatering.modell: {@link no.systemfabrikken.lederplan.tjenester.pushmeldinger.ModelloppdateringBygger.OppdateringmodellKommentarMedForelder}*/
    KOMMENTAR_SLETTET = "modelloppdatering.kommentar.slettet",
    /** Tilhørende Modelloppdatering.modell: {@link no.systemfabrikken.lederplan.tjenester.pushmeldinger.ModelloppdateringBygger.OppdateringmodellSvarMedForelder}*/
    SVAR_SLETTET = "modelloppdatering.svar.slettet",
    NY_SPØRREUNDERSØKELSE = "modelloppdatering.spørreundersøkelse.ny",
    SPØRREUNDERSØKELSE_OPPDATERT = "modelloppdatering.spørreundersøkelse.oppdatert",
    SPØRREUNDERSØKELSE_SLETTET = "modelloppdatering.spørreundersøkelse.slettet",
    SYSTEMMELDING_OPPRETTET = "modelloppdatering.systemmelding.opprettet",
    SYSTEMMELDING_SLETTET = "modelloppdatering.systemmelding.slettet",
}

/**  @see no.systemfabrikken.lederplan.resources.møte.MøteRessurs$Moetesteg */
export enum Moetesteg {
    moetet_er_under_arbeid = 'moetet_er_under_arbeid',
    opprett_saker = 'opprett_saker',
    publiser_moetet = 'publiser_moetet',
    send_innkalling = 'send_innkalling',
    svar_paa_innkalling = 'svar_paa_innkalling',
    du_har_godtatt_innkallingen = 'du_har_godtatt_innkallingen',
    du_har_avslaatt_innkallingen = 'du_har_avslaatt_innkallingen',
    skriv_protokoll = 'skriv_protokoll',
    protokollen_er_under_arbeid = 'protokollen_er_under_arbeid',
    publiser_protokoll = 'publiser_protokoll',
    send_til_signering = 'send_til_signering',
    signer_protokoll = 'signer_protokoll',
    venter_paa_signaturer = 'venter_paa_signaturer',
    du_har_signert_protokollen = 'du_har_signert_protokollen',
    protokoll_ferdig_signert = 'protokoll_ferdig_signert',
}

/** NB: Denne typen må holdes i synk med motsvarende enum på javascript-siden
 * @see no.systemfabrikken.lederplan.domene.møte.Møteprotokoll$MøteProtokollValideringsfeil */
export enum MøteProtokollValideringsfeil {
    medlem_skjermet_signere = 'medlem_skjermet_signere',
}

/** NB: Denne typen må holdes i synk med motsvarende enum på javascript-siden
 * @see no.systemfabrikken.lederplan.domene.møte.Møte$MøtePublisering$MøtePubliseringValideringsfeil */
export enum MøtePubliseringValideringsfeil {
    åpent_for_avstemning = 'åpent_for_avstemning',
    protokoll_låst = 'protokoll_låst',
}

/**  @see no.systemfabrikken.lederplan.domene.møte.Møte$MøtebehandlingOpptak$MøtebehandlingOpptakValideringsfeil */
export enum MøtebehandlingOpptakValideringsfeil {
    maks_opptakslengde_overskredet = 'maks_opptakslengde_overskredet',
}

/** Møtedokumentdeler som kan utelates fra møtedokument
 * @see no.systemfabrikken.lederplan.tjenester.dokumentgenerering.generatorer.MøtedokumentGenerator$Møtedokumentdel (enum annotert med @JsonValue) */
export enum Møtedokumentdel {
    innholdsfortegnelse = 0,
    saksforside = 1,
    AGENDADOC_INCLUDE_DESCRIPTION = 3,
    AGENDADOC_INCLUDE_SUGESTED_RESOLUTION = 4,
}

/**  @see no.systemfabrikken.lederplan.domene.møte.Møte$OppdaterMøteValideringsfeil */
export enum OppdaterMøteValideringsfeil {
    protokoll_låst = 'protokoll_låst',
    møte_opprett_samme_starttidspunkt = 'møte_opprett_samme_starttidspunkt',
    deltaker_er_stemmeberettiget = 'deltaker_er_stemmeberettiget',
}

/** NB: Denne typen må holdes i synk med motsvarende enum på javascript-siden
 * @see no.systemfabrikken.lederplan.resources.skjemalås.SkjemalåsRessurs$OppdaterSkjemalåsStatus */
export enum OppdaterSkjemalåsStatus {
    låsOppdatert = 'låsOppdatert',
    låstAvAnnenBruker = 'låstAvAnnenBruker',
    låstAvSammeBrukerAnnetVindu = 'låstAvSammeBrukerAnnetVindu',
}

/** Møtedokumentdeler som kan utelates fra møtedokument
 * @see no.systemfabrikken.lederplan.domene.oppgave.OppgaveForelderType (enum annotert med @JsonValue) */
export enum OppgaveForelderType {
    gruppe = 0,
    sak = 1,
    beslutning = 2,
}

/** NB: Denne typen må holdes i synk med motsvarende enum på javascript-siden
 * @see no.systemfabrikken.lederplan.domene.oppgave.IndeksbasertOppgaveSøk$FinnOppgaverKriterie$Oppgavesorteringskolonne (enum annotert med @JsonValue) */
export enum Oppgavesorteringskolonne {
    frist = 0,
    tittel = 1,
    status = 2,
    bruker = 3,
}

/**  @see no.systemfabrikken.lederplan.domene.oppgave.Oppgave$Oppgavestatus (enum annotert med @JsonValue) */
export enum Oppgavestatus {
    ikke_påbegynt = 0,
    påbegynt = 1,
    utført = 2,
}

/** NB: Denne typen må holdes i synk med motsvarende enum på javascript-siden
 * @see no.systemfabrikken.lederplan.domene.oppgave.IndeksbasertOppgaveSøk$FinnOppgaverKriterie$OppgavestatusKriterie (enum annotert med @JsonValue) */
export enum OppgavestatusKriterie {
    forfalt = 0,
    ikke_forfalt = 1,
    utfoert = 2,
    ikke_utfoert = 4,
    uten_frist = 3,
}

/**  @see no.systemfabrikken.lederplan.domene.dokument.OpplastetDokumentVersjon$OpplastetDokumentVersjonBygger$OpplastetDokumentVersjonValideringsfeil */
export enum OpplastetDokumentVersjonValideringsfeil {
    ugyldig_mimeformat = 'ugyldig_mimeformat',
    møte_låst = 'møte_låst',
    dokument_låst = 'dokument_låst',
}

/**  @see no.systemfabrikken.lederplan.domene.sak.Agendaelement$AgendaelementBygger$OpprettAgendaelementValideringsfeil */
export enum OpprettAgendaelementValideringsfeil {
    protokoll_låst = 'protokoll_låst',
}

/**  @see no.systemfabrikken.lederplan.domene.møte.Møte$Møtebygger$OpprettMøteValideringsfeil */
export enum OpprettMøteValideringsfeil {
    protokoll_låst = 'protokoll_låst',
    møte_opprett_samme_starttidspunkt = 'møte_opprett_samme_starttidspunkt',
    møte_opprett_ingen_plan = 'møte_opprett_ingen_plan',
}

/** NB: Denne typen må holdes i synk med motsvarende enum på javascript-siden
 * @see no.systemfabrikken.lederplan.resources.skjemalås.SkjemalåsRessurs$OpprettSkjemalåsStatus */
export enum OpprettSkjemalåsStatus {
    låsOpprettet = 'låsOpprettet',
    låstAvAnnenBruker = 'låstAvAnnenBruker',
    låstAvSammeBrukerAnnetVindu = 'låstAvSammeBrukerAnnetVindu',
    ingenEndringerLåsOvertatt = 'ingenEndringerLåsOvertatt',
}

/** NB: Denne typen må holdes i synk med motsvarende enum på javascript-siden
 * @see no.systemfabrikken.lederplan.domene.møte.ProtokollførtMøtedeltaker$ProtokollførtDeltakerstatus (enum annotert med @JsonValue) */
export enum ProtokollførtDeltakerstatus {
    deltatt = 0,
    forfall = 1,
    ikkeInnkalt = 2,
}

/**  @see no.systemfabrikken.lederplan.domene.spørreundersøkelse.Respondent$RegistrerBesvarelseValideringsfeil */
export enum RegistrerBesvarelseValideringsfeil {
    undersøkelse_ikke_åpen = 'undersøkelse_ikke_åpen',
}

/**  @see no.systemfabrikken.lederplan.domene.spørreundersøkelse.Respondent$RespondentStatus (enum annotert med @JsonValue) */
export enum RespondentStatus {
    ikke_besvart = 0,
    delvis_besvart = 1,
    besvart = 2,
}

/**  @see no.systemfabrikken.lederplan.resources.møte.MøteRessurs$SignatarStatus */
export enum SignatarStatus {
    skalIkkeSignere = 'skalIkkeSignere',
    skalSignere = 'skalSignere',
    signert = 'signert',
}

/** Valideringsfeil knyttet til sending av dokument til signering. Tilknyttet {@link Valideringsfeil#data} er av typen {dokumentId: DokumentId}, for medlem_feil_gruppe og medlem_skjermet inneholder data i tillegg {medlemId: MedlemId}
 * @see no.systemfabrikken.lederplan.domene.dokument.Signatar$SignatarValideringsfeil */
export enum SignatarValideringsfeil {
    medlem_ikke_satt = 'medlem_ikke_satt',
    dokument_ikke_satt = 'dokument_ikke_satt',
    medlem_skjermet = 'medlem_skjermet',
    medlem_feil_gruppe = 'medlem_feil_gruppe',
}

/** Status for signering av dokumentet. NB: Denne typen må holdes i synk med motsvarende enum på javascript-siden
 * @see no.systemfabrikken.lederplan.domene.dokument.Signering$SigneringStatus (enum annotert med @JsonValue) */
export enum SigneringStatus {
    ikkeAktivert = 0,
    tilSignering = 1,
    delvisSignert = 2,
    signert = 3,
    signertOgKonvoluttert = 4,
    eksterntSignert = 5,
}

/** Enum som angir forespurt e-id ved signering. Merk at hvilken metode som faktisk ble benyttet til å danne signaturen beskrives via {@link BenyttetSigneringsmetode} . NB: Denne typen må holdes i synk med motsvarende enum på javascript-siden
 * @see no.systemfabrikken.lederplan.domene.dokument.Signering$Signeringsmetode (enum annotert med @JsonValue) */
export enum Signeringsmetode {
    lederplan_autentisert_tofakt_sms = 0,
    lederplan_autentisert_tofakt_epost = 7,
    norsk_bankid_netsentrisk_tekst = 1,
    norsk_bankid_netsentrisk_pdf = 3,
    svensk_bankid_samedevice = 4,
    svensk_bankid_anotherdevice = 5,
    svensk_bankid_anotherdeviceqr = 6,
}

/**  @see no.systemfabrikken.lederplan.resources.aksjeeierbok.SkatteetatenAksjeeierbokRessurs$SkatteetatenStatus */
export enum SkatteetatenStatus {
    OK = 'OK',
    IKKE_FUNNET = 'IKKE_FUNNET',
    FOR_MANGE = 'FOR_MANGE',
}

/** Identifiserer skjemaet {@link Skjemalås} gjelder for. NB: Denne typen må holdes i synk med motsvarende enum på javascript-siden
 * @see no.systemfabrikken.lederplan.domene.skjemalås.Skjemalås$SkjemalåsSkjemaId (enum annotert med @JsonValue) */
export enum SkjemalåsSkjemaId {
    moeteprotokoll = 0,
    moetetranskripsjon = 1,
}

/** NB: Denne typen må holdes i synk med motsvarende enum på javascript-siden
 * @see no.systemfabrikken.lederplan.domene.MedSkjerming$SkjermingValideringsfeil */
export enum SkjermingValideringsfeil {
    medlem_skal_signere_protokoll = 'medlem_skal_signere_protokoll',
    stenge_egen_tilgang = 'stenge_egen_tilgang',
    fjerne_egen_skjerming = 'fjerne_egen_skjerming',
    ikke_medlem_i_gruppe = 'ikke_medlem_i_gruppe',
    medlem_skal_signere_dokument = 'medlem_skal_signere_dokument',
}

/**  @see no.systemfabrikken.lederplan.tjenester.bruker.SlåSammenBrukere$SlåSammenBrukereValideringsfeil */
export enum SlåSammenBrukereValideringsfeil {
    brukere_medlem_i_samme_gruppe = 'brukere_medlem_i_samme_gruppe',
}

/**  @see no.systemfabrikken.lederplan.tjenester.i18n.I18nStøttedeSnakkedeSpråk$SnakketSpråk (enum annotert med @JsonValue) */
export enum SnakketSpråk {
    norsk = 0,
    engelsk = 1,
}

/**  @see no.systemfabrikken.lederplan.infrastruktur.datalager.Sortering */
export enum Sortering {
    stigende = 'stigende',
    synkende = 'synkende',
}

/**  @see no.systemfabrikken.lederplan.tjenester.i18n.I18nStøttedeSpråk$Språk (enum annotert med @JsonValue) */
export enum Språk {
    norsk_bokmål = "nb",
    engelsk = "en",
    norsk_nynorsk = "nn",
}

/**  @see no.systemfabrikken.lederplan.domene.spørreundersøkelse.Spørreskjema$SpørreskjemaValideringsfeil */
export enum SpørreskjemaValideringsfeil {
    mangler_spørsmål = 'mangler_spørsmål',
    første_spørsmål_ikke_grupperingstittel = 'første_spørsmål_ikke_grupperingstittel',
    gruppe_uten_spørsmål = 'gruppe_uten_spørsmål',
    ugyldige_alternativer = 'ugyldige_alternativer',
    ugyldig_maksimalt_antall_valg = 'ugyldig_maksimalt_antall_valg',
    dupliserte_spørsmål = 'dupliserte_spørsmål',
    korrelert_spørsmål_har_annen_type_eller_oppsett = 'korrelert_spørsmål_har_annen_type_eller_oppsett',
    struktur_endret_for_skjema_i_bruk = 'struktur_endret_for_skjema_i_bruk',
    skjema_i_bruk = 'skjema_i_bruk',
}

/**  @see no.systemfabrikken.lederplan.domene.spørreundersøkelse.Spørsmål$Spørsmålstype (enum annotert med @JsonValue) */
export enum Spørsmålstype {
    grupperingstittel = 0,
    boolsk = 1,
    fritekst = 2,
    rangering = 3,
    velgEnAvFlere = 4,
    /** Respondenten kan velge ett eller flere av alternativene. Svaret lagres som en kommaseparert liste med verdiene til de valgte alternativene, f.eks. "1,3"*/
    velgNoenAvFlere = 5,
}

/** {@link AsynkOppgave} status.
 * @see no.systemfabrikken.lederplan.infrastruktur.asynkrontArbeid.AsynkOppgave$Status (enum annotert med @JsonValue) */
export enum Status {
    ikke_påbegynt = 0,
    påbegynt = 1,
    feilet = 2,
    avsluttet = 3,
    /** For å unngå at listen over feilede oppgaver vokser uendelig og blir uoversiktlig kan administrator sette en oppgave som parkert. Parkerte oppgaver vil ikke bli kjørt.*/
    parkert = 4,
}

/**  @see no.systemfabrikken.lederplan.resources.sak.AvstemningRessurs$StemmegivningStatus */
export enum StemmegivningStatus {
    ikkePåbegynt = 'ikkePåbegynt',
    påbegynt = 'påbegynt',
    fullført = 'fullført',
}

/** NB: Denne typen må holdes i synk med motsvarende enum på javascript-siden
 * @see no.systemfabrikken.lederplan.domene.revisjonslogg.Endringshendelse$SubEndringstype (enum annotert med @JsonValue) */
export enum SubEndringstype {
    flyttTilMøte = 0,
    saksreferatOppdatert = 1,
    møtereferatDetaljerOppdatert = 28,
    dokumentversjon = 2,
    dokumentSignert = 3,
    dokumentKlarTilSignering = 4,
    dokumentSignatarerOppdatert = 26,
    dokumentKomplettSignert = 19,
    dokumentEksterntSignert = 21,
    dokumentLåstOpp = 5,
    epostadresseBekreftet = 6,
    mobilnummerBekreftet = 18,
    avstemningsresultatEndret = 7,
    avstemningsresultatNullstilt = 8,
    avstemningAapnet = 9,
    avstemningStengt = 10,
    otpAutentiseringAktivert = 11,
    otpAutentiseringDeaktivert = 12,
    utloggingAlle = 13,
    openIdIdentitetLagtTil = 14,
    openIdIdentitetSlettet = 15,
    skjermingOppdatert = 16,
    publiseringOppdatert = 17,
    møteKopiert = 20,
    sakKopiert = 30,
    sp2Endringshendelse = 22,
    sp2SignEndringshendelse = 23,
    sp2SmsEndringshendelse = 24,
    brukerSlåttSammen = 25,
    medlemAnonymisert = 27,
    gruppeImportertFraAnnenDB = 29,
    spoerreundersoekelseAapnet = 31,
    spoerreundersoekelseStengt = 32,
}

/** NB: Denne typen må holdes i synk med motsvarende enum på javascript-siden
 * @see no.systemfabrikken.lederplan.resources.søk.SøkRessurs$SøkEntitetType (enum annotert med @JsonValue) */
export enum SøkEntitetType {
    sak = 0,
    dokument = 1,
    møte = 2,
    oppgave = 3,
    beslutning = 4,
    kommentar = 5,
    gruppe = 6,
    medlem = 7,
    bruker = 8,
}

/** MERK!! tallRepresentasjon må holdes i synk med tilsvarende enum i JS koden!!
 * @see no.systemfabrikken.lederplan.domene.dokument.DokumentAnnotering$Tekstmarkeringsfarge (enum annotert med @JsonValue) */
export enum Tekstmarkeringsfarge {
    gul = 0,
    groenn = 1,
    roed = 2,
    blaa = 3,
}

/** Definerer tilgangsroller på brukernivå benyttet for autorisasjon av WS tjenester (vjha {@link `RollerMedTilgang` no.systemfabrikken.lederplan.infrastruktur.sikkerhet.AutorisasjonsfilterFabrikk.RollerMedTilgang} ) og webappen (vhja state.data.tilgangsroller og Moduler.Bruker.Tilgansroller enumen). Gruppespesifikke tilganger er definert via {@link no.systemfabrikken.lederplan.domene.gruppe.Medlem.TilgangsrolleMedlem} . Felt av denne typen må mappes for bruk i hibernate vhja \`@Convert(converter = TilgangsrolleBrukerSamlingConverter.class)\`
 * @see no.systemfabrikken.lederplan.domene.bruker.Bruker$TilgangsrolleBruker (enum annotert med @JsonValue) */
export enum TilgangsrolleBruker {
    /** Ordinært bruker*/
    ordinaer = 1,
    /** systemadministrator - har tilgang til å se data på tvers av avtaler og grupper uten å være medlem av disse. Typisk system admin hos systemfabrikken*/
    administrator = 2,
    /** Rolle som gir tilgang til å slå sammen to brukere. Dette er en systemadministrator rolle, du børikke ha denne uten og også ha {@link #administrator} . Se {@link no.systemfabrikken.lederplan.resources.bruker.BrukerRessurs#kobleBrukere}*/
    koble_brukere = 3,
}

/** Definerer tilgangsroller på medlemsnivå. Brukerspesifikke tilganger (på tvers av brukers grupper) er definert via {@link no.systemfabrikken.lederplan.domene.bruker.Bruker.TilgangsrolleBruker} .
 * @see no.systemfabrikken.lederplan.domene.gruppe.Medlem$TilgangsrolleMedlem (enum annotert med @JsonValue) */
export enum TilgangsrolleMedlem {
    lese = 0,
    /** gir generell redigering (opprett/rediger/slett) tilgang.*/
    skrive = 1,
    /** Gir tilgang ikke-publisert informasjon, feks saksdetaljer knyttet til møte som ikke er publisert.*/
    tilgangIkkePublisert = 2,
    /** Gir tilgang til hendelseslogginnslag knyttet til slettede entiteter, feks hendelsen "opprett møte" når dette møte er slettet.*/
    tilgangSlettetIHendelseslogg = 3,
}

/**  @see no.systemfabrikken.lederplan.domene.dokument.TofaktorSigneringskode$TofaktorSigneringskodeKanal (enum annotert med @JsonValue) */
export enum TofaktorSigneringskodeKanal {
    sms = 0,
    epost = 1,
}

/** Varighet token kan opprettes med. MERK!! tallRepresentasjon må holdes i synk med tilsvarende enum i JS koden!!
 * @see no.systemfabrikken.lederplan.infrastruktur.sikkerhet.JsonWebTokenTjeneste$Tokenvarighet (enum annotert med @JsonValue) */
export enum Tokenvarighet {
    kort = 0,
    medium = 1,
    lang = 2,
    criipto_dokumentsignering = 3,
    bankid_dokumentsignering = 4,
}

/**  @see no.systemfabrikken.lederplan.domene.systemmelding.SystemMelding$Varseltype (enum annotert med @JsonValue) */
export enum Varseltype {
    info = 0,
    advarsel = 1,
    feil = 2,
}

/**  @see no.systemfabrikken.lederplan.domene.dokument.DokumentVersjon$VirussjekkStatus (enum annotert med @JsonValue) */
export enum VirussjekkStatus {
    ikke_sjekket = 0,
    ok = 1,
    infisert = 2,
}
